import { defineComponent as Wn, computed as pi, unref as qi, openBlock as qt, createBlock as Xr, resolveDynamicComponent as kl, createElementBlock as bn, normalizeClass as Bl, createVNode as _e, Transition as Hl, withCtx as Dr, createElementVNode as Ft, renderSlot as Rs, toDisplayString as mi, createTextVNode as Os, resolveComponent as Rn, createCommentVNode as Ns, reactive as Jo, ref as Ye, onMounted as ks, nextTick as Ir, onBeforeUnmount as Vl, onActivated as Gl, onDeactivated as Wl, mergeProps as Qo, watch as Wt, onUnmounted as jl, onErrorCaptured as Xl, normalizeStyle as Wi, withModifiers as ql } from "vue";
import { Table as Yl, Pagination as el, Input as Kl, Button as Zl, Popover as $l, InputSearch as Jl, message as Hi } from "ant-design-vue";
import { fabric as We } from "fabric";
const Ql = /* @__PURE__ */ Wn({
  __name: "AutoIcon",
  props: {
    type: null
  },
  setup(r) {
    const e = r, t = pi(
      () => e.type && e.type.indexOf("antv-") === 0 ? e.type.replace("antv-", "") : null
    );
    return (n, i) => qi(t) ? (qt(), Xr(kl(`${qi(t)}-outlined`), { key: 0 })) : (qt(), bn("span", {
      key: 1,
      class: Bl(`anticon iota-auto-icon iota-icon iota-icon-${r.type}`)
    }, null, 2));
  }
});
const un = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [n, i] of e)
    t[n] = i;
  return t;
}, ec = /* @__PURE__ */ un(Ql, [["__scopeId", "data-v-3d87ea2d"]]), tl = {
  name: "IotaAvatarEditor",
  props: {
    title: {
      type: String
    },
    previewHint: {
      type: String
    },
    selectImgHint: {
      type: String
    },
    cropHint: {
      type: String
    },
    radiusPerc: Number,
    width: Number,
    height: Number,
    avatarFile: {
      type: [Object, String, File]
    }
  },
  created() {
    this.move = !1, this.resize = !1, this.scaleBase = 100, this.calcWidth = this.width > 0 ? this.width : this.scaleBase, this.calcHeight = this.height > 0 ? this.height : this.scaleBase, this.aspectRatio = this.calcWidth / this.calcHeight, this.widthBase = this.aspectRatio > 1 ? this.scaleBase : this.scaleBase * this.aspectRatio, this.heightBase = this.widthBase / this.aspectRatio, this.caclRadiusPerc = this.radiusPerc ? this.radiusPerc : 0, typeof this.calcRadiusPerc != "number" && (this.calcRadiusPerc = 0), (this.calcRadiusPerc > 100 || this.calcRadiusPerc < 0) && (this.calcRadiusPerc = 0), this.radius = Math.min(this.widthBase, this.heightBase) * this.calcRadiusPerc / 100 / 2, this.widthOfRawCanvas = void 0, this.heightOfRawCanvas = void 0, this.widthOfCropCanvas = void 0, this.heightOfCropCanvas = void 0, this.domWidthOfRawCanvas = 320, this.domHeightOfRawCanvas = void 0, this.domWidthOfCropCanvas = void 0, this.domHeightOfCropCanvas = void 0, this.topOfRawCanvas = void 0, this.leftOfRawCanvas = void 0, this.topOfCropCanvas = void 0, this.leftOfCropCanvas = void 0, this.topOfResizeCanvas = void 0, this.leftOfResizeCanvas = void 0, this.img = void 0;
  },
  mounted() {
    document.addEventListener("mousedown", this.onMoveDown), document.addEventListener("mousedown", this.onResizeDown), this.oldAvatarFile = this.avatarFile, this.redraw(this.avatarFile);
  },
  updated() {
    this.oldAvatarFile !== this.avatarFile && (this.oldAvatarFile = this.avatarFile, this.redraw(this.avatarFile));
  },
  methods: {
    onResizeMove(r) {
      let e = r.clientX, t = r.clientY, n = e - this.beginX, i = t - this.beginY;
      this.aspectRatio > 1 ? i = n / this.aspectRatio : n = i * this.aspectRatio;
      let s = this.lastDomWidth + n, a = this.lastDomHeight + i;
      this.domWidthOfCropCanvas = s, this.domHeightOfCropCanvas = a, s < 10 && (this.domWidthOfCropCanvas = 10), a < 10 && (this.domHeightOfCropCanvas = 10);
      let o = s + this.leftOfCropCanvas - (this.leftOfRawCanvas + this.domWidthOfRawCanvas), l = a + this.topOfCropCanvas - (this.topOfRawCanvas + this.domHeightOfRawCanvas);
      (o > 0 || l > 0) && (this.domWidthOfCropCanvas = this.leftOfRawCanvas + this.domWidthOfRawCanvas - this.leftOfCropCanvas, this.domHeightOfCropCanvas = this.domWidthOfCropCanvas / this.aspectRatio, this.domHeightOfCropCanvas + this.topOfCropCanvas > this.topOfRawCanvas + this.domHeightOfRawCanvas && (this.domHeightOfCropCanvas = this.topOfRawCanvas + this.domHeightOfRawCanvas - this.topOfCropCanvas, this.domWidthOfCropCanvas = this.domHeightOfCropCanvas * this.aspectRatio)), this.widthOfCropCanvas = this.lastWidth * this.domWidthOfCropCanvas / this.lastDomWidth, this.heightOfCropCanvas = this.lastHeight * this.domHeightOfCropCanvas / this.lastDomHeight, this.draw();
    },
    onResizeDown(r) {
      r.target == this.$refs._resizeCanvas && (this.beginX = r.clientX, this.beginY = r.clientY, this.lastDomWidth = this.domWidthOfCropCanvas, this.lastDomHeight = this.domHeightOfCropCanvas, this.lastWidth = this.widthOfCropCanvas, this.lastHeight = this.heightOfCropCanvas, document.addEventListener("mousemove", this.onResizeMove), document.addEventListener("mouseup", this.onResizeUp));
    },
    onResizeUp() {
      document.removeEventListener("mousemove", this.onResizeMove), document.removeEventListener("mouseup", this.onResizeUp);
    },
    onMoveMove(r) {
      let e = r.clientX, t = r.clientY, n = e - this.beginX, i = t - this.beginY, s = this.lastTop + i;
      this.topOfCropCanvas = s, s < this.topOfRawCanvas && (this.topOfCropCanvas = this.topOfRawCanvas), s + this.domHeightOfCropCanvas > this.topOfRawCanvas + this.domHeightOfRawCanvas && (this.topOfCropCanvas = this.domHeightOfRawCanvas + this.topOfRawCanvas - this.domHeightOfCropCanvas);
      let a = this.lastLeft + n;
      this.leftOfCropCanvas = a, a < this.leftOfRawCanvas && (this.leftOfCropCanvas = this.leftOfRawCanvas), a + this.domWidthOfCropCanvas > this.leftOfRawCanvas + this.domWidthOfRawCanvas && (this.leftOfCropCanvas = this.domWidthOfRawCanvas + this.leftOfRawCanvas - this.domWidthOfCropCanvas), this.draw();
    },
    onMoveUp() {
      document.removeEventListener("mousemove", this.onMoveMove), document.removeEventListener("mouseup", this.onMoveUp);
    },
    onMoveDown(r) {
      r.target == this.$refs._cropCanvas && (this.beginX = r.clientX, this.beginY = r.clientY, this.lastTop = this.topOfCropCanvas, this.lastLeft = this.leftOfCropCanvas, document.addEventListener("mousemove", this.onMoveMove), document.addEventListener("mouseup", this.onMoveUp));
    },
    reDrawByImg() {
      let r = this.img;
      this.widthOfRawCanvas = r.width, this.heightOfRawCanvas = r.height, this.widthOfRawCanvas > this.heightOfRawCanvas ? (this.domWidthOfRawCanvas = 320, this.domHeightOfRawCanvas = 320 * this.heightOfRawCanvas / this.widthOfRawCanvas, this.leftOfRawCanvas = 0, this.topOfRawCanvas = (320 - this.domHeightOfRawCanvas) / 2) : (this.domHeightOfRawCanvas = 320, this.domWidthOfRawCanvas = 320 * this.widthOfRawCanvas / this.heightOfRawCanvas, this.topOfRawCanvas = 0, this.leftOfRawCanvas = (320 - this.domWidthOfRawCanvas) / 2);
      let e = Math.min(this.domWidthOfRawCanvas, this.domHeightOfRawCanvas), t = e;
      e > 200 && (e = 200), e > 100 && e < 200 && (e = e - 20), this.aspectRatio > 1 ? (this.domWidthOfCropCanvas = e, this.domHeightOfCropCanvas = e / this.aspectRatio) : (this.domHeightOfCropCanvas = e, this.domWidthOfCropCanvas = e * this.aspectRatio), this.widthOfCropCanvas = Math.min(this.widthOfRawCanvas, this.heightOfRawCanvas) * this.domWidthOfCropCanvas / t, this.heightOfCropCanvas = this.widthOfCropCanvas / this.aspectRatio, this.leftOfCropCanvas = (320 - this.domWidthOfCropCanvas) / 2, this.topOfCropCanvas = (320 - this.domHeightOfCropCanvas) / 2, this.draw();
    },
    roundRect(r, e, t, n, i, s, a, o) {
      if (typeof o > "u" && (o = !0), typeof s > "u" && (s = 5), typeof s == "number")
        s = {
          tl: s,
          tr: s,
          br: s,
          bl: s
        };
      else {
        var l = {
          tl: 0,
          tr: 0,
          br: 0,
          bl: 0
        };
        for (var c in l)
          s[c] = s[c] || l[c];
      }
      r.beginPath(), r.moveTo(e + s.tl, t), r.lineTo(e + n - s.tr, t), r.arc(e + n - s.tr, t + s.tr, s.tr, Math.PI * 1.5, Math.PI * 2), r.lineTo(e + n, t + i - s.br), r.arc(e + n - s.br, t + i - s.br, s.br, 0, Math.PI * 0.5), r.lineTo(e + s.bl, t + i), r.arc(e + s.bl, t + i - s.bl, s.bl, Math.PI * 0.5, Math.PI), r.lineTo(e, t + s.tl), r.arc(e + s.tl, t + s.tl, s.tl, Math.PI, Math.PI * 1.5), r.closePath(), a && r.fill(), o && r.stroke();
    },
    draw() {
      let r = (this.leftOfCropCanvas - this.leftOfRawCanvas) * this.widthOfRawCanvas / this.domWidthOfRawCanvas, e = (this.topOfCropCanvas - this.topOfRawCanvas) * this.heightOfRawCanvas / this.domHeightOfRawCanvas;
      this.topOfResizeCanvas = this.topOfCropCanvas + this.domHeightOfCropCanvas - 5, this.leftOfResizeCanvas = this.leftOfCropCanvas + this.domWidthOfCropCanvas - 5, this.$refs._rawCanvas.width = this.widthOfRawCanvas, this.$refs._rawCanvas.height = this.heightOfRawCanvas, this.$refs._rawCanvas.style.width = this.domWidthOfRawCanvas + "px", this.$refs._rawCanvas.style.height = this.domHeightOfRawCanvas + "px", this.$refs._rawCanvas.style.top = this.topOfRawCanvas + "px", this.$refs._rawCanvas.style.left = this.leftOfRawCanvas + "px", this.$refs._cropCanvas.width = this.widthOfCropCanvas, this.$refs._cropCanvas.height = this.heightOfCropCanvas, this.$refs._cropCanvas.style.width = this.domWidthOfCropCanvas + "px", this.$refs._cropCanvas.style.height = this.domHeightOfCropCanvas + "px", this.$refs._cropCanvas.style.top = this.topOfCropCanvas + "px", this.$refs._cropCanvas.style.left = this.leftOfCropCanvas + "px", this.$refs._resizeCanvas.style.top = this.topOfResizeCanvas + "px", this.$refs._resizeCanvas.style.left = this.leftOfResizeCanvas + "px";
      let t = this.img, n = this.$refs._rawCanvas.getContext("2d");
      n.clearRect(0, 0, this.widthOfRawCanvas, this.heightOfRawCanvas), n.globalAlpha = 0.6, n.fillRect(0, 0, this.widthOfRawCanvas, this.heightOfRawCanvas), n.globalAlpha = 1, n.globalCompositeOperation = "destination-out", this.roundRect(n, r, e, this.widthOfCropCanvas, this.heightOfCropCanvas, Math.min(this.widthOfCropCanvas, this.heightOfCropCanvas) * this.calcRadiusPerc / 100 / 2), n.fill();
      let i = this.$refs._cropCanvas.getContext("2d");
      i.clearRect(0, 0, this.widthOfCropCanvas, this.heightOfCropCanvas), i.globalAlpha = 1, i.strokeStyle = "white";
      for (let s = 0; s < Math.max(1, this.widthOfCropCanvas * 5e-3); s++)
        i.strokeRect(s, s, this.widthOfCropCanvas - s * 2, this.heightOfCropCanvas - s * 2);
      n.globalAlpha = 1, n.globalCompositeOperation = "destination-over", n.drawImage(t, 0, 0), n.globalAlpha = 1, n.fillStyle = "white", n.fillRect(0, 0, this.widthOfRawCanvas, this.heightOfRawCanvas), this.refreshPreView(t, r, e, this.$refs._v100Canvas.getContext("2d"), this.widthOfCropCanvas, this.heightOfCropCanvas, this.calcWidth, this.calcHeight), this.refreshPreView(t, r, e, this.$refs._v64Canvas.getContext("2d"), this.widthOfCropCanvas, this.heightOfCropCanvas, this.calcWidth * 0.64, this.calcHeight * 0.64), this.refreshPreView(t, r, e, this.$refs._v32Canvas.getContext("2d"), this.widthOfCropCanvas, this.heightOfCropCanvas, this.calcWidth * 0.32, this.calcHeight * 0.32), this.$emit("avatar", this.$refs._v100Canvas);
    },
    refreshPreView(r, e, t, n, i, s, a, o) {
      n.clearRect(0, 0, a, o), n.fillStyle = "white", n.fillRect(0, 0, a, o), n.drawImage(r, e, t, i, s, 0, 0, a, o);
    },
    redraw(r) {
      if (r) {
        let t = this.$refs._resizeCanvas.getContext("2d");
        t.globalAlpha = 1, t.strokeStyle = "white";
        for (let i = 0; i < 3; i++)
          t.strokeRect(i, i, 10 - i * 2, 10 - i * 2);
        let n = this;
        var e = new Image();
        e.onload = function() {
          n.img = e, n.reDrawByImg();
        }, typeof r == "object" ? e.src = URL.createObjectURL(r) : e.src = r;
      }
    },
    onSelectImg(r) {
      r.stopPropagation(), r.preventDefault(), this.$refs._fileInput.click();
      let e = this;
      this.$refs._fileInput.type = "file", this.$refs._fileInput.accept = "image/*", this.$refs._fileInput.addEventListener("change", function() {
        let t = e.$refs._fileInput.files;
        e.redraw(t[0]);
      });
    }
  },
  render() {
    return _e("div", {
      class: "iota-avatar-modal-body"
    }, [_e("div", {
      class: "source-wrapper"
    }, [_e("div", {
      class: "cropper-wrapper"
    }, [_e("div", {
      class: "image-ropper-wrapper"
    }, [_e("div", {
      class: "avatar-editor"
    }, [_e("canvas", {
      ref: "_rawCanvas",
      style: {
        cursor: "default",
        position: "absolute"
      }
    }, null), _e("canvas", {
      ref: "_cropCanvas",
      style: {
        cursor: "move",
        position: "absolute"
      }
    }, null), _e("canvas", {
      ref: "_resizeCanvas",
      height: "10",
      width: "10",
      style: {
        cursor: "se-resize",
        position: "absolute"
      }
    }, null)])])]), _e("p", {
      class: "crop-hint"
    }, [_e("input", {
      ref: "_fileInput",
      type: "file",
      accept: "image/*",
      class: "image-cropper-input",
      style: {
        display: "none"
      }
    }, null), _e("label", null, [_e("button", {
      class: "iota-avatar-button iota-avatar-button-dashed",
      onClick: this.onSelectImg
    }, [this.selectImgHint ? this.selectImgHint : "Select Image"])]), _e("span", {
      class: "tip"
    }, [this.cropHint ? this.cropHint : `Best size: ${this.calcWidth}\xD7${this.calcWidth}, you can cut it.`])])]), _e("div", {
      class: "preview-wrapper"
    }, [_e("div", {
      class: "preview"
    }, [_e("p", {
      class: "title"
    }, [this.previewHint ? this.previewHint : "Preview"]), _e("canvas", {
      ref: "_v100Canvas",
      width: this.calcWidth,
      height: this.calcHeight,
      style: {
        width: `${this.widthBase * 1.5}px`,
        height: `${this.heightBase * 1.5}px`,
        borderRadius: this.radius
      }
    }, null), _e("div", {
      class: "prev-hint"
    }, [this.aspectRatio > 1 ? `100x${Math.round(100 / this.aspectRatio)}` : `${Math.round(100 * this.aspectRatio)}\xD7100`]), _e("canvas", {
      ref: "_v64Canvas",
      width: this.calcWidth * 0.64,
      height: this.calcHeight * 0.64,
      style: {
        width: `${this.widthBase * 0.64 * 1.5}px`,
        height: `${this.heightBase * 0.64 * 1.5}px`,
        borderRadius: this.radius * 0.64
      }
    }, null), _e("div", {
      class: "prev-hint"
    }, [this.aspectRatio > 1 ? `64x${Math.round(64 / this.aspectRatio)}` : `${Math.round(64 * this.aspectRatio)}\xD764`]), _e("canvas", {
      ref: "_v32Canvas",
      width: this.calcWidth * 0.32,
      height: this.calcHeight * 0.32,
      style: {
        width: `${this.widthBase * 0.32 * 1.5}px`,
        height: `${this.heightBase * 0.32 * 1.5}px`,
        borderRadius: this.radius * 0.32
      }
    }, null), _e("div", {
      class: "prev-hint"
    }, [this.aspectRatio > 1 ? `32x${Math.round(32 / this.aspectRatio)}` : `${Math.round(32 * this.aspectRatio)}\xD732`])])])]);
  }
};
const tc = {
  props: {
    okText: String,
    cancelText: String
  },
  methods: {
    onCancel(r) {
      r.stopPropagation(), r.preventDefault(), this.$emit("cancel", r);
    },
    onOk(r) {
      r.stopPropagation(), r.preventDefault(), this.$emit("ok", r);
    }
  }
};
const nc = { class: "iota-avatar-modal-mask" }, ic = { class: "modal-container" }, sc = { class: "modal-header" }, rc = /* @__PURE__ */ Os(" default header "), ac = { class: "modal-body" }, oc = /* @__PURE__ */ Os(" default body "), lc = { class: "modal-footer" };
function cc(r, e) {
  return qt(), Xr(Hl, { name: "iota-avatar-modal" }, {
    default: Dr(() => [
      Ft("div", nc, [
        Ft("div", ic, [
          Ft("div", sc, [
            Rs(r.$slots, "header", {}, () => [
              rc
            ])
          ]),
          Ft("div", ac, [
            Rs(r.$slots, "body", {}, () => [
              oc
            ])
          ]),
          Ft("div", lc, [
            Rs(r.$slots, "footer", {}, () => [
              Ft("button", {
                class: "iota-avatar-button iota-avatar-button-lg",
                onClick: e[0] || (e[0] = (...t) => r.onCancel && r.onCancel(...t))
              }, mi(r.cancelText || "Cancel"), 1),
              Ft("button", {
                class: "iota-avatar-button iota-avatar-button-lg iota-avatar-button-primary",
                onClick: e[1] || (e[1] = (...t) => r.onOk && r.onOk(...t))
              }, mi(r.okText || "OK"), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 3
  });
}
const hc = /* @__PURE__ */ un(tc, [["render", cc]]), uc = {
  name: "IotaAvatar",
  components: {
    AvatarEditor: tl,
    Modal: hc
  },
  props: {
    title: String,
    previewHint: String,
    selectImgHint: String,
    cropHint: String,
    width: Number,
    height: Number,
    radiusPerc: Number,
    okText: String,
    cancelText: String
  },
  data() {
    return {
      visible: !1,
      avatarFile: null
    };
  },
  methods: {
    setVisible(r) {
      this.visible = r;
    },
    setAvatarFile(r) {
      this.visible = !0, this.avatarFile = r;
    },
    onClick(r) {
      r.stopPropagation();
      let e = document.createElement("input"), t = this;
      e.type = "file", e.accept = "image/*", e.addEventListener("change", function() {
        let n = e.files;
        t.setAvatarFile(n[0]);
      }), e.click();
    },
    onOk() {
      this.setVisible(!1), this.$emit("avatar", this.avatarCanvas);
    },
    onCancel() {
      this.setVisible(!1);
    },
    onAvatarDataOfEditor(r) {
      this.avatarCanvas = r, this.avatarCanvas.toBlob || (this.avatarCanvas.toBlob = function(e, t, n) {
        for (var i = atob(this.toDataURL(t, n).split(",")[1]), s = i.length, a = new Uint8Array(s), o = 0; o < s; o++)
          a[o] = i.charCodeAt(o);
        e(new Blob([a], {
          type: t || "image/png"
        }));
      });
    }
  }
};
const dc = { class: "avatar" }, fc = { class: "iota-avatar-button iota-avatar-button-dashed" }, pc = { class: "iota-avatar-modal-title" };
function mc(r, e, t, n, i, s) {
  const a = Rn("AvatarEditor"), o = Rn("Modal");
  return qt(), bn("div", dc, [
    Ft("div", {
      class: "controller",
      onClick: e[0] || (e[0] = (...l) => s.onClick && s.onClick(...l))
    }, [
      Rs(r.$slots, "controller", {}, () => [
        Ft("button", fc, mi(t.title ? t.title : "Select Image"), 1)
      ])
    ]),
    i.visible ? (qt(), Xr(o, {
      key: 0,
      onCancel: s.onCancel,
      onOk: s.onOk,
      okText: t.okText,
      cancelText: t.cancelText
    }, {
      body: Dr(() => [
        _e(a, {
          title: t.title,
          previewHint: t.previewHint,
          width: t.width,
          height: t.height,
          radiusPerc: t.radiusPerc,
          selectImgHint: t.selectImgHint,
          cropHint: t.cropHint,
          onAvatar: s.onAvatarDataOfEditor,
          avatarFile: i.avatarFile
        }, null, 8, ["title", "previewHint", "width", "height", "radiusPerc", "selectImgHint", "cropHint", "onAvatar", "avatarFile"])
      ]),
      header: Dr(() => [
        Ft("div", pc, mi(t.title ? t.title : "Upload Image"), 1)
      ]),
      _: 1
    }, 8, ["onCancel", "onOk", "okText", "cancelText"])) : Ns("", !0)
  ]);
}
const gc = /* @__PURE__ */ un(uc, [["render", mc]]), _c = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/), vc = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPjxwYXRoIGQ9Ik00MzMgNjAxYy0xMCAwLTIwLTQtMjctMTJhMzggMzggMCAwMTAtNTNsMTA2LTEwM2MxNC0xNCAzOC0xNCA1MiAwbDEwNCAxMDJhMzggMzggMCAwMS01MyA1M2wtNzctNzUtNzkgNzdjLTcgNy0xNyAxMS0yNiAxMXoiLz48cGF0aCBkPSJNNTM3IDkwOWMtMjEgMC0zOC0xNi0zOC0zN1Y0ODJhMzggMzggMCAwMTc2IDB2MzkwYzAgMjEtMTcgMzctMzggMzd6Ii8+PGc+PHBhdGggZD0iTTc4MyA3MjdhMzggMzggMCAwMTAtNzZjNTcgMCAxMDQtNDMgMTA0LTk3di0yN2MwLTQ0LTMyLTgyLTc3LTk0bC0yOS03IDEtMzZjMi00NS0xOC05My01NC0xMzEtNDItNDQtMTAwLTY5LTE1OS02OS0xMTggMC0yMTMgOTAtMjEzIDIwMnYzN0gyNDFjLTU3IDAtMTA0IDQ0LTEwNCA5OHYyN2MwIDU0IDQ3IDk3IDEwNCA5N2EzOCAzOCAwIDAxMCA3NmMtOTkgMC0xNzktNzgtMTc5LTE3M3YtMjdjMC05NiA4MC0xNzMgMTc5LTE3M2g0MmEyODUgMjg1IDAgMDEyODYtMjM5Yzc5IDAgMTU3IDMzIDIxNCA5MiA0NCA0NyA3MCAxMDUgNzQgMTYzIDYzIDI3IDEwNSA4OCAxMDUgMTU3djI3YzAgOTUtODAgMTczLTE3OSAxNzN6Ii8+PC9nPjwvc3ZnPg==", nl = {
  name: "IotaAvatarViewer",
  props: {
    showUpload: Boolean,
    nickname: {
      type: String
    },
    img: String,
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    radius: {
      type: Number,
      default: 4
    },
    color: {
      type: String,
      default: "gray"
    },
    userStyle: {
      type: Object,
      default() {
      }
    }
  },
  render() {
    let {
      userStyle: r,
      showUpload: e,
      nickname: t,
      img: n,
      width: i,
      height: s,
      radius: a,
      color: o
    } = this;
    if (r === void 0) {
      r = {}, o && _c.test(o) ? r.backgroundColor = o : r.backgroundColor = this.color;
      let h = Math.min(i, s) * 0.618;
      r.borderRadius = a >= 0 ? a > h ? h : a : h, r.borderRadius = `${r.borderRadius}px`, r.fontSize = `${h}px`, r.width = `${i}px`, r.height = `${s}px`, r.lineHeight = `${s}px`, r.display = "block";
    }
    let l = {
      margin: "auto",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      maxHeight: "100%",
      maxWidth: "100%"
    }, c = Object.assign({}, r);
    c.position = "absolute", delete c.backgroundColor, c.left = "0", c.top = "0", e = e === void 0 ? !n && !t : e;
    let u = _e("img", {
      class: "upload",
      src: vc,
      style: c
    }, null);
    return _e("div", {
      class: "iota-avatar-viewer",
      style: r
    }, [n ? _e("img", {
      alt: t,
      src: n,
      style: l
    }, null) : _e("div", {
      style: r
    }, [t ? t[0] : e ? null : ""]), e ? u : null]);
  }
};
const xc = {
  name: "IotaRawAvatar",
  props: {
    uploadImg: Function,
    width: Number,
    height: Number,
    img: String,
    tips: Array,
    disabled: Boolean,
    showUpload: Boolean,
    color: String,
    radius: Number
  },
  methods: {
    onClick() {
      let r = document.createElement("input"), e = this;
      r.type = "file", r.accept = "image/*", this.disabled || (r.addEventListener("change", function() {
        let t = r.files;
        e.uploadImg && e.uploadImg(t[0]);
      }), r.click());
    }
  },
  render() {
    return _e("div", {
      onClick: this.onClick
    }, [_e(nl, {
      img: this.img,
      height: this.height,
      width: this.width,
      color: this.color || "transparent",
      showUpload: this.showUpload,
      radius: this.radius
    }, null), this.tips ? _e("ol", {
      style: {
        textAlign: "left"
      }
    }, [this.tips.map((r, e) => _e("li", {
      key: e
    }, [r]))]) : _e("div", null, null)]);
  }
}, yc = ["disabled"], bc = /* @__PURE__ */ Wn({
  __name: "CountDownButton",
  props: {
    timeout: {
      type: Number,
      default: 60
    },
    countingTextPrefix: String,
    countingTextPost: String,
    text: String,
    disabled: Boolean
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = r, n = Jo({
      counting: !1,
      seconds: 0
    }), i = pi(() => t.disabled || n.counting), s = () => {
      n.seconds = n.seconds - 1, n.seconds > 0 ? setTimeout(() => {
        s();
      }, 1e3) : n.counting = !1;
    }, a = () => {
      e("click"), n.counting = !0, n.seconds = t.timeout, s();
    };
    return (o, l) => (qt(), bn("button", {
      onClick: a,
      class: "button",
      disabled: qi(i)
    }, mi(n.counting ? `${r.countingTextPrefix || ""}(${n.seconds})s${r.countingTextPost || ""}` : r.text), 9, yc));
  }
});
const Mc = /* @__PURE__ */ un(bc, [["__scopeId", "data-v-901406df"]]), wc = Wn({
  name: "AScrollTable",
  setup(r, {
    attrs: e,
    slots: t,
    expose: n
  }) {
    const i = Ye();
    n({
      container: i
    });
    const s = Ye(), a = Ye(window.location.pathname), o = () => `ascrollTable_${a.value}`, l = () => {
      const p = localStorage.getItem(o());
      return p ? parseInt(p) : 1;
    }, c = (p) => {
      localStorage.setItem(o(), p.toString());
    }, u = () => {
      a.value = window.location.pathname;
    }, h = () => {
      if (i.value) {
        let f = i.value.querySelector(".ant-table-wrapper").clientHeight;
        const v = i.value.querySelector(".ant-table-thead");
        v && (f = f - v.clientHeight), s.value = f;
      }
    }, d = pi(() => {
      let p = null;
      return e.scroll && (p = e.scroll, p = p.x || "100%"), p;
    });
    ks(() => {
      window.addEventListener("resize", h), window.addEventListener("popstate", u), Ir(() => {
        h();
      }), setTimeout(h, 1e3);
    }), Vl(() => {
      window.removeEventListener("resize", h), window.removeEventListener("popstate", u);
    }), Gl(() => {
      window.addEventListener("resize", h), window.addEventListener("popstate", u), Ir(() => {
        h();
      });
    }), Wl(() => {
      window.removeEventListener("resize", h), window.removeEventListener("popstate", u);
    });
    const m = (p, f, v, S) => {
      if (p && p.current && c(p.current), e.onChange)
        if (p && p.current && p.pageSize) {
          const y = (p.current - 1) * p.pageSize;
          if (typeof e.onChange == "function") {
            const b = {
              ...p
            };
            b.offset = y, e.onChange(b, f, v, S);
          }
        } else
          e.onChange(p, f, v, S);
    }, g = pi(() => {
      const p = {
        ...e
      };
      if (p.pagination !== !1) {
        const f = l();
        typeof p.pagination != "object" ? p.pagination = {} : p.pagination = {
          ...p.pagination
        }, p.pagination.current || (p.pagination.defaultCurrent = f);
      }
      return delete p.onChange, p;
    });
    return () => _e("div", {
      ref: i,
      class: "scroller"
    }, [_e(Yl, Qo({
      class: "table-fixed flex-1"
    }, g.value, {
      onChange: m,
      scroll: {
        y: s.value,
        x: d.value
      }
    }), t)]);
  }
});
const Sc = /* @__PURE__ */ un(wc, [["__scopeId", "data-v-211cfc26"]]), Tc = Wn({
  name: "APagination",
  props: {
    onChange: {
      type: Function
    }
  },
  setup(r, {
    attrs: e
  }) {
    const t = e.current ? Ye(e.current) : Ye(1), n = e.pageSize ? Ye(e.pageSize) : Ye(10);
    return {
      attrs: e,
      onPageChange: (o, l) => {
        t.value = o, n.value = l, r.onChange && r.onChange(t.value, n.value || l);
      },
      watchPaginationCurrent: (o) => {
        const l = o.target;
        t.value = Number(l.value);
      },
      jumpPagination: () => {
        r.onChange && r.onChange(t.value, n.value);
      }
    };
  },
  render() {
    const {
      attrs: r,
      watchPaginationCurrent: e,
      onPageChange: t,
      jumpPagination: n
    } = this;
    return _e("div", {
      class: "pagination-container"
    }, [_e("div", {
      class: "pagination-total"
    }, [_e("span", null, [Os("\u6BCF\u9875\u663E\u793A")])]), _e(el, Qo(r, {
      onChange: t,
      "show-less-items": !0
    }), null), _e(Kl, {
      class: "pagination-input",
      onChange: e
    }, null), _e(Zl, {
      class: "pagination-button",
      onClick: n
    }, {
      default: () => [Os("GO")]
    })]);
  }
});
const Ac = /* @__PURE__ */ un(Tc, [["__scopeId", "data-v-e43353ee"]]), Ec = {
  name: "IiPaginationSelect",
  components: {
    APopover: $l,
    AInputSearch: Jl,
    APagination: el
  },
  props: {
    className: {
      type: String
    },
    showPagination: {
      type: String,
      validator: function(r) {
        return ["top", "bottom", "both", "none"].indexOf(r) !== -1;
      },
      default: "bottom"
    },
    pageSizeOptions: {
      type: Array,
      default: function() {
        return ["20", "40", "60", "80"];
      }
    },
    size: {
      type: String,
      validator: function(r) {
        return ["default", "large", "small"].indexOf(r) !== -1;
      },
      default: "small"
    },
    fetchData: {
      type: Function,
      default: void 0
    },
    customRender: {
      type: Function,
      default: function(r) {
        return r[this.itemName];
      }
    },
    dataKey: {
      type: String,
      required: !0
    },
    itemId: {
      type: String,
      default: "id"
    },
    itemName: {
      type: String,
      default: "name"
    },
    value: {
      type: Object
    },
    placeholder: {
      type: String
    },
    searchEnable: {
      type: Boolean
    },
    allowClear: {
      type: Boolean
    },
    searchPlaceholder: {
      type: String
    },
    minWidth: {
      type: String
    },
    width: {
      type: String
    },
    popWidth: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    showPreviewItem: {
      type: Boolean,
      default: !1
    },
    renderPreviewItem: {
      type: Function,
      default: function(r) {
        return _e("span", null, [r[this.itemName]]);
      }
    }
  },
  data() {
    return {
      total: 0,
      limit: 20,
      page: 1,
      dataSource: [],
      isOpen: !1,
      searchCondition: void 0
    };
  },
  methods: {
    refetchData() {
      let r = this.limit, e = this.page, t = this.searchCondition;
      typeof this.fetchData == "function" && this.fetchData(r, (e - 1) * r, t).then((n) => {
        this.dataSource = n[this.dataKey], this.total = n.total || n.count;
      }).catch(() => {
      });
    },
    onPageChange(r) {
      this.page = r, this.refetchData();
    },
    onLimitChange(r, e) {
      this.limit = e, this.page = 1, this.refetchData();
    },
    handleVisibleChange(r) {
      this.disabled || (this.isOpen = r, this.dataSource = [], r && this.refetchData());
    },
    onChange(r) {
      let e = this;
      return (t) => {
        t.stopPropagation(), e.isOpen = !1, e.$emit("change", r);
      };
    },
    onClear(r) {
      r.stopPropagation(), this.isOpen = !1, this.$emit("change", void 0);
    },
    onSearch() {
      this.page = 1, this.refetchData();
    },
    onSearchChange(r) {
      this.searchCondition = r.target.value;
    },
    renderOptions() {
      let r = this.dataSource, e = this.value || {}, t = this.itemId, n = !!this.searchEnable, i = this.searchPlaceholder;
      return r.length > 0 ? _e("div", null, [_e("div", {
        class: "select__list",
        style: {
          minWidth: this.minWidth
        }
      }, [n ? _e(Rn("a-input-search"), {
        class: "select__search",
        placeholder: i,
        onSearch: this.onSearch,
        value: this.searchCondition,
        onChange: this.onSearchChange
      }, null) : null, _e("ul", {
        class: "ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light ant-dropdown-content",
        style: {
          margin: 0,
          padding: 0
        }
      }, [r.map((s, a) => {
        let o = e ? e[t] === s[t] : !1;
        return this.showPreviewItem ? _e(Rn("a-popover"), {
          tigger: "hover",
          placement: "left",
          content: this.renderPreviewItem(s),
          autoAdjustOverflow: !0
        }, {
          default: () => [_e("li", {
            key: a + "",
            unselectable: "unselectable",
            class: ["ant-dropdown-menu-item", o ? "ant-select-dropdown-menu-item_selected" : ""],
            role: "menuitem",
            "aria-selected": "false",
            onClick: this.onChange(s),
            style: {
              userSelect: "none"
            }
          }, [typeof this.customRender == "function" ? this.customRender(s) : s[this.itemName]])]
        }) : _e("li", {
          key: a + "",
          unselectable: "unselectable",
          class: ["ant-dropdown-menu-item", o ? "ant-select-dropdown-menu-item_selected" : ""],
          role: "menuitem",
          "aria-selected": "false",
          onClick: this.onChange(s),
          style: {
            userSelect: "none"
          }
        }, [typeof this.customRender == "function" ? this.customRender(s) : s[this.itemName]]);
      })])]), _e("div", {
        class: "select__pagination"
      }, [_e(Rn("a-pagination"), {
        onChange: this.onPageChange,
        current: this.page,
        total: this.total,
        pageSize: this.limit,
        onShowSizeChange: this.onLimitChange,
        pageSizeOptions: this.pageSizeOptions,
        size: "small",
        showSizeChanger: !0,
        showTotal: (s) => `\u603B\u5171 ${s} \u6761`
      }, null)])]) : _e("div", {
        class: "select__list",
        style: {
          minWidth: this.minWidth
        }
      }, [n ? _e(Rn("a-input-search"), {
        class: "select__search",
        placeholder: i,
        onSearch: this.onSearch,
        value: this.searchCondition,
        onChange: this.onSearchChange
      }, null) : null, _e("ul", {
        class: "ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light ant-dropdown-content",
        role: "menu",
        "aria-activedescendant": ""
      }, [_e("li", {
        unselectable: "unselectable",
        class: "ant-select-dropdown-menu-item-disabled ant-select-dropdown-menu-item",
        role: "menuitem",
        "aria-selected": "false",
        "aria-disabled": "true",
        style: {
          userSelect: "none"
        }
      }, ["\u65E0\u5339\u914D\u7ED3\u679C"])])]);
    }
  },
  render() {
    let r = this.value, e = this.allowClear, t = "";
    switch (this.size) {
      case "large":
        t = "ant-select-lg";
        break;
      case "small":
        t = "ant-select-sm";
        break;
    }
    return _e(Rn("a-popover"), {
      content: this.renderOptions(),
      overlayClassName: "select__popover",
      overlayStyle: {
        minWidth: this.popWidth
      },
      placement: "bottom",
      trigger: "click",
      visible: this.isOpen,
      onVisibleChange: this.handleVisibleChange
    }, {
      default: () => [_e("div", {
        class: [t, "select", this.className || "", "ant-select", this.disabled ? "ant-select-disabled" : "ant-select-enabled", "ant-select-single", "ant-select-show-arrow", this.isOpen ? "ant-select-open ant-select-focused" : "", this.allowClear ? "ant-select-allow-clear" : ""]
      }, [_e("div", {
        class: ["ant-select-selector"],
        tabIndex: "0"
      }, [r && r[this.itemName] ? _e("span", {
        class: "ant-select-selection-item"
      }, [r[this.itemName]]) : _e("span", {
        class: "ant-select-selection-placeholder"
      }, [this.placeholder || "\u8BF7\u9009\u62E9"]), _e("span", {
        class: "ant-select-arrow",
        unselectable: "unselectable",
        style: {
          userSelect: "none"
        }
      }, [_e("span", {
        role: "img",
        "aria-label": "down",
        class: "anticon anticon-down ant-select-suffix"
      }, [_e("svg", {
        focusable: "false",
        class: "",
        "data-icon": "down",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "64 64 896 896"
      }, [_e("path", {
        d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
      }, null)])])]), e && this.value ? _e("span", {
        unselectable: "unselectable",
        class: "ant-select-clear",
        onClick: this.onClear,
        style: {
          userSelect: "none",
          display: "block"
        }
      }, [_e("span", {
        role: "img",
        "aria-label": "close-circle",
        class: "anticon anticon-close-circle"
      }, [_e("svg", {
        focusable: "false",
        class: "",
        "data-icon": "close-circle",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "64 64 896 896"
      }, [_e("path", {
        d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"
      }, null)])])]) : null])])]
    });
  }
};
const Cc = /* @__PURE__ */ un(Ec, [["__scopeId", "data-v-18b72dc7"]]), Lc = ["onContextmenu"], Rc = /* @__PURE__ */ Wn({
  __name: "ImageCustomizeEditor",
  props: {
    container: { default: null },
    mode: { default: "view" },
    id: { default: "" },
    name: null,
    templateBasicParameters: { default: () => ({
      color: "",
      image: "",
      width: 0,
      height: 0,
      cornerSize: 20
    }) },
    colorName: null,
    scale: null,
    customizedAreaScale: { default: 1 },
    autoScale: { type: Boolean, default: !0 },
    customArea: { default: () => ({
      id: 1,
      bgWidth: null,
      bgHeight: null,
      dpi: null,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      scale: 1,
      json: void 0
    }) },
    customizedImage: null,
    autoScaleCustomImage: { type: Boolean, default: !1 },
    defaultFont: { default: "SimSun" }
  },
  emits: ["ready", "customized", "customActiveObject", "imgLoading", "dragDrop"],
  setup(r, { expose: e, emit: t }) {
    const n = r, i = Ye({
      title: "",
      backgroundColor: "",
      color: ""
    }), s = () => {
      const P = new Int32Array(256);
      for (let L = 0; L < 256; L++) {
        let _ = L;
        for (let E = 0; E < 8; E++)
          _ = _ & 1 ? 3988292384 ^ _ >>> 1 : _ >>> 1;
        P[L] = _;
      }
      return P;
    };
    let a = null;
    const o = (P) => {
      let L = -1;
      a || (a = s());
      for (let _ = 0; _ < P.length; _++)
        L = a[(L ^ P[_]) & 255] ^ L >>> 8;
      return L ^ -1;
    }, l = () => {
      Hi.error("\u9884\u89C8\u56FE\u7247\u4E0D\u652F\u6301\u4FDD\u5B58\u54E6");
    }, c = (P) => {
      const L = "p".charCodeAt(0), _ = "H".charCodeAt(0), E = "Y".charCodeAt(0), U = "s".charCodeAt(0), I = P * 39.3701, N = new Uint8Array(21);
      N[0] = 0, N[1] = 0, N[2] = 0, N[3] = 9, N[4] = L, N[5] = _, N[6] = E, N[7] = U, N[8] = I >>> 24, N[9] = I >>> 16, N[10] = I >>> 8, N[11] = I & 255, N[12] = N[8], N[13] = N[9], N[14] = N[10], N[15] = N[11], N[16] = 1;
      const J = o(N.slice(4, 17));
      return N[17] = J >>> 24, N[18] = J >>> 16, N[19] = J >>> 8, N[20] = J & 255, N;
    }, u = (P, L) => {
      const _ = c(L), E = btoa(String.fromCharCode(..._)), U = P.substring(0, 44) + E + P.substring(44), I = atob(U), N = I.length, J = new Uint8Array(N);
      for (let Q = 0; Q < N; Q++)
        J[Q] = I.charCodeAt(Q);
      return J;
    }, h = Ye((n.customArea.scale || 2) * (n.scale || 1)), d = Ye((n.customArea.bgWidth || n.templateBasicParameters.width) * h.value), m = Ye((n.customArea.bgHeight || n.templateBasicParameters.height) * h.value), g = Jo({
      bgWidth: (n.customArea.bgWidth || 0) * h.value,
      bgHeight: (n.customArea.bgHeight || 0) * h.value,
      width: (n.customArea.width || 0) * h.value,
      height: (n.customArea.height || 0) * h.value,
      left: (n.customArea.left || 0) * h.value,
      top: (n.customArea.top || 0) * h.value
    }), p = Ye(""), f = Ye(!1), v = Ye(null), S = Ye(null), y = Ye(null), b = Ye(null), w = Ye(null), D = Ye([]), z = Ye([]);
    let x = [], R = null;
    const k = Ye(null);
    let T, ee, V;
    const H = Ye([]), j = () => {
      let P = 1;
      if (n.container) {
        const L = n.container.offsetHeight;
        P = n.container.offsetWidth / d.value, P * m.value > L && (P = L / m.value);
      }
      return P;
    }, G = Ye(1);
    G.value = j();
    const te = Ye({
      width: `${d.value}px`,
      height: `${m.value}px`
    });
    n.mode === "edit" ? te.value.transform = `scale(${G.value})` : te.value.zoom = G.value;
    const Z = Ye(), re = () => {
      te.value.width = `${d.value}px`, te.value.height = `${m.value}px`, G.value = j(), n.mode === "edit" ? te.value.transform = `scale(${G.value})` : te.value.zoom = G.value;
    };
    Wt(() => n.templateBasicParameters.image, () => {
      oe();
    }), Wt(() => n.container, () => {
      G.value = j();
    }), Wt(() => n.customArea.id, (P) => {
      if (!P || !T)
        return;
      h.value = (n.customArea.scale || 2) * (n.scale || 1), d.value = (n.customArea.bgWidth || n.templateBasicParameters.width) * h.value, m.value = (n.customArea.bgHeight || n.templateBasicParameters.height) * h.value;
      const L = 1 / G.value, _ = {
        bgWidth: (n.customArea.bgWidth || 0) * h.value,
        bgHeight: (n.customArea.bgHeight || 0) * h.value,
        width: (n.customArea.width || 0) * h.value,
        height: (n.customArea.height || 0) * h.value,
        left: (n.customArea.left || 0) * h.value,
        top: (n.customArea.top || 0) * h.value
      };
      Ee.set({
        left: _.left - L,
        top: _.top - L,
        width: _.width + L,
        height: _.height + L
      });
      const E = T.getObjects("rect")[0];
      E && E.set({
        fill: "rgba(0, 0, 0, 0)",
        scaleX: 1,
        scaleY: 1,
        left: _.left - L,
        top: _.top - L,
        width: _.width,
        height: _.height
      }), Ae.set({
        scaleX: 1,
        scaleY: 1,
        left: _.left - 2 * L,
        top: _.top - 2 * L,
        width: _.width,
        height: _.height
      }), T.renderAll();
    }), Wt(() => n.customizedImage, (P) => {
      P && T && (h.value = (n.customArea.scale || 2) * (n.scale || 1), d.value = (n.customArea.bgWidth || n.templateBasicParameters.width) * h.value, m.value = (n.customArea.bgHeight || n.templateBasicParameters.height) * h.value, Object.assign(g, {
        bgWidth: (n.customArea.bgWidth || 0) * h.value,
        bgHeight: (n.customArea.bgHeight || 0) * h.value,
        width: (n.customArea.width || 0) * h.value,
        height: (n.customArea.height || 0) * h.value,
        left: (n.customArea.left || 0) * h.value,
        top: (n.customArea.top || 0) * h.value
      }), T.remove(T.getObjects("image")[0]), we(P));
    }), Wt(() => n.templateBasicParameters.color, () => {
      T && (n.mode === "edit" && Ee.set("stroke", "#" + Y(n.templateBasicParameters.color)), T.setBackgroundColor(
        n.templateBasicParameters.color,
        T.renderAll.bind(T)
      ));
    }), Wt(() => n.customizedAreaScale, (P) => {
      !T || !P || (yt(P), T.renderAll());
    }, {
      immediate: !0
    }), ks(() => {
      window.addEventListener("resize", re), st();
    }), jl(() => {
      window.removeEventListener("resize", re);
      try {
        Ee._removeCacheCanvas(), Ae._removeCacheCanvas();
      } catch (P) {
        console.log(P);
      }
      if (T) {
        We.util.removeListener(T.getElement(), "keydown", xt), T.getObjects().forEach((P) => {
          try {
            We._measuringContext = null, P._removeCacheCanvas();
          } catch (L) {
            console.log(L);
          }
          try {
            delete P.controls.deleteControl;
          } catch (L) {
            console.log(L);
          }
          try {
            delete P.controls.mtr;
          } catch (L) {
            console.log(L);
          }
        }), T.clear();
        try {
          T.removeListeners(), T.dispose(), T.__eventListeners = null;
        } catch (P) {
          console.log(P);
        }
      }
    });
    let $ = null;
    const K = (P) => {
      if (!T)
        return;
      W(!0);
      const L = T.getActiveObject();
      L && L.type === "image" && ($ = L), T.discardActiveObject(), T.getObjects().forEach((I) => {
        I.selectable = !1, I.evented = !1;
      }), p.value = P;
      const E = g.left, U = g.top;
      P === "square" && (R = new We.Rect({
        left: E,
        top: U,
        width: 500,
        height: 500,
        fill: "rgba(255,0,255,0.3)",
        stroke: "purple",
        strokeWidth: 2,
        selectable: !0,
        hasControls: !0,
        hasBorders: !0,
        lockRotation: !0,
        hasRotatingPoint: !1
      }), R.setControlsVisibility({
        mt: !0,
        mb: !0,
        ml: !0,
        mr: !0,
        mtr: !1
      }), delete R.controls.deleteControl, T.add(R));
    }, W = (P = !1, L = !1) => {
      R && T.remove(R), x.length && x.forEach((_) => T.remove(_)), P || (T.getObjects().forEach((E) => {
        E.type != "rect" && (E.selectable = !0, E.evented = !0);
      }), $ && !L && T.setActiveObject($)), $ = null, R = null, x = [], z.value = [], p.value = "";
    }, le = () => {
      const P = R;
      if (!$ || !$.left || !$.top || !P || !P.left || !P.top || !P.width || !P.height || !P.scaleX || !P.scaleY || !T)
        return Hi.info("\u8BF7\u5148\u4E0A\u4F20\u56FE\u7247\u5E76\u7ED8\u5236\u533A\u57DF\uFF01"), !1;
      const L = P.left, _ = P.top, E = P.top, U = P.left, I = P.width * P.scaleX, N = P.height * P.scaleY, J = $.getBoundingRect(), Q = document.createElement("canvas");
      Q.width = I, Q.height = N;
      const se = Q.getContext("2d"), xe = P.calcTransformMatrix();
      return se ? (se.save(), se.translate(-L, -_), se.beginPath(), p.value === "polygon" ? ae(P, xe, se) : p.value === "square" && se.rect(P.left, P.top, P.width * P.scaleX, P.height * P.scaleY), se.clip(), se.drawImage(
        $.getElement(),
        J.left,
        J.top,
        J.width,
        J.height
      ), se.restore(), We.Image.fromURL(Q.toDataURL("image/png"), (ce) => {
        T.remove($), T.remove(P), ce.set({ top: E, left: U, width: I, height: N }), ce.clipPath = Ae, T.add(ce), $ = ce, t("customActiveObject", $, { realLeft: g.left, realTop: g.top }), W();
      }), !0) : !1;
    }, ae = (P, L, _) => {
      const E = P, U = E.points.map(
        (I) => We.util.transformPoint(
          new We.Point(I.x - E.pathOffset.x, I.y - E.pathOffset.y),
          L
        )
      );
      _.moveTo(U[0].x, U[0].y), U.forEach((I) => _.lineTo(I.x, I.y)), _.closePath();
    }, ue = (P) => Math.round(Number(P) / h.value / 26.2 * 25.4), Y = (P, L = -5) => {
      P ? P = P.replace("#", "") : P = "ffffff";
      const _ = [];
      let E = Math.floor(15 + (L || 0));
      (E < 0 || E > 15) && (E = 15);
      for (let U = 0; U < P.length; U++) {
        const I = parseInt(P.charAt(U), 16);
        let N = parseInt((E - I).toString(), 10);
        N < 0 && (N = Math.abs(N)), _.push(N.toString(16));
      }
      return _.join("");
    }, Oe = document.createElement("img");
    Oe.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAACRFJREFUWEe1WVtzHFcR7j6X0cqWdle2Zcm2rJtlYmJDCrCT4oEUcSUEiqIIbzzBO4/8mPBK8ZQ3CDxwSQipUJUisbkUOMaObd0sX1bX3ZVsrWbOOU194z2u0Xp1sYlP1dSsvTs93/m6+zvdLaZ9LBExtVqtp1QqDXnvv6SUOh1CmFJKjRLRcSIaIKI+IjLM7EVki4jWiahBRLUQwoJS6mYI4XOt9edpmi4NDg62mNnt9Xre6wciojc2Ng5lWTZMRGMi8oLWepKIJgCOmYeZuUJEpYKtQEQbRNQMISwT0T0imvHe32Lm60Q0b62t9fX1rWBDu2HYFaCIqEajMS4iL4nIK0R0Dqwxc7/WuqyUOqiU6lFKEfN2UyJCIQRcrRDCQ+99U0QA+DYRfcbMnzDzvyqVyiwzY0Nd144A6/X6gIiMhxAuKKVewcXMU1rrHoDRWhOAxaub9TbAHKj3ngDae78FJonokxDC35RSl5h5tlqtrnWz0RXg2tpalZm/4b1/VSn1La31aa31kDHGAhgWgGF1Mtf5EoDCAkgsAHXOZd77mvf+Rgjhr1rrj0Tk7wMDA/XO57cBFBFuNBpVEfmqiHyXmS8aY76ite41xjxmba+43e37yKZzDmA3nXP/EZEPmPkPzPzvSqVSZ+ZHuwIBRWNwKxF9PYTwOjO/Ya09Y4w5CHDd4uxZgcb4BEjn3IMsy66JyHtKqfeJ6B9Fdz8GKCI99Xr9yyGEHzHzm0mSnIvgoluLgNI0pa2tLWq1WoTPcF10IzaDTVlrqVQq5Rc+d662u3OQaZpeEZE/KqV+Xa1W/8vMkKpHDIpI0mw2R51zF5VSP9ZaX0iSpA9GY6x1gqvX67S6ukq4P3jwIAeKF8YE6unpoYMHD1K1WqVDhw7RwMBAV5DYVJZl2OSG9/5SCOEdY8wH5XJ5nplTRtytr69D577NzG8ZY143xgwnSZLHXHEBAFgDqKWlJWo0GrS5uZkDiwwCIC4wiAtA+/r6cqAAic+dbOJZeME5d98592cR+Y219sP+/v4VXlxc7DPGTIrIT7XWP7TWTiRJomC8c0VwtVqN1tbWcpceOHAgfymAxDiNG3n48CFtbGzk7MLekSNHaGRkJL93Zj/iMU3TkGXZrPf+XWb+pXNuGlk7lWXZWaXUz4wxF5MkMWCvm3xEgCsrKzlzYCK6r7e393E4ADi+B9P47fLycg4Udo8dO0YnTpygSqWyjUkkDlhM09R57// ivX/bWnuFV1dXv09EZ7XWPzHGnIWRbuxFDQNIXGAJv4tJ0E3/YhKB7cXFxZx1bPzo0aM0NjaWb6642iwC5FUR+VV+4qysrPycmSEn37PWjgBgt8R4VknBc0gCsDg/P08ID7B96tSp3N1RwqKYg8Usyxacc78Xketg8G1UJ8aYC9baCty21+nwLGDx4rt379L09HTugaGhodzVSB7Eb1tN8s1kWdZ0zn0aQrgJgL9FdWKtnbLW9iBznwdAAIAc3b59O3c3vDQ4OEgnT57MEy0uuDnLsjTLshve+xleW1u7pLUeS5LkiLWWv2j3dsoUXL2wsJDHY39/P01NTdHhw4cf/6yti7K1tbUcQpgDwBta6xOlUik/b4vsIRMhFVjYJWLnWVYU46gCcDVYRLwjWeBuhBb+jXtbpnBO3wHAu1rr4d7eXi5mL8Ddv3+f7t1DrUm5PAwPDz8TSLhtfX09lx0wCHD4DDLAHlwNEY9Cjv9vtVqSZdl9AKxprY+CHQAEerCGk2J2djYPbDxw/PjxfLcwBja7nc87sRsBwiZiEJkMwFhwMzaOjIb8QPTbAHGyLHO9Xr8HBqFnAAjVh6GZmZncWLPZzB8ol8u5kfHx8dwQfr/fFV2Ms3tubi63CwaxINhIFGwebMLFEG14MAKc1VqPlEolDVbwBVwAQ3Av2MQDYA07hSHci5m3X6CwBfbu3LmTnzBYAAW5QRxGm2B8c3NTvPe5i69orUdLpVI/Mhh6BTnADmEMbEKbwCCAgT1oFxh8WjkCk/AQMjgyCFu4ikcl3tdqtTa993fg4o+VUuNJkgxrrTnWdNgFAhruwDmK2ABAxCDKqKeJwU6GAQCeip4pVjdRZtI0Xfbez0Go31VKTSZJgtMk79CiFiKQkSRgEckDdyBesOP/dwEcrqLutpuq7UK9urr6C6XUVLejDu6GKyCscDfcOjExkWc0NOtpFpgBAITFTocBvn/iqNutWIgPAOCtW7fy+EEwj46OPs64/YBEuCBBAHKn6me3YmHPcivKA7IboCGoSBbcEdzxsO8Ei5MDsYbKG+EC1qMod9tY13JrPwUraMdLIA+QHrgeSYPKGHHZmYXYBBjDM7FgBVBsaHJyMvdC59qhYP2ss+R/y1qLjH6i5IeBeNDjjt3CXchogC3WkXBllCsoAMDhEADrSLJicVCsYjpL/ryaKTRNrxWapqFuTROYxAujjsV+o92Eb2s7IUOxaYrdXTxrO0Oi0DTVnHPvb2uasIN22znmvb/IzGg7z+/WdgIoQHZrO2EP4CK7OMpi39It8zvazssi8o7WGm3nXN52RorbjfuLaNyVUm8aY85Zaw/EkUc3sUVWd2vcY9sJQGALYLuBi417lmUPnXNXQgixcb+6rXGPL8fQyHt/Xin1BjN/xxhzxlpbep6jjyzLWs45jD7+FEJ4T2t9uThEemK61Wg0DoUQXiKiHxDRa8aYF7XWyXMaHqXOuashhA+11r9rzwtXi97qOn5rNpuHnXMYWL7KzN9k5lPW2qNx/BanBzC0V8EQx2/xaIvjtyzLFkVkWkQ+JqKPjDGflstlTGO3rR0HmAAZQpgIIZxnZoB9WWt9Cud1PK52G2BGQMUhJv7PORcHmJdEBAPMy0qpmXK5/Kj+2i/AdnbrRqOB7P4aM7+MBl8pNYbxLzPHEbAtjuaKjLXP3yyE8ADjX+99I4Qwj4ZcRNCs/bM9At5xTr3fIfrhLMsg/+NEdIaIMOGfZOZjRDQIsB1DdOyvBVBEtCQi90II00R0k4iuEdHsFzJEL0iQWVpaKiVJMhRCeEFEzjDzaWYeISIAR/2FP0PEEidtT/lR19dEZEFEbjDzNaXU9TRNa/v9M8T/ADfrjLvM3d2xAAAAAElFTkSuQmCC";
    const be = document.createElement("img");
    be.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAACIVJREFUWEfFWVtvXFcVXmtfjseJPR4ncewkTmynCTFNoAKSVjxQ0ailIIQobzzBO4/8mPKKeOobFB64tJSqSBVtwkWQhqQ2tuM4cSaO52Ynds7Zey/0ncw2J9OxZ1y1YktHHmnm7P3tb631rYuZ+lgiYqrV6kCpVBr33n9BKXU2hHBGKXWKiI4T0SgRDRGRYWYvIo+JaIOImkRUDSGsKKXmQwgfa60/TtN0bWxsbJuZXa/judcPRERvbm4eyrJsgoimROSc1vo0Ec0AHDNPMPMIEZUKewUi2iSiVgjhARGtEtGi9/4/zHyTiJattdWhoaF1XGgvDHsCFBHVbDanReQ5EXmBiC6ANWYe1lqXlVIHlVIDSilifnorEaEQAp7tEMIj731LRAD4NhF9xMwfMPM/RkZGlpgZF+q6dgXYaDRGRWQ6hHBJKfUCHmY+o7UeABitNQFYfLrt3gaYA/XeE0B77x+DSSL6IITwF6XUFWZeqlQq9W57dAVYr9crzPw17/2LSqlvaK3Paq3HjTEWwLAADKuTuc5DAAoLILEA1DmXee+r3vu5EMKftdbvichfR0dHG53vPwVQRLjZbFZE5Msi8m1mvmyM+ZLWetAYs8NaL7/d6/vIpnMOYLecc/8SkXeY+XfM/M+RkZEGMz+5FQgobgazEtFXQwgvM/Mr1tpZY8xBgOvmZ58WaPRPgHTOPcyy7IaIvKWUepuI/lY09w5AERloNBpfDCH8gJlfTZLkQgQXzfppAe32XtvcOcg0Ta+JyO+VUr+sVCr/ZmZI1RMGRSRptVqnnHOXlVI/1FpfSpJkyFq742ufNbi4H0yeZRmlabrpvb8SQnjDGPNOuVxeZuaU4XcbGxvQuW8y82vGmJeNMRNJkuQ+h5WmKT169Ch39FKplD8xSPoFDnNub2/nYPDu4OAg4YwYODjDOXfPOfdHEfmVtfbd4eHhdb5// /6QMea0iPxYa/19a+1MkiQKfhdXs9mku3fv5gcMDw/TkSNH8r/9mh6gWq0Wra+v08OHD+ngwYM0Pj5OIyPQ9ycLF0jTNGRZtuS9f5OZf+6cW0DUnsmy7LxS6ifGmMtJkhjcrCgf9XqdlpaWaG1tjQD86NGjdPz4capUKj2ZhJ/VajW6c+cOPXiApEL5+6dOncrfjwuBAxbTNHXe+z9571+31l7jWq32XSI6r7X+kTHmPMAV2cMGMO/q6irdunUrPwzmmZ6eppMnT9LQ0NCuIOESjUaDbt++TcvLy/T48WMaGxvLwU1MTOT7FFebRYC8LiK/yDPO+vr6T5kZcvIda+0kAHb6F1jY2NiglZWV/KDNzc3cPJOTkzmT+NztHYADc3gP75TLZZqamqITJ050vRguBBazLFtxzv1WRG6CwddRnRhjLllrRxC53bIDbgc/ApM4EH4J9nAggMInI8jIXLwQLDA6Opr/7tixY/l7nVZqq0keRFmWtZxzH4YQ5gHw16hOrLVnrLUDcPzd0hcOBhMwGcwdmYSpwSRAYnVjDi4Rmdtt/3auBsA0y7I57/0i1+v1K1rrqSRJjlhruZd8AGSM6sgkgIFJRCa+B8u4BCIWzOECYA4m7pW727ooaZo+8N7fAsA5rfWJUqmU59teG4ChyCQAgkk4Pw6HL4IFMAh2Dxw4kAdEL+aKgYL325q55b2/A4B3tdYTg4OD3M0vdhNigIRPQh/v3buXgwJQLAj5oUOH8kjF0w9zndG8tbUl3vt7AFjVWh9FyO8HYNwQsrOwsEBzc3M5WFgAjM3OzuZSVBTj/WSdra0tVDsPuNForCqlJnBrRPB+F8R3cXGR5ufnc9/DQsCcO3eOZmZmnhLjfveGiXcA1uv1Ja31ZKlU0vsBCG2EWcFatVrNdRIaBh+CliJLwLwACxP3Cr69THwNfUapVBreTQM7b17UOUQrtAvRGoMEZgfggYGBHZ3cK+PsGSSNRuN9Zp5OkmQCMtOrAIjMFTME2OqUGWQcgAR7USe7ZZxul8+y7H8yU6vV3lRKnU6S5Gw/Qg2zdmaIqHNRqKNOgl18jjrZK3d3FeparfYzpdSZvVJd1CYcBubwxNzaLUPABcBezDgQ7Ji7o2D3ner6KRYQVQAXmUOE9coQMeNEV4hMQrhj7u50p92KhZ7lFhhAtMKvYGIUnLFIgPPvlbsjk6gnIeSHDx/e8Vdkmp7lVr8FK1IaNA+RjoITpoLZeqVGsIKCFxdERQ13QU0IFvsoWD/qLPlfs9Yioj9R8kPrUPIjKpHG+pWNWM6DSQCFNZC1cEnsFVe3kj+vZgpN00uFpmm8s2kCOLABbcOzH+EFCMgTTAwxj01TTAz4rt00VZ1zbz/VNLULRbSdU977y8yMtvPi/6ntvCoib2it0XbeytvOQtOCxv1ZNO5KqVeNMRestQfiyKPfPLqf38XGPcuyR865ayGE2Lhff6pxj5tiaOS9v6iUeoWZv2WMmbXWlj7P0UeWZdvOOYw+/hBCeEtrfbU4RPrEdKvZbB4KITxHRN8jopeMMc9qrZPPaXiUOueuhxDe1Vr/pj0vrBWt0HX81mq1DjvnMLB8kZm/zszPWGuPxvEbpCXKSy+ZieM3/I2pDOO3LMvui8iCiLxPRO8ZYz4sl8tPGufC2nWACZAhhJkQwkVmBtjntdbPGGPyAWZxeNktoiOg4hCznTLjAPOKiGCAeVUptVgul9e7+W+vEbBuNpuI7q8w8/No8JVSUxj/MnMcAdviaK7IGMCJSBZCeIjxr/e+GUJYRkMuImjW/t4eAe86p+53iH44y7JxIpomolkiwoT/NDMfI6IxgO0YooOMbYAiojURWQ0hLBDRPBHdIKKlz2SIXpAgs7a2VkqSZDyEcE5EZpn5LDNPEhGAY8iCf0M8GVcRpe0pP0a6VRFZEZE5Zr6hlLqZpmm1339D/BeEIju4BNbdgAAAAABJRU5ErkJggg==";
    const Ce = (P, L) => function(_, E, U, I) {
      const N = 20 / L;
      _.save(), _.translate(E, U), _.rotate(We.util.degreesToRadians(I.angle)), _.drawImage(P, -N / 2, -N / 2, N, N), _.restore();
    }, ve = (P, L) => {
      const _ = L.target.canvas, E = L.target;
      if (E.type != "rect") {
        const U = E.type != "i-text" && E.getSrc() || !1;
        t("customized", U), i.value.title = "";
      }
      return _ == null || _.remove(E), _ == null || _.requestRenderAll(), !1;
    }, Ae = new We.Rect({
      left: g.left - 2 / G.value,
      top: g.top - 2 / G.value,
      width: g.width + 2 / G.value,
      height: g.height + 2 / G.value,
      absolutePositioned: !0
    }), Ee = new We.Rect({
      left: g.left - 1 / G.value,
      top: g.top - 1 / G.value,
      width: g.width + 1 / G.value,
      height: g.height + 1 / G.value,
      stroke: "#" + Y(n.templateBasicParameters.color),
      strokeDashArray: [10, 10],
      borderDashArray: [20, 20],
      strokeWidth: 1 / G.value,
      fill: "rgba(0, 0, 0, 0)",
      objectCaching: !0,
      scaleX: 1,
      scaleY: 1,
      padding: 100,
      selectable: !1,
      absolutePositioned: !0
    });
    Xl(() => !1);
    const Le = (P) => {
      if (P.transparentCorners = !1, n && n.templateBasicParameters && n.templateBasicParameters.cornerSize) {
        P.cornerSize = n.templateBasicParameters.cornerSize * h.value, P.touchCornerSize = n.templateBasicParameters.cornerSize * 1.2 * h.value, P.cornerStyle = "circle";
        const L = We;
        P.controls.mtr = new We.Control({
          x: 0,
          y: -0.5,
          offsetY: -60 / G.value,
          cursorStyle: "pointer",
          actionHandler: L.controlsUtils.rotationWithSnapping,
          actionName: "rotate",
          render: Ce(Oe, G.value)
        }), n.mode === "edit" ? (P.controls.deleteControl = new We.Control({
          x: 0,
          y: -0.5,
          offsetX: 30 / G.value,
          offsetY: -30 / G.value,
          cursorStyle: "pointer",
          mouseUpHandler: ve,
          render: Ce(be, G.value)
        }), P.setControlsVisibility({
          bl: !0,
          br: !0,
          mb: !0,
          ml: !0,
          mr: !0,
          mt: !0,
          tl: !0,
          tr: !0,
          mtr: !0
        })) : n.customizedImage && P.setControlsVisibility({
          bl: !1,
          br: !1,
          mb: !1,
          ml: !1,
          mr: !1,
          mt: !1,
          tl: !1,
          tr: !1,
          mtr: !1
        });
      }
    }, st = () => {
      try {
        T = new We.Canvas(Z.value, {
          width: d.value,
          height: m.value,
          selection: !1,
          renderOnAddRemove: !0,
          enableRetinaScaling: !1,
          controlsAboveOverlay: !0,
          backgroundColor: n.templateBasicParameters.color
        });
      } catch {
        return;
      }
      oe(), Le(We.Object.prototype), n.mode === "edit" ? (ie(), T.add(Ee), pt()) : n.customizedImage && (n.autoScaleCustomImage ? fe(n.customizedImage) : we(n.customizedImage)), n.customArea.json ? rs(n.customArea.json) : T.renderAll(), t("ready", T);
    };
    let Qe = null, et = null;
    const pt = () => {
      const P = d.value, L = m.value, _ = P / 2, E = L / 2;
      Qe = new We.Line(
        [_, 0, _, 200],
        {
          stroke: "blue",
          strokeWidth: 50,
          strokeDashArray: [10, 20],
          selectable: !1,
          shadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
        }
      ), et = new We.Line(
        [0, E, 200, E],
        {
          stroke: "red",
          strokeWidth: 50,
          strokeDashArray: [10, 20],
          selectable: !1,
          shadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
        }
      ), T.add(Qe), T.add(et);
    }, $e = (P) => {
      Qe && et && (Qe.visible = P, et.visible = P);
    }, ke = (P) => {
      Ee && (Ee.visible = !1, $e(!1)), T.getObjects("rect")[0] && (T.getObjects("rect")[0].visible = !1), P.color ? T.backgroundColor = n.templateBasicParameters.color : T.backgroundColor = void 0, P.templateImage ? ee.visible = !0 : ee.visible = !1, V = T.getActiveObject(), T.discardActiveObject(), T.renderAll();
    }, xt = (P) => {
      const L = P.which || P.keyCode, _ = T.getActiveObject();
      if (_) {
        let { left: E, top: U } = _;
        switch (E = E || 0, U = U || 0, L) {
          case 37:
            _.set({
              left: E - 1
            });
            break;
          case 38:
            _.set({
              left: U - 1
            });
            break;
          case 39:
            _.set({
              left: E + 1
            });
            break;
          case 40:
            _.set({
              left: U + 1
            });
            break;
        }
      }
    }, at = () => {
      T.backgroundColor = n.templateBasicParameters.color, ee.visible = !0, V && T.setActiveObject(V), Ee && (Ee.visible = !0, $e(!0)), T.getObjects("rect")[0] && (T.getObjects("rect")[0].visible = !0), T.renderAll();
    }, A = (P) => {
      if (!P || P.type != "image")
        return i.value.title = "";
      P.scaleX <= 1 && P.scaleY <= 1 && (i.value.title = ""), (P.scaleX > 1.5 || P.scaleY > 1.5) && (i.value.title = "\u56FE\u7247\u88AB\u653E\u5927,\u7565\u5FAE\u5F71\u54CD\u5370\u5237\u6E05\u6670\u5EA6!", i.value.backgroundColor = "#e8b40033", i.value.color = "#e8b400"), (P.scaleX > 2 || P.scaleY > 2) && (i.value.title = "\u56FE\u7247\u50CF\u7D20\u4E0D\u8DB3,\u8F83\u4E3A\u5F71\u54CD\u5370\u5237\u6E05\u6670\u5EA6!", i.value.backgroundColor = "#dc810033", i.value.color = "#dc8100"), (P.scaleX > 3 || P.scaleY > 3) && (i.value.title = "\u56FE\u7247\u50CF\u7D20\u4E0D\u8DB3,\u4E25\u91CD\u5F71\u54CD\u5370\u5237\u6E05\u6670\u5EA6!", i.value.backgroundColor = "#dc340033", i.value.color = "#dc3400");
    }, M = () => {
      Ee.visible = !1, $e(!1), T.renderAll();
      const P = T.toDataURL({
        format: "png",
        quality: 1,
        multiplier: 1 / h.value
      });
      return Ee.visible = !0, $e(!0), T.renderAll(), P;
    }, X = () => {
      if (!T || !v.value || !S.value)
        return;
      const P = Math.sqrt(
        Math.pow(S.value.x - v.value.x, 2) + Math.pow(S.value.y - v.value.y, 2)
      ).toFixed(2);
      b.value = new We.Line(
        [v.value.x, v.value.y, S.value.x, S.value.y],
        {
          stroke: "#" + Y(n.templateBasicParameters.color),
          strokeWidth: 10,
          selectable: !1
        }
      ), w.value = new We.Text(`${ue(P)} mm`, {
        left: (v.value.x + S.value.x) / 2,
        top: (v.value.y + S.value.y) / 2,
        fontSize: 200,
        fill: "red",
        selectable: !1
      }), T.add(b.value, w.value), H.value.push(b.value, w.value), T.renderAll();
    }, ie = () => {
      let P = null, L = 1, _ = [];
      T.on("mouse:down", function(J) {
        const { target: Q, e: se } = J, xe = T.getActiveObject();
        if (t("customActiveObject", xe, { realLeft: g.left, realTop: g.top }), p.value === "polygon" && !xe) {
          const ce = T.getPointer(se);
          z.value.push({ x: ce.x, y: ce.y });
          const Me = new We.Circle({
            left: ce.x,
            top: ce.y,
            radius: 20,
            fill: "red",
            selectable: !1,
            evented: !1,
            originX: "center",
            originY: "center"
          });
          x.push(Me), T.add(Me), T.bringToFront(Me);
        }
        if (f.value) {
          const ce = T.getPointer(se);
          v.value ? S.value || (Math.abs(ce.x - v.value.x) > Math.abs(ce.y - v.value.y) ? S.value = { x: ce.x, y: v.value.y } : S.value = { x: v.value.x, y: ce.y }, y.value && (T.remove(y.value), y.value = null), X(), v.value = null, S.value = null) : (v.value = { x: ce.x, y: ce.y }, y.value = new We.Line(
            [v.value.x, v.value.y, v.value.x, v.value.y],
            {
              stroke: "#" + Y(n.templateBasicParameters.color),
              strokeWidth: 10,
              selectable: !1
            }
          ), T.add(y.value));
        }
        A(Q);
      }), T.on("mouse:dblclick", () => {
        p.value === "polygon" && z.value.length > 1 && (R = new We.Polygon(z.value, {
          fill: "rgba(0,128,255,0.3)",
          stroke: "blue",
          strokeWidth: 10,
          selectable: !0,
          hasControls: !0,
          hasBorders: !0,
          objectCaching: !1
        }), R && (T.add(R), x.forEach((Q) => T.remove(Q)), x = [], T.setActiveObject(R)), z.value = [], T.getObjects().forEach((Q) => {
          Q.type != "rect" && (Q.selectable = !0, Q.evented = !0);
        }));
      }), T.on("mouse:up", function(J) {
        const Q = T.getActiveObject();
        (P != null || L != 1) && (P = null, L = 1), Q && (t("customActiveObject", Q, { realLeft: g.left, realTop: g.top }), t("dragDrop", "flipHorizontal", Q.flipX), t("dragDrop", "flipVertical", Q.flipY)), I(), T.renderAll();
      }), T.on("object:moving", function(J) {
        const { pointer: Q, target: se } = J;
        f.value || N(se);
      }), T.on("object:rotating", function(J) {
      }), T.on("object:scaling", function(J) {
        const { target: Q } = J;
        Q && Q instanceof We.Image && A(Q), t("dragDrop", "scaling", !1);
      }), T.on("mouse:move", function(J) {
        const { target: Q, e: se } = J;
        if (f.value) {
          const Be = T.getPointer(J.e);
          k.value ? k.value.set({ left: Be.x, top: Be.y }) : (k.value = new We.Circle({
            left: Be.x,
            top: Be.y,
            radius: 50,
            fill: "red",
            selectable: !1,
            evented: !1,
            originX: "center",
            originY: "center"
          }), T.add(k.value)), v.value && y.value && y.value.set({ x2: Be.x, y2: Be.y }), T.renderAll();
        }
        if (se.type === "mousemove" || se.targetTouches.length != 2)
          return;
        const xe = se.targetTouches[0], ce = se.targetTouches[1];
        (P === null || L === 1) && (P = E(xe, ce), L = Q.scaleX);
        const ye = E(xe, ce) / P, He = L * ye;
        Q.scaleX = He, Q.scaleY = He, t("dragDrop", "scaling", !1);
      });
      function E(J, Q) {
        const se = Q.pageX - J.pageX, xe = Q.pageY - J.pageY;
        return Math.sqrt(se * se + xe * xe);
      }
      T.on("object:added", function(J) {
      }), We.util.addListener(T.getElement(), "keydown", xt);
      function U(J, Q, se) {
        const xe = new We.Line(
          se ? [J, 0, J, T.getHeight()] : [0, Q, T.getWidth(), Q],
          {
            stroke: se ? "#0000ff" : "#ff0000",
            strokeWidth: 10,
            strokeDashArray: [5, 5],
            selectable: !1,
            evented: !1
          }
        );
        return T.add(xe), _.push(xe), xe.bringToFront(), xe;
      }
      function I() {
        _.forEach((J) => T.remove(J)), _ = [];
      }
      function N(J) {
        if (I(), !J)
          return;
        const Q = J.getCenterPoint();
        U(Q.x, 0, !0), U(0, Q.y, !1), T.renderAll();
      }
      T.on("selection:cleared", function() {
        I(), T.renderAll();
      }), T.on("object:modified", function() {
        I(), T.renderAll();
      });
    }, oe = () => {
      const P = n.templateBasicParameters.image;
      P && We.Image.fromURL(P, function(L) {
        ee && T.remove(ee), ee = L, L.set({
          transparentCorners: !1,
          cornerSize: 0,
          perPixelTargetFind: !0,
          visible: !0,
          selectable: !1,
          evented: !1,
          left: 0,
          top: 0
        });
        let _ = 1;
        g.bgHeight && g.bgWidth && L.width && L.height && (_ = g.bgWidth / L.width, _ * L.height > g.bgHeight && (_ = g.bgHeight / L.height)), L.scale(_), T.setBackgroundImage(L, T.renderAll.bind(T));
      }, {
        crossOrigin: "anonymous"
      });
    }, de = (P, L = !1) => {
      const _ = Math.round(2 / G.value), E = new We.IText(P, {
        left: g.left - _,
        top: g.top - _,
        width: g.width + _,
        height: g.height + _,
        fill: n.templateBasicParameters.color == "#ffffff" ? "#000000" : "#ffffff",
        fontSize: L ? 36 * (h.value + 1) : 36 * h.value,
        fontFamily: n.defaultFont,
        absolutePositioned: !1,
        strokeWidth: 0,
        editable: !L
      });
      E.clipPath = Ae, D.value.push(E), T.add(E), T.setActiveObject(E), T.renderAll();
      const U = { realLeft: g.left - _, realTop: g.top - _ }, I = T.getActiveObject();
      t("customized"), t("customActiveObject", I, U);
    }, Re = (P) => {
      const L = T == null ? void 0 : T.getActiveObject();
      !L || (L.text = P, T.renderAll());
    }, C = (P) => {
      Ee.visible = !P, T.renderAll();
    }, B = (P) => {
      const L = T == null ? void 0 : T.getActiveObject();
      if (!!L) {
        if (P.maximize || P.spreadOut || P.heightMaximization || P.widthMaximization) {
          const _ = L;
          if (_ && _.width && _.height) {
            let E = g.width, U = g.height;
            const I = g.left, N = g.top;
            let J = _.width, Q = _.height, se = 1, xe = E / J, ce = U / Q;
            se = xe, se * Q > U && (se = ce), L.scale(se);
            let Me = I + Math.abs((E - (J || 0) * se) / 2), ye = N + Math.abs((U - (Q || 0) * se) / 2);
            L.top = ye, L.left = Me, Me = I + Math.abs((E - (J || 0) * xe) / 2), ye = N + Math.abs((U - (Q || 0) * ce) / 2), P.maximize && (Q > J ? (se = xe, L.left = Me, L.top = N - Math.abs((U - (Q || 0) * se) / 2)) : (se = ce, L.top = ye, L.left = I - Math.abs((E - (J || 0) * se) / 2)), L.scale(se)), n.customizedAreaScale && n.customizedAreaScale != 1 && (se = se * n.customizedAreaScale, xe = xe * n.customizedAreaScale, ce = ce * n.customizedAreaScale, J = J * n.customizedAreaScale, Q = Q * n.customizedAreaScale, ye = N - 1 / G.value + (U + 1 / G.value - (U + 1 / G.value) * n.customizedAreaScale) / 2, Me = I - 1 / G.value + (E + 1 / G.value - (E + 1 / G.value) * n.customizedAreaScale) / 2, E = E * n.customizedAreaScale, U = U * n.customizedAreaScale), P.spreadOut && (L.scaleX = xe, L.scaleY = ce, L.top = ye, L.left = Me), P.heightMaximization && (L.scaleY = ce, L.top = ye, n.customizedAreaScale && n.customizedAreaScale != 1 && (L.scaleX = se, L.left = I + Math.abs((g.width - (J || 0) * (se / n.customizedAreaScale)) / 2))), P.widthMaximization && (L.scaleX = xe, L.left = Me, n.customizedAreaScale && n.customizedAreaScale != 1 && (L.scaleY = se, L.top = N + Math.abs((g.height - (Q || 0) * (se / n.customizedAreaScale)) / 2))), A(L);
          }
        } else
          (P.width != L.width || P.height != L.height) && P.width && P.height && (L.scaleX = P.width / L.width, L.scaleY = P.height / L.height, A(L));
        L.type == "i-text" && (L.fill = P.fontColor, L.fontFamily = P.fontFamily, L.fontSize = P.fontSize, L.strokeWidth = P.strokeWidth, L.stroke = P.strokeColor, L.textAlign = P.textAlign, L.linethrough = P.linethrough, L.underline = P.underline, L.fontWeight = P.fontBold ? "bold" : "normal", L.fontStyle = P.fontItalic ? "italic" : "normal"), L.left = P.left || L.left, L.top = P.top || L.top, L.set("flipX", P.flipHorizontal), L.set("flipY", P.flipVertical), L.rotate(P.rotate), T.renderAll();
      }
    }, pe = () => T == null ? void 0 : T.getActiveObject(), ge = (P) => {
      f.value = P, !f.value && T && (k.value && (T.remove(k.value), k.value = null), y.value && (T.remove(y.value), y.value = null), v.value = null, S.value = null, T.renderAll());
    }, fe = (P) => {
      try {
        We.Image.fromURL(P, function(L) {
          const _ = g.left, E = g.top;
          if (L.clipPath = Ae, n.autoScaleCustomImage) {
            L.set({
              transparentCorners: !1,
              cornerSize: 15 / G.value,
              perPixelTargetFind: !0,
              visible: !0,
              selectable: !1,
              evented: !1,
              left: _,
              top: E
            }), T.add(L), T.renderAll();
            return;
          }
          L.set({
            left: _,
            top: E,
            transparentCorners: !1,
            cornerSize: 15 / G.value,
            visible: !0,
            selectable: !0,
            evented: !0,
            borderOpacityWhenMoving: 1
          }), T.add(L), T.setActiveObject(L);
          const U = T.getActiveObject();
          t("customActiveObject", U, { realLeft: g.left, realTop: g.top }), t("imgLoading", !1), T.renderAll(), t("customized");
        }, {
          crossOrigin: "anonymous"
        });
      } catch (L) {
        console.log(L);
      }
    }, we = (P) => {
      We.Image.fromURL(P, function(L) {
        const _ = L.width;
        L.set({
          transparentCorners: !1,
          cornerSize: 0,
          perPixelTargetFind: !0,
          visible: !0,
          selectable: !1,
          evented: !1,
          left: g.left,
          top: g.top
        }), _ && L.scale(_ > g.width ? g.width / _ : _ / g.width), T.add(L), T.renderAll();
      }, {
        crossOrigin: "anonymous"
      });
    }, Se = () => {
      T && (H.value.forEach((P) => T.remove(P)), H.value.length = 0, y.value && (T.remove(y.value), y.value = null), k.value && (T.remove(k.value), k.value = null), v.value = null, S.value = null, f.value = !1, T.renderAll());
    }, Ne = (P) => {
      if (T) {
        const L = T.getActiveObject();
        L.setSrc(P, () => {
          T.renderAll(), t("customActiveObject", L);
        }, {
          crossOrigin: "anonymous"
        });
      }
    }, ze = () => {
      ke({});
      const P = T.getContext().getImageData(
        g.left,
        g.top,
        g.width,
        g.height
      );
      return at(), O(P);
    }, je = () => {
      try {
        const P = T.getActiveObject();
        if (!P || !(P instanceof We.Image))
          return Hi.error("\u4F60\u6CA1\u9009\u62E9\u56FE\u7247\u5462"), !1;
        const L = P;
        if (L.cropX != 0 || L.cropY != 0)
          L.set({
            cropX: L.originalCropX || 0,
            cropY: L.originalCropY || 0,
            width: L.originalWidth || L.width,
            height: L.originalHeight || L.height,
            isCroppedToNonTransparent: !1
          });
        else {
          L.originalWidth = L.width, L.originalHeight = L.height, L.originalCropX = L.cropX || 0, L.originalCropY = L.cropY || 0;
          const _ = document.createElement("canvas");
          _.width = L.width, _.height = L.height;
          const E = _.getContext("2d");
          if (!E)
            return;
          const U = L.getElement();
          E.drawImage(U, 0, 0, L.width, L.height);
          const I = E.getImageData(0, 0, L.width, L.height), N = O(I);
          if (N.width === 0 || N.height === 0) {
            Hi.error("\u8BE5\u56FE\u7247\u68C0\u6D4B\u4E0D\u6B63\u786E\uFF0C\u8BF7\u8054\u7CFB\u5F00\u53D1\u4EBA\u5458"), _.remove();
            return;
          }
          const J = document.createElement("canvas");
          J.width = N.width, J.height = N.height;
          const Q = J.getContext("2d");
          if (Q) {
            Q.putImageData(I, -N.left, -N.top);
            const se = new We.Image(J, {
              left: L.left + L.scaleX * N.left,
              top: L.top + L.scaleY * N.top,
              width: N.width,
              height: N.height,
              clipPath: Ae,
              scaleX: L.scaleX,
              scaleY: L.scaleY
            });
            T.remove(L), T.add(se), T.setActiveObject(se);
          }
          _.remove();
        }
        T.renderAll(), P && t("customActiveObject", P, { realLeft: g.left, realTop: g.top });
      } catch (P) {
        console.log(P);
      }
    }, O = (P) => {
      const L = (ce, Me) => {
        const ye = Me.width, He = ye * 4 * ce, Be = ye * 4 * ce + ye * 4, Lt = Me.data;
        for (let bt = He; bt < Be; bt += 4)
          if (Lt[bt] != 0)
            return !0;
        return !1;
      }, _ = (ce, Me, ye, He) => {
        const Be = Me.width, Lt = Me.data;
        for (let bt = ye; bt < He; bt++) {
          const tt = Be * 4 * bt;
          if (Lt[tt + ce * 4] != 0)
            return !0;
        }
        return !1;
      }, E = (ce) => {
        const Me = ce.height;
        for (let ye = 0; ye < Me; ye++)
          if (L(ye, ce))
            return ye;
        return Me;
      }, U = (ce, Me, ye) => {
        const He = ce.width;
        for (let Be = 0; Be < He; Be++)
          if (_(Be, ce, Me, ye))
            return Be;
        return He;
      }, I = (ce) => {
        const Me = ce.height;
        for (let ye = Me - 1; ye > 0; ye--)
          if (L(ye, ce))
            return ye + 1;
        return Me;
      }, N = (ce, Me, ye) => {
        const He = ce.width;
        for (let Be = He - 1; Be > 0; Be--)
          if (_(Be, ce, Me, ye))
            return Be + 1;
        return He;
      }, J = E(P), Q = I(P);
      if (J === Q)
        return { top: 0, left: 0, width: 0, height: 0 };
      const se = U(P, J, Q), xe = N(P, J, Q);
      return { top: J, left: se, width: xe - se, height: Q - J };
    }, q = () => {
      ke({ color: !0, templateImage: !0 });
      const L = T.toDataURL({
        format: "png",
        width: d.value,
        height: m.value,
        quality: 1
      }).split(",")[1], _ = u(L, 300);
      return at(), new Blob([_], { type: "image/png" });
    }, ne = (P) => {
      ke({ color: !0, templateImage: !0 });
      const L = P.split(",")[1], _ = u(L, 300);
      return at(), new Blob([_], { type: "image/png" });
    }, me = () => new Promise((P) => {
      const L = q();
      return P(L);
    }), Te = (P = g) => {
      ke({});
      const L = T.toDataURL({
        format: "png",
        left: P.left,
        top: P.top,
        width: P.width,
        height: P.height,
        quality: 1
      });
      at();
      const _ = L.split(",")[1], E = u(_, 300);
      return new Blob([E], { type: "image/png" });
    }, Ge = async () => new Promise((P) => {
      const L = Te();
      return P(L);
    }), it = () => {
      const P = ze(), L = {
        left: g.left + P.left,
        top: g.top + P.top,
        width: P.width,
        height: P.height
      };
      return {
        blob: Te(L),
        boundingRect: { left: L.left / h.value, top: L.top / h.value, width: L.width / h.value, height: L.height / h.value }
      };
    }, ht = async () => new Promise((P) => {
      const L = it();
      return P(L);
    }), Qt = () => T.toJSON(), Je = () => T ? T.getObjects("image").length > 0 || T.getObjects("i-text").length > 0 : !1, Bt = () => n.id, yt = (P) => {
      const L = T.getObjects("rect")[0];
      L.set("fill", "rgba(0, 0, 0, 0)"), L.set("scaleX", P), L.set("scaleY", P), L.set("top", g.top - 1 / G.value + (g.height + 2 / G.value - (g.height + 2 / G.value) * P) / 2), L.set("left", g.left - 1 / G.value + (g.width + 1 / G.value - (g.width + 1 / G.value) * P) / 2), Ae.set("scaleX", P), Ae.set("scaleY", P), Ae.set("top", g.top - 2 / G.value + (g.height + 2 / G.value - (g.height + 2 / G.value) * P) / 2), Ae.set("left", g.left - 2 / G.value + (g.width + 2 / G.value - (g.width + 2 / G.value) * P) / 2);
    }, ss = (P) => {
      const L = T.getObjects("rect")[0];
      L.set("fill", "rgba(0, 0, 0, 0)"), L.set("scaleX", 1), L.set("scaleY", 1), Ae.set("scaleX", 1), Ae.set("scaleY", 1), P ? (L.set("top", 0), L.set("left", 0), L.set("width", g.bgWidth - 5), L.set("height", g.bgHeight - 5), Ae.set("top", 0), Ae.set("left", 0), Ae.set("width", g.bgWidth - 5), Ae.set("height", g.bgHeight - 5)) : (L.set("top", g.top - 2 / G.value), L.set("left", g.left - 2 / G.value), L.set("width", g.width + 2 / G.value), L.set("height", g.height + 2 / G.value), Ae.set("top", g.top - 2 / G.value), Ae.set("left", g.left - 2 / G.value), Ae.set("width", g.width + 2 / G.value), Ae.set("height", g.height + 2 / G.value)), T.renderAll();
    }, rs = (P) => {
      const L = P.backgroundImage;
      if (L) {
        const _ = 4.23 / (L != null && L.scaleY ? L == null ? void 0 : L.scaleY : 1);
        L.scaleY = 4.23, L.scaleX = 4.23, P.objects.forEach((E) => {
          E.width = E.width * _, E.height = E.height * _, E.top = E.top * _, E.left = E.left * _;
        }), T.loadFromJSON(P, () => {
          const E = T.getObjects("rect")[0];
          E.absolutePositioned = !0, E.objectCaching = !0, E.selectable = !1, yt(P.objects[0].scaleX), T.getObjects("i-text").forEach((U) => {
            U.clipPath = Ae;
          }), T.getObjects("image").forEach((U) => {
            U.clipPath = Ae;
          }), T.renderAll.bind(T), ee = T.backgroundImage;
        });
      }
    };
    return e({
      exportCustomAreaImageAsBlob: Te,
      exportCustomAreaImageAsBlobAsync: Ge,
      exportVisualCustomAreaImageAsBlob: it,
      exportVisualCustomAreaImageAsBlobAsync: ht,
      cropSelectedImageToNonTransparent: je,
      exportPreviewBase64: M,
      convertBase64PNGToBinWithDPI: u,
      exportConverDPI: ne,
      toggleMeasureMode: ge,
      exportFullImageAsBlob: q,
      exportFullImageAsBlobAsync: me,
      replaceImg: Ne,
      clearCanvas: Se,
      cancelRectAndRectBorder: ss,
      exportCustomAreaJson: Qt,
      onQuickPreview: C,
      loadCustomAreaJson: rs,
      currentSelectionActiveObject: pe,
      addImageToCustomArea: fe,
      addTextToCustomArea: de,
      updateCustomArea: B,
      updateCurrentIText: Re,
      isCustomized: Je,
      editorId: Bt,
      startDraw: K,
      applyCrop: le,
      closedDraw: W
    }), (P, L) => r.container ? (qt(), bn("div", {
      key: 0,
      class: "fabric-div",
      style: Wi(te.value),
      onContextmenu: ql(l, ["prevent"])
    }, [
      Ft("canvas", {
        ref_key: "canvasId",
        ref: Z,
        style: Wi({
          position: "absolute",
          left: 0,
          top: 0,
          width: `${d.value}px`,
          height: `${m.value}px`
        })
      }, null, 4),
      i.value.title.length > 0 ? (qt(), bn("div", {
        key: 0,
        class: "fabric-img-message",
        style: Wi({
          fontSize: 24 * (n.customArea.scale || 2) * (n.scale || 1) + "px",
          backgroundColor: i.value.backgroundColor,
          color: i.value.color
        })
      }, mi(i.value.title), 5)) : Ns("", !0)
    ], 44, Lc)) : Ns("", !0);
  }
});
const Pc = /* @__PURE__ */ un(Rc, [["__scopeId", "data-v-bf556439"]]);
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const qr = "148", qn = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 }, Yn = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 }, Dc = 0, da = 1, Ic = 2, il = 1, Oc = 2, Vi = 3, Mn = 0, kt = 1, Bs = 2, as = 3, yn = 0, ui = 1, fa = 2, pa = 3, ma = 4, Nc = 5, ci = 100, Fc = 101, zc = 102, ga = 103, _a = 104, Uc = 200, kc = 201, Bc = 202, Hc = 203, sl = 204, rl = 205, Vc = 206, Gc = 207, Wc = 208, jc = 209, Xc = 210, qc = 0, Yc = 1, Kc = 2, Or = 3, Zc = 4, $c = 5, Jc = 6, Qc = 7, Yr = 0, eh = 1, th = 2, cn = 0, nh = 1, ih = 2, sh = 3, rh = 4, ah = 5, al = 300, gi = 301, _i = 302, Nr = 303, Fr = 304, Hs = 306, vi = 1e3, Ct = 1001, Fs = 1002, ft = 1003, zr = 1004, Ps = 1005, Et = 1006, ol = 1007, Un = 1008, kn = 1009, oh = 1010, lh = 1011, ll = 1012, ch = 1013, Dn = 1014, xn = 1015, Yi = 1016, hh = 1017, uh = 1018, di = 1020, dh = 1021, fh = 1022, zt = 1023, ph = 1024, mh = 1025, Nn = 1026, xi = 1027, gh = 1028, _h = 1029, vh = 1030, xh = 1031, yh = 1033, Ys = 33776, Ks = 33777, Zs = 33778, $s = 33779, va = 35840, xa = 35841, ya = 35842, ba = 35843, bh = 36196, Ma = 37492, wa = 37496, Sa = 37808, Ta = 37809, Aa = 37810, Ea = 37811, Ca = 37812, La = 37813, Ra = 37814, Pa = 37815, Da = 37816, Ia = 37817, Oa = 37818, Na = 37819, Fa = 37820, za = 37821, Ua = 36492, Ki = 2300, yi = 2301, Js = 2302, ka = 2400, Ba = 2401, Ha = 2402, Mh = 2500, wh = 1, cl = 2, Bn = 3e3, Xe = 3001, Sh = 3200, Th = 3201, Kr = 0, Ah = 1, Kt = "srgb", Zi = "srgb-linear", Qs = 7680, Eh = 519, Ur = 35044, Va = "300 es", kr = 1035;
class jn {
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const n = this._listeners;
    n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
  }
  hasEventListener(e, t) {
    if (this._listeners === void 0)
      return !1;
    const n = this._listeners;
    return n[e] !== void 0 && n[e].indexOf(t) !== -1;
  }
  removeEventListener(e, t) {
    if (this._listeners === void 0)
      return;
    const i = this._listeners[e];
    if (i !== void 0) {
      const s = i.indexOf(t);
      s !== -1 && i.splice(s, 1);
    }
  }
  dispatchEvent(e) {
    if (this._listeners === void 0)
      return;
    const n = this._listeners[e.type];
    if (n !== void 0) {
      e.target = this;
      const i = n.slice(0);
      for (let s = 0, a = i.length; s < a; s++)
        i[s].call(this, e);
      e.target = null;
    }
  }
}
const _t = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let Ga = 1234567;
const ji = Math.PI / 180, $i = 180 / Math.PI;
function jt() {
  const r = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
  return (_t[r & 255] + _t[r >> 8 & 255] + _t[r >> 16 & 255] + _t[r >> 24 & 255] + "-" + _t[e & 255] + _t[e >> 8 & 255] + "-" + _t[e >> 16 & 15 | 64] + _t[e >> 24 & 255] + "-" + _t[t & 63 | 128] + _t[t >> 8 & 255] + "-" + _t[t >> 16 & 255] + _t[t >> 24 & 255] + _t[n & 255] + _t[n >> 8 & 255] + _t[n >> 16 & 255] + _t[n >> 24 & 255]).toLowerCase();
}
function vt(r, e, t) {
  return Math.max(e, Math.min(t, r));
}
function Zr(r, e) {
  return (r % e + e) % e;
}
function Ch(r, e, t, n, i) {
  return n + (r - e) * (i - n) / (t - e);
}
function Lh(r, e, t) {
  return r !== e ? (t - r) / (e - r) : 0;
}
function Xi(r, e, t) {
  return (1 - t) * r + t * e;
}
function Rh(r, e, t, n) {
  return Xi(r, e, 1 - Math.exp(-t * n));
}
function Ph(r, e = 1) {
  return e - Math.abs(Zr(r, e * 2) - e);
}
function Dh(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * (3 - 2 * r));
}
function Ih(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * r * (r * (r * 6 - 15) + 10));
}
function Oh(r, e) {
  return r + Math.floor(Math.random() * (e - r + 1));
}
function Nh(r, e) {
  return r + Math.random() * (e - r);
}
function Fh(r) {
  return r * (0.5 - Math.random());
}
function zh(r) {
  r !== void 0 && (Ga = r);
  let e = Ga += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function Uh(r) {
  return r * ji;
}
function kh(r) {
  return r * $i;
}
function Br(r) {
  return (r & r - 1) === 0 && r !== 0;
}
function hl(r) {
  return Math.pow(2, Math.ceil(Math.log(r) / Math.LN2));
}
function zs(r) {
  return Math.pow(2, Math.floor(Math.log(r) / Math.LN2));
}
function Bh(r, e, t, n, i) {
  const s = Math.cos, a = Math.sin, o = s(t / 2), l = a(t / 2), c = s((e + n) / 2), u = a((e + n) / 2), h = s((e - n) / 2), d = a((e - n) / 2), m = s((n - e) / 2), g = a((n - e) / 2);
  switch (i) {
    case "XYX":
      r.set(o * u, l * h, l * d, o * c);
      break;
    case "YZY":
      r.set(l * d, o * u, l * h, o * c);
      break;
    case "ZXZ":
      r.set(l * h, l * d, o * u, o * c);
      break;
    case "XZX":
      r.set(o * u, l * g, l * m, o * c);
      break;
    case "YXY":
      r.set(l * m, o * u, l * g, o * c);
      break;
    case "ZYZ":
      r.set(l * g, l * m, o * u, o * c);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
  }
}
function ln(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint16Array:
      return r / 65535;
    case Uint8Array:
      return r / 255;
    case Int16Array:
      return Math.max(r / 32767, -1);
    case Int8Array:
      return Math.max(r / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function Ke(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint16Array:
      return Math.round(r * 65535);
    case Uint8Array:
      return Math.round(r * 255);
    case Int16Array:
      return Math.round(r * 32767);
    case Int8Array:
      return Math.round(r * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
var Hh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DEG2RAD: ji,
  RAD2DEG: $i,
  generateUUID: jt,
  clamp: vt,
  euclideanModulo: Zr,
  mapLinear: Ch,
  inverseLerp: Lh,
  lerp: Xi,
  damp: Rh,
  pingpong: Ph,
  smoothstep: Dh,
  smootherstep: Ih,
  randInt: Oh,
  randFloat: Nh,
  randFloatSpread: Fh,
  seededRandom: zh,
  degToRad: Uh,
  radToDeg: kh,
  isPowerOfTwo: Br,
  ceilPowerOfTwo: hl,
  floorPowerOfTwo: zs,
  setQuaternionFromProperEuler: Bh,
  normalize: Ke,
  denormalize: ln
});
class Pe {
  constructor(e = 0, t = 0) {
    Pe.prototype.isVector2 = !0, this.x = e, this.y = t;
  }
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = e.elements;
    return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this;
  }
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y;
    return t * t + n * n;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this;
  }
  rotateAround(e, t) {
    const n = Math.cos(t), i = Math.sin(t), s = this.x - e.x, a = this.y - e.y;
    return this.x = s * n - a * i + e.x, this.y = s * i + a * n + e.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class It {
  constructor() {
    It.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
  }
  set(e, t, n, i, s, a, o, l, c) {
    const u = this.elements;
    return u[0] = e, u[1] = i, u[2] = o, u[3] = t, u[4] = s, u[5] = l, u[6] = n, u[7] = a, u[8] = c, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
  }
  extractBasis(e, t, n) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, s = this.elements, a = n[0], o = n[3], l = n[6], c = n[1], u = n[4], h = n[7], d = n[2], m = n[5], g = n[8], p = i[0], f = i[3], v = i[6], S = i[1], y = i[4], b = i[7], w = i[2], D = i[5], z = i[8];
    return s[0] = a * p + o * S + l * w, s[3] = a * f + o * y + l * D, s[6] = a * v + o * b + l * z, s[1] = c * p + u * S + h * w, s[4] = c * f + u * y + h * D, s[7] = c * v + u * b + h * z, s[2] = d * p + m * S + g * w, s[5] = d * f + m * y + g * D, s[8] = d * v + m * b + g * z, this;
  }
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  determinant() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8];
    return t * a * u - t * o * c - n * s * u + n * o * l + i * s * c - i * a * l;
  }
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8], h = u * a - o * c, d = o * l - u * s, m = c * s - a * l, g = t * h + n * d + i * m;
    if (g === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const p = 1 / g;
    return e[0] = h * p, e[1] = (i * c - u * n) * p, e[2] = (o * n - i * a) * p, e[3] = d * p, e[4] = (u * t - i * l) * p, e[5] = (i * s - o * t) * p, e[6] = m * p, e[7] = (n * l - c * t) * p, e[8] = (a * t - n * s) * p, this;
  }
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  setUvTransform(e, t, n, i, s, a, o) {
    const l = Math.cos(s), c = Math.sin(s);
    return this.set(
      n * l,
      n * c,
      -n * (l * a + c * o) + a + e,
      -i * c,
      i * l,
      -i * (-c * a + l * o) + o + t,
      0,
      0,
      1
    ), this;
  }
  scale(e, t) {
    return this.premultiply(er.makeScale(e, t)), this;
  }
  rotate(e) {
    return this.premultiply(er.makeRotation(-e)), this;
  }
  translate(e, t) {
    return this.premultiply(er.makeTranslation(e, t)), this;
  }
  makeTranslation(e, t) {
    return this.set(
      1,
      0,
      e,
      0,
      1,
      t,
      0,
      0,
      1
    ), this;
  }
  makeRotation(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      n,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, t) {
    return this.set(
      e,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 9; i++)
      if (t[i] !== n[i])
        return !1;
    return !0;
  }
  fromArray(e, t = 0) {
    for (let n = 0; n < 9; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const er = /* @__PURE__ */ new It();
function ul(r) {
  for (let e = r.length - 1; e >= 0; --e)
    if (r[e] >= 65535)
      return !0;
  return !1;
}
function Ji(r) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", r);
}
function Fn(r) {
  return r < 0.04045 ? r * 0.0773993808 : Math.pow(r * 0.9478672986 + 0.0521327014, 2.4);
}
function Ds(r) {
  return r < 31308e-7 ? r * 12.92 : 1.055 * Math.pow(r, 0.41666) - 0.055;
}
const tr = {
  [Kt]: { [Zi]: Fn },
  [Zi]: { [Kt]: Ds }
}, wt = {
  legacyMode: !0,
  get workingColorSpace() {
    return Zi;
  },
  set workingColorSpace(r) {
    console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
  },
  convert: function(r, e, t) {
    if (this.legacyMode || e === t || !e || !t)
      return r;
    if (tr[e] && tr[e][t] !== void 0) {
      const n = tr[e][t];
      return r.r = n(r.r), r.g = n(r.g), r.b = n(r.b), r;
    }
    throw new Error("Unsupported color space conversion.");
  },
  fromWorkingColorSpace: function(r, e) {
    return this.convert(r, this.workingColorSpace, e);
  },
  toWorkingColorSpace: function(r, e) {
    return this.convert(r, e, this.workingColorSpace);
  }
}, dl = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, ot = { r: 0, g: 0, b: 0 }, Ht = { h: 0, s: 0, l: 0 }, os = { h: 0, s: 0, l: 0 };
function nr(r, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? r + (e - r) * 6 * (2 / 3 - t) : r;
}
function ls(r, e) {
  return e.r = r.r, e.g = r.g, e.b = r.b, e;
}
class De {
  constructor(e, t, n) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, t === void 0 && n === void 0 ? this.set(e) : this.setRGB(e, t, n);
  }
  set(e) {
    return e && e.isColor ? this.copy(e) : typeof e == "number" ? this.setHex(e) : typeof e == "string" && this.setStyle(e), this;
  }
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  setHex(e, t = Kt) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, wt.toWorkingColorSpace(this, t), this;
  }
  setRGB(e, t, n, i = wt.workingColorSpace) {
    return this.r = e, this.g = t, this.b = n, wt.toWorkingColorSpace(this, i), this;
  }
  setHSL(e, t, n, i = wt.workingColorSpace) {
    if (e = Zr(e, 1), t = vt(t, 0, 1), n = vt(n, 0, 1), t === 0)
      this.r = this.g = this.b = n;
    else {
      const s = n <= 0.5 ? n * (1 + t) : n + t - n * t, a = 2 * n - s;
      this.r = nr(a, s, e + 1 / 3), this.g = nr(a, s, e), this.b = nr(a, s, e - 1 / 3);
    }
    return wt.toWorkingColorSpace(this, i), this;
  }
  setStyle(e, t = Kt) {
    function n(s) {
      s !== void 0 && parseFloat(s) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let i;
    if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(e)) {
      let s;
      const a = i[1], o = i[2];
      switch (a) {
        case "rgb":
        case "rgba":
          if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return this.r = Math.min(255, parseInt(s[1], 10)) / 255, this.g = Math.min(255, parseInt(s[2], 10)) / 255, this.b = Math.min(255, parseInt(s[3], 10)) / 255, wt.toWorkingColorSpace(this, t), n(s[4]), this;
          if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return this.r = Math.min(100, parseInt(s[1], 10)) / 100, this.g = Math.min(100, parseInt(s[2], 10)) / 100, this.b = Math.min(100, parseInt(s[3], 10)) / 100, wt.toWorkingColorSpace(this, t), n(s[4]), this;
          break;
        case "hsl":
        case "hsla":
          if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)) {
            const l = parseFloat(s[1]) / 360, c = parseFloat(s[2]) / 100, u = parseFloat(s[3]) / 100;
            return n(s[4]), this.setHSL(l, c, u, t);
          }
          break;
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const s = i[1], a = s.length;
      if (a === 3)
        return this.r = parseInt(s.charAt(0) + s.charAt(0), 16) / 255, this.g = parseInt(s.charAt(1) + s.charAt(1), 16) / 255, this.b = parseInt(s.charAt(2) + s.charAt(2), 16) / 255, wt.toWorkingColorSpace(this, t), this;
      if (a === 6)
        return this.r = parseInt(s.charAt(0) + s.charAt(1), 16) / 255, this.g = parseInt(s.charAt(2) + s.charAt(3), 16) / 255, this.b = parseInt(s.charAt(4) + s.charAt(5), 16) / 255, wt.toWorkingColorSpace(this, t), this;
    }
    return e && e.length > 0 ? this.setColorName(e, t) : this;
  }
  setColorName(e, t = Kt) {
    const n = dl[e.toLowerCase()];
    return n !== void 0 ? this.setHex(n, t) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  copySRGBToLinear(e) {
    return this.r = Fn(e.r), this.g = Fn(e.g), this.b = Fn(e.b), this;
  }
  copyLinearToSRGB(e) {
    return this.r = Ds(e.r), this.g = Ds(e.g), this.b = Ds(e.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(e = Kt) {
    return wt.fromWorkingColorSpace(ls(this, ot), e), vt(ot.r * 255, 0, 255) << 16 ^ vt(ot.g * 255, 0, 255) << 8 ^ vt(ot.b * 255, 0, 255) << 0;
  }
  getHexString(e = Kt) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  getHSL(e, t = wt.workingColorSpace) {
    wt.fromWorkingColorSpace(ls(this, ot), t);
    const n = ot.r, i = ot.g, s = ot.b, a = Math.max(n, i, s), o = Math.min(n, i, s);
    let l, c;
    const u = (o + a) / 2;
    if (o === a)
      l = 0, c = 0;
    else {
      const h = a - o;
      switch (c = u <= 0.5 ? h / (a + o) : h / (2 - a - o), a) {
        case n:
          l = (i - s) / h + (i < s ? 6 : 0);
          break;
        case i:
          l = (s - n) / h + 2;
          break;
        case s:
          l = (n - i) / h + 4;
          break;
      }
      l /= 6;
    }
    return e.h = l, e.s = c, e.l = u, e;
  }
  getRGB(e, t = wt.workingColorSpace) {
    return wt.fromWorkingColorSpace(ls(this, ot), t), e.r = ot.r, e.g = ot.g, e.b = ot.b, e;
  }
  getStyle(e = Kt) {
    return wt.fromWorkingColorSpace(ls(this, ot), e), e !== Kt ? `color(${e} ${ot.r} ${ot.g} ${ot.b})` : `rgb(${ot.r * 255 | 0},${ot.g * 255 | 0},${ot.b * 255 | 0})`;
  }
  offsetHSL(e, t, n) {
    return this.getHSL(Ht), Ht.h += e, Ht.s += t, Ht.l += n, this.setHSL(Ht.h, Ht.s, Ht.l), this;
  }
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  lerpColors(e, t, n) {
    return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
  }
  lerpHSL(e, t) {
    this.getHSL(Ht), e.getHSL(os);
    const n = Xi(Ht.h, os.h, t), i = Xi(Ht.s, os.s, t), s = Xi(Ht.l, os.l, t);
    return this.setHSL(n, i, s), this;
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
De.NAMES = dl;
let Kn;
class fl {
  static getDataURL(e) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let t;
    if (e instanceof HTMLCanvasElement)
      t = e;
    else {
      Kn === void 0 && (Kn = Ji("canvas")), Kn.width = e.width, Kn.height = e.height;
      const n = Kn.getContext("2d");
      e instanceof ImageData ? n.putImageData(e, 0, 0) : n.drawImage(e, 0, 0, e.width, e.height), t = Kn;
    }
    return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e), t.toDataURL("image/jpeg", 0.6)) : t.toDataURL("image/png");
  }
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = Ji("canvas");
      t.width = e.width, t.height = e.height;
      const n = t.getContext("2d");
      n.drawImage(e, 0, 0, e.width, e.height);
      const i = n.getImageData(0, 0, e.width, e.height), s = i.data;
      for (let a = 0; a < s.length; a++)
        s[a] = Fn(s[a] / 255) * 255;
      return n.putImageData(i, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let n = 0; n < t.length; n++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[n] = Math.floor(Fn(t[n] / 255) * 255) : t[n] = Fn(t[n]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
class pl {
  constructor(e = null) {
    this.isSource = !0, this.uuid = jt(), this.data = e, this.version = 0;
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const n = {
      uuid: this.uuid,
      url: ""
    }, i = this.data;
    if (i !== null) {
      let s;
      if (Array.isArray(i)) {
        s = [];
        for (let a = 0, o = i.length; a < o; a++)
          i[a].isDataTexture ? s.push(ir(i[a].image)) : s.push(ir(i[a]));
      } else
        s = ir(i);
      n.url = s;
    }
    return t || (e.images[this.uuid] = n), n;
  }
}
function ir(r) {
  return typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap ? fl.getDataURL(r) : r.data ? {
    data: Array.from(r.data),
    width: r.width,
    height: r.height,
    type: r.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let Vh = 0;
class mt extends jn {
  constructor(e = mt.DEFAULT_IMAGE, t = mt.DEFAULT_MAPPING, n = Ct, i = Ct, s = Et, a = Un, o = zt, l = kn, c = mt.DEFAULT_ANISOTROPY, u = Bn) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Vh++ }), this.uuid = jt(), this.name = "", this.source = new pl(e), this.mipmaps = [], this.mapping = t, this.wrapS = n, this.wrapT = i, this.magFilter = s, this.minFilter = a, this.anisotropy = c, this.format = o, this.internalFormat = null, this.type = l, this.offset = new Pe(0, 0), this.repeat = new Pe(1, 1), this.center = new Pe(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new It(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = u, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
  }
  get image() {
    return this.source.data;
  }
  set image(e) {
    this.source.data = e;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.encoding = e.encoding, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const n = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(e) {
    if (this.mapping !== al)
      return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case vi:
          e.x = e.x - Math.floor(e.x);
          break;
        case Ct:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case Fs:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case vi:
          e.y = e.y - Math.floor(e.y);
          break;
        case Ct:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case Fs:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
}
mt.DEFAULT_IMAGE = null;
mt.DEFAULT_MAPPING = al;
mt.DEFAULT_ANISOTROPY = 1;
class Ze {
  constructor(e = 0, t = 0, n = 0, i = 1) {
    Ze.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = n, this.w = i;
  }
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  set(e, t, n, i) {
    return this.x = e, this.y = t, this.z = n, this.w = i, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setW(e) {
    return this.w = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, s = this.w, a = e.elements;
    return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * s, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * s, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * s, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * s, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  setAxisAngleFromRotationMatrix(e) {
    let t, n, i, s;
    const l = e.elements, c = l[0], u = l[4], h = l[8], d = l[1], m = l[5], g = l[9], p = l[2], f = l[6], v = l[10];
    if (Math.abs(u - d) < 0.01 && Math.abs(h - p) < 0.01 && Math.abs(g - f) < 0.01) {
      if (Math.abs(u + d) < 0.1 && Math.abs(h + p) < 0.1 && Math.abs(g + f) < 0.1 && Math.abs(c + m + v - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const y = (c + 1) / 2, b = (m + 1) / 2, w = (v + 1) / 2, D = (u + d) / 4, z = (h + p) / 4, x = (g + f) / 4;
      return y > b && y > w ? y < 0.01 ? (n = 0, i = 0.707106781, s = 0.707106781) : (n = Math.sqrt(y), i = D / n, s = z / n) : b > w ? b < 0.01 ? (n = 0.707106781, i = 0, s = 0.707106781) : (i = Math.sqrt(b), n = D / i, s = x / i) : w < 0.01 ? (n = 0.707106781, i = 0.707106781, s = 0) : (s = Math.sqrt(w), n = z / s, i = x / s), this.set(n, i, s, t), this;
    }
    let S = Math.sqrt((f - g) * (f - g) + (h - p) * (h - p) + (d - u) * (d - u));
    return Math.abs(S) < 1e-3 && (S = 1), this.x = (f - g) / S, this.y = (h - p) / S, this.z = (d - u) / S, this.w = Math.acos((c + m + v - 1) / 2), this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this.w = Math.max(e.w, Math.min(t.w, this.w)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this.z = Math.max(e, Math.min(t, this.z)), this.w = Math.max(e, Math.min(t, this.w)), this;
  }
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class Hn extends jn {
  constructor(e = 1, t = 1, n = {}) {
    super(), this.isWebGLRenderTarget = !0, this.width = e, this.height = t, this.depth = 1, this.scissor = new Ze(0, 0, e, t), this.scissorTest = !1, this.viewport = new Ze(0, 0, e, t);
    const i = { width: e, height: t, depth: 1 };
    this.texture = new mt(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = n.generateMipmaps !== void 0 ? n.generateMipmaps : !1, this.texture.internalFormat = n.internalFormat !== void 0 ? n.internalFormat : null, this.texture.minFilter = n.minFilter !== void 0 ? n.minFilter : Et, this.depthBuffer = n.depthBuffer !== void 0 ? n.depthBuffer : !0, this.stencilBuffer = n.stencilBuffer !== void 0 ? n.stencilBuffer : !1, this.depthTexture = n.depthTexture !== void 0 ? n.depthTexture : null, this.samples = n.samples !== void 0 ? n.samples : 0;
  }
  setSize(e, t, n = 1) {
    (this.width !== e || this.height !== t || this.depth !== n) && (this.width = e, this.height = t, this.depth = n, this.texture.image.width = e, this.texture.image.height = t, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.texture.isRenderTargetTexture = !0;
    const t = Object.assign({}, e.texture.image);
    return this.texture.source = new pl(t), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class ml extends mt {
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = ft, this.minFilter = ft, this.wrapR = Ct, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Gh extends mt {
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = ft, this.minFilter = ft, this.wrapR = Ct, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class $t {
  constructor(e = 0, t = 0, n = 0, i = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = i;
  }
  static slerpFlat(e, t, n, i, s, a, o) {
    let l = n[i + 0], c = n[i + 1], u = n[i + 2], h = n[i + 3];
    const d = s[a + 0], m = s[a + 1], g = s[a + 2], p = s[a + 3];
    if (o === 0) {
      e[t + 0] = l, e[t + 1] = c, e[t + 2] = u, e[t + 3] = h;
      return;
    }
    if (o === 1) {
      e[t + 0] = d, e[t + 1] = m, e[t + 2] = g, e[t + 3] = p;
      return;
    }
    if (h !== p || l !== d || c !== m || u !== g) {
      let f = 1 - o;
      const v = l * d + c * m + u * g + h * p, S = v >= 0 ? 1 : -1, y = 1 - v * v;
      if (y > Number.EPSILON) {
        const w = Math.sqrt(y), D = Math.atan2(w, v * S);
        f = Math.sin(f * D) / w, o = Math.sin(o * D) / w;
      }
      const b = o * S;
      if (l = l * f + d * b, c = c * f + m * b, u = u * f + g * b, h = h * f + p * b, f === 1 - o) {
        const w = 1 / Math.sqrt(l * l + c * c + u * u + h * h);
        l *= w, c *= w, u *= w, h *= w;
      }
    }
    e[t] = l, e[t + 1] = c, e[t + 2] = u, e[t + 3] = h;
  }
  static multiplyQuaternionsFlat(e, t, n, i, s, a) {
    const o = n[i], l = n[i + 1], c = n[i + 2], u = n[i + 3], h = s[a], d = s[a + 1], m = s[a + 2], g = s[a + 3];
    return e[t] = o * g + u * h + l * m - c * d, e[t + 1] = l * g + u * d + c * h - o * m, e[t + 2] = c * g + u * m + o * d - l * h, e[t + 3] = u * g - o * h - l * d - c * m, e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  set(e, t, n, i) {
    return this._x = e, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  setFromEuler(e, t) {
    const n = e._x, i = e._y, s = e._z, a = e._order, o = Math.cos, l = Math.sin, c = o(n / 2), u = o(i / 2), h = o(s / 2), d = l(n / 2), m = l(i / 2), g = l(s / 2);
    switch (a) {
      case "XYZ":
        this._x = d * u * h + c * m * g, this._y = c * m * h - d * u * g, this._z = c * u * g + d * m * h, this._w = c * u * h - d * m * g;
        break;
      case "YXZ":
        this._x = d * u * h + c * m * g, this._y = c * m * h - d * u * g, this._z = c * u * g - d * m * h, this._w = c * u * h + d * m * g;
        break;
      case "ZXY":
        this._x = d * u * h - c * m * g, this._y = c * m * h + d * u * g, this._z = c * u * g + d * m * h, this._w = c * u * h - d * m * g;
        break;
      case "ZYX":
        this._x = d * u * h - c * m * g, this._y = c * m * h + d * u * g, this._z = c * u * g - d * m * h, this._w = c * u * h + d * m * g;
        break;
      case "YZX":
        this._x = d * u * h + c * m * g, this._y = c * m * h + d * u * g, this._z = c * u * g - d * m * h, this._w = c * u * h - d * m * g;
        break;
      case "XZY":
        this._x = d * u * h - c * m * g, this._y = c * m * h - d * u * g, this._z = c * u * g + d * m * h, this._w = c * u * h + d * m * g;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
    }
    return t !== !1 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(e, t) {
    const n = t / 2, i = Math.sin(n);
    return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e) {
    const t = e.elements, n = t[0], i = t[4], s = t[8], a = t[1], o = t[5], l = t[9], c = t[2], u = t[6], h = t[10], d = n + o + h;
    if (d > 0) {
      const m = 0.5 / Math.sqrt(d + 1);
      this._w = 0.25 / m, this._x = (u - l) * m, this._y = (s - c) * m, this._z = (a - i) * m;
    } else if (n > o && n > h) {
      const m = 2 * Math.sqrt(1 + n - o - h);
      this._w = (u - l) / m, this._x = 0.25 * m, this._y = (i + a) / m, this._z = (s + c) / m;
    } else if (o > h) {
      const m = 2 * Math.sqrt(1 + o - n - h);
      this._w = (s - c) / m, this._x = (i + a) / m, this._y = 0.25 * m, this._z = (l + u) / m;
    } else {
      const m = 2 * Math.sqrt(1 + h - n - o);
      this._w = (a - i) / m, this._x = (s + c) / m, this._y = (l + u) / m, this._z = 0.25 * m;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(e, t) {
    let n = e.dot(t) + 1;
    return n < Number.EPSILON ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(vt(this.dot(e), -1, 1)));
  }
  rotateTowards(e, t) {
    const n = this.angleTo(e);
    if (n === 0)
      return this;
    const i = Math.min(1, t / n);
    return this.slerp(e, i), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, t) {
    const n = e._x, i = e._y, s = e._z, a = e._w, o = t._x, l = t._y, c = t._z, u = t._w;
    return this._x = n * u + a * o + i * c - s * l, this._y = i * u + a * l + s * o - n * c, this._z = s * u + a * c + n * l - i * o, this._w = a * u - n * o - i * l - s * c, this._onChangeCallback(), this;
  }
  slerp(e, t) {
    if (t === 0)
      return this;
    if (t === 1)
      return this.copy(e);
    const n = this._x, i = this._y, s = this._z, a = this._w;
    let o = a * e._w + n * e._x + i * e._y + s * e._z;
    if (o < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, o = -o) : this.copy(e), o >= 1)
      return this._w = a, this._x = n, this._y = i, this._z = s, this;
    const l = 1 - o * o;
    if (l <= Number.EPSILON) {
      const m = 1 - t;
      return this._w = m * a + t * this._w, this._x = m * n + t * this._x, this._y = m * i + t * this._y, this._z = m * s + t * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    const c = Math.sqrt(l), u = Math.atan2(c, o), h = Math.sin((1 - t) * u) / c, d = Math.sin(t * u) / c;
    return this._w = a * h + this._w * d, this._x = n * h + this._x * d, this._y = i * h + this._y * d, this._z = s * h + this._z * d, this._onChangeCallback(), this;
  }
  slerpQuaternions(e, t, n) {
    return this.copy(e).slerp(t, n);
  }
  random() {
    const e = Math.random(), t = Math.sqrt(1 - e), n = Math.sqrt(e), i = 2 * Math.PI * Math.random(), s = 2 * Math.PI * Math.random();
    return this.set(
      t * Math.cos(i),
      n * Math.sin(s),
      n * Math.cos(s),
      t * Math.sin(i)
    );
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class F {
  constructor(e = 0, t = 0, n = 0) {
    F.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = n;
  }
  set(e, t, n) {
    return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  applyEuler(e) {
    return this.applyQuaternion(Wa.setFromEuler(e));
  }
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Wa.setFromAxisAngle(e, t));
  }
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements;
    return this.x = s[0] * t + s[3] * n + s[6] * i, this.y = s[1] * t + s[4] * n + s[7] * i, this.z = s[2] * t + s[5] * n + s[8] * i, this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements, a = 1 / (s[3] * t + s[7] * n + s[11] * i + s[15]);
    return this.x = (s[0] * t + s[4] * n + s[8] * i + s[12]) * a, this.y = (s[1] * t + s[5] * n + s[9] * i + s[13]) * a, this.z = (s[2] * t + s[6] * n + s[10] * i + s[14]) * a, this;
  }
  applyQuaternion(e) {
    const t = this.x, n = this.y, i = this.z, s = e.x, a = e.y, o = e.z, l = e.w, c = l * t + a * i - o * n, u = l * n + o * t - s * i, h = l * i + s * n - a * t, d = -s * t - a * n - o * i;
    return this.x = c * l + d * -s + u * -o - h * -a, this.y = u * l + d * -a + h * -s - c * -o, this.z = h * l + d * -o + c * -a - u * -s, this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements;
    return this.x = s[0] * t + s[4] * n + s[8] * i, this.y = s[1] * t + s[5] * n + s[9] * i, this.z = s[2] * t + s[6] * n + s[10] * i, this.normalize();
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this.z = Math.max(e, Math.min(t, this.z)), this;
  }
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
  }
  cross(e) {
    return this.crossVectors(this, e);
  }
  crossVectors(e, t) {
    const n = e.x, i = e.y, s = e.z, a = t.x, o = t.y, l = t.z;
    return this.x = i * l - s * o, this.y = s * a - n * l, this.z = n * o - i * a, this;
  }
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0)
      return this.set(0, 0, 0);
    const n = e.dot(this) / t;
    return this.copy(e).multiplyScalar(n);
  }
  projectOnPlane(e) {
    return sr.copy(this).projectOnVector(e), this.sub(sr);
  }
  reflect(e) {
    return this.sub(sr.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0)
      return Math.PI / 2;
    const n = this.dot(e) / t;
    return Math.acos(vt(n, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y, i = this.z - e.z;
    return t * t + n * n + i * i;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, t, n) {
    const i = Math.sin(t) * e;
    return this.x = i * Math.sin(n), this.y = Math.cos(t) * e, this.z = i * Math.cos(n), this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, t, n) {
    return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
  }
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = n, this.z = i, this;
  }
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const e = (Math.random() - 0.5) * 2, t = Math.random() * Math.PI * 2, n = Math.sqrt(1 - e ** 2);
    return this.x = n * Math.cos(t), this.y = n * Math.sin(t), this.z = e, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const sr = /* @__PURE__ */ new F(), Wa = /* @__PURE__ */ new $t();
class wi {
  constructor(e = new F(1 / 0, 1 / 0, 1 / 0), t = new F(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  setFromArray(e) {
    let t = 1 / 0, n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0, o = -1 / 0;
    for (let l = 0, c = e.length; l < c; l += 3) {
      const u = e[l], h = e[l + 1], d = e[l + 2];
      u < t && (t = u), h < n && (n = h), d < i && (i = d), u > s && (s = u), h > a && (a = h), d > o && (o = d);
    }
    return this.min.set(t, n, i), this.max.set(s, a, o), this;
  }
  setFromBufferAttribute(e) {
    let t = 1 / 0, n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0, o = -1 / 0;
    for (let l = 0, c = e.count; l < c; l++) {
      const u = e.getX(l), h = e.getY(l), d = e.getZ(l);
      u < t && (t = u), h < n && (n = h), d < i && (i = d), u > s && (s = u), h > a && (a = h), d > o && (o = d);
    }
    return this.min.set(t, n, i), this.max.set(s, a, o), this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  setFromCenterAndSize(e, t) {
    const n = Tn.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
  }
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const n = e.geometry;
    if (n !== void 0)
      if (t && n.attributes != null && n.attributes.position !== void 0) {
        const s = n.attributes.position;
        for (let a = 0, o = s.count; a < o; a++)
          Tn.fromBufferAttribute(s, a).applyMatrix4(e.matrixWorld), this.expandByPoint(Tn);
      } else
        n.boundingBox === null && n.computeBoundingBox(), rr.copy(n.boundingBox), rr.applyMatrix4(e.matrixWorld), this.union(rr);
    const i = e.children;
    for (let s = 0, a = i.length; s < a; s++)
      this.expandByObject(i[s], t);
    return this;
  }
  containsPoint(e) {
    return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(e) {
    return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
  }
  intersectsSphere(e) {
    return this.clampPoint(e.center, Tn), Tn.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let t, n;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Ri), cs.subVectors(this.max, Ri), Zn.subVectors(e.a, Ri), $n.subVectors(e.b, Ri), Jn.subVectors(e.c, Ri), dn.subVectors($n, Zn), fn.subVectors(Jn, $n), An.subVectors(Zn, Jn);
    let t = [
      0,
      -dn.z,
      dn.y,
      0,
      -fn.z,
      fn.y,
      0,
      -An.z,
      An.y,
      dn.z,
      0,
      -dn.x,
      fn.z,
      0,
      -fn.x,
      An.z,
      0,
      -An.x,
      -dn.y,
      dn.x,
      0,
      -fn.y,
      fn.x,
      0,
      -An.y,
      An.x,
      0
    ];
    return !ar(t, Zn, $n, Jn, cs) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !ar(t, Zn, $n, Jn, cs)) ? !1 : (hs.crossVectors(dn, fn), t = [hs.x, hs.y, hs.z], ar(t, Zn, $n, Jn, cs));
  }
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return Tn.copy(e).clamp(this.min, this.max).sub(e).length();
  }
  getBoundingSphere(e) {
    return this.getCenter(e.center), e.radius = this.getSize(Tn).length() * 0.5, e;
  }
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  applyMatrix4(e) {
    return this.isEmpty() ? this : (en[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), en[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), en[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), en[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), en[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), en[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), en[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), en[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(en), this);
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const en = [
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F(),
  /* @__PURE__ */ new F()
], Tn = /* @__PURE__ */ new F(), rr = /* @__PURE__ */ new wi(), Zn = /* @__PURE__ */ new F(), $n = /* @__PURE__ */ new F(), Jn = /* @__PURE__ */ new F(), dn = /* @__PURE__ */ new F(), fn = /* @__PURE__ */ new F(), An = /* @__PURE__ */ new F(), Ri = /* @__PURE__ */ new F(), cs = /* @__PURE__ */ new F(), hs = /* @__PURE__ */ new F(), En = /* @__PURE__ */ new F();
function ar(r, e, t, n, i) {
  for (let s = 0, a = r.length - 3; s <= a; s += 3) {
    En.fromArray(r, s);
    const o = i.x * Math.abs(En.x) + i.y * Math.abs(En.y) + i.z * Math.abs(En.z), l = e.dot(En), c = t.dot(En), u = n.dot(En);
    if (Math.max(-Math.max(l, c, u), Math.min(l, c, u)) > o)
      return !1;
  }
  return !0;
}
const Wh = /* @__PURE__ */ new wi(), Pi = /* @__PURE__ */ new F(), or = /* @__PURE__ */ new F();
class Si {
  constructor(e = new F(), t = -1) {
    this.center = e, this.radius = t;
  }
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  setFromPoints(e, t) {
    const n = this.center;
    t !== void 0 ? n.copy(t) : Wh.setFromPoints(e).getCenter(n);
    let i = 0;
    for (let s = 0, a = e.length; s < a; s++)
      i = Math.max(i, n.distanceToSquared(e[s]));
    return this.radius = Math.sqrt(i), this;
  }
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, t) {
    const n = this.center.distanceToSquared(e);
    return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  translate(e) {
    return this.center.add(e), this;
  }
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    Pi.subVectors(e, this.center);
    const t = Pi.lengthSq();
    if (t > this.radius * this.radius) {
      const n = Math.sqrt(t), i = (n - this.radius) * 0.5;
      this.center.addScaledVector(Pi, i / n), this.radius += i;
    }
    return this;
  }
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (or.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(Pi.copy(e.center).add(or)), this.expandByPoint(Pi.copy(e.center).sub(or))), this);
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const tn = /* @__PURE__ */ new F(), lr = /* @__PURE__ */ new F(), us = /* @__PURE__ */ new F(), pn = /* @__PURE__ */ new F(), cr = /* @__PURE__ */ new F(), ds = /* @__PURE__ */ new F(), hr = /* @__PURE__ */ new F();
class $r {
  constructor(e = new F(), t = new F(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  at(e, t) {
    return t.copy(this.direction).multiplyScalar(e).add(this.origin);
  }
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  recast(e) {
    return this.origin.copy(this.at(e, tn)), this;
  }
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const n = t.dot(this.direction);
    return n < 0 ? t.copy(this.origin) : t.copy(this.direction).multiplyScalar(n).add(this.origin);
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  distanceSqToPoint(e) {
    const t = tn.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (tn.copy(this.direction).multiplyScalar(t).add(this.origin), tn.distanceToSquared(e));
  }
  distanceSqToSegment(e, t, n, i) {
    lr.copy(e).add(t).multiplyScalar(0.5), us.copy(t).sub(e).normalize(), pn.copy(this.origin).sub(lr);
    const s = e.distanceTo(t) * 0.5, a = -this.direction.dot(us), o = pn.dot(this.direction), l = -pn.dot(us), c = pn.lengthSq(), u = Math.abs(1 - a * a);
    let h, d, m, g;
    if (u > 0)
      if (h = a * l - o, d = a * o - l, g = s * u, h >= 0)
        if (d >= -g)
          if (d <= g) {
            const p = 1 / u;
            h *= p, d *= p, m = h * (h + a * d + 2 * o) + d * (a * h + d + 2 * l) + c;
          } else
            d = s, h = Math.max(0, -(a * d + o)), m = -h * h + d * (d + 2 * l) + c;
        else
          d = -s, h = Math.max(0, -(a * d + o)), m = -h * h + d * (d + 2 * l) + c;
      else
        d <= -g ? (h = Math.max(0, -(-a * s + o)), d = h > 0 ? -s : Math.min(Math.max(-s, -l), s), m = -h * h + d * (d + 2 * l) + c) : d <= g ? (h = 0, d = Math.min(Math.max(-s, -l), s), m = d * (d + 2 * l) + c) : (h = Math.max(0, -(a * s + o)), d = h > 0 ? s : Math.min(Math.max(-s, -l), s), m = -h * h + d * (d + 2 * l) + c);
    else
      d = a > 0 ? -s : s, h = Math.max(0, -(a * d + o)), m = -h * h + d * (d + 2 * l) + c;
    return n && n.copy(this.direction).multiplyScalar(h).add(this.origin), i && i.copy(us).multiplyScalar(d).add(lr), m;
  }
  intersectSphere(e, t) {
    tn.subVectors(e.center, this.origin);
    const n = tn.dot(this.direction), i = tn.dot(tn) - n * n, s = e.radius * e.radius;
    if (i > s)
      return null;
    const a = Math.sqrt(s - i), o = n - a, l = n + a;
    return o < 0 && l < 0 ? null : o < 0 ? this.at(l, t) : this.at(o, t);
  }
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const n = -(this.origin.dot(e.normal) + e.constant) / t;
    return n >= 0 ? n : null;
  }
  intersectPlane(e, t) {
    const n = this.distanceToPlane(e);
    return n === null ? null : this.at(n, t);
  }
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  intersectBox(e, t) {
    let n, i, s, a, o, l;
    const c = 1 / this.direction.x, u = 1 / this.direction.y, h = 1 / this.direction.z, d = this.origin;
    return c >= 0 ? (n = (e.min.x - d.x) * c, i = (e.max.x - d.x) * c) : (n = (e.max.x - d.x) * c, i = (e.min.x - d.x) * c), u >= 0 ? (s = (e.min.y - d.y) * u, a = (e.max.y - d.y) * u) : (s = (e.max.y - d.y) * u, a = (e.min.y - d.y) * u), n > a || s > i || ((s > n || isNaN(n)) && (n = s), (a < i || isNaN(i)) && (i = a), h >= 0 ? (o = (e.min.z - d.z) * h, l = (e.max.z - d.z) * h) : (o = (e.max.z - d.z) * h, l = (e.min.z - d.z) * h), n > l || o > i) || ((o > n || n !== n) && (n = o), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(n >= 0 ? n : i, t);
  }
  intersectsBox(e) {
    return this.intersectBox(e, tn) !== null;
  }
  intersectTriangle(e, t, n, i, s) {
    cr.subVectors(t, e), ds.subVectors(n, e), hr.crossVectors(cr, ds);
    let a = this.direction.dot(hr), o;
    if (a > 0) {
      if (i)
        return null;
      o = 1;
    } else if (a < 0)
      o = -1, a = -a;
    else
      return null;
    pn.subVectors(this.origin, e);
    const l = o * this.direction.dot(ds.crossVectors(pn, ds));
    if (l < 0)
      return null;
    const c = o * this.direction.dot(cr.cross(pn));
    if (c < 0 || l + c > a)
      return null;
    const u = -o * pn.dot(hr);
    return u < 0 ? null : this.at(u / a, s);
  }
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Fe {
  constructor() {
    Fe.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
  }
  set(e, t, n, i, s, a, o, l, c, u, h, d, m, g, p, f) {
    const v = this.elements;
    return v[0] = e, v[4] = t, v[8] = n, v[12] = i, v[1] = s, v[5] = a, v[9] = o, v[13] = l, v[2] = c, v[6] = u, v[10] = h, v[14] = d, v[3] = m, v[7] = g, v[11] = p, v[15] = f, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new Fe().fromArray(this.elements);
  }
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
  }
  copyPosition(e) {
    const t = this.elements, n = e.elements;
    return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
  }
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(e, t, n) {
    return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(e, t, n) {
    return this.set(
      e.x,
      t.x,
      n.x,
      0,
      e.y,
      t.y,
      n.y,
      0,
      e.z,
      t.z,
      n.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(e) {
    const t = this.elements, n = e.elements, i = 1 / Qn.setFromMatrixColumn(e, 0).length(), s = 1 / Qn.setFromMatrixColumn(e, 1).length(), a = 1 / Qn.setFromMatrixColumn(e, 2).length();
    return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * s, t[5] = n[5] * s, t[6] = n[6] * s, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  makeRotationFromEuler(e) {
    const t = this.elements, n = e.x, i = e.y, s = e.z, a = Math.cos(n), o = Math.sin(n), l = Math.cos(i), c = Math.sin(i), u = Math.cos(s), h = Math.sin(s);
    if (e.order === "XYZ") {
      const d = a * u, m = a * h, g = o * u, p = o * h;
      t[0] = l * u, t[4] = -l * h, t[8] = c, t[1] = m + g * c, t[5] = d - p * c, t[9] = -o * l, t[2] = p - d * c, t[6] = g + m * c, t[10] = a * l;
    } else if (e.order === "YXZ") {
      const d = l * u, m = l * h, g = c * u, p = c * h;
      t[0] = d + p * o, t[4] = g * o - m, t[8] = a * c, t[1] = a * h, t[5] = a * u, t[9] = -o, t[2] = m * o - g, t[6] = p + d * o, t[10] = a * l;
    } else if (e.order === "ZXY") {
      const d = l * u, m = l * h, g = c * u, p = c * h;
      t[0] = d - p * o, t[4] = -a * h, t[8] = g + m * o, t[1] = m + g * o, t[5] = a * u, t[9] = p - d * o, t[2] = -a * c, t[6] = o, t[10] = a * l;
    } else if (e.order === "ZYX") {
      const d = a * u, m = a * h, g = o * u, p = o * h;
      t[0] = l * u, t[4] = g * c - m, t[8] = d * c + p, t[1] = l * h, t[5] = p * c + d, t[9] = m * c - g, t[2] = -c, t[6] = o * l, t[10] = a * l;
    } else if (e.order === "YZX") {
      const d = a * l, m = a * c, g = o * l, p = o * c;
      t[0] = l * u, t[4] = p - d * h, t[8] = g * h + m, t[1] = h, t[5] = a * u, t[9] = -o * u, t[2] = -c * u, t[6] = m * h + g, t[10] = d - p * h;
    } else if (e.order === "XZY") {
      const d = a * l, m = a * c, g = o * l, p = o * c;
      t[0] = l * u, t[4] = -h, t[8] = c * u, t[1] = d * h + p, t[5] = a * u, t[9] = m * h - g, t[2] = g * h - m, t[6] = o * u, t[10] = p * h + d;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  makeRotationFromQuaternion(e) {
    return this.compose(jh, e, Xh);
  }
  lookAt(e, t, n) {
    const i = this.elements;
    return Pt.subVectors(e, t), Pt.lengthSq() === 0 && (Pt.z = 1), Pt.normalize(), mn.crossVectors(n, Pt), mn.lengthSq() === 0 && (Math.abs(n.z) === 1 ? Pt.x += 1e-4 : Pt.z += 1e-4, Pt.normalize(), mn.crossVectors(n, Pt)), mn.normalize(), fs.crossVectors(Pt, mn), i[0] = mn.x, i[4] = fs.x, i[8] = Pt.x, i[1] = mn.y, i[5] = fs.y, i[9] = Pt.y, i[2] = mn.z, i[6] = fs.z, i[10] = Pt.z, this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, s = this.elements, a = n[0], o = n[4], l = n[8], c = n[12], u = n[1], h = n[5], d = n[9], m = n[13], g = n[2], p = n[6], f = n[10], v = n[14], S = n[3], y = n[7], b = n[11], w = n[15], D = i[0], z = i[4], x = i[8], R = i[12], k = i[1], T = i[5], ee = i[9], V = i[13], H = i[2], j = i[6], G = i[10], te = i[14], Z = i[3], re = i[7], $ = i[11], K = i[15];
    return s[0] = a * D + o * k + l * H + c * Z, s[4] = a * z + o * T + l * j + c * re, s[8] = a * x + o * ee + l * G + c * $, s[12] = a * R + o * V + l * te + c * K, s[1] = u * D + h * k + d * H + m * Z, s[5] = u * z + h * T + d * j + m * re, s[9] = u * x + h * ee + d * G + m * $, s[13] = u * R + h * V + d * te + m * K, s[2] = g * D + p * k + f * H + v * Z, s[6] = g * z + p * T + f * j + v * re, s[10] = g * x + p * ee + f * G + v * $, s[14] = g * R + p * V + f * te + v * K, s[3] = S * D + y * k + b * H + w * Z, s[7] = S * z + y * T + b * j + w * re, s[11] = S * x + y * ee + b * G + w * $, s[15] = S * R + y * V + b * te + w * K, this;
  }
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  determinant() {
    const e = this.elements, t = e[0], n = e[4], i = e[8], s = e[12], a = e[1], o = e[5], l = e[9], c = e[13], u = e[2], h = e[6], d = e[10], m = e[14], g = e[3], p = e[7], f = e[11], v = e[15];
    return g * (+s * l * h - i * c * h - s * o * d + n * c * d + i * o * m - n * l * m) + p * (+t * l * m - t * c * d + s * a * d - i * a * m + i * c * u - s * l * u) + f * (+t * c * h - t * o * m - s * a * h + n * a * m + s * o * u - n * c * u) + v * (-i * o * u - t * l * h + t * o * d + i * a * h - n * a * d + n * l * u);
  }
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  setPosition(e, t, n) {
    const i = this.elements;
    return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = t, i[14] = n), this;
  }
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], c = e[7], u = e[8], h = e[9], d = e[10], m = e[11], g = e[12], p = e[13], f = e[14], v = e[15], S = h * f * c - p * d * c + p * l * m - o * f * m - h * l * v + o * d * v, y = g * d * c - u * f * c - g * l * m + a * f * m + u * l * v - a * d * v, b = u * p * c - g * h * c + g * o * m - a * p * m - u * o * v + a * h * v, w = g * h * l - u * p * l - g * o * d + a * p * d + u * o * f - a * h * f, D = t * S + n * y + i * b + s * w;
    if (D === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const z = 1 / D;
    return e[0] = S * z, e[1] = (p * d * s - h * f * s - p * i * m + n * f * m + h * i * v - n * d * v) * z, e[2] = (o * f * s - p * l * s + p * i * c - n * f * c - o * i * v + n * l * v) * z, e[3] = (h * l * s - o * d * s - h * i * c + n * d * c + o * i * m - n * l * m) * z, e[4] = y * z, e[5] = (u * f * s - g * d * s + g * i * m - t * f * m - u * i * v + t * d * v) * z, e[6] = (g * l * s - a * f * s - g * i * c + t * f * c + a * i * v - t * l * v) * z, e[7] = (a * d * s - u * l * s + u * i * c - t * d * c - a * i * m + t * l * m) * z, e[8] = b * z, e[9] = (g * h * s - u * p * s - g * n * m + t * p * m + u * n * v - t * h * v) * z, e[10] = (a * p * s - g * o * s + g * n * c - t * p * c - a * n * v + t * o * v) * z, e[11] = (u * o * s - a * h * s - u * n * c + t * h * c + a * n * m - t * o * m) * z, e[12] = w * z, e[13] = (u * p * i - g * h * i + g * n * d - t * p * d - u * n * f + t * h * f) * z, e[14] = (g * o * i - a * p * i - g * n * l + t * p * l + a * n * f - t * o * f) * z, e[15] = (a * h * i - u * o * i + u * n * l - t * h * l - a * n * d + t * o * d) * z, this;
  }
  scale(e) {
    const t = this.elements, n = e.x, i = e.y, s = e.z;
    return t[0] *= n, t[4] *= i, t[8] *= s, t[1] *= n, t[5] *= i, t[9] *= s, t[2] *= n, t[6] *= i, t[10] *= s, t[3] *= n, t[7] *= i, t[11] *= s, this;
  }
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, n, i));
  }
  makeTranslation(e, t, n) {
    return this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      0,
      n,
      0,
      0,
      1,
      0,
      0,
      -n,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(e, t) {
    const n = Math.cos(t), i = Math.sin(t), s = 1 - n, a = e.x, o = e.y, l = e.z, c = s * a, u = s * o;
    return this.set(
      c * a + n,
      c * o - i * l,
      c * l + i * o,
      0,
      c * o + i * l,
      u * o + n,
      u * l - i * a,
      0,
      c * l - i * o,
      u * l + i * a,
      s * l * l + n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, t, n) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(e, t, n, i, s, a) {
    return this.set(
      1,
      n,
      s,
      0,
      e,
      1,
      a,
      0,
      t,
      i,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(e, t, n) {
    const i = this.elements, s = t._x, a = t._y, o = t._z, l = t._w, c = s + s, u = a + a, h = o + o, d = s * c, m = s * u, g = s * h, p = a * u, f = a * h, v = o * h, S = l * c, y = l * u, b = l * h, w = n.x, D = n.y, z = n.z;
    return i[0] = (1 - (p + v)) * w, i[1] = (m + b) * w, i[2] = (g - y) * w, i[3] = 0, i[4] = (m - b) * D, i[5] = (1 - (d + v)) * D, i[6] = (f + S) * D, i[7] = 0, i[8] = (g + y) * z, i[9] = (f - S) * z, i[10] = (1 - (d + p)) * z, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
  }
  decompose(e, t, n) {
    const i = this.elements;
    let s = Qn.set(i[0], i[1], i[2]).length();
    const a = Qn.set(i[4], i[5], i[6]).length(), o = Qn.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (s = -s), e.x = i[12], e.y = i[13], e.z = i[14], Vt.copy(this);
    const c = 1 / s, u = 1 / a, h = 1 / o;
    return Vt.elements[0] *= c, Vt.elements[1] *= c, Vt.elements[2] *= c, Vt.elements[4] *= u, Vt.elements[5] *= u, Vt.elements[6] *= u, Vt.elements[8] *= h, Vt.elements[9] *= h, Vt.elements[10] *= h, t.setFromRotationMatrix(Vt), n.x = s, n.y = a, n.z = o, this;
  }
  makePerspective(e, t, n, i, s, a) {
    const o = this.elements, l = 2 * s / (t - e), c = 2 * s / (n - i), u = (t + e) / (t - e), h = (n + i) / (n - i), d = -(a + s) / (a - s), m = -2 * a * s / (a - s);
    return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = m, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
  }
  makeOrthographic(e, t, n, i, s, a) {
    const o = this.elements, l = 1 / (t - e), c = 1 / (n - i), u = 1 / (a - s), h = (t + e) * l, d = (n + i) * c, m = (a + s) * u;
    return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = -2 * u, o[14] = -m, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
  }
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 16; i++)
      if (t[i] !== n[i])
        return !1;
    return !0;
  }
  fromArray(e, t = 0) {
    for (let n = 0; n < 16; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
  }
}
const Qn = /* @__PURE__ */ new F(), Vt = /* @__PURE__ */ new Fe(), jh = /* @__PURE__ */ new F(0, 0, 0), Xh = /* @__PURE__ */ new F(1, 1, 1), mn = /* @__PURE__ */ new F(), fs = /* @__PURE__ */ new F(), Pt = /* @__PURE__ */ new F(), ja = /* @__PURE__ */ new Fe(), Xa = /* @__PURE__ */ new $t();
class ts {
  constructor(e = 0, t = 0, n = 0, i = ts.DefaultOrder) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = n, this._order = i;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  set(e, t, n, i = this._order) {
    return this._x = e, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e, t = this._order, n = !0) {
    const i = e.elements, s = i[0], a = i[4], o = i[8], l = i[1], c = i[5], u = i[9], h = i[2], d = i[6], m = i[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(vt(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-u, m), this._z = Math.atan2(-a, s)) : (this._x = Math.atan2(d, c), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-vt(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(o, m), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-h, s), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(vt(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._y = Math.atan2(-h, m), this._z = Math.atan2(-a, c)) : (this._y = 0, this._z = Math.atan2(l, s));
        break;
      case "ZYX":
        this._y = Math.asin(-vt(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(d, m), this._z = Math.atan2(l, s)) : (this._x = 0, this._z = Math.atan2(-a, c));
        break;
      case "YZX":
        this._z = Math.asin(vt(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-u, c), this._y = Math.atan2(-h, s)) : (this._x = 0, this._y = Math.atan2(o, m));
        break;
      case "XZY":
        this._z = Math.asin(-vt(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(o, s)) : (this._x = Math.atan2(-u, m), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, n === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(e, t, n) {
    return ja.makeRotationFromQuaternion(e), this.setFromRotationMatrix(ja, t, n);
  }
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  reorder(e) {
    return Xa.setFromEuler(this), this.setFromQuaternion(Xa, e);
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
  toVector3() {
    console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
  }
}
ts.DefaultOrder = "XYZ";
ts.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];
class gl {
  constructor() {
    this.mask = 1;
  }
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let qh = 0;
const qa = /* @__PURE__ */ new F(), ei = /* @__PURE__ */ new $t(), nn = /* @__PURE__ */ new Fe(), ps = /* @__PURE__ */ new F(), Di = /* @__PURE__ */ new F(), Yh = /* @__PURE__ */ new F(), Kh = /* @__PURE__ */ new $t(), Ya = /* @__PURE__ */ new F(1, 0, 0), Ka = /* @__PURE__ */ new F(0, 1, 0), Za = /* @__PURE__ */ new F(0, 0, 1), Zh = { type: "added" }, $a = { type: "removed" };
class nt extends jn {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: qh++ }), this.uuid = jt(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = nt.DefaultUp.clone();
    const e = new F(), t = new ts(), n = new $t(), i = new F(1, 1, 1);
    function s() {
      n.setFromEuler(t, !1);
    }
    function a() {
      t.setFromQuaternion(n, void 0, !1);
    }
    t._onChange(s), n._onChange(a), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      modelViewMatrix: {
        value: new Fe()
      },
      normalMatrix: {
        value: new It()
      }
    }), this.matrix = new Fe(), this.matrixWorld = new Fe(), this.matrixAutoUpdate = nt.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = nt.DefaultMatrixWorldAutoUpdate, this.layers = new gl(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  rotateOnAxis(e, t) {
    return ei.setFromAxisAngle(e, t), this.quaternion.multiply(ei), this;
  }
  rotateOnWorldAxis(e, t) {
    return ei.setFromAxisAngle(e, t), this.quaternion.premultiply(ei), this;
  }
  rotateX(e) {
    return this.rotateOnAxis(Ya, e);
  }
  rotateY(e) {
    return this.rotateOnAxis(Ka, e);
  }
  rotateZ(e) {
    return this.rotateOnAxis(Za, e);
  }
  translateOnAxis(e, t) {
    return qa.copy(e).applyQuaternion(this.quaternion), this.position.add(qa.multiplyScalar(t)), this;
  }
  translateX(e) {
    return this.translateOnAxis(Ya, e);
  }
  translateY(e) {
    return this.translateOnAxis(Ka, e);
  }
  translateZ(e) {
    return this.translateOnAxis(Za, e);
  }
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(nn.copy(this.matrixWorld).invert());
  }
  lookAt(e, t, n) {
    e.isVector3 ? ps.copy(e) : ps.set(e, t, n);
    const i = this.parent;
    this.updateWorldMatrix(!0, !1), Di.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? nn.lookAt(Di, ps, this.up) : nn.lookAt(ps, Di, this.up), this.quaternion.setFromRotationMatrix(nn), i && (nn.extractRotation(i.matrixWorld), ei.setFromRotationMatrix(nn), this.quaternion.premultiply(ei.invert()));
  }
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.parent !== null && e.parent.remove(e), e.parent = this, this.children.push(e), e.dispatchEvent(Zh)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.remove(arguments[n]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent($a)), this;
  }
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  clear() {
    for (let e = 0; e < this.children.length; e++) {
      const t = this.children[e];
      t.parent = null, t.dispatchEvent($a);
    }
    return this.children.length = 0, this;
  }
  attach(e) {
    return this.updateWorldMatrix(!0, !1), nn.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), nn.multiply(e.parent.matrixWorld)), e.applyMatrix4(nn), this.add(e), e.updateWorldMatrix(!1, !0), this;
  }
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  getObjectByProperty(e, t) {
    if (this[e] === t)
      return this;
    for (let n = 0, i = this.children.length; n < i; n++) {
      const a = this.children[n].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  getObjectsByProperty(e, t) {
    let n = [];
    this[e] === t && n.push(this);
    for (let i = 0, s = this.children.length; i < s; i++) {
      const a = this.children[i].getObjectsByProperty(e, t);
      a.length > 0 && (n = n.concat(a));
    }
    return n;
  }
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Di, e, Yh), e;
  }
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Di, Kh, e), e;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  raycast() {
  }
  traverse(e) {
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverse(e);
  }
  traverseVisible(e) {
    if (this.visible === !1)
      return;
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverseVisible(e);
  }
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      (s.matrixWorldAutoUpdate === !0 || e === !0) && s.updateMatrixWorld(e);
    }
  }
  updateWorldMatrix(e, t) {
    const n = this.parent;
    if (e === !0 && n !== null && n.matrixWorldAutoUpdate === !0 && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), t === !0) {
      const i = this.children;
      for (let s = 0, a = i.length; s < a; s++) {
        const o = i[s];
        o.matrixWorldAutoUpdate === !0 && o.updateWorldMatrix(!1, !0);
      }
    }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", n = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, n.metadata = {
      version: 4.5,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const i = {};
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON()));
    function s(o, l) {
      return o[l.uuid] === void 0 && (o[l.uuid] = l.toJSON(e)), l.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      i.geometry = s(e.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const l = o.shapes;
        if (Array.isArray(l))
          for (let c = 0, u = l.length; c < u; c++) {
            const h = l[c];
            s(e.shapes, h);
          }
        else
          s(e.shapes, l);
      }
    }
    if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let l = 0, c = this.material.length; l < c; l++)
          o.push(s(e.materials, this.material[l]));
        i.material = o;
      } else
        i.material = s(e.materials, this.material);
    if (this.children.length > 0) {
      i.children = [];
      for (let o = 0; o < this.children.length; o++)
        i.children.push(this.children[o].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      i.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const l = this.animations[o];
        i.animations.push(s(e.animations, l));
      }
    }
    if (t) {
      const o = a(e.geometries), l = a(e.materials), c = a(e.textures), u = a(e.images), h = a(e.shapes), d = a(e.skeletons), m = a(e.animations), g = a(e.nodes);
      o.length > 0 && (n.geometries = o), l.length > 0 && (n.materials = l), c.length > 0 && (n.textures = c), u.length > 0 && (n.images = u), h.length > 0 && (n.shapes = h), d.length > 0 && (n.skeletons = d), m.length > 0 && (n.animations = m), g.length > 0 && (n.nodes = g);
    }
    return n.object = i, n;
    function a(o) {
      const l = [];
      for (const c in o) {
        const u = o[c];
        delete u.metadata, l.push(u);
      }
      return l;
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let n = 0; n < e.children.length; n++) {
        const i = e.children[n];
        this.add(i.clone());
      }
    return this;
  }
}
nt.DefaultUp = /* @__PURE__ */ new F(0, 1, 0);
nt.DefaultMatrixAutoUpdate = !0;
nt.DefaultMatrixWorldAutoUpdate = !0;
const Gt = /* @__PURE__ */ new F(), sn = /* @__PURE__ */ new F(), ur = /* @__PURE__ */ new F(), rn = /* @__PURE__ */ new F(), ti = /* @__PURE__ */ new F(), ni = /* @__PURE__ */ new F(), Ja = /* @__PURE__ */ new F(), dr = /* @__PURE__ */ new F(), fr = /* @__PURE__ */ new F(), pr = /* @__PURE__ */ new F();
class on {
  constructor(e = new F(), t = new F(), n = new F()) {
    this.a = e, this.b = t, this.c = n;
  }
  static getNormal(e, t, n, i) {
    i.subVectors(n, t), Gt.subVectors(e, t), i.cross(Gt);
    const s = i.lengthSq();
    return s > 0 ? i.multiplyScalar(1 / Math.sqrt(s)) : i.set(0, 0, 0);
  }
  static getBarycoord(e, t, n, i, s) {
    Gt.subVectors(i, t), sn.subVectors(n, t), ur.subVectors(e, t);
    const a = Gt.dot(Gt), o = Gt.dot(sn), l = Gt.dot(ur), c = sn.dot(sn), u = sn.dot(ur), h = a * c - o * o;
    if (h === 0)
      return s.set(-2, -1, -1);
    const d = 1 / h, m = (c * l - o * u) * d, g = (a * u - o * l) * d;
    return s.set(1 - m - g, g, m);
  }
  static containsPoint(e, t, n, i) {
    return this.getBarycoord(e, t, n, i, rn), rn.x >= 0 && rn.y >= 0 && rn.x + rn.y <= 1;
  }
  static getUV(e, t, n, i, s, a, o, l) {
    return this.getBarycoord(e, t, n, i, rn), l.set(0, 0), l.addScaledVector(s, rn.x), l.addScaledVector(a, rn.y), l.addScaledVector(o, rn.z), l;
  }
  static isFrontFacing(e, t, n, i) {
    return Gt.subVectors(n, t), sn.subVectors(e, t), Gt.cross(sn).dot(i) < 0;
  }
  set(e, t, n) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
  }
  setFromPointsAndIndices(e, t, n, i) {
    return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this;
  }
  setFromAttributeAndIndices(e, t, n, i) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, i), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  getArea() {
    return Gt.subVectors(this.c, this.b), sn.subVectors(this.a, this.b), Gt.cross(sn).length() * 0.5;
  }
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(e) {
    return on.getNormal(this.a, this.b, this.c, e);
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(e, t) {
    return on.getBarycoord(e, this.a, this.b, this.c, t);
  }
  getUV(e, t, n, i, s) {
    return on.getUV(e, this.a, this.b, this.c, t, n, i, s);
  }
  containsPoint(e) {
    return on.containsPoint(e, this.a, this.b, this.c);
  }
  isFrontFacing(e) {
    return on.isFrontFacing(this.a, this.b, this.c, e);
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  closestPointToPoint(e, t) {
    const n = this.a, i = this.b, s = this.c;
    let a, o;
    ti.subVectors(i, n), ni.subVectors(s, n), dr.subVectors(e, n);
    const l = ti.dot(dr), c = ni.dot(dr);
    if (l <= 0 && c <= 0)
      return t.copy(n);
    fr.subVectors(e, i);
    const u = ti.dot(fr), h = ni.dot(fr);
    if (u >= 0 && h <= u)
      return t.copy(i);
    const d = l * h - u * c;
    if (d <= 0 && l >= 0 && u <= 0)
      return a = l / (l - u), t.copy(n).addScaledVector(ti, a);
    pr.subVectors(e, s);
    const m = ti.dot(pr), g = ni.dot(pr);
    if (g >= 0 && m <= g)
      return t.copy(s);
    const p = m * c - l * g;
    if (p <= 0 && c >= 0 && g <= 0)
      return o = c / (c - g), t.copy(n).addScaledVector(ni, o);
    const f = u * g - m * h;
    if (f <= 0 && h - u >= 0 && m - g >= 0)
      return Ja.subVectors(s, i), o = (h - u) / (h - u + (m - g)), t.copy(i).addScaledVector(Ja, o);
    const v = 1 / (f + p + d);
    return a = p * v, o = d * v, t.copy(n).addScaledVector(ti, a).addScaledVector(ni, o);
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
let $h = 0;
class Xt extends jn {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: $h++ }), this.uuid = jt(), this.name = "", this.type = "Material", this.blending = ui, this.side = Mn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = sl, this.blendDst = rl, this.blendEquation = ci, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = Or, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = Eh, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Qs, this.stencilZFail = Qs, this.stencilZPass = Qs, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  onBuild() {
  }
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const n = e[t];
        if (n === void 0) {
          console.warn("THREE.Material: '" + t + "' parameter is undefined.");
          continue;
        }
        const i = this[t];
        if (i === void 0) {
          console.warn("THREE." + this.type + ": '" + t + "' is not a property of this material.");
          continue;
        }
        i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n;
      }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const n = {
      metadata: {
        version: 4.5,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== ui && (n.blending = this.blending), this.side !== Mn && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (n.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = this.premultipliedAlpha), this.wireframe === !0 && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = this.flatShading), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
    function i(s) {
      const a = [];
      for (const o in s) {
        const l = s[o];
        delete l.metadata, a.push(l);
      }
      return a;
    }
    if (t) {
      const s = i(e.textures), a = i(e.images);
      s.length > 0 && (n.textures = s), a.length > 0 && (n.images = a);
    }
    return n;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let n = null;
    if (t !== null) {
      const i = t.length;
      n = new Array(i);
      for (let s = 0; s !== i; ++s)
        n[s] = t[s].clone();
    }
    return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
class In extends Xt {
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new De(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Yr, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const rt = /* @__PURE__ */ new F(), ms = /* @__PURE__ */ new Pe();
class gt {
  constructor(e, t, n = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = n, this.usage = Ur, this.updateRange = { offset: 0, count: -1 }, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this;
  }
  copyAt(e, t, n) {
    e *= this.itemSize, n *= t.itemSize;
    for (let i = 0, s = this.itemSize; i < s; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  copyArray(e) {
    return this.array.set(e), this;
  }
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, n = this.count; t < n; t++)
        ms.fromBufferAttribute(this, t), ms.applyMatrix3(e), this.setXY(t, ms.x, ms.y);
    else if (this.itemSize === 3)
      for (let t = 0, n = this.count; t < n; t++)
        rt.fromBufferAttribute(this, t), rt.applyMatrix3(e), this.setXYZ(t, rt.x, rt.y, rt.z);
    return this;
  }
  applyMatrix4(e) {
    for (let t = 0, n = this.count; t < n; t++)
      rt.fromBufferAttribute(this, t), rt.applyMatrix4(e), this.setXYZ(t, rt.x, rt.y, rt.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      rt.fromBufferAttribute(this, t), rt.applyNormalMatrix(e), this.setXYZ(t, rt.x, rt.y, rt.z);
    return this;
  }
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      rt.fromBufferAttribute(this, t), rt.transformDirection(e), this.setXYZ(t, rt.x, rt.y, rt.z);
    return this;
  }
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  getX(e) {
    let t = this.array[e * this.itemSize];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  setX(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.array[e * this.itemSize] = t, this;
  }
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  setY(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
  }
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  setZ(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
  }
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  setW(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
  }
  setXY(e, t, n) {
    return e *= this.itemSize, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
  }
  setXYZ(e, t, n, i) {
    return e *= this.itemSize, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array), i = Ke(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this;
  }
  setXYZW(e, t, n, i, s) {
    return e *= this.itemSize, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array), i = Ke(i, this.array), s = Ke(s, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this.array[e + 3] = s, this;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== Ur && (e.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (e.updateRange = this.updateRange), e;
  }
  copyColorsArray() {
    console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
  }
  copyVector2sArray() {
    console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
  }
  copyVector3sArray() {
    console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
  }
  copyVector4sArray() {
    console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
  }
}
class _l extends gt {
  constructor(e, t, n) {
    super(new Uint16Array(e), t, n);
  }
}
class vl extends gt {
  constructor(e, t, n) {
    super(new Uint32Array(e), t, n);
  }
}
class hn extends gt {
  constructor(e, t, n) {
    super(new Float32Array(e), t, n);
  }
}
let Jh = 0;
const Ot = /* @__PURE__ */ new Fe(), mr = /* @__PURE__ */ new nt(), ii = /* @__PURE__ */ new F(), Dt = /* @__PURE__ */ new wi(), Ii = /* @__PURE__ */ new wi(), dt = /* @__PURE__ */ new F();
class Yt extends jn {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: Jh++ }), this.uuid = jt(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (ul(e) ? vl : _l)(e, 1) : this.index = e, this;
  }
  getAttribute(e) {
    return this.attributes[e];
  }
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  addGroup(e, t, n = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: n
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const n = this.attributes.normal;
    if (n !== void 0) {
      const s = new It().getNormalMatrix(e);
      n.applyNormalMatrix(s), n.needsUpdate = !0;
    }
    const i = this.attributes.tangent;
    return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(e) {
    return Ot.makeRotationFromQuaternion(e), this.applyMatrix4(Ot), this;
  }
  rotateX(e) {
    return Ot.makeRotationX(e), this.applyMatrix4(Ot), this;
  }
  rotateY(e) {
    return Ot.makeRotationY(e), this.applyMatrix4(Ot), this;
  }
  rotateZ(e) {
    return Ot.makeRotationZ(e), this.applyMatrix4(Ot), this;
  }
  translate(e, t, n) {
    return Ot.makeTranslation(e, t, n), this.applyMatrix4(Ot), this;
  }
  scale(e, t, n) {
    return Ot.makeScale(e, t, n), this.applyMatrix4(Ot), this;
  }
  lookAt(e) {
    return mr.lookAt(e), mr.updateMatrix(), this.applyMatrix4(mr.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(ii).negate(), this.translate(ii.x, ii.y, ii.z), this;
  }
  setFromPoints(e) {
    const t = [];
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      t.push(s.x, s.y, s.z || 0);
    }
    return this.setAttribute("position", new hn(t, 3)), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new wi());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(
        new F(-1 / 0, -1 / 0, -1 / 0),
        new F(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let n = 0, i = t.length; n < i; n++) {
          const s = t[n];
          Dt.setFromBufferAttribute(s), this.morphTargetsRelative ? (dt.addVectors(this.boundingBox.min, Dt.min), this.boundingBox.expandByPoint(dt), dt.addVectors(this.boundingBox.max, Dt.max), this.boundingBox.expandByPoint(dt)) : (this.boundingBox.expandByPoint(Dt.min), this.boundingBox.expandByPoint(Dt.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Si());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new F(), 1 / 0);
      return;
    }
    if (e) {
      const n = this.boundingSphere.center;
      if (Dt.setFromBufferAttribute(e), t)
        for (let s = 0, a = t.length; s < a; s++) {
          const o = t[s];
          Ii.setFromBufferAttribute(o), this.morphTargetsRelative ? (dt.addVectors(Dt.min, Ii.min), Dt.expandByPoint(dt), dt.addVectors(Dt.max, Ii.max), Dt.expandByPoint(dt)) : (Dt.expandByPoint(Ii.min), Dt.expandByPoint(Ii.max));
        }
      Dt.getCenter(n);
      let i = 0;
      for (let s = 0, a = e.count; s < a; s++)
        dt.fromBufferAttribute(e, s), i = Math.max(i, n.distanceToSquared(dt));
      if (t)
        for (let s = 0, a = t.length; s < a; s++) {
          const o = t[s], l = this.morphTargetsRelative;
          for (let c = 0, u = o.count; c < u; c++)
            dt.fromBufferAttribute(o, c), l && (ii.fromBufferAttribute(e, c), dt.add(ii)), i = Math.max(i, n.distanceToSquared(dt));
        }
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const n = e.array, i = t.position.array, s = t.normal.array, a = t.uv.array, o = i.length / 3;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new gt(new Float32Array(4 * o), 4));
    const l = this.getAttribute("tangent").array, c = [], u = [];
    for (let k = 0; k < o; k++)
      c[k] = new F(), u[k] = new F();
    const h = new F(), d = new F(), m = new F(), g = new Pe(), p = new Pe(), f = new Pe(), v = new F(), S = new F();
    function y(k, T, ee) {
      h.fromArray(i, k * 3), d.fromArray(i, T * 3), m.fromArray(i, ee * 3), g.fromArray(a, k * 2), p.fromArray(a, T * 2), f.fromArray(a, ee * 2), d.sub(h), m.sub(h), p.sub(g), f.sub(g);
      const V = 1 / (p.x * f.y - f.x * p.y);
      !isFinite(V) || (v.copy(d).multiplyScalar(f.y).addScaledVector(m, -p.y).multiplyScalar(V), S.copy(m).multiplyScalar(p.x).addScaledVector(d, -f.x).multiplyScalar(V), c[k].add(v), c[T].add(v), c[ee].add(v), u[k].add(S), u[T].add(S), u[ee].add(S));
    }
    let b = this.groups;
    b.length === 0 && (b = [{
      start: 0,
      count: n.length
    }]);
    for (let k = 0, T = b.length; k < T; ++k) {
      const ee = b[k], V = ee.start, H = ee.count;
      for (let j = V, G = V + H; j < G; j += 3)
        y(
          n[j + 0],
          n[j + 1],
          n[j + 2]
        );
    }
    const w = new F(), D = new F(), z = new F(), x = new F();
    function R(k) {
      z.fromArray(s, k * 3), x.copy(z);
      const T = c[k];
      w.copy(T), w.sub(z.multiplyScalar(z.dot(T))).normalize(), D.crossVectors(x, T);
      const V = D.dot(u[k]) < 0 ? -1 : 1;
      l[k * 4] = w.x, l[k * 4 + 1] = w.y, l[k * 4 + 2] = w.z, l[k * 4 + 3] = V;
    }
    for (let k = 0, T = b.length; k < T; ++k) {
      const ee = b[k], V = ee.start, H = ee.count;
      for (let j = V, G = V + H; j < G; j += 3)
        R(n[j + 0]), R(n[j + 1]), R(n[j + 2]);
    }
  }
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let n = this.getAttribute("normal");
      if (n === void 0)
        n = new gt(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
      else
        for (let d = 0, m = n.count; d < m; d++)
          n.setXYZ(d, 0, 0, 0);
      const i = new F(), s = new F(), a = new F(), o = new F(), l = new F(), c = new F(), u = new F(), h = new F();
      if (e)
        for (let d = 0, m = e.count; d < m; d += 3) {
          const g = e.getX(d + 0), p = e.getX(d + 1), f = e.getX(d + 2);
          i.fromBufferAttribute(t, g), s.fromBufferAttribute(t, p), a.fromBufferAttribute(t, f), u.subVectors(a, s), h.subVectors(i, s), u.cross(h), o.fromBufferAttribute(n, g), l.fromBufferAttribute(n, p), c.fromBufferAttribute(n, f), o.add(u), l.add(u), c.add(u), n.setXYZ(g, o.x, o.y, o.z), n.setXYZ(p, l.x, l.y, l.z), n.setXYZ(f, c.x, c.y, c.z);
        }
      else
        for (let d = 0, m = t.count; d < m; d += 3)
          i.fromBufferAttribute(t, d + 0), s.fromBufferAttribute(t, d + 1), a.fromBufferAttribute(t, d + 2), u.subVectors(a, s), h.subVectors(i, s), u.cross(h), n.setXYZ(d + 0, u.x, u.y, u.z), n.setXYZ(d + 1, u.x, u.y, u.z), n.setXYZ(d + 2, u.x, u.y, u.z);
      this.normalizeNormals(), n.needsUpdate = !0;
    }
  }
  merge() {
    return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead."), this;
  }
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, n = e.count; t < n; t++)
      dt.fromBufferAttribute(e, t), dt.normalize(), e.setXYZ(t, dt.x, dt.y, dt.z);
  }
  toNonIndexed() {
    function e(o, l) {
      const c = o.array, u = o.itemSize, h = o.normalized, d = new c.constructor(l.length * u);
      let m = 0, g = 0;
      for (let p = 0, f = l.length; p < f; p++) {
        o.isInterleavedBufferAttribute ? m = l[p] * o.data.stride + o.offset : m = l[p] * u;
        for (let v = 0; v < u; v++)
          d[g++] = c[m++];
      }
      return new gt(d, u, h);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new Yt(), n = this.index.array, i = this.attributes;
    for (const o in i) {
      const l = i[o], c = e(l, n);
      t.setAttribute(o, c);
    }
    const s = this.morphAttributes;
    for (const o in s) {
      const l = [], c = s[o];
      for (let u = 0, h = c.length; u < h; u++) {
        const d = c[u], m = e(d, n);
        l.push(m);
      }
      t.morphAttributes[o] = l;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const a = this.groups;
    for (let o = 0, l = a.length; o < l; o++) {
      const c = a[o];
      t.addGroup(c.start, c.count, c.materialIndex);
    }
    return t;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.5,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const l = this.parameters;
      for (const c in l)
        l[c] !== void 0 && (e[c] = l[c]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const n = this.attributes;
    for (const l in n) {
      const c = n[l];
      e.data.attributes[l] = c.toJSON(e.data);
    }
    const i = {};
    let s = !1;
    for (const l in this.morphAttributes) {
      const c = this.morphAttributes[l], u = [];
      for (let h = 0, d = c.length; h < d; h++) {
        const m = c[h];
        u.push(m.toJSON(e.data));
      }
      u.length > 0 && (i[l] = u, s = !0);
    }
    s && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const a = this.groups;
    a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
    const o = this.boundingSphere;
    return o !== null && (e.data.boundingSphere = {
      center: o.center.toArray(),
      radius: o.radius
    }), e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const n = e.index;
    n !== null && this.setIndex(n.clone(t));
    const i = e.attributes;
    for (const c in i) {
      const u = i[c];
      this.setAttribute(c, u.clone(t));
    }
    const s = e.morphAttributes;
    for (const c in s) {
      const u = [], h = s[c];
      for (let d = 0, m = h.length; d < m; d++)
        u.push(h[d].clone(t));
      this.morphAttributes[c] = u;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const a = e.groups;
    for (let c = 0, u = a.length; c < u; c++) {
      const h = a[c];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const o = e.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const l = e.boundingSphere;
    return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, e.parameters !== void 0 && (this.parameters = Object.assign({}, e.parameters)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const Qa = /* @__PURE__ */ new Fe(), si = /* @__PURE__ */ new $r(), gr = /* @__PURE__ */ new Si(), Oi = /* @__PURE__ */ new F(), Ni = /* @__PURE__ */ new F(), Fi = /* @__PURE__ */ new F(), _r = /* @__PURE__ */ new F(), gs = /* @__PURE__ */ new F(), _s = /* @__PURE__ */ new Pe(), vs = /* @__PURE__ */ new Pe(), xs = /* @__PURE__ */ new Pe(), vr = /* @__PURE__ */ new F(), ys = /* @__PURE__ */ new F();
class Ut extends nt {
  constructor(e = new Yt(), t = new In()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = e.material, this.geometry = e.geometry, this;
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
  getVertexPosition(e, t) {
    const n = this.geometry, i = n.attributes.position, s = n.morphAttributes.position, a = n.morphTargetsRelative;
    t.fromBufferAttribute(i, e);
    const o = this.morphTargetInfluences;
    if (s && o) {
      gs.set(0, 0, 0);
      for (let l = 0, c = s.length; l < c; l++) {
        const u = o[l], h = s[l];
        u !== 0 && (_r.fromBufferAttribute(h, e), a ? gs.addScaledVector(_r, u) : gs.addScaledVector(_r.sub(t), u));
      }
      t.add(gs);
    }
    return this.isSkinnedMesh && this.boneTransform(e, t), t;
  }
  raycast(e, t) {
    const n = this.geometry, i = this.material, s = this.matrixWorld;
    if (i === void 0 || (n.boundingSphere === null && n.computeBoundingSphere(), gr.copy(n.boundingSphere), gr.applyMatrix4(s), e.ray.intersectsSphere(gr) === !1) || (Qa.copy(s).invert(), si.copy(e.ray).applyMatrix4(Qa), n.boundingBox !== null && si.intersectsBox(n.boundingBox) === !1))
      return;
    let a;
    const o = n.index, l = n.attributes.position, c = n.attributes.uv, u = n.attributes.uv2, h = n.groups, d = n.drawRange;
    if (o !== null)
      if (Array.isArray(i))
        for (let m = 0, g = h.length; m < g; m++) {
          const p = h[m], f = i[p.materialIndex], v = Math.max(p.start, d.start), S = Math.min(o.count, Math.min(p.start + p.count, d.start + d.count));
          for (let y = v, b = S; y < b; y += 3) {
            const w = o.getX(y), D = o.getX(y + 1), z = o.getX(y + 2);
            a = bs(this, f, e, si, c, u, w, D, z), a && (a.faceIndex = Math.floor(y / 3), a.face.materialIndex = p.materialIndex, t.push(a));
          }
        }
      else {
        const m = Math.max(0, d.start), g = Math.min(o.count, d.start + d.count);
        for (let p = m, f = g; p < f; p += 3) {
          const v = o.getX(p), S = o.getX(p + 1), y = o.getX(p + 2);
          a = bs(this, i, e, si, c, u, v, S, y), a && (a.faceIndex = Math.floor(p / 3), t.push(a));
        }
      }
    else if (l !== void 0)
      if (Array.isArray(i))
        for (let m = 0, g = h.length; m < g; m++) {
          const p = h[m], f = i[p.materialIndex], v = Math.max(p.start, d.start), S = Math.min(l.count, Math.min(p.start + p.count, d.start + d.count));
          for (let y = v, b = S; y < b; y += 3) {
            const w = y, D = y + 1, z = y + 2;
            a = bs(this, f, e, si, c, u, w, D, z), a && (a.faceIndex = Math.floor(y / 3), a.face.materialIndex = p.materialIndex, t.push(a));
          }
        }
      else {
        const m = Math.max(0, d.start), g = Math.min(l.count, d.start + d.count);
        for (let p = m, f = g; p < f; p += 3) {
          const v = p, S = p + 1, y = p + 2;
          a = bs(this, i, e, si, c, u, v, S, y), a && (a.faceIndex = Math.floor(p / 3), t.push(a));
        }
      }
  }
}
function Qh(r, e, t, n, i, s, a, o) {
  let l;
  if (e.side === kt ? l = n.intersectTriangle(a, s, i, !0, o) : l = n.intersectTriangle(i, s, a, e.side === Mn, o), l === null)
    return null;
  ys.copy(o), ys.applyMatrix4(r.matrixWorld);
  const c = t.ray.origin.distanceTo(ys);
  return c < t.near || c > t.far ? null : {
    distance: c,
    point: ys.clone(),
    object: r
  };
}
function bs(r, e, t, n, i, s, a, o, l) {
  r.getVertexPosition(a, Oi), r.getVertexPosition(o, Ni), r.getVertexPosition(l, Fi);
  const c = Qh(r, e, t, n, Oi, Ni, Fi, vr);
  if (c) {
    i && (_s.fromBufferAttribute(i, a), vs.fromBufferAttribute(i, o), xs.fromBufferAttribute(i, l), c.uv = on.getUV(vr, Oi, Ni, Fi, _s, vs, xs, new Pe())), s && (_s.fromBufferAttribute(s, a), vs.fromBufferAttribute(s, o), xs.fromBufferAttribute(s, l), c.uv2 = on.getUV(vr, Oi, Ni, Fi, _s, vs, xs, new Pe()));
    const u = {
      a,
      b: o,
      c: l,
      normal: new F(),
      materialIndex: 0
    };
    on.getNormal(Oi, Ni, Fi, u.normal), c.face = u;
  }
  return c;
}
class ns extends Yt {
  constructor(e = 1, t = 1, n = 1, i = 1, s = 1, a = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: n,
      widthSegments: i,
      heightSegments: s,
      depthSegments: a
    };
    const o = this;
    i = Math.floor(i), s = Math.floor(s), a = Math.floor(a);
    const l = [], c = [], u = [], h = [];
    let d = 0, m = 0;
    g("z", "y", "x", -1, -1, n, t, e, a, s, 0), g("z", "y", "x", 1, -1, n, t, -e, a, s, 1), g("x", "z", "y", 1, 1, e, n, t, i, a, 2), g("x", "z", "y", 1, -1, e, n, -t, i, a, 3), g("x", "y", "z", 1, -1, e, t, n, i, s, 4), g("x", "y", "z", -1, -1, e, t, -n, i, s, 5), this.setIndex(l), this.setAttribute("position", new hn(c, 3)), this.setAttribute("normal", new hn(u, 3)), this.setAttribute("uv", new hn(h, 2));
    function g(p, f, v, S, y, b, w, D, z, x, R) {
      const k = b / z, T = w / x, ee = b / 2, V = w / 2, H = D / 2, j = z + 1, G = x + 1;
      let te = 0, Z = 0;
      const re = new F();
      for (let $ = 0; $ < G; $++) {
        const K = $ * T - V;
        for (let W = 0; W < j; W++) {
          const le = W * k - ee;
          re[p] = le * S, re[f] = K * y, re[v] = H, c.push(re.x, re.y, re.z), re[p] = 0, re[f] = 0, re[v] = D > 0 ? 1 : -1, u.push(re.x, re.y, re.z), h.push(W / z), h.push(1 - $ / x), te += 1;
        }
      }
      for (let $ = 0; $ < x; $++)
        for (let K = 0; K < z; K++) {
          const W = d + K + j * $, le = d + K + j * ($ + 1), ae = d + (K + 1) + j * ($ + 1), ue = d + (K + 1) + j * $;
          l.push(W, le, ue), l.push(le, ae, ue), Z += 6;
        }
      o.addGroup(m, Z, R), m += Z, d += te;
    }
  }
  static fromJSON(e) {
    return new ns(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function bi(r) {
  const e = {};
  for (const t in r) {
    e[t] = {};
    for (const n in r[t]) {
      const i = r[t][n];
      i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? e[t][n] = i.clone() : Array.isArray(i) ? e[t][n] = i.slice() : e[t][n] = i;
    }
  }
  return e;
}
function Tt(r) {
  const e = {};
  for (let t = 0; t < r.length; t++) {
    const n = bi(r[t]);
    for (const i in n)
      e[i] = n[i];
  }
  return e;
}
function eu(r) {
  const e = [];
  for (let t = 0; t < r.length; t++)
    e.push(r[t].clone());
  return e;
}
function xl(r) {
  return r.getRenderTarget() === null && r.outputEncoding === Xe ? Kt : Zi;
}
const tu = { clone: bi, merge: Tt };
var nu = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, iu = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class Vn extends Xt {
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = nu, this.fragmentShader = iu, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
      derivatives: !1,
      fragDepth: !1,
      drawBuffers: !1,
      shaderTextureLOD: !1
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv2: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = bi(e.uniforms), this.uniformsGroups = eu(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    t.glslVersion = this.glslVersion, t.uniforms = {};
    for (const i in this.uniforms) {
      const a = this.uniforms[i].value;
      a && a.isTexture ? t.uniforms[i] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? t.uniforms[i] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? t.uniforms[i] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? t.uniforms[i] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? t.uniforms[i] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? t.uniforms[i] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? t.uniforms[i] = {
        type: "m4",
        value: a.toArray()
      } : t.uniforms[i] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader;
    const n = {};
    for (const i in this.extensions)
      this.extensions[i] === !0 && (n[i] = !0);
    return Object.keys(n).length > 0 && (t.extensions = n), t;
  }
}
class yl extends nt {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Fe(), this.projectionMatrix = new Fe(), this.projectionMatrixInverse = new Fe();
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(-t[8], -t[9], -t[10]).normalize();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class At extends yl {
  constructor(e = 50, t = 1, n = 0.1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = $i * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  getFocalLength() {
    const e = Math.tan(ji * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  getEffectiveFOV() {
    return $i * 2 * Math.atan(
      Math.tan(ji * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  setViewOffset(e, t, n, i, s, a) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(ji * 0.5 * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, s = -0.5 * i;
    const a = this.view;
    if (this.view !== null && this.view.enabled) {
      const l = a.fullWidth, c = a.fullHeight;
      s += a.offsetX * i / l, t -= a.offsetY * n / c, i *= a.width / l, n *= a.height / c;
    }
    const o = this.filmOffset;
    o !== 0 && (s += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + i, t, t - n, e, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
const ri = -90, ai = 1;
class su extends nt {
  constructor(e, t, n) {
    super(), this.type = "CubeCamera", this.renderTarget = n;
    const i = new At(ri, ai, e, t);
    i.layers = this.layers, i.up.set(0, 1, 0), i.lookAt(1, 0, 0), this.add(i);
    const s = new At(ri, ai, e, t);
    s.layers = this.layers, s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), this.add(s);
    const a = new At(ri, ai, e, t);
    a.layers = this.layers, a.up.set(0, 0, -1), a.lookAt(0, 1, 0), this.add(a);
    const o = new At(ri, ai, e, t);
    o.layers = this.layers, o.up.set(0, 0, 1), o.lookAt(0, -1, 0), this.add(o);
    const l = new At(ri, ai, e, t);
    l.layers = this.layers, l.up.set(0, 1, 0), l.lookAt(0, 0, 1), this.add(l);
    const c = new At(ri, ai, e, t);
    c.layers = this.layers, c.up.set(0, 1, 0), c.lookAt(0, 0, -1), this.add(c);
  }
  update(e, t) {
    this.parent === null && this.updateMatrixWorld();
    const n = this.renderTarget, [i, s, a, o, l, c] = this.children, u = e.getRenderTarget(), h = e.toneMapping, d = e.xr.enabled;
    e.toneMapping = cn, e.xr.enabled = !1;
    const m = n.texture.generateMipmaps;
    n.texture.generateMipmaps = !1, e.setRenderTarget(n, 0), e.render(t, i), e.setRenderTarget(n, 1), e.render(t, s), e.setRenderTarget(n, 2), e.render(t, a), e.setRenderTarget(n, 3), e.render(t, o), e.setRenderTarget(n, 4), e.render(t, l), n.texture.generateMipmaps = m, e.setRenderTarget(n, 5), e.render(t, c), e.setRenderTarget(u), e.toneMapping = h, e.xr.enabled = d, n.texture.needsPMREMUpdate = !0;
  }
}
class bl extends mt {
  constructor(e, t, n, i, s, a, o, l, c, u) {
    e = e !== void 0 ? e : [], t = t !== void 0 ? t : gi, super(e, t, n, i, s, a, o, l, c, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class ru extends Hn {
  constructor(e = 1, t = {}) {
    super(e, e, t), this.isWebGLCubeRenderTarget = !0;
    const n = { width: e, height: e, depth: 1 }, i = [n, n, n, n, n, n];
    this.texture = new bl(i, t.mapping, t.wrapS, t.wrapT, t.magFilter, t.minFilter, t.format, t.type, t.anisotropy, t.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = t.generateMipmaps !== void 0 ? t.generateMipmaps : !1, this.texture.minFilter = t.minFilter !== void 0 ? t.minFilter : Et;
  }
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type, this.texture.encoding = t.encoding, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const n = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
      fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
    }, i = new ns(5, 5, 5), s = new Vn({
      name: "CubemapFromEquirect",
      uniforms: bi(n.uniforms),
      vertexShader: n.vertexShader,
      fragmentShader: n.fragmentShader,
      side: kt,
      blending: yn
    });
    s.uniforms.tEquirect.value = t;
    const a = new Ut(i, s), o = t.minFilter;
    return t.minFilter === Un && (t.minFilter = Et), new su(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
  }
  clear(e, t, n, i) {
    const s = e.getRenderTarget();
    for (let a = 0; a < 6; a++)
      e.setRenderTarget(this, a), e.clear(t, n, i);
    e.setRenderTarget(s);
  }
}
const xr = /* @__PURE__ */ new F(), au = /* @__PURE__ */ new F(), ou = /* @__PURE__ */ new It();
class Cn {
  constructor(e = new F(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  setComponents(e, t, n, i) {
    return this.normal.set(e, t, n), this.constant = i, this;
  }
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  setFromCoplanarPoints(e, t, n) {
    const i = xr.subVectors(n, t).cross(au.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(i, e), this;
  }
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  projectPoint(e, t) {
    return t.copy(this.normal).multiplyScalar(-this.distanceToPoint(e)).add(e);
  }
  intersectLine(e, t) {
    const n = e.delta(xr), i = this.normal.dot(n);
    if (i === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const s = -(e.start.dot(this.normal) + this.constant) / i;
    return s < 0 || s > 1 ? null : t.copy(n).multiplyScalar(s).add(e.start);
  }
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
    return t < 0 && n > 0 || n < 0 && t > 0;
  }
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(e, t) {
    const n = t || ou.getNormalMatrix(e), i = this.coplanarPoint(xr).applyMatrix4(e), s = this.normal.applyMatrix3(n).normalize();
    return this.constant = -i.dot(s), this;
  }
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const oi = /* @__PURE__ */ new Si(), Ms = /* @__PURE__ */ new F();
class Jr {
  constructor(e = new Cn(), t = new Cn(), n = new Cn(), i = new Cn(), s = new Cn(), a = new Cn()) {
    this.planes = [e, t, n, i, s, a];
  }
  set(e, t, n, i, s, a) {
    const o = this.planes;
    return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(i), o[4].copy(s), o[5].copy(a), this;
  }
  copy(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      t[n].copy(e.planes[n]);
    return this;
  }
  setFromProjectionMatrix(e) {
    const t = this.planes, n = e.elements, i = n[0], s = n[1], a = n[2], o = n[3], l = n[4], c = n[5], u = n[6], h = n[7], d = n[8], m = n[9], g = n[10], p = n[11], f = n[12], v = n[13], S = n[14], y = n[15];
    return t[0].setComponents(o - i, h - l, p - d, y - f).normalize(), t[1].setComponents(o + i, h + l, p + d, y + f).normalize(), t[2].setComponents(o + s, h + c, p + m, y + v).normalize(), t[3].setComponents(o - s, h - c, p - m, y - v).normalize(), t[4].setComponents(o - a, h - u, p - g, y - S).normalize(), t[5].setComponents(o + a, h + u, p + g, y + S).normalize(), this;
  }
  intersectsObject(e) {
    const t = e.geometry;
    return t.boundingSphere === null && t.computeBoundingSphere(), oi.copy(t.boundingSphere).applyMatrix4(e.matrixWorld), this.intersectsSphere(oi);
  }
  intersectsSprite(e) {
    return oi.center.set(0, 0, 0), oi.radius = 0.7071067811865476, oi.applyMatrix4(e.matrixWorld), this.intersectsSphere(oi);
  }
  intersectsSphere(e) {
    const t = this.planes, n = e.center, i = -e.radius;
    for (let s = 0; s < 6; s++)
      if (t[s].distanceToPoint(n) < i)
        return !1;
    return !0;
  }
  intersectsBox(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++) {
      const i = t[n];
      if (Ms.x = i.normal.x > 0 ? e.max.x : e.min.x, Ms.y = i.normal.y > 0 ? e.max.y : e.min.y, Ms.z = i.normal.z > 0 ? e.max.z : e.min.z, i.distanceToPoint(Ms) < 0)
        return !1;
    }
    return !0;
  }
  containsPoint(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      if (t[n].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function Ml() {
  let r = null, e = !1, t = null, n = null;
  function i(s, a) {
    t(s, a), n = r.requestAnimationFrame(i);
  }
  return {
    start: function() {
      e !== !0 && t !== null && (n = r.requestAnimationFrame(i), e = !0);
    },
    stop: function() {
      r.cancelAnimationFrame(n), e = !1;
    },
    setAnimationLoop: function(s) {
      t = s;
    },
    setContext: function(s) {
      r = s;
    }
  };
}
function lu(r, e) {
  const t = e.isWebGL2, n = /* @__PURE__ */ new WeakMap();
  function i(c, u) {
    const h = c.array, d = c.usage, m = r.createBuffer();
    r.bindBuffer(u, m), r.bufferData(u, h, d), c.onUploadCallback();
    let g;
    if (h instanceof Float32Array)
      g = 5126;
    else if (h instanceof Uint16Array)
      if (c.isFloat16BufferAttribute)
        if (t)
          g = 5131;
        else
          throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
      else
        g = 5123;
    else if (h instanceof Int16Array)
      g = 5122;
    else if (h instanceof Uint32Array)
      g = 5125;
    else if (h instanceof Int32Array)
      g = 5124;
    else if (h instanceof Int8Array)
      g = 5120;
    else if (h instanceof Uint8Array)
      g = 5121;
    else if (h instanceof Uint8ClampedArray)
      g = 5121;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
    return {
      buffer: m,
      type: g,
      bytesPerElement: h.BYTES_PER_ELEMENT,
      version: c.version
    };
  }
  function s(c, u, h) {
    const d = u.array, m = u.updateRange;
    r.bindBuffer(h, c), m.count === -1 ? r.bufferSubData(h, 0, d) : (t ? r.bufferSubData(
      h,
      m.offset * d.BYTES_PER_ELEMENT,
      d,
      m.offset,
      m.count
    ) : r.bufferSubData(
      h,
      m.offset * d.BYTES_PER_ELEMENT,
      d.subarray(m.offset, m.offset + m.count)
    ), m.count = -1), u.onUploadCallback();
  }
  function a(c) {
    return c.isInterleavedBufferAttribute && (c = c.data), n.get(c);
  }
  function o(c) {
    c.isInterleavedBufferAttribute && (c = c.data);
    const u = n.get(c);
    u && (r.deleteBuffer(u.buffer), n.delete(c));
  }
  function l(c, u) {
    if (c.isGLBufferAttribute) {
      const d = n.get(c);
      (!d || d.version < c.version) && n.set(c, {
        buffer: c.buffer,
        type: c.type,
        bytesPerElement: c.elementSize,
        version: c.version
      });
      return;
    }
    c.isInterleavedBufferAttribute && (c = c.data);
    const h = n.get(c);
    h === void 0 ? n.set(c, i(c, u)) : h.version < c.version && (s(h.buffer, c, u), h.version = c.version);
  }
  return {
    get: a,
    remove: o,
    update: l
  };
}
class Qr extends Yt {
  constructor(e = 1, t = 1, n = 1, i = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: t,
      widthSegments: n,
      heightSegments: i
    };
    const s = e / 2, a = t / 2, o = Math.floor(n), l = Math.floor(i), c = o + 1, u = l + 1, h = e / o, d = t / l, m = [], g = [], p = [], f = [];
    for (let v = 0; v < u; v++) {
      const S = v * d - a;
      for (let y = 0; y < c; y++) {
        const b = y * h - s;
        g.push(b, -S, 0), p.push(0, 0, 1), f.push(y / o), f.push(1 - v / l);
      }
    }
    for (let v = 0; v < l; v++)
      for (let S = 0; S < o; S++) {
        const y = S + c * v, b = S + c * (v + 1), w = S + 1 + c * (v + 1), D = S + 1 + c * v;
        m.push(y, b, D), m.push(b, w, D);
      }
    this.setIndex(m), this.setAttribute("position", new hn(g, 3)), this.setAttribute("normal", new hn(p, 3)), this.setAttribute("uv", new hn(f, 2));
  }
  static fromJSON(e) {
    return new Qr(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
var cu = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, hu = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, uu = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, du = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, fu = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, pu = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, mu = "vec3 transformed = vec3( position );", gu = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, _u = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
	vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, vu = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, xu = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, yu = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, bu = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, Mu = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, wu = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, Su = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, Tu = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, Au = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, Eu = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, Cu = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, Lu = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, Ru = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, Pu = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, Du = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, Iu = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, Ou = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, Nu = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Fu = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, zu = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, Uu = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, ku = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Bu = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, Hu = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Vu = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, Gu = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, Wu = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, ju = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, Xu = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, qu = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, Yu = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Ku = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Zu = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, $u = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, Ju = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, Qu = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, ed = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, td = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, nd = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, id = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, sd = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, rd = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, ad = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, od = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, ld = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, cd = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, hd = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, ud = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, dd = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, fd = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, pd = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, md = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, gd = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, _d = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, vd = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, xd = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, yd = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, bd = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, Md = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, wd = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, Sd = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Td = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Ad = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, Ed = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, Cd = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, Ld = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, Rd = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, Pd = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, Dd = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, Id = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, Od = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, Nd = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Fd = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, zd = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, Ud = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, kd = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, Bd = `#if NUM_SPOT_LIGHT_COORDS > 0
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, Hd = `#if NUM_SPOT_LIGHT_COORDS > 0
  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, Vd = `#if defined( USE_SHADOWMAP ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_COORDS > 0 || NUM_POINT_LIGHT_SHADOWS > 0
		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		vec4 shadowWorldPosition;
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
#endif`, Gd = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, Wd = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, jd = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, Xd = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, qd = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, Yd = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, Kd = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Zd = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, $d = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, Jd = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
#endif`, Qd = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, ef = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, tf = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, nf = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, sf = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, rf = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, af = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, of = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const lf = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, cf = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, hf = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, uf = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, df = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, ff = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, pf = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, mf = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, gf = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, _f = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, vf = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, xf = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, yf = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, bf = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Mf = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, wf = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Sf = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Tf = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Af = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, Ef = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Cf = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, Lf = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, Rf = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Pf = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Df = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, If = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Of = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Nf = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Ff = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, zf = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Uf = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, kf = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, Bf = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Hf = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, Ie = {
  alphamap_fragment: cu,
  alphamap_pars_fragment: hu,
  alphatest_fragment: uu,
  alphatest_pars_fragment: du,
  aomap_fragment: fu,
  aomap_pars_fragment: pu,
  begin_vertex: mu,
  beginnormal_vertex: gu,
  bsdfs: _u,
  iridescence_fragment: vu,
  bumpmap_pars_fragment: xu,
  clipping_planes_fragment: yu,
  clipping_planes_pars_fragment: bu,
  clipping_planes_pars_vertex: Mu,
  clipping_planes_vertex: wu,
  color_fragment: Su,
  color_pars_fragment: Tu,
  color_pars_vertex: Au,
  color_vertex: Eu,
  common: Cu,
  cube_uv_reflection_fragment: Lu,
  defaultnormal_vertex: Ru,
  displacementmap_pars_vertex: Pu,
  displacementmap_vertex: Du,
  emissivemap_fragment: Iu,
  emissivemap_pars_fragment: Ou,
  encodings_fragment: Nu,
  encodings_pars_fragment: Fu,
  envmap_fragment: zu,
  envmap_common_pars_fragment: Uu,
  envmap_pars_fragment: ku,
  envmap_pars_vertex: Bu,
  envmap_physical_pars_fragment: Ju,
  envmap_vertex: Hu,
  fog_vertex: Vu,
  fog_pars_vertex: Gu,
  fog_fragment: Wu,
  fog_pars_fragment: ju,
  gradientmap_pars_fragment: Xu,
  lightmap_fragment: qu,
  lightmap_pars_fragment: Yu,
  lights_lambert_fragment: Ku,
  lights_lambert_pars_fragment: Zu,
  lights_pars_begin: $u,
  lights_toon_fragment: Qu,
  lights_toon_pars_fragment: ed,
  lights_phong_fragment: td,
  lights_phong_pars_fragment: nd,
  lights_physical_fragment: id,
  lights_physical_pars_fragment: sd,
  lights_fragment_begin: rd,
  lights_fragment_maps: ad,
  lights_fragment_end: od,
  logdepthbuf_fragment: ld,
  logdepthbuf_pars_fragment: cd,
  logdepthbuf_pars_vertex: hd,
  logdepthbuf_vertex: ud,
  map_fragment: dd,
  map_pars_fragment: fd,
  map_particle_fragment: pd,
  map_particle_pars_fragment: md,
  metalnessmap_fragment: gd,
  metalnessmap_pars_fragment: _d,
  morphcolor_vertex: vd,
  morphnormal_vertex: xd,
  morphtarget_pars_vertex: yd,
  morphtarget_vertex: bd,
  normal_fragment_begin: Md,
  normal_fragment_maps: wd,
  normal_pars_fragment: Sd,
  normal_pars_vertex: Td,
  normal_vertex: Ad,
  normalmap_pars_fragment: Ed,
  clearcoat_normal_fragment_begin: Cd,
  clearcoat_normal_fragment_maps: Ld,
  clearcoat_pars_fragment: Rd,
  iridescence_pars_fragment: Pd,
  output_fragment: Dd,
  packing: Id,
  premultiplied_alpha_fragment: Od,
  project_vertex: Nd,
  dithering_fragment: Fd,
  dithering_pars_fragment: zd,
  roughnessmap_fragment: Ud,
  roughnessmap_pars_fragment: kd,
  shadowmap_pars_fragment: Bd,
  shadowmap_pars_vertex: Hd,
  shadowmap_vertex: Vd,
  shadowmask_pars_fragment: Gd,
  skinbase_vertex: Wd,
  skinning_pars_vertex: jd,
  skinning_vertex: Xd,
  skinnormal_vertex: qd,
  specularmap_fragment: Yd,
  specularmap_pars_fragment: Kd,
  tonemapping_fragment: Zd,
  tonemapping_pars_fragment: $d,
  transmission_fragment: Jd,
  transmission_pars_fragment: Qd,
  uv_pars_fragment: ef,
  uv_pars_vertex: tf,
  uv_vertex: nf,
  uv2_pars_fragment: sf,
  uv2_pars_vertex: rf,
  uv2_vertex: af,
  worldpos_vertex: of,
  background_vert: lf,
  background_frag: cf,
  backgroundCube_vert: hf,
  backgroundCube_frag: uf,
  cube_vert: df,
  cube_frag: ff,
  depth_vert: pf,
  depth_frag: mf,
  distanceRGBA_vert: gf,
  distanceRGBA_frag: _f,
  equirect_vert: vf,
  equirect_frag: xf,
  linedashed_vert: yf,
  linedashed_frag: bf,
  meshbasic_vert: Mf,
  meshbasic_frag: wf,
  meshlambert_vert: Sf,
  meshlambert_frag: Tf,
  meshmatcap_vert: Af,
  meshmatcap_frag: Ef,
  meshnormal_vert: Cf,
  meshnormal_frag: Lf,
  meshphong_vert: Rf,
  meshphong_frag: Pf,
  meshphysical_vert: Df,
  meshphysical_frag: If,
  meshtoon_vert: Of,
  meshtoon_frag: Nf,
  points_vert: Ff,
  points_frag: zf,
  shadow_vert: Uf,
  shadow_frag: kf,
  sprite_vert: Bf,
  sprite_frag: Hf
}, he = {
  common: {
    diffuse: { value: /* @__PURE__ */ new De(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    uvTransform: { value: /* @__PURE__ */ new It() },
    uv2Transform: { value: /* @__PURE__ */ new It() },
    alphaMap: { value: null },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    ior: { value: 1.5 },
    refractionRatio: { value: 0.98 }
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 }
  },
  emissivemap: {
    emissiveMap: { value: null }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalScale: { value: /* @__PURE__ */ new Pe(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  roughnessmap: {
    roughnessMap: { value: null }
  },
  metalnessmap: {
    metalnessMap: { value: null }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new De(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new De(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new It() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new De(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Pe(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new It() }
  }
}, Zt = {
  basic: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.specularmap,
      he.envmap,
      he.aomap,
      he.lightmap,
      he.fog
    ]),
    vertexShader: Ie.meshbasic_vert,
    fragmentShader: Ie.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.specularmap,
      he.envmap,
      he.aomap,
      he.lightmap,
      he.emissivemap,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      he.fog,
      he.lights,
      {
        emissive: { value: /* @__PURE__ */ new De(0) }
      }
    ]),
    vertexShader: Ie.meshlambert_vert,
    fragmentShader: Ie.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.specularmap,
      he.envmap,
      he.aomap,
      he.lightmap,
      he.emissivemap,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      he.fog,
      he.lights,
      {
        emissive: { value: /* @__PURE__ */ new De(0) },
        specular: { value: /* @__PURE__ */ new De(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: Ie.meshphong_vert,
    fragmentShader: Ie.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.envmap,
      he.aomap,
      he.lightmap,
      he.emissivemap,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      he.roughnessmap,
      he.metalnessmap,
      he.fog,
      he.lights,
      {
        emissive: { value: /* @__PURE__ */ new De(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: Ie.meshphysical_vert,
    fragmentShader: Ie.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.aomap,
      he.lightmap,
      he.emissivemap,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      he.gradientmap,
      he.fog,
      he.lights,
      {
        emissive: { value: /* @__PURE__ */ new De(0) }
      }
    ]),
    vertexShader: Ie.meshtoon_vert,
    fragmentShader: Ie.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      he.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: Ie.meshmatcap_vert,
    fragmentShader: Ie.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ Tt([
      he.points,
      he.fog
    ]),
    vertexShader: Ie.points_vert,
    fragmentShader: Ie.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: Ie.linedashed_vert,
    fragmentShader: Ie.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.displacementmap
    ]),
    vertexShader: Ie.depth_vert,
    fragmentShader: Ie.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.bumpmap,
      he.normalmap,
      he.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ie.meshnormal_vert,
    fragmentShader: Ie.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ Tt([
      he.sprite,
      he.fog
    ]),
    vertexShader: Ie.sprite_vert,
    fragmentShader: Ie.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new It() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: Ie.background_vert,
    fragmentShader: Ie.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: Ie.backgroundCube_vert,
    fragmentShader: Ie.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: Ie.cube_vert,
    fragmentShader: Ie.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: Ie.equirect_vert,
    fragmentShader: Ie.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ Tt([
      he.common,
      he.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new F() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: Ie.distanceRGBA_vert,
    fragmentShader: Ie.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ Tt([
      he.lights,
      he.fog,
      {
        color: { value: /* @__PURE__ */ new De(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ie.shadow_vert,
    fragmentShader: Ie.shadow_frag
  }
};
Zt.physical = {
  uniforms: /* @__PURE__ */ Tt([
    Zt.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Pe(1, 1) },
      clearcoatNormalMap: { value: null },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new De(0) },
      sheenColorMap: { value: null },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Pe() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new De(0) },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularColor: { value: /* @__PURE__ */ new De(1, 1, 1) },
      specularColorMap: { value: null }
    }
  ]),
  vertexShader: Ie.meshphysical_vert,
  fragmentShader: Ie.meshphysical_frag
};
const ws = { r: 0, b: 0, g: 0 };
function Vf(r, e, t, n, i, s, a) {
  const o = new De(0);
  let l = s === !0 ? 0 : 1, c, u, h = null, d = 0, m = null;
  function g(f, v) {
    let S = !1, y = v.isScene === !0 ? v.background : null;
    y && y.isTexture && (y = (v.backgroundBlurriness > 0 ? t : e).get(y));
    const b = r.xr, w = b.getSession && b.getSession();
    w && w.environmentBlendMode === "additive" && (y = null), y === null ? p(o, l) : y && y.isColor && (p(y, 1), S = !0), (r.autoClear || S) && r.clear(r.autoClearColor, r.autoClearDepth, r.autoClearStencil), y && (y.isCubeTexture || y.mapping === Hs) ? (u === void 0 && (u = new Ut(
      new ns(1, 1, 1),
      new Vn({
        name: "BackgroundCubeMaterial",
        uniforms: bi(Zt.backgroundCube.uniforms),
        vertexShader: Zt.backgroundCube.vertexShader,
        fragmentShader: Zt.backgroundCube.fragmentShader,
        side: kt,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), u.geometry.deleteAttribute("normal"), u.geometry.deleteAttribute("uv"), u.onBeforeRender = function(D, z, x) {
      this.matrixWorld.copyPosition(x.matrixWorld);
    }, Object.defineProperty(u.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), i.update(u)), u.material.uniforms.envMap.value = y, u.material.uniforms.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, u.material.uniforms.backgroundBlurriness.value = v.backgroundBlurriness, u.material.uniforms.backgroundIntensity.value = v.backgroundIntensity, u.material.toneMapped = y.encoding !== Xe, (h !== y || d !== y.version || m !== r.toneMapping) && (u.material.needsUpdate = !0, h = y, d = y.version, m = r.toneMapping), u.layers.enableAll(), f.unshift(u, u.geometry, u.material, 0, 0, null)) : y && y.isTexture && (c === void 0 && (c = new Ut(
      new Qr(2, 2),
      new Vn({
        name: "BackgroundMaterial",
        uniforms: bi(Zt.background.uniforms),
        vertexShader: Zt.background.vertexShader,
        fragmentShader: Zt.background.fragmentShader,
        side: Mn,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), i.update(c)), c.material.uniforms.t2D.value = y, c.material.uniforms.backgroundIntensity.value = v.backgroundIntensity, c.material.toneMapped = y.encoding !== Xe, y.matrixAutoUpdate === !0 && y.updateMatrix(), c.material.uniforms.uvTransform.value.copy(y.matrix), (h !== y || d !== y.version || m !== r.toneMapping) && (c.material.needsUpdate = !0, h = y, d = y.version, m = r.toneMapping), c.layers.enableAll(), f.unshift(c, c.geometry, c.material, 0, 0, null));
  }
  function p(f, v) {
    f.getRGB(ws, xl(r)), n.buffers.color.setClear(ws.r, ws.g, ws.b, v, a);
  }
  return {
    getClearColor: function() {
      return o;
    },
    setClearColor: function(f, v = 1) {
      o.set(f), l = v, p(o, l);
    },
    getClearAlpha: function() {
      return l;
    },
    setClearAlpha: function(f) {
      l = f, p(o, l);
    },
    render: g
  };
}
function Gf(r, e, t, n) {
  const i = r.getParameter(34921), s = n.isWebGL2 ? null : e.get("OES_vertex_array_object"), a = n.isWebGL2 || s !== null, o = {}, l = f(null);
  let c = l, u = !1;
  function h(H, j, G, te, Z) {
    let re = !1;
    if (a) {
      const $ = p(te, G, j);
      c !== $ && (c = $, m(c.object)), re = v(H, te, G, Z), re && S(H, te, G, Z);
    } else {
      const $ = j.wireframe === !0;
      (c.geometry !== te.id || c.program !== G.id || c.wireframe !== $) && (c.geometry = te.id, c.program = G.id, c.wireframe = $, re = !0);
    }
    Z !== null && t.update(Z, 34963), (re || u) && (u = !1, x(H, j, G, te), Z !== null && r.bindBuffer(34963, t.get(Z).buffer));
  }
  function d() {
    return n.isWebGL2 ? r.createVertexArray() : s.createVertexArrayOES();
  }
  function m(H) {
    return n.isWebGL2 ? r.bindVertexArray(H) : s.bindVertexArrayOES(H);
  }
  function g(H) {
    return n.isWebGL2 ? r.deleteVertexArray(H) : s.deleteVertexArrayOES(H);
  }
  function p(H, j, G) {
    const te = G.wireframe === !0;
    let Z = o[H.id];
    Z === void 0 && (Z = {}, o[H.id] = Z);
    let re = Z[j.id];
    re === void 0 && (re = {}, Z[j.id] = re);
    let $ = re[te];
    return $ === void 0 && ($ = f(d()), re[te] = $), $;
  }
  function f(H) {
    const j = [], G = [], te = [];
    for (let Z = 0; Z < i; Z++)
      j[Z] = 0, G[Z] = 0, te[Z] = 0;
    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: j,
      enabledAttributes: G,
      attributeDivisors: te,
      object: H,
      attributes: {},
      index: null
    };
  }
  function v(H, j, G, te) {
    const Z = c.attributes, re = j.attributes;
    let $ = 0;
    const K = G.getAttributes();
    for (const W in K)
      if (K[W].location >= 0) {
        const ae = Z[W];
        let ue = re[W];
        if (ue === void 0 && (W === "instanceMatrix" && H.instanceMatrix && (ue = H.instanceMatrix), W === "instanceColor" && H.instanceColor && (ue = H.instanceColor)), ae === void 0 || ae.attribute !== ue || ue && ae.data !== ue.data)
          return !0;
        $++;
      }
    return c.attributesNum !== $ || c.index !== te;
  }
  function S(H, j, G, te) {
    const Z = {}, re = j.attributes;
    let $ = 0;
    const K = G.getAttributes();
    for (const W in K)
      if (K[W].location >= 0) {
        let ae = re[W];
        ae === void 0 && (W === "instanceMatrix" && H.instanceMatrix && (ae = H.instanceMatrix), W === "instanceColor" && H.instanceColor && (ae = H.instanceColor));
        const ue = {};
        ue.attribute = ae, ae && ae.data && (ue.data = ae.data), Z[W] = ue, $++;
      }
    c.attributes = Z, c.attributesNum = $, c.index = te;
  }
  function y() {
    const H = c.newAttributes;
    for (let j = 0, G = H.length; j < G; j++)
      H[j] = 0;
  }
  function b(H) {
    w(H, 0);
  }
  function w(H, j) {
    const G = c.newAttributes, te = c.enabledAttributes, Z = c.attributeDivisors;
    G[H] = 1, te[H] === 0 && (r.enableVertexAttribArray(H), te[H] = 1), Z[H] !== j && ((n.isWebGL2 ? r : e.get("ANGLE_instanced_arrays"))[n.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](H, j), Z[H] = j);
  }
  function D() {
    const H = c.newAttributes, j = c.enabledAttributes;
    for (let G = 0, te = j.length; G < te; G++)
      j[G] !== H[G] && (r.disableVertexAttribArray(G), j[G] = 0);
  }
  function z(H, j, G, te, Z, re) {
    n.isWebGL2 === !0 && (G === 5124 || G === 5125) ? r.vertexAttribIPointer(H, j, G, Z, re) : r.vertexAttribPointer(H, j, G, te, Z, re);
  }
  function x(H, j, G, te) {
    if (n.isWebGL2 === !1 && (H.isInstancedMesh || te.isInstancedBufferGeometry) && e.get("ANGLE_instanced_arrays") === null)
      return;
    y();
    const Z = te.attributes, re = G.getAttributes(), $ = j.defaultAttributeValues;
    for (const K in re) {
      const W = re[K];
      if (W.location >= 0) {
        let le = Z[K];
        if (le === void 0 && (K === "instanceMatrix" && H.instanceMatrix && (le = H.instanceMatrix), K === "instanceColor" && H.instanceColor && (le = H.instanceColor)), le !== void 0) {
          const ae = le.normalized, ue = le.itemSize, Y = t.get(le);
          if (Y === void 0)
            continue;
          const Oe = Y.buffer, be = Y.type, Ce = Y.bytesPerElement;
          if (le.isInterleavedBufferAttribute) {
            const ve = le.data, Ae = ve.stride, Ee = le.offset;
            if (ve.isInstancedInterleavedBuffer) {
              for (let Le = 0; Le < W.locationSize; Le++)
                w(W.location + Le, ve.meshPerAttribute);
              H.isInstancedMesh !== !0 && te._maxInstanceCount === void 0 && (te._maxInstanceCount = ve.meshPerAttribute * ve.count);
            } else
              for (let Le = 0; Le < W.locationSize; Le++)
                b(W.location + Le);
            r.bindBuffer(34962, Oe);
            for (let Le = 0; Le < W.locationSize; Le++)
              z(
                W.location + Le,
                ue / W.locationSize,
                be,
                ae,
                Ae * Ce,
                (Ee + ue / W.locationSize * Le) * Ce
              );
          } else {
            if (le.isInstancedBufferAttribute) {
              for (let ve = 0; ve < W.locationSize; ve++)
                w(W.location + ve, le.meshPerAttribute);
              H.isInstancedMesh !== !0 && te._maxInstanceCount === void 0 && (te._maxInstanceCount = le.meshPerAttribute * le.count);
            } else
              for (let ve = 0; ve < W.locationSize; ve++)
                b(W.location + ve);
            r.bindBuffer(34962, Oe);
            for (let ve = 0; ve < W.locationSize; ve++)
              z(
                W.location + ve,
                ue / W.locationSize,
                be,
                ae,
                ue * Ce,
                ue / W.locationSize * ve * Ce
              );
          }
        } else if ($ !== void 0) {
          const ae = $[K];
          if (ae !== void 0)
            switch (ae.length) {
              case 2:
                r.vertexAttrib2fv(W.location, ae);
                break;
              case 3:
                r.vertexAttrib3fv(W.location, ae);
                break;
              case 4:
                r.vertexAttrib4fv(W.location, ae);
                break;
              default:
                r.vertexAttrib1fv(W.location, ae);
            }
        }
      }
    }
    D();
  }
  function R() {
    ee();
    for (const H in o) {
      const j = o[H];
      for (const G in j) {
        const te = j[G];
        for (const Z in te)
          g(te[Z].object), delete te[Z];
        delete j[G];
      }
      delete o[H];
    }
  }
  function k(H) {
    if (o[H.id] === void 0)
      return;
    const j = o[H.id];
    for (const G in j) {
      const te = j[G];
      for (const Z in te)
        g(te[Z].object), delete te[Z];
      delete j[G];
    }
    delete o[H.id];
  }
  function T(H) {
    for (const j in o) {
      const G = o[j];
      if (G[H.id] === void 0)
        continue;
      const te = G[H.id];
      for (const Z in te)
        g(te[Z].object), delete te[Z];
      delete G[H.id];
    }
  }
  function ee() {
    V(), u = !0, c !== l && (c = l, m(c.object));
  }
  function V() {
    l.geometry = null, l.program = null, l.wireframe = !1;
  }
  return {
    setup: h,
    reset: ee,
    resetDefaultState: V,
    dispose: R,
    releaseStatesOfGeometry: k,
    releaseStatesOfProgram: T,
    initAttributes: y,
    enableAttribute: b,
    disableUnusedAttributes: D
  };
}
function Wf(r, e, t, n) {
  const i = n.isWebGL2;
  let s;
  function a(c) {
    s = c;
  }
  function o(c, u) {
    r.drawArrays(s, c, u), t.update(u, s, 1);
  }
  function l(c, u, h) {
    if (h === 0)
      return;
    let d, m;
    if (i)
      d = r, m = "drawArraysInstanced";
    else if (d = e.get("ANGLE_instanced_arrays"), m = "drawArraysInstancedANGLE", d === null) {
      console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    d[m](s, c, u, h), t.update(u, s, h);
  }
  this.setMode = a, this.render = o, this.renderInstances = l;
}
function jf(r, e, t) {
  let n;
  function i() {
    if (n !== void 0)
      return n;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const z = e.get("EXT_texture_filter_anisotropic");
      n = r.getParameter(z.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      n = 0;
    return n;
  }
  function s(z) {
    if (z === "highp") {
      if (r.getShaderPrecisionFormat(35633, 36338).precision > 0 && r.getShaderPrecisionFormat(35632, 36338).precision > 0)
        return "highp";
      z = "mediump";
    }
    return z === "mediump" && r.getShaderPrecisionFormat(35633, 36337).precision > 0 && r.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
  }
  const a = typeof WebGL2RenderingContext < "u" && r instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext < "u" && r instanceof WebGL2ComputeRenderingContext;
  let o = t.precision !== void 0 ? t.precision : "highp";
  const l = s(o);
  l !== o && (console.warn("THREE.WebGLRenderer:", o, "not supported, using", l, "instead."), o = l);
  const c = a || e.has("WEBGL_draw_buffers"), u = t.logarithmicDepthBuffer === !0, h = r.getParameter(34930), d = r.getParameter(35660), m = r.getParameter(3379), g = r.getParameter(34076), p = r.getParameter(34921), f = r.getParameter(36347), v = r.getParameter(36348), S = r.getParameter(36349), y = d > 0, b = a || e.has("OES_texture_float"), w = y && b, D = a ? r.getParameter(36183) : 0;
  return {
    isWebGL2: a,
    drawBuffers: c,
    getMaxAnisotropy: i,
    getMaxPrecision: s,
    precision: o,
    logarithmicDepthBuffer: u,
    maxTextures: h,
    maxVertexTextures: d,
    maxTextureSize: m,
    maxCubemapSize: g,
    maxAttributes: p,
    maxVertexUniforms: f,
    maxVaryings: v,
    maxFragmentUniforms: S,
    vertexTextures: y,
    floatFragmentTextures: b,
    floatVertexTextures: w,
    maxSamples: D
  };
}
function Xf(r) {
  const e = this;
  let t = null, n = 0, i = !1, s = !1;
  const a = new Cn(), o = new It(), l = { value: null, needsUpdate: !1 };
  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, d, m) {
    const g = h.length !== 0 || d || n !== 0 || i;
    return i = d, t = u(h, m, 0), n = h.length, g;
  }, this.beginShadows = function() {
    s = !0, u(null);
  }, this.endShadows = function() {
    s = !1, c();
  }, this.setState = function(h, d, m) {
    const g = h.clippingPlanes, p = h.clipIntersection, f = h.clipShadows, v = r.get(h);
    if (!i || g === null || g.length === 0 || s && !f)
      s ? u(null) : c();
    else {
      const S = s ? 0 : n, y = S * 4;
      let b = v.clippingState || null;
      l.value = b, b = u(g, d, y, m);
      for (let w = 0; w !== y; ++w)
        b[w] = t[w];
      v.clippingState = b, this.numIntersection = p ? this.numPlanes : 0, this.numPlanes += S;
    }
  };
  function c() {
    l.value !== t && (l.value = t, l.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0;
  }
  function u(h, d, m, g) {
    const p = h !== null ? h.length : 0;
    let f = null;
    if (p !== 0) {
      if (f = l.value, g !== !0 || f === null) {
        const v = m + p * 4, S = d.matrixWorldInverse;
        o.getNormalMatrix(S), (f === null || f.length < v) && (f = new Float32Array(v));
        for (let y = 0, b = m; y !== p; ++y, b += 4)
          a.copy(h[y]).applyMatrix4(S, o), a.normal.toArray(f, b), f[b + 3] = a.constant;
      }
      l.value = f, l.needsUpdate = !0;
    }
    return e.numPlanes = p, e.numIntersection = 0, f;
  }
}
function qf(r) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(a, o) {
    return o === Nr ? a.mapping = gi : o === Fr && (a.mapping = _i), a;
  }
  function n(a) {
    if (a && a.isTexture && a.isRenderTargetTexture === !1) {
      const o = a.mapping;
      if (o === Nr || o === Fr)
        if (e.has(a)) {
          const l = e.get(a).texture;
          return t(l, a.mapping);
        } else {
          const l = a.image;
          if (l && l.height > 0) {
            const c = new ru(l.height / 2);
            return c.fromEquirectangularTexture(r, a), e.set(a, c), a.addEventListener("dispose", i), t(c.texture, a.mapping);
          } else
            return null;
        }
    }
    return a;
  }
  function i(a) {
    const o = a.target;
    o.removeEventListener("dispose", i);
    const l = e.get(o);
    l !== void 0 && (e.delete(o), l.dispose());
  }
  function s() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: s
  };
}
class ea extends yl {
  constructor(e = -1, t = 1, n = 1, i = -1, s = 0.1, a = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = i, this.near = s, this.far = a, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  setViewOffset(e, t, n, i, s, a) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
    let s = n - e, a = n + e, o = i + t, l = i - t;
    if (this.view !== null && this.view.enabled) {
      const c = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      s += c * this.view.offsetX, a = s + c * this.view.width, o -= u * this.view.offsetY, l = o - u * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(s, a, o, l, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
const hi = 4, eo = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Pn = 20, yr = /* @__PURE__ */ new ea(), to = /* @__PURE__ */ new De();
let br = null;
const Ln = (1 + Math.sqrt(5)) / 2, li = 1 / Ln, no = [
  /* @__PURE__ */ new F(1, 1, 1),
  /* @__PURE__ */ new F(-1, 1, 1),
  /* @__PURE__ */ new F(1, 1, -1),
  /* @__PURE__ */ new F(-1, 1, -1),
  /* @__PURE__ */ new F(0, Ln, li),
  /* @__PURE__ */ new F(0, Ln, -li),
  /* @__PURE__ */ new F(li, 0, Ln),
  /* @__PURE__ */ new F(-li, 0, Ln),
  /* @__PURE__ */ new F(Ln, li, 0),
  /* @__PURE__ */ new F(-Ln, li, 0)
];
class io {
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  fromScene(e, t = 0, n = 0.1, i = 100) {
    br = this._renderer.getRenderTarget(), this._setSize(256);
    const s = this._allocateTargets();
    return s.depthBuffer = !0, this._sceneToCubeUV(e, n, i, s), t > 0 && this._blur(s, 0, 0, t), this._applyPMREM(s), this._cleanup(s), s;
  }
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = ao(), this._compileMaterial(this._cubemapMaterial));
  }
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = ro(), this._compileMaterial(this._equirectMaterial));
  }
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(br), e.scissorTest = !1, Ss(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    e.mapping === gi || e.mapping === _i ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), br = this._renderer.getRenderTarget();
    const n = t || this._allocateTargets();
    return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
      magFilter: Et,
      minFilter: Et,
      generateMipmaps: !1,
      type: Yi,
      format: zt,
      encoding: Bn,
      depthBuffer: !1
    }, i = so(e, t, n);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = so(e, t, n);
      const { _lodMax: s } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = Yf(s)), this._blurMaterial = Kf(s, e, t);
    }
    return i;
  }
  _compileMaterial(e) {
    const t = new Ut(this._lodPlanes[0], e);
    this._renderer.compile(t, yr);
  }
  _sceneToCubeUV(e, t, n, i) {
    const o = new At(90, 1, t, n), l = [1, -1, 1, 1, 1, 1], c = [1, 1, 1, -1, -1, -1], u = this._renderer, h = u.autoClear, d = u.toneMapping;
    u.getClearColor(to), u.toneMapping = cn, u.autoClear = !1;
    const m = new In({
      name: "PMREM.Background",
      side: kt,
      depthWrite: !1,
      depthTest: !1
    }), g = new Ut(new ns(), m);
    let p = !1;
    const f = e.background;
    f ? f.isColor && (m.color.copy(f), e.background = null, p = !0) : (m.color.copy(to), p = !0);
    for (let v = 0; v < 6; v++) {
      const S = v % 3;
      S === 0 ? (o.up.set(0, l[v], 0), o.lookAt(c[v], 0, 0)) : S === 1 ? (o.up.set(0, 0, l[v]), o.lookAt(0, c[v], 0)) : (o.up.set(0, l[v], 0), o.lookAt(0, 0, c[v]));
      const y = this._cubeSize;
      Ss(i, S * y, v > 2 ? y : 0, y, y), u.setRenderTarget(i), p && u.render(g, o), u.render(e, o);
    }
    g.geometry.dispose(), g.material.dispose(), u.toneMapping = d, u.autoClear = h, e.background = f;
  }
  _textureToCubeUV(e, t) {
    const n = this._renderer, i = e.mapping === gi || e.mapping === _i;
    i ? (this._cubemapMaterial === null && (this._cubemapMaterial = ao()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = ro());
    const s = i ? this._cubemapMaterial : this._equirectMaterial, a = new Ut(this._lodPlanes[0], s), o = s.uniforms;
    o.envMap.value = e;
    const l = this._cubeSize;
    Ss(t, 0, 0, 3 * l, 2 * l), n.setRenderTarget(t), n.render(a, yr);
  }
  _applyPMREM(e) {
    const t = this._renderer, n = t.autoClear;
    t.autoClear = !1;
    for (let i = 1; i < this._lodPlanes.length; i++) {
      const s = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]), a = no[(i - 1) % no.length];
      this._blur(e, i - 1, i, s, a);
    }
    t.autoClear = n;
  }
  _blur(e, t, n, i, s) {
    const a = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      a,
      t,
      n,
      i,
      "latitudinal",
      s
    ), this._halfBlur(
      a,
      e,
      n,
      n,
      i,
      "longitudinal",
      s
    );
  }
  _halfBlur(e, t, n, i, s, a, o) {
    const l = this._renderer, c = this._blurMaterial;
    a !== "latitudinal" && a !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const u = 3, h = new Ut(this._lodPlanes[i], c), d = c.uniforms, m = this._sizeLods[n] - 1, g = isFinite(s) ? Math.PI / (2 * m) : 2 * Math.PI / (2 * Pn - 1), p = s / g, f = isFinite(s) ? 1 + Math.floor(u * p) : Pn;
    f > Pn && console.warn(`sigmaRadians, ${s}, is too large and will clip, as it requested ${f} samples when the maximum is set to ${Pn}`);
    const v = [];
    let S = 0;
    for (let z = 0; z < Pn; ++z) {
      const x = z / p, R = Math.exp(-x * x / 2);
      v.push(R), z === 0 ? S += R : z < f && (S += 2 * R);
    }
    for (let z = 0; z < v.length; z++)
      v[z] = v[z] / S;
    d.envMap.value = e.texture, d.samples.value = f, d.weights.value = v, d.latitudinal.value = a === "latitudinal", o && (d.poleAxis.value = o);
    const { _lodMax: y } = this;
    d.dTheta.value = g, d.mipInt.value = y - n;
    const b = this._sizeLods[i], w = 3 * b * (i > y - hi ? i - y + hi : 0), D = 4 * (this._cubeSize - b);
    Ss(t, w, D, 3 * b, 2 * b), l.setRenderTarget(t), l.render(h, yr);
  }
}
function Yf(r) {
  const e = [], t = [], n = [];
  let i = r;
  const s = r - hi + 1 + eo.length;
  for (let a = 0; a < s; a++) {
    const o = Math.pow(2, i);
    t.push(o);
    let l = 1 / o;
    a > r - hi ? l = eo[a - r + hi - 1] : a === 0 && (l = 0), n.push(l);
    const c = 1 / (o - 2), u = -c, h = 1 + c, d = [u, u, h, u, h, h, u, u, h, h, u, h], m = 6, g = 6, p = 3, f = 2, v = 1, S = new Float32Array(p * g * m), y = new Float32Array(f * g * m), b = new Float32Array(v * g * m);
    for (let D = 0; D < m; D++) {
      const z = D % 3 * 2 / 3 - 1, x = D > 2 ? 0 : -1, R = [
        z,
        x,
        0,
        z + 2 / 3,
        x,
        0,
        z + 2 / 3,
        x + 1,
        0,
        z,
        x,
        0,
        z + 2 / 3,
        x + 1,
        0,
        z,
        x + 1,
        0
      ];
      S.set(R, p * g * D), y.set(d, f * g * D);
      const k = [D, D, D, D, D, D];
      b.set(k, v * g * D);
    }
    const w = new Yt();
    w.setAttribute("position", new gt(S, p)), w.setAttribute("uv", new gt(y, f)), w.setAttribute("faceIndex", new gt(b, v)), e.push(w), i > hi && i--;
  }
  return { lodPlanes: e, sizeLods: t, sigmas: n };
}
function so(r, e, t) {
  const n = new Hn(r, e, t);
  return n.texture.mapping = Hs, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function Ss(r, e, t, n, i) {
  r.viewport.set(e, t, n, i), r.scissor.set(e, t, n, i);
}
function Kf(r, e, t) {
  const n = new Float32Array(Pn), i = new F(0, 1, 0);
  return new Vn({
    name: "SphericalGaussianBlur",
    defines: {
      n: Pn,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${r}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: n },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: i }
    },
    vertexShader: ta(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
    blending: yn,
    depthTest: !1,
    depthWrite: !1
  });
}
function ro() {
  return new Vn({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: ta(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
    blending: yn,
    depthTest: !1,
    depthWrite: !1
  });
}
function ao() {
  return new Vn({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: ta(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
    blending: yn,
    depthTest: !1,
    depthWrite: !1
  });
}
function ta() {
  return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function Zf(r) {
  let e = /* @__PURE__ */ new WeakMap(), t = null;
  function n(o) {
    if (o && o.isTexture) {
      const l = o.mapping, c = l === Nr || l === Fr, u = l === gi || l === _i;
      if (c || u)
        if (o.isRenderTargetTexture && o.needsPMREMUpdate === !0) {
          o.needsPMREMUpdate = !1;
          let h = e.get(o);
          return t === null && (t = new io(r)), h = c ? t.fromEquirectangular(o, h) : t.fromCubemap(o, h), e.set(o, h), h.texture;
        } else {
          if (e.has(o))
            return e.get(o).texture;
          {
            const h = o.image;
            if (c && h && h.height > 0 || u && h && i(h)) {
              t === null && (t = new io(r));
              const d = c ? t.fromEquirectangular(o) : t.fromCubemap(o);
              return e.set(o, d), o.addEventListener("dispose", s), d.texture;
            } else
              return null;
          }
        }
    }
    return o;
  }
  function i(o) {
    let l = 0;
    const c = 6;
    for (let u = 0; u < c; u++)
      o[u] !== void 0 && l++;
    return l === c;
  }
  function s(o) {
    const l = o.target;
    l.removeEventListener("dispose", s);
    const c = e.get(l);
    c !== void 0 && (e.delete(l), c.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap(), t !== null && (t.dispose(), t = null);
  }
  return {
    get: n,
    dispose: a
  };
}
function $f(r) {
  const e = {};
  function t(n) {
    if (e[n] !== void 0)
      return e[n];
    let i;
    switch (n) {
      case "WEBGL_depth_texture":
        i = r.getExtension("WEBGL_depth_texture") || r.getExtension("MOZ_WEBGL_depth_texture") || r.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        i = r.getExtension("EXT_texture_filter_anisotropic") || r.getExtension("MOZ_EXT_texture_filter_anisotropic") || r.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        i = r.getExtension("WEBGL_compressed_texture_s3tc") || r.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || r.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        i = r.getExtension("WEBGL_compressed_texture_pvrtc") || r.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        i = r.getExtension(n);
    }
    return e[n] = i, i;
  }
  return {
    has: function(n) {
      return t(n) !== null;
    },
    init: function(n) {
      n.isWebGL2 ? t("EXT_color_buffer_float") : (t("WEBGL_depth_texture"), t("OES_texture_float"), t("OES_texture_half_float"), t("OES_texture_half_float_linear"), t("OES_standard_derivatives"), t("OES_element_index_uint"), t("OES_vertex_array_object"), t("ANGLE_instanced_arrays")), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture");
    },
    get: function(n) {
      const i = t(n);
      return i === null && console.warn("THREE.WebGLRenderer: " + n + " extension not supported."), i;
    }
  };
}
function Jf(r, e, t, n) {
  const i = {}, s = /* @__PURE__ */ new WeakMap();
  function a(h) {
    const d = h.target;
    d.index !== null && e.remove(d.index);
    for (const g in d.attributes)
      e.remove(d.attributes[g]);
    d.removeEventListener("dispose", a), delete i[d.id];
    const m = s.get(d);
    m && (e.remove(m), s.delete(d)), n.releaseStatesOfGeometry(d), d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount, t.memory.geometries--;
  }
  function o(h, d) {
    return i[d.id] === !0 || (d.addEventListener("dispose", a), i[d.id] = !0, t.memory.geometries++), d;
  }
  function l(h) {
    const d = h.attributes;
    for (const g in d)
      e.update(d[g], 34962);
    const m = h.morphAttributes;
    for (const g in m) {
      const p = m[g];
      for (let f = 0, v = p.length; f < v; f++)
        e.update(p[f], 34962);
    }
  }
  function c(h) {
    const d = [], m = h.index, g = h.attributes.position;
    let p = 0;
    if (m !== null) {
      const S = m.array;
      p = m.version;
      for (let y = 0, b = S.length; y < b; y += 3) {
        const w = S[y + 0], D = S[y + 1], z = S[y + 2];
        d.push(w, D, D, z, z, w);
      }
    } else {
      const S = g.array;
      p = g.version;
      for (let y = 0, b = S.length / 3 - 1; y < b; y += 3) {
        const w = y + 0, D = y + 1, z = y + 2;
        d.push(w, D, D, z, z, w);
      }
    }
    const f = new (ul(d) ? vl : _l)(d, 1);
    f.version = p;
    const v = s.get(h);
    v && e.remove(v), s.set(h, f);
  }
  function u(h) {
    const d = s.get(h);
    if (d) {
      const m = h.index;
      m !== null && d.version < m.version && c(h);
    } else
      c(h);
    return s.get(h);
  }
  return {
    get: o,
    update: l,
    getWireframeAttribute: u
  };
}
function Qf(r, e, t, n) {
  const i = n.isWebGL2;
  let s;
  function a(d) {
    s = d;
  }
  let o, l;
  function c(d) {
    o = d.type, l = d.bytesPerElement;
  }
  function u(d, m) {
    r.drawElements(s, m, o, d * l), t.update(m, s, 1);
  }
  function h(d, m, g) {
    if (g === 0)
      return;
    let p, f;
    if (i)
      p = r, f = "drawElementsInstanced";
    else if (p = e.get("ANGLE_instanced_arrays"), f = "drawElementsInstancedANGLE", p === null) {
      console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    p[f](s, m, o, d * l, g), t.update(m, s, g);
  }
  this.setMode = a, this.setIndex = c, this.render = u, this.renderInstances = h;
}
function ep(r) {
  const e = {
    geometries: 0,
    textures: 0
  }, t = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function n(s, a, o) {
    switch (t.calls++, a) {
      case 4:
        t.triangles += o * (s / 3);
        break;
      case 1:
        t.lines += o * (s / 2);
        break;
      case 3:
        t.lines += o * (s - 1);
        break;
      case 2:
        t.lines += o * s;
        break;
      case 0:
        t.points += o * s;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", a);
        break;
    }
  }
  function i() {
    t.frame++, t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
  }
  return {
    memory: e,
    render: t,
    programs: null,
    autoReset: !0,
    reset: i,
    update: n
  };
}
function tp(r, e) {
  return r[0] - e[0];
}
function np(r, e) {
  return Math.abs(e[1]) - Math.abs(r[1]);
}
function ip(r, e, t) {
  const n = {}, i = new Float32Array(8), s = /* @__PURE__ */ new WeakMap(), a = new Ze(), o = [];
  for (let c = 0; c < 8; c++)
    o[c] = [c, 0];
  function l(c, u, h, d) {
    const m = c.morphTargetInfluences;
    if (e.isWebGL2 === !0) {
      const g = u.morphAttributes.position || u.morphAttributes.normal || u.morphAttributes.color, p = g !== void 0 ? g.length : 0;
      let f = s.get(u);
      if (f === void 0 || f.count !== p) {
        let j = function() {
          V.dispose(), s.delete(u), u.removeEventListener("dispose", j);
        };
        f !== void 0 && f.texture.dispose();
        const y = u.morphAttributes.position !== void 0, b = u.morphAttributes.normal !== void 0, w = u.morphAttributes.color !== void 0, D = u.morphAttributes.position || [], z = u.morphAttributes.normal || [], x = u.morphAttributes.color || [];
        let R = 0;
        y === !0 && (R = 1), b === !0 && (R = 2), w === !0 && (R = 3);
        let k = u.attributes.position.count * R, T = 1;
        k > e.maxTextureSize && (T = Math.ceil(k / e.maxTextureSize), k = e.maxTextureSize);
        const ee = new Float32Array(k * T * 4 * p), V = new ml(ee, k, T, p);
        V.type = xn, V.needsUpdate = !0;
        const H = R * 4;
        for (let G = 0; G < p; G++) {
          const te = D[G], Z = z[G], re = x[G], $ = k * T * 4 * G;
          for (let K = 0; K < te.count; K++) {
            const W = K * H;
            y === !0 && (a.fromBufferAttribute(te, K), ee[$ + W + 0] = a.x, ee[$ + W + 1] = a.y, ee[$ + W + 2] = a.z, ee[$ + W + 3] = 0), b === !0 && (a.fromBufferAttribute(Z, K), ee[$ + W + 4] = a.x, ee[$ + W + 5] = a.y, ee[$ + W + 6] = a.z, ee[$ + W + 7] = 0), w === !0 && (a.fromBufferAttribute(re, K), ee[$ + W + 8] = a.x, ee[$ + W + 9] = a.y, ee[$ + W + 10] = a.z, ee[$ + W + 11] = re.itemSize === 4 ? a.w : 1);
          }
        }
        f = {
          count: p,
          texture: V,
          size: new Pe(k, T)
        }, s.set(u, f), u.addEventListener("dispose", j);
      }
      let v = 0;
      for (let y = 0; y < m.length; y++)
        v += m[y];
      const S = u.morphTargetsRelative ? 1 : 1 - v;
      d.getUniforms().setValue(r, "morphTargetBaseInfluence", S), d.getUniforms().setValue(r, "morphTargetInfluences", m), d.getUniforms().setValue(r, "morphTargetsTexture", f.texture, t), d.getUniforms().setValue(r, "morphTargetsTextureSize", f.size);
    } else {
      const g = m === void 0 ? 0 : m.length;
      let p = n[u.id];
      if (p === void 0 || p.length !== g) {
        p = [];
        for (let b = 0; b < g; b++)
          p[b] = [b, 0];
        n[u.id] = p;
      }
      for (let b = 0; b < g; b++) {
        const w = p[b];
        w[0] = b, w[1] = m[b];
      }
      p.sort(np);
      for (let b = 0; b < 8; b++)
        b < g && p[b][1] ? (o[b][0] = p[b][0], o[b][1] = p[b][1]) : (o[b][0] = Number.MAX_SAFE_INTEGER, o[b][1] = 0);
      o.sort(tp);
      const f = u.morphAttributes.position, v = u.morphAttributes.normal;
      let S = 0;
      for (let b = 0; b < 8; b++) {
        const w = o[b], D = w[0], z = w[1];
        D !== Number.MAX_SAFE_INTEGER && z ? (f && u.getAttribute("morphTarget" + b) !== f[D] && u.setAttribute("morphTarget" + b, f[D]), v && u.getAttribute("morphNormal" + b) !== v[D] && u.setAttribute("morphNormal" + b, v[D]), i[b] = z, S += z) : (f && u.hasAttribute("morphTarget" + b) === !0 && u.deleteAttribute("morphTarget" + b), v && u.hasAttribute("morphNormal" + b) === !0 && u.deleteAttribute("morphNormal" + b), i[b] = 0);
      }
      const y = u.morphTargetsRelative ? 1 : 1 - S;
      d.getUniforms().setValue(r, "morphTargetBaseInfluence", y), d.getUniforms().setValue(r, "morphTargetInfluences", i);
    }
  }
  return {
    update: l
  };
}
function sp(r, e, t, n) {
  let i = /* @__PURE__ */ new WeakMap();
  function s(l) {
    const c = n.render.frame, u = l.geometry, h = e.get(l, u);
    return i.get(h) !== c && (e.update(h), i.set(h, c)), l.isInstancedMesh && (l.hasEventListener("dispose", o) === !1 && l.addEventListener("dispose", o), t.update(l.instanceMatrix, 34962), l.instanceColor !== null && t.update(l.instanceColor, 34962)), h;
  }
  function a() {
    i = /* @__PURE__ */ new WeakMap();
  }
  function o(l) {
    const c = l.target;
    c.removeEventListener("dispose", o), t.remove(c.instanceMatrix), c.instanceColor !== null && t.remove(c.instanceColor);
  }
  return {
    update: s,
    dispose: a
  };
}
const wl = /* @__PURE__ */ new mt(), Sl = /* @__PURE__ */ new ml(), Tl = /* @__PURE__ */ new Gh(), Al = /* @__PURE__ */ new bl(), oo = [], lo = [], co = new Float32Array(16), ho = new Float32Array(9), uo = new Float32Array(4);
function Ti(r, e, t) {
  const n = r[0];
  if (n <= 0 || n > 0)
    return r;
  const i = e * t;
  let s = oo[i];
  if (s === void 0 && (s = new Float32Array(i), oo[i] = s), e !== 0) {
    n.toArray(s, 0);
    for (let a = 1, o = 0; a !== e; ++a)
      o += t, r[a].toArray(s, o);
  }
  return s;
}
function lt(r, e) {
  if (r.length !== e.length)
    return !1;
  for (let t = 0, n = r.length; t < n; t++)
    if (r[t] !== e[t])
      return !1;
  return !0;
}
function ct(r, e) {
  for (let t = 0, n = e.length; t < n; t++)
    r[t] = e[t];
}
function Vs(r, e) {
  let t = lo[e];
  t === void 0 && (t = new Int32Array(e), lo[e] = t);
  for (let n = 0; n !== e; ++n)
    t[n] = r.allocateTextureUnit();
  return t;
}
function rp(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1f(this.addr, e), t[0] = e);
}
function ap(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (lt(t, e))
      return;
    r.uniform2fv(this.addr, e), ct(t, e);
  }
}
function op(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (r.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
  else {
    if (lt(t, e))
      return;
    r.uniform3fv(this.addr, e), ct(t, e);
  }
}
function lp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (lt(t, e))
      return;
    r.uniform4fv(this.addr, e), ct(t, e);
  }
}
function cp(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (lt(t, e))
      return;
    r.uniformMatrix2fv(this.addr, !1, e), ct(t, e);
  } else {
    if (lt(t, n))
      return;
    uo.set(n), r.uniformMatrix2fv(this.addr, !1, uo), ct(t, n);
  }
}
function hp(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (lt(t, e))
      return;
    r.uniformMatrix3fv(this.addr, !1, e), ct(t, e);
  } else {
    if (lt(t, n))
      return;
    ho.set(n), r.uniformMatrix3fv(this.addr, !1, ho), ct(t, n);
  }
}
function up(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (lt(t, e))
      return;
    r.uniformMatrix4fv(this.addr, !1, e), ct(t, e);
  } else {
    if (lt(t, n))
      return;
    co.set(n), r.uniformMatrix4fv(this.addr, !1, co), ct(t, n);
  }
}
function dp(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1i(this.addr, e), t[0] = e);
}
function fp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2i(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (lt(t, e))
      return;
    r.uniform2iv(this.addr, e), ct(t, e);
  }
}
function pp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3i(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (lt(t, e))
      return;
    r.uniform3iv(this.addr, e), ct(t, e);
  }
}
function mp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4i(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (lt(t, e))
      return;
    r.uniform4iv(this.addr, e), ct(t, e);
  }
}
function gp(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1ui(this.addr, e), t[0] = e);
}
function _p(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2ui(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (lt(t, e))
      return;
    r.uniform2uiv(this.addr, e), ct(t, e);
  }
}
function vp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3ui(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (lt(t, e))
      return;
    r.uniform3uiv(this.addr, e), ct(t, e);
  }
}
function xp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4ui(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (lt(t, e))
      return;
    r.uniform4uiv(this.addr, e), ct(t, e);
  }
}
function yp(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTexture2D(e || wl, i);
}
function bp(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTexture3D(e || Tl, i);
}
function Mp(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTextureCube(e || Al, i);
}
function wp(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTexture2DArray(e || Sl, i);
}
function Sp(r) {
  switch (r) {
    case 5126:
      return rp;
    case 35664:
      return ap;
    case 35665:
      return op;
    case 35666:
      return lp;
    case 35674:
      return cp;
    case 35675:
      return hp;
    case 35676:
      return up;
    case 5124:
    case 35670:
      return dp;
    case 35667:
    case 35671:
      return fp;
    case 35668:
    case 35672:
      return pp;
    case 35669:
    case 35673:
      return mp;
    case 5125:
      return gp;
    case 36294:
      return _p;
    case 36295:
      return vp;
    case 36296:
      return xp;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return yp;
    case 35679:
    case 36299:
    case 36307:
      return bp;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return Mp;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return wp;
  }
}
function Tp(r, e) {
  r.uniform1fv(this.addr, e);
}
function Ap(r, e) {
  const t = Ti(e, this.size, 2);
  r.uniform2fv(this.addr, t);
}
function Ep(r, e) {
  const t = Ti(e, this.size, 3);
  r.uniform3fv(this.addr, t);
}
function Cp(r, e) {
  const t = Ti(e, this.size, 4);
  r.uniform4fv(this.addr, t);
}
function Lp(r, e) {
  const t = Ti(e, this.size, 4);
  r.uniformMatrix2fv(this.addr, !1, t);
}
function Rp(r, e) {
  const t = Ti(e, this.size, 9);
  r.uniformMatrix3fv(this.addr, !1, t);
}
function Pp(r, e) {
  const t = Ti(e, this.size, 16);
  r.uniformMatrix4fv(this.addr, !1, t);
}
function Dp(r, e) {
  r.uniform1iv(this.addr, e);
}
function Ip(r, e) {
  r.uniform2iv(this.addr, e);
}
function Op(r, e) {
  r.uniform3iv(this.addr, e);
}
function Np(r, e) {
  r.uniform4iv(this.addr, e);
}
function Fp(r, e) {
  r.uniform1uiv(this.addr, e);
}
function zp(r, e) {
  r.uniform2uiv(this.addr, e);
}
function Up(r, e) {
  r.uniform3uiv(this.addr, e);
}
function kp(r, e) {
  r.uniform4uiv(this.addr, e);
}
function Bp(r, e, t) {
  const n = this.cache, i = e.length, s = Vs(t, i);
  lt(n, s) || (r.uniform1iv(this.addr, s), ct(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTexture2D(e[a] || wl, s[a]);
}
function Hp(r, e, t) {
  const n = this.cache, i = e.length, s = Vs(t, i);
  lt(n, s) || (r.uniform1iv(this.addr, s), ct(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTexture3D(e[a] || Tl, s[a]);
}
function Vp(r, e, t) {
  const n = this.cache, i = e.length, s = Vs(t, i);
  lt(n, s) || (r.uniform1iv(this.addr, s), ct(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTextureCube(e[a] || Al, s[a]);
}
function Gp(r, e, t) {
  const n = this.cache, i = e.length, s = Vs(t, i);
  lt(n, s) || (r.uniform1iv(this.addr, s), ct(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTexture2DArray(e[a] || Sl, s[a]);
}
function Wp(r) {
  switch (r) {
    case 5126:
      return Tp;
    case 35664:
      return Ap;
    case 35665:
      return Ep;
    case 35666:
      return Cp;
    case 35674:
      return Lp;
    case 35675:
      return Rp;
    case 35676:
      return Pp;
    case 5124:
    case 35670:
      return Dp;
    case 35667:
    case 35671:
      return Ip;
    case 35668:
    case 35672:
      return Op;
    case 35669:
    case 35673:
      return Np;
    case 5125:
      return Fp;
    case 36294:
      return zp;
    case 36295:
      return Up;
    case 36296:
      return kp;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return Bp;
    case 35679:
    case 36299:
    case 36307:
      return Hp;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return Vp;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return Gp;
  }
}
class jp {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.setValue = Sp(t.type);
  }
}
class Xp {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.size = t.size, this.setValue = Wp(t.type);
  }
}
class qp {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, t, n) {
    const i = this.seq;
    for (let s = 0, a = i.length; s !== a; ++s) {
      const o = i[s];
      o.setValue(e, t[o.id], n);
    }
  }
}
const Mr = /(\w+)(\])?(\[|\.)?/g;
function fo(r, e) {
  r.seq.push(e), r.map[e.id] = e;
}
function Yp(r, e, t) {
  const n = r.name, i = n.length;
  for (Mr.lastIndex = 0; ; ) {
    const s = Mr.exec(n), a = Mr.lastIndex;
    let o = s[1];
    const l = s[2] === "]", c = s[3];
    if (l && (o = o | 0), c === void 0 || c === "[" && a + 2 === i) {
      fo(t, c === void 0 ? new jp(o, r, e) : new Xp(o, r, e));
      break;
    } else {
      let h = t.map[o];
      h === void 0 && (h = new qp(o), fo(t, h)), t = h;
    }
  }
}
class Is {
  constructor(e, t) {
    this.seq = [], this.map = {};
    const n = e.getProgramParameter(t, 35718);
    for (let i = 0; i < n; ++i) {
      const s = e.getActiveUniform(t, i), a = e.getUniformLocation(t, s.name);
      Yp(s, a, this);
    }
  }
  setValue(e, t, n, i) {
    const s = this.map[t];
    s !== void 0 && s.setValue(e, n, i);
  }
  setOptional(e, t, n) {
    const i = t[n];
    i !== void 0 && this.setValue(e, n, i);
  }
  static upload(e, t, n, i) {
    for (let s = 0, a = t.length; s !== a; ++s) {
      const o = t[s], l = n[o.id];
      l.needsUpdate !== !1 && o.setValue(e, l.value, i);
    }
  }
  static seqWithValue(e, t) {
    const n = [];
    for (let i = 0, s = e.length; i !== s; ++i) {
      const a = e[i];
      a.id in t && n.push(a);
    }
    return n;
  }
}
function po(r, e, t) {
  const n = r.createShader(e);
  return r.shaderSource(n, t), r.compileShader(n), n;
}
let Kp = 0;
function Zp(r, e) {
  const t = r.split(`
`), n = [], i = Math.max(e - 6, 0), s = Math.min(e + 6, t.length);
  for (let a = i; a < s; a++) {
    const o = a + 1;
    n.push(`${o === e ? ">" : " "} ${o}: ${t[a]}`);
  }
  return n.join(`
`);
}
function $p(r) {
  switch (r) {
    case Bn:
      return ["Linear", "( value )"];
    case Xe:
      return ["sRGB", "( value )"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported encoding:", r), ["Linear", "( value )"];
  }
}
function mo(r, e, t) {
  const n = r.getShaderParameter(e, 35713), i = r.getShaderInfoLog(e).trim();
  if (n && i === "")
    return "";
  const s = /ERROR: 0:(\d+)/.exec(i);
  if (s) {
    const a = parseInt(s[1]);
    return t.toUpperCase() + `

` + i + `

` + Zp(r.getShaderSource(e), a);
  } else
    return i;
}
function Jp(r, e) {
  const t = $p(e);
  return "vec4 " + r + "( vec4 value ) { return LinearTo" + t[0] + t[1] + "; }";
}
function Qp(r, e) {
  let t;
  switch (e) {
    case nh:
      t = "Linear";
      break;
    case ih:
      t = "Reinhard";
      break;
    case sh:
      t = "OptimizedCineon";
      break;
    case rh:
      t = "ACESFilmic";
      break;
    case ah:
      t = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), t = "Linear";
  }
  return "vec3 " + r + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
function em(r) {
  return [
    r.extensionDerivatives || !!r.envMapCubeUVHeight || r.bumpMap || r.tangentSpaceNormalMap || r.clearcoatNormalMap || r.flatShading || r.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (r.extensionFragDepth || r.logarithmicDepthBuffer) && r.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    r.extensionDrawBuffers && r.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (r.extensionShaderTextureLOD || r.envMap || r.transmission) && r.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ].filter(Gi).join(`
`);
}
function tm(r) {
  const e = [];
  for (const t in r) {
    const n = r[t];
    n !== !1 && e.push("#define " + t + " " + n);
  }
  return e.join(`
`);
}
function nm(r, e) {
  const t = {}, n = r.getProgramParameter(e, 35721);
  for (let i = 0; i < n; i++) {
    const s = r.getActiveAttrib(e, i), a = s.name;
    let o = 1;
    s.type === 35674 && (o = 2), s.type === 35675 && (o = 3), s.type === 35676 && (o = 4), t[a] = {
      type: s.type,
      location: r.getAttribLocation(e, a),
      locationSize: o
    };
  }
  return t;
}
function Gi(r) {
  return r !== "";
}
function go(r, e) {
  const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return r.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, t).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function _o(r, e) {
  return r.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const im = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Hr(r) {
  return r.replace(im, sm);
}
function sm(r, e) {
  const t = Ie[e];
  if (t === void 0)
    throw new Error("Can not resolve #include <" + e + ">");
  return Hr(t);
}
const rm = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function vo(r) {
  return r.replace(rm, am);
}
function am(r, e, t, n) {
  let i = "";
  for (let s = parseInt(e); s < parseInt(t); s++)
    i += n.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
  return i;
}
function xo(r) {
  let e = "precision " + r.precision + ` float;
precision ` + r.precision + " int;";
  return r.precision === "highp" ? e += `
#define HIGH_PRECISION` : r.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : r.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function om(r) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return r.shadowMapType === il ? e = "SHADOWMAP_TYPE_PCF" : r.shadowMapType === Oc ? e = "SHADOWMAP_TYPE_PCF_SOFT" : r.shadowMapType === Vi && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function lm(r) {
  let e = "ENVMAP_TYPE_CUBE";
  if (r.envMap)
    switch (r.envMapMode) {
      case gi:
      case _i:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case Hs:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function cm(r) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (r.envMap)
    switch (r.envMapMode) {
      case _i:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function hm(r) {
  let e = "ENVMAP_BLENDING_NONE";
  if (r.envMap)
    switch (r.combine) {
      case Yr:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case eh:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case th:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function um(r) {
  const e = r.envMapCubeUVHeight;
  if (e === null)
    return null;
  const t = Math.log2(e) - 2, n = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 7 * 16)), texelHeight: n, maxMip: t };
}
function dm(r, e, t, n) {
  const i = r.getContext(), s = t.defines;
  let a = t.vertexShader, o = t.fragmentShader;
  const l = om(t), c = lm(t), u = cm(t), h = hm(t), d = um(t), m = t.isWebGL2 ? "" : em(t), g = tm(s), p = i.createProgram();
  let f, v, S = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
  t.isRawShaderMaterial ? (f = [
    g
  ].filter(Gi).join(`
`), f.length > 0 && (f += `
`), v = [
    m,
    g
  ].filter(Gi).join(`
`), v.length > 0 && (v += `
`)) : (f = [
    xo(t),
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.instancing ? "#define USE_INSTANCING" : "",
    t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    t.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + u : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMap && t.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
    t.normalMap && t.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.displacementMap && t.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
    t.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
    t.vertexTangents ? "#define USE_TANGENT" : "",
    t.vertexColors ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUvs ? "#define USE_UV" : "",
    t.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.skinning ? "#define USE_SKINNING" : "",
    t.morphTargets ? "#define USE_MORPHTARGETS" : "",
    t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    t.morphColors && t.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.logarithmicDepthBuffer && t.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
    "	attribute vec3 morphTarget0;",
    "	attribute vec3 morphTarget1;",
    "	attribute vec3 morphTarget2;",
    "	attribute vec3 morphTarget3;",
    "	#ifdef USE_MORPHNORMALS",
    "		attribute vec3 morphNormal0;",
    "		attribute vec3 morphNormal1;",
    "		attribute vec3 morphNormal2;",
    "		attribute vec3 morphNormal3;",
    "	#else",
    "		attribute vec3 morphTarget4;",
    "		attribute vec3 morphTarget5;",
    "		attribute vec3 morphTarget6;",
    "		attribute vec3 morphTarget7;",
    "	#endif",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(Gi).join(`
`), v = [
    m,
    xo(t),
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.matcap ? "#define USE_MATCAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + c : "",
    t.envMap ? "#define " + u : "",
    t.envMap ? "#define " + h : "",
    d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
    d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
    d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMap && t.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
    t.normalMap && t.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
    t.clearcoat ? "#define USE_CLEARCOAT" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescence ? "#define USE_IRIDESCENCE" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
    t.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaTest ? "#define USE_ALPHATEST" : "",
    t.sheen ? "#define USE_SHEEN" : "",
    t.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    t.vertexTangents ? "#define USE_TANGENT" : "",
    t.vertexColors || t.instancingColor ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUvs ? "#define USE_UV" : "",
    t.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
    t.gradientMap ? "#define USE_GRADIENTMAP" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + l : "",
    t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    t.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.logarithmicDepthBuffer && t.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    t.toneMapping !== cn ? "#define TONE_MAPPING" : "",
    t.toneMapping !== cn ? Ie.tonemapping_pars_fragment : "",
    t.toneMapping !== cn ? Qp("toneMapping", t.toneMapping) : "",
    t.dithering ? "#define DITHERING" : "",
    t.opaque ? "#define OPAQUE" : "",
    Ie.encodings_pars_fragment,
    Jp("linearToOutputTexel", t.outputEncoding),
    t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
    `
`
  ].filter(Gi).join(`
`)), a = Hr(a), a = go(a, t), a = _o(a, t), o = Hr(o), o = go(o, t), o = _o(o, t), a = vo(a), o = vo(o), t.isWebGL2 && t.isRawShaderMaterial !== !0 && (S = `#version 300 es
`, f = [
    "precision mediump sampler2DArray;",
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + f, v = [
    "#define varying in",
    t.glslVersion === Va ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    t.glslVersion === Va ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + v);
  const y = S + f + a, b = S + v + o, w = po(i, 35633, y), D = po(i, 35632, b);
  if (i.attachShader(p, w), i.attachShader(p, D), t.index0AttributeName !== void 0 ? i.bindAttribLocation(p, 0, t.index0AttributeName) : t.morphTargets === !0 && i.bindAttribLocation(p, 0, "position"), i.linkProgram(p), r.debug.checkShaderErrors) {
    const R = i.getProgramInfoLog(p).trim(), k = i.getShaderInfoLog(w).trim(), T = i.getShaderInfoLog(D).trim();
    let ee = !0, V = !0;
    if (i.getProgramParameter(p, 35714) === !1) {
      ee = !1;
      const H = mo(i, w, "vertex"), j = mo(i, D, "fragment");
      console.error(
        "THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(p, 35715) + `

Program Info Log: ` + R + `
` + H + `
` + j
      );
    } else
      R !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", R) : (k === "" || T === "") && (V = !1);
    V && (this.diagnostics = {
      runnable: ee,
      programLog: R,
      vertexShader: {
        log: k,
        prefix: f
      },
      fragmentShader: {
        log: T,
        prefix: v
      }
    });
  }
  i.deleteShader(w), i.deleteShader(D);
  let z;
  this.getUniforms = function() {
    return z === void 0 && (z = new Is(i, p)), z;
  };
  let x;
  return this.getAttributes = function() {
    return x === void 0 && (x = nm(i, p)), x;
  }, this.destroy = function() {
    n.releaseStatesOfProgram(this), i.deleteProgram(p), this.program = void 0;
  }, this.name = t.shaderName, this.id = Kp++, this.cacheKey = e, this.usedTimes = 1, this.program = p, this.vertexShader = w, this.fragmentShader = D, this;
}
let fm = 0;
class pm {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const t = e.vertexShader, n = e.fragmentShader, i = this._getShaderStage(t), s = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e);
    return a.has(i) === !1 && (a.add(i), i.usedTimes++), a.has(s) === !1 && (a.add(s), s.usedTimes++), this;
  }
  remove(e) {
    const t = this.materialCache.get(e);
    for (const n of t)
      n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache;
    let n = t.get(e);
    return n === void 0 && (n = /* @__PURE__ */ new Set(), t.set(e, n)), n;
  }
  _getShaderStage(e) {
    const t = this.shaderCache;
    let n = t.get(e);
    return n === void 0 && (n = new mm(e), t.set(e, n)), n;
  }
}
class mm {
  constructor(e) {
    this.id = fm++, this.code = e, this.usedTimes = 0;
  }
}
function gm(r, e, t, n, i, s, a) {
  const o = new gl(), l = new pm(), c = [], u = i.isWebGL2, h = i.logarithmicDepthBuffer, d = i.vertexTextures;
  let m = i.precision;
  const g = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function p(x, R, k, T, ee) {
    const V = T.fog, H = ee.geometry, j = x.isMeshStandardMaterial ? T.environment : null, G = (x.isMeshStandardMaterial ? t : e).get(x.envMap || j), te = !!G && G.mapping === Hs ? G.image.height : null, Z = g[x.type];
    x.precision !== null && (m = i.getMaxPrecision(x.precision), m !== x.precision && console.warn("THREE.WebGLProgram.getParameters:", x.precision, "not supported, using", m, "instead."));
    const re = H.morphAttributes.position || H.morphAttributes.normal || H.morphAttributes.color, $ = re !== void 0 ? re.length : 0;
    let K = 0;
    H.morphAttributes.position !== void 0 && (K = 1), H.morphAttributes.normal !== void 0 && (K = 2), H.morphAttributes.color !== void 0 && (K = 3);
    let W, le, ae, ue;
    if (Z) {
      const Ae = Zt[Z];
      W = Ae.vertexShader, le = Ae.fragmentShader;
    } else
      W = x.vertexShader, le = x.fragmentShader, l.update(x), ae = l.getVertexShaderID(x), ue = l.getFragmentShaderID(x);
    const Y = r.getRenderTarget(), Oe = x.alphaTest > 0, be = x.clearcoat > 0, Ce = x.iridescence > 0;
    return {
      isWebGL2: u,
      shaderID: Z,
      shaderName: x.type,
      vertexShader: W,
      fragmentShader: le,
      defines: x.defines,
      customVertexShaderID: ae,
      customFragmentShaderID: ue,
      isRawShaderMaterial: x.isRawShaderMaterial === !0,
      glslVersion: x.glslVersion,
      precision: m,
      instancing: ee.isInstancedMesh === !0,
      instancingColor: ee.isInstancedMesh === !0 && ee.instanceColor !== null,
      supportsVertexTextures: d,
      outputEncoding: Y === null ? r.outputEncoding : Y.isXRRenderTarget === !0 ? Y.texture.encoding : Bn,
      map: !!x.map,
      matcap: !!x.matcap,
      envMap: !!G,
      envMapMode: G && G.mapping,
      envMapCubeUVHeight: te,
      lightMap: !!x.lightMap,
      aoMap: !!x.aoMap,
      emissiveMap: !!x.emissiveMap,
      bumpMap: !!x.bumpMap,
      normalMap: !!x.normalMap,
      objectSpaceNormalMap: x.normalMapType === Ah,
      tangentSpaceNormalMap: x.normalMapType === Kr,
      decodeVideoTexture: !!x.map && x.map.isVideoTexture === !0 && x.map.encoding === Xe,
      clearcoat: be,
      clearcoatMap: be && !!x.clearcoatMap,
      clearcoatRoughnessMap: be && !!x.clearcoatRoughnessMap,
      clearcoatNormalMap: be && !!x.clearcoatNormalMap,
      iridescence: Ce,
      iridescenceMap: Ce && !!x.iridescenceMap,
      iridescenceThicknessMap: Ce && !!x.iridescenceThicknessMap,
      displacementMap: !!x.displacementMap,
      roughnessMap: !!x.roughnessMap,
      metalnessMap: !!x.metalnessMap,
      specularMap: !!x.specularMap,
      specularIntensityMap: !!x.specularIntensityMap,
      specularColorMap: !!x.specularColorMap,
      opaque: x.transparent === !1 && x.blending === ui,
      alphaMap: !!x.alphaMap,
      alphaTest: Oe,
      gradientMap: !!x.gradientMap,
      sheen: x.sheen > 0,
      sheenColorMap: !!x.sheenColorMap,
      sheenRoughnessMap: !!x.sheenRoughnessMap,
      transmission: x.transmission > 0,
      transmissionMap: !!x.transmissionMap,
      thicknessMap: !!x.thicknessMap,
      combine: x.combine,
      vertexTangents: !!x.normalMap && !!H.attributes.tangent,
      vertexColors: x.vertexColors,
      vertexAlphas: x.vertexColors === !0 && !!H.attributes.color && H.attributes.color.itemSize === 4,
      vertexUvs: !!x.map || !!x.bumpMap || !!x.normalMap || !!x.specularMap || !!x.alphaMap || !!x.emissiveMap || !!x.roughnessMap || !!x.metalnessMap || !!x.clearcoatMap || !!x.clearcoatRoughnessMap || !!x.clearcoatNormalMap || !!x.iridescenceMap || !!x.iridescenceThicknessMap || !!x.displacementMap || !!x.transmissionMap || !!x.thicknessMap || !!x.specularIntensityMap || !!x.specularColorMap || !!x.sheenColorMap || !!x.sheenRoughnessMap,
      uvsVertexOnly: !(!!x.map || !!x.bumpMap || !!x.normalMap || !!x.specularMap || !!x.alphaMap || !!x.emissiveMap || !!x.roughnessMap || !!x.metalnessMap || !!x.clearcoatNormalMap || !!x.iridescenceMap || !!x.iridescenceThicknessMap || x.transmission > 0 || !!x.transmissionMap || !!x.thicknessMap || !!x.specularIntensityMap || !!x.specularColorMap || x.sheen > 0 || !!x.sheenColorMap || !!x.sheenRoughnessMap) && !!x.displacementMap,
      fog: !!V,
      useFog: x.fog === !0,
      fogExp2: V && V.isFogExp2,
      flatShading: !!x.flatShading,
      sizeAttenuation: x.sizeAttenuation,
      logarithmicDepthBuffer: h,
      skinning: ee.isSkinnedMesh === !0,
      morphTargets: H.morphAttributes.position !== void 0,
      morphNormals: H.morphAttributes.normal !== void 0,
      morphColors: H.morphAttributes.color !== void 0,
      morphTargetsCount: $,
      morphTextureStride: K,
      numDirLights: R.directional.length,
      numPointLights: R.point.length,
      numSpotLights: R.spot.length,
      numSpotLightMaps: R.spotLightMap.length,
      numRectAreaLights: R.rectArea.length,
      numHemiLights: R.hemi.length,
      numDirLightShadows: R.directionalShadowMap.length,
      numPointLightShadows: R.pointShadowMap.length,
      numSpotLightShadows: R.spotShadowMap.length,
      numSpotLightShadowsWithMaps: R.numSpotLightShadowsWithMaps,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: x.dithering,
      shadowMapEnabled: r.shadowMap.enabled && k.length > 0,
      shadowMapType: r.shadowMap.type,
      toneMapping: x.toneMapped ? r.toneMapping : cn,
      physicallyCorrectLights: r.physicallyCorrectLights,
      premultipliedAlpha: x.premultipliedAlpha,
      doubleSided: x.side === Bs,
      flipSided: x.side === kt,
      useDepthPacking: !!x.depthPacking,
      depthPacking: x.depthPacking || 0,
      index0AttributeName: x.index0AttributeName,
      extensionDerivatives: x.extensions && x.extensions.derivatives,
      extensionFragDepth: x.extensions && x.extensions.fragDepth,
      extensionDrawBuffers: x.extensions && x.extensions.drawBuffers,
      extensionShaderTextureLOD: x.extensions && x.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: u || n.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: u || n.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: u || n.has("EXT_shader_texture_lod"),
      customProgramCacheKey: x.customProgramCacheKey()
    };
  }
  function f(x) {
    const R = [];
    if (x.shaderID ? R.push(x.shaderID) : (R.push(x.customVertexShaderID), R.push(x.customFragmentShaderID)), x.defines !== void 0)
      for (const k in x.defines)
        R.push(k), R.push(x.defines[k]);
    return x.isRawShaderMaterial === !1 && (v(R, x), S(R, x), R.push(r.outputEncoding)), R.push(x.customProgramCacheKey), R.join();
  }
  function v(x, R) {
    x.push(R.precision), x.push(R.outputEncoding), x.push(R.envMapMode), x.push(R.envMapCubeUVHeight), x.push(R.combine), x.push(R.vertexUvs), x.push(R.fogExp2), x.push(R.sizeAttenuation), x.push(R.morphTargetsCount), x.push(R.morphAttributeCount), x.push(R.numDirLights), x.push(R.numPointLights), x.push(R.numSpotLights), x.push(R.numSpotLightMaps), x.push(R.numHemiLights), x.push(R.numRectAreaLights), x.push(R.numDirLightShadows), x.push(R.numPointLightShadows), x.push(R.numSpotLightShadows), x.push(R.numSpotLightShadowsWithMaps), x.push(R.shadowMapType), x.push(R.toneMapping), x.push(R.numClippingPlanes), x.push(R.numClipIntersection), x.push(R.depthPacking);
  }
  function S(x, R) {
    o.disableAll(), R.isWebGL2 && o.enable(0), R.supportsVertexTextures && o.enable(1), R.instancing && o.enable(2), R.instancingColor && o.enable(3), R.map && o.enable(4), R.matcap && o.enable(5), R.envMap && o.enable(6), R.lightMap && o.enable(7), R.aoMap && o.enable(8), R.emissiveMap && o.enable(9), R.bumpMap && o.enable(10), R.normalMap && o.enable(11), R.objectSpaceNormalMap && o.enable(12), R.tangentSpaceNormalMap && o.enable(13), R.clearcoat && o.enable(14), R.clearcoatMap && o.enable(15), R.clearcoatRoughnessMap && o.enable(16), R.clearcoatNormalMap && o.enable(17), R.iridescence && o.enable(18), R.iridescenceMap && o.enable(19), R.iridescenceThicknessMap && o.enable(20), R.displacementMap && o.enable(21), R.specularMap && o.enable(22), R.roughnessMap && o.enable(23), R.metalnessMap && o.enable(24), R.gradientMap && o.enable(25), R.alphaMap && o.enable(26), R.alphaTest && o.enable(27), R.vertexColors && o.enable(28), R.vertexAlphas && o.enable(29), R.vertexUvs && o.enable(30), R.vertexTangents && o.enable(31), R.uvsVertexOnly && o.enable(32), x.push(o.mask), o.disableAll(), R.fog && o.enable(0), R.useFog && o.enable(1), R.flatShading && o.enable(2), R.logarithmicDepthBuffer && o.enable(3), R.skinning && o.enable(4), R.morphTargets && o.enable(5), R.morphNormals && o.enable(6), R.morphColors && o.enable(7), R.premultipliedAlpha && o.enable(8), R.shadowMapEnabled && o.enable(9), R.physicallyCorrectLights && o.enable(10), R.doubleSided && o.enable(11), R.flipSided && o.enable(12), R.useDepthPacking && o.enable(13), R.dithering && o.enable(14), R.specularIntensityMap && o.enable(15), R.specularColorMap && o.enable(16), R.transmission && o.enable(17), R.transmissionMap && o.enable(18), R.thicknessMap && o.enable(19), R.sheen && o.enable(20), R.sheenColorMap && o.enable(21), R.sheenRoughnessMap && o.enable(22), R.decodeVideoTexture && o.enable(23), R.opaque && o.enable(24), x.push(o.mask);
  }
  function y(x) {
    const R = g[x.type];
    let k;
    if (R) {
      const T = Zt[R];
      k = tu.clone(T.uniforms);
    } else
      k = x.uniforms;
    return k;
  }
  function b(x, R) {
    let k;
    for (let T = 0, ee = c.length; T < ee; T++) {
      const V = c[T];
      if (V.cacheKey === R) {
        k = V, ++k.usedTimes;
        break;
      }
    }
    return k === void 0 && (k = new dm(r, R, x, s), c.push(k)), k;
  }
  function w(x) {
    if (--x.usedTimes === 0) {
      const R = c.indexOf(x);
      c[R] = c[c.length - 1], c.pop(), x.destroy();
    }
  }
  function D(x) {
    l.remove(x);
  }
  function z() {
    l.dispose();
  }
  return {
    getParameters: p,
    getProgramCacheKey: f,
    getUniforms: y,
    acquireProgram: b,
    releaseProgram: w,
    releaseShaderCache: D,
    programs: c,
    dispose: z
  };
}
function _m() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(s) {
    let a = r.get(s);
    return a === void 0 && (a = {}, r.set(s, a)), a;
  }
  function t(s) {
    r.delete(s);
  }
  function n(s, a, o) {
    r.get(s)[a] = o;
  }
  function i() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    remove: t,
    update: n,
    dispose: i
  };
}
function vm(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.material.id !== e.material.id ? r.material.id - e.material.id : r.z !== e.z ? r.z - e.z : r.id - e.id;
}
function yo(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.z !== e.z ? e.z - r.z : r.id - e.id;
}
function bo() {
  const r = [];
  let e = 0;
  const t = [], n = [], i = [];
  function s() {
    e = 0, t.length = 0, n.length = 0, i.length = 0;
  }
  function a(h, d, m, g, p, f) {
    let v = r[e];
    return v === void 0 ? (v = {
      id: h.id,
      object: h,
      geometry: d,
      material: m,
      groupOrder: g,
      renderOrder: h.renderOrder,
      z: p,
      group: f
    }, r[e] = v) : (v.id = h.id, v.object = h, v.geometry = d, v.material = m, v.groupOrder = g, v.renderOrder = h.renderOrder, v.z = p, v.group = f), e++, v;
  }
  function o(h, d, m, g, p, f) {
    const v = a(h, d, m, g, p, f);
    m.transmission > 0 ? n.push(v) : m.transparent === !0 ? i.push(v) : t.push(v);
  }
  function l(h, d, m, g, p, f) {
    const v = a(h, d, m, g, p, f);
    m.transmission > 0 ? n.unshift(v) : m.transparent === !0 ? i.unshift(v) : t.unshift(v);
  }
  function c(h, d) {
    t.length > 1 && t.sort(h || vm), n.length > 1 && n.sort(d || yo), i.length > 1 && i.sort(d || yo);
  }
  function u() {
    for (let h = e, d = r.length; h < d; h++) {
      const m = r[h];
      if (m.id === null)
        break;
      m.id = null, m.object = null, m.geometry = null, m.material = null, m.group = null;
    }
  }
  return {
    opaque: t,
    transmissive: n,
    transparent: i,
    init: s,
    push: o,
    unshift: l,
    finish: u,
    sort: c
  };
}
function xm() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(n, i) {
    const s = r.get(n);
    let a;
    return s === void 0 ? (a = new bo(), r.set(n, [a])) : i >= s.length ? (a = new bo(), s.push(a)) : a = s[i], a;
  }
  function t() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: t
  };
}
function ym() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            direction: new F(),
            color: new De()
          };
          break;
        case "SpotLight":
          t = {
            position: new F(),
            direction: new F(),
            color: new De(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          t = {
            position: new F(),
            color: new De(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          t = {
            direction: new F(),
            skyColor: new De(),
            groundColor: new De()
          };
          break;
        case "RectAreaLight":
          t = {
            color: new De(),
            position: new F(),
            halfWidth: new F(),
            halfHeight: new F()
          };
          break;
      }
      return r[e.id] = t, t;
    }
  };
}
function bm() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pe()
          };
          break;
        case "SpotLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pe()
          };
          break;
        case "PointLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Pe(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return r[e.id] = t, t;
    }
  };
}
let Mm = 0;
function wm(r, e) {
  return (e.castShadow ? 2 : 0) - (r.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (r.map ? 1 : 0);
}
function Sm(r, e) {
  const t = new ym(), n = bm(), i = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0
  };
  for (let u = 0; u < 9; u++)
    i.probe.push(new F());
  const s = new F(), a = new Fe(), o = new Fe();
  function l(u, h) {
    let d = 0, m = 0, g = 0;
    for (let T = 0; T < 9; T++)
      i.probe[T].set(0, 0, 0);
    let p = 0, f = 0, v = 0, S = 0, y = 0, b = 0, w = 0, D = 0, z = 0, x = 0;
    u.sort(wm);
    const R = h !== !0 ? Math.PI : 1;
    for (let T = 0, ee = u.length; T < ee; T++) {
      const V = u[T], H = V.color, j = V.intensity, G = V.distance, te = V.shadow && V.shadow.map ? V.shadow.map.texture : null;
      if (V.isAmbientLight)
        d += H.r * j * R, m += H.g * j * R, g += H.b * j * R;
      else if (V.isLightProbe)
        for (let Z = 0; Z < 9; Z++)
          i.probe[Z].addScaledVector(V.sh.coefficients[Z], j);
      else if (V.isDirectionalLight) {
        const Z = t.get(V);
        if (Z.color.copy(V.color).multiplyScalar(V.intensity * R), V.castShadow) {
          const re = V.shadow, $ = n.get(V);
          $.shadowBias = re.bias, $.shadowNormalBias = re.normalBias, $.shadowRadius = re.radius, $.shadowMapSize = re.mapSize, i.directionalShadow[p] = $, i.directionalShadowMap[p] = te, i.directionalShadowMatrix[p] = V.shadow.matrix, b++;
        }
        i.directional[p] = Z, p++;
      } else if (V.isSpotLight) {
        const Z = t.get(V);
        Z.position.setFromMatrixPosition(V.matrixWorld), Z.color.copy(H).multiplyScalar(j * R), Z.distance = G, Z.coneCos = Math.cos(V.angle), Z.penumbraCos = Math.cos(V.angle * (1 - V.penumbra)), Z.decay = V.decay, i.spot[v] = Z;
        const re = V.shadow;
        if (V.map && (i.spotLightMap[z] = V.map, z++, re.updateMatrices(V), V.castShadow && x++), i.spotLightMatrix[v] = re.matrix, V.castShadow) {
          const $ = n.get(V);
          $.shadowBias = re.bias, $.shadowNormalBias = re.normalBias, $.shadowRadius = re.radius, $.shadowMapSize = re.mapSize, i.spotShadow[v] = $, i.spotShadowMap[v] = te, D++;
        }
        v++;
      } else if (V.isRectAreaLight) {
        const Z = t.get(V);
        Z.color.copy(H).multiplyScalar(j), Z.halfWidth.set(V.width * 0.5, 0, 0), Z.halfHeight.set(0, V.height * 0.5, 0), i.rectArea[S] = Z, S++;
      } else if (V.isPointLight) {
        const Z = t.get(V);
        if (Z.color.copy(V.color).multiplyScalar(V.intensity * R), Z.distance = V.distance, Z.decay = V.decay, V.castShadow) {
          const re = V.shadow, $ = n.get(V);
          $.shadowBias = re.bias, $.shadowNormalBias = re.normalBias, $.shadowRadius = re.radius, $.shadowMapSize = re.mapSize, $.shadowCameraNear = re.camera.near, $.shadowCameraFar = re.camera.far, i.pointShadow[f] = $, i.pointShadowMap[f] = te, i.pointShadowMatrix[f] = V.shadow.matrix, w++;
        }
        i.point[f] = Z, f++;
      } else if (V.isHemisphereLight) {
        const Z = t.get(V);
        Z.skyColor.copy(V.color).multiplyScalar(j * R), Z.groundColor.copy(V.groundColor).multiplyScalar(j * R), i.hemi[y] = Z, y++;
      }
    }
    S > 0 && (e.isWebGL2 || r.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = he.LTC_FLOAT_1, i.rectAreaLTC2 = he.LTC_FLOAT_2) : r.has("OES_texture_half_float_linear") === !0 ? (i.rectAreaLTC1 = he.LTC_HALF_1, i.rectAreaLTC2 = he.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), i.ambient[0] = d, i.ambient[1] = m, i.ambient[2] = g;
    const k = i.hash;
    (k.directionalLength !== p || k.pointLength !== f || k.spotLength !== v || k.rectAreaLength !== S || k.hemiLength !== y || k.numDirectionalShadows !== b || k.numPointShadows !== w || k.numSpotShadows !== D || k.numSpotMaps !== z) && (i.directional.length = p, i.spot.length = v, i.rectArea.length = S, i.point.length = f, i.hemi.length = y, i.directionalShadow.length = b, i.directionalShadowMap.length = b, i.pointShadow.length = w, i.pointShadowMap.length = w, i.spotShadow.length = D, i.spotShadowMap.length = D, i.directionalShadowMatrix.length = b, i.pointShadowMatrix.length = w, i.spotLightMatrix.length = D + z - x, i.spotLightMap.length = z, i.numSpotLightShadowsWithMaps = x, k.directionalLength = p, k.pointLength = f, k.spotLength = v, k.rectAreaLength = S, k.hemiLength = y, k.numDirectionalShadows = b, k.numPointShadows = w, k.numSpotShadows = D, k.numSpotMaps = z, i.version = Mm++);
  }
  function c(u, h) {
    let d = 0, m = 0, g = 0, p = 0, f = 0;
    const v = h.matrixWorldInverse;
    for (let S = 0, y = u.length; S < y; S++) {
      const b = u[S];
      if (b.isDirectionalLight) {
        const w = i.directional[d];
        w.direction.setFromMatrixPosition(b.matrixWorld), s.setFromMatrixPosition(b.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(v), d++;
      } else if (b.isSpotLight) {
        const w = i.spot[g];
        w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(v), w.direction.setFromMatrixPosition(b.matrixWorld), s.setFromMatrixPosition(b.target.matrixWorld), w.direction.sub(s), w.direction.transformDirection(v), g++;
      } else if (b.isRectAreaLight) {
        const w = i.rectArea[p];
        w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(v), o.identity(), a.copy(b.matrixWorld), a.premultiply(v), o.extractRotation(a), w.halfWidth.set(b.width * 0.5, 0, 0), w.halfHeight.set(0, b.height * 0.5, 0), w.halfWidth.applyMatrix4(o), w.halfHeight.applyMatrix4(o), p++;
      } else if (b.isPointLight) {
        const w = i.point[m];
        w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(v), m++;
      } else if (b.isHemisphereLight) {
        const w = i.hemi[f];
        w.direction.setFromMatrixPosition(b.matrixWorld), w.direction.transformDirection(v), f++;
      }
    }
  }
  return {
    setup: l,
    setupView: c,
    state: i
  };
}
function Mo(r, e) {
  const t = new Sm(r, e), n = [], i = [];
  function s() {
    n.length = 0, i.length = 0;
  }
  function a(h) {
    n.push(h);
  }
  function o(h) {
    i.push(h);
  }
  function l(h) {
    t.setup(n, h);
  }
  function c(h) {
    t.setupView(n, h);
  }
  return {
    init: s,
    state: {
      lightsArray: n,
      shadowsArray: i,
      lights: t
    },
    setupLights: l,
    setupLightsView: c,
    pushLight: a,
    pushShadow: o
  };
}
function Tm(r, e) {
  let t = /* @__PURE__ */ new WeakMap();
  function n(s, a = 0) {
    const o = t.get(s);
    let l;
    return o === void 0 ? (l = new Mo(r, e), t.set(s, [l])) : a >= o.length ? (l = new Mo(r, e), o.push(l)) : l = o[a], l;
  }
  function i() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: i
  };
}
class Am extends Xt {
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Sh, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class Em extends Xt {
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new F(), this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.referencePosition.copy(e.referencePosition), this.nearDistance = e.nearDistance, this.farDistance = e.farDistance, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const Cm = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, Lm = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function Rm(r, e, t) {
  let n = new Jr();
  const i = new Pe(), s = new Pe(), a = new Ze(), o = new Am({ depthPacking: Th }), l = new Em(), c = {}, u = t.maxTextureSize, h = { 0: kt, 1: Mn, 2: Bs }, d = new Vn({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Pe() },
      radius: { value: 4 }
    },
    vertexShader: Cm,
    fragmentShader: Lm
  }), m = d.clone();
  m.defines.HORIZONTAL_PASS = 1;
  const g = new Yt();
  g.setAttribute(
    "position",
    new gt(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const p = new Ut(g, d), f = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = il, this.render = function(b, w, D) {
    if (f.enabled === !1 || f.autoUpdate === !1 && f.needsUpdate === !1 || b.length === 0)
      return;
    const z = r.getRenderTarget(), x = r.getActiveCubeFace(), R = r.getActiveMipmapLevel(), k = r.state;
    k.setBlending(yn), k.buffers.color.setClear(1, 1, 1, 1), k.buffers.depth.setTest(!0), k.setScissorTest(!1);
    for (let T = 0, ee = b.length; T < ee; T++) {
      const V = b[T], H = V.shadow;
      if (H === void 0) {
        console.warn("THREE.WebGLShadowMap:", V, "has no shadow.");
        continue;
      }
      if (H.autoUpdate === !1 && H.needsUpdate === !1)
        continue;
      i.copy(H.mapSize);
      const j = H.getFrameExtents();
      if (i.multiply(j), s.copy(H.mapSize), (i.x > u || i.y > u) && (i.x > u && (s.x = Math.floor(u / j.x), i.x = s.x * j.x, H.mapSize.x = s.x), i.y > u && (s.y = Math.floor(u / j.y), i.y = s.y * j.y, H.mapSize.y = s.y)), H.map === null) {
        const te = this.type !== Vi ? { minFilter: ft, magFilter: ft } : {};
        H.map = new Hn(i.x, i.y, te), H.map.texture.name = V.name + ".shadowMap", H.camera.updateProjectionMatrix();
      }
      r.setRenderTarget(H.map), r.clear();
      const G = H.getViewportCount();
      for (let te = 0; te < G; te++) {
        const Z = H.getViewport(te);
        a.set(
          s.x * Z.x,
          s.y * Z.y,
          s.x * Z.z,
          s.y * Z.w
        ), k.viewport(a), H.updateMatrices(V, te), n = H.getFrustum(), y(w, D, H.camera, V, this.type);
      }
      H.isPointLightShadow !== !0 && this.type === Vi && v(H, D), H.needsUpdate = !1;
    }
    f.needsUpdate = !1, r.setRenderTarget(z, x, R);
  };
  function v(b, w) {
    const D = e.update(p);
    d.defines.VSM_SAMPLES !== b.blurSamples && (d.defines.VSM_SAMPLES = b.blurSamples, m.defines.VSM_SAMPLES = b.blurSamples, d.needsUpdate = !0, m.needsUpdate = !0), b.mapPass === null && (b.mapPass = new Hn(i.x, i.y)), d.uniforms.shadow_pass.value = b.map.texture, d.uniforms.resolution.value = b.mapSize, d.uniforms.radius.value = b.radius, r.setRenderTarget(b.mapPass), r.clear(), r.renderBufferDirect(w, null, D, d, p, null), m.uniforms.shadow_pass.value = b.mapPass.texture, m.uniforms.resolution.value = b.mapSize, m.uniforms.radius.value = b.radius, r.setRenderTarget(b.map), r.clear(), r.renderBufferDirect(w, null, D, m, p, null);
  }
  function S(b, w, D, z, x, R) {
    let k = null;
    const T = D.isPointLight === !0 ? b.customDistanceMaterial : b.customDepthMaterial;
    if (T !== void 0)
      k = T;
    else if (k = D.isPointLight === !0 ? l : o, r.localClippingEnabled && w.clipShadows === !0 && Array.isArray(w.clippingPlanes) && w.clippingPlanes.length !== 0 || w.displacementMap && w.displacementScale !== 0 || w.alphaMap && w.alphaTest > 0 || w.map && w.alphaTest > 0) {
      const ee = k.uuid, V = w.uuid;
      let H = c[ee];
      H === void 0 && (H = {}, c[ee] = H);
      let j = H[V];
      j === void 0 && (j = k.clone(), H[V] = j), k = j;
    }
    return k.visible = w.visible, k.wireframe = w.wireframe, R === Vi ? k.side = w.shadowSide !== null ? w.shadowSide : w.side : k.side = w.shadowSide !== null ? w.shadowSide : h[w.side], k.alphaMap = w.alphaMap, k.alphaTest = w.alphaTest, k.map = w.map, k.clipShadows = w.clipShadows, k.clippingPlanes = w.clippingPlanes, k.clipIntersection = w.clipIntersection, k.displacementMap = w.displacementMap, k.displacementScale = w.displacementScale, k.displacementBias = w.displacementBias, k.wireframeLinewidth = w.wireframeLinewidth, k.linewidth = w.linewidth, D.isPointLight === !0 && k.isMeshDistanceMaterial === !0 && (k.referencePosition.setFromMatrixPosition(D.matrixWorld), k.nearDistance = z, k.farDistance = x), k;
  }
  function y(b, w, D, z, x) {
    if (b.visible === !1)
      return;
    if (b.layers.test(w.layers) && (b.isMesh || b.isLine || b.isPoints) && (b.castShadow || b.receiveShadow && x === Vi) && (!b.frustumCulled || n.intersectsObject(b))) {
      b.modelViewMatrix.multiplyMatrices(D.matrixWorldInverse, b.matrixWorld);
      const T = e.update(b), ee = b.material;
      if (Array.isArray(ee)) {
        const V = T.groups;
        for (let H = 0, j = V.length; H < j; H++) {
          const G = V[H], te = ee[G.materialIndex];
          if (te && te.visible) {
            const Z = S(b, te, z, D.near, D.far, x);
            r.renderBufferDirect(D, null, T, Z, b, G);
          }
        }
      } else if (ee.visible) {
        const V = S(b, ee, z, D.near, D.far, x);
        r.renderBufferDirect(D, null, T, V, b, null);
      }
    }
    const k = b.children;
    for (let T = 0, ee = k.length; T < ee; T++)
      y(k[T], w, D, z, x);
  }
}
function Pm(r, e, t) {
  const n = t.isWebGL2;
  function i() {
    let O = !1;
    const q = new Ze();
    let ne = null;
    const me = new Ze(0, 0, 0, 0);
    return {
      setMask: function(Te) {
        ne !== Te && !O && (r.colorMask(Te, Te, Te, Te), ne = Te);
      },
      setLocked: function(Te) {
        O = Te;
      },
      setClear: function(Te, Ge, it, ht, Qt) {
        Qt === !0 && (Te *= ht, Ge *= ht, it *= ht), q.set(Te, Ge, it, ht), me.equals(q) === !1 && (r.clearColor(Te, Ge, it, ht), me.copy(q));
      },
      reset: function() {
        O = !1, ne = null, me.set(-1, 0, 0, 0);
      }
    };
  }
  function s() {
    let O = !1, q = null, ne = null, me = null;
    return {
      setTest: function(Te) {
        Te ? Oe(2929) : be(2929);
      },
      setMask: function(Te) {
        q !== Te && !O && (r.depthMask(Te), q = Te);
      },
      setFunc: function(Te) {
        if (ne !== Te) {
          switch (Te) {
            case qc:
              r.depthFunc(512);
              break;
            case Yc:
              r.depthFunc(519);
              break;
            case Kc:
              r.depthFunc(513);
              break;
            case Or:
              r.depthFunc(515);
              break;
            case Zc:
              r.depthFunc(514);
              break;
            case $c:
              r.depthFunc(518);
              break;
            case Jc:
              r.depthFunc(516);
              break;
            case Qc:
              r.depthFunc(517);
              break;
            default:
              r.depthFunc(515);
          }
          ne = Te;
        }
      },
      setLocked: function(Te) {
        O = Te;
      },
      setClear: function(Te) {
        me !== Te && (r.clearDepth(Te), me = Te);
      },
      reset: function() {
        O = !1, q = null, ne = null, me = null;
      }
    };
  }
  function a() {
    let O = !1, q = null, ne = null, me = null, Te = null, Ge = null, it = null, ht = null, Qt = null;
    return {
      setTest: function(Je) {
        O || (Je ? Oe(2960) : be(2960));
      },
      setMask: function(Je) {
        q !== Je && !O && (r.stencilMask(Je), q = Je);
      },
      setFunc: function(Je, Bt, yt) {
        (ne !== Je || me !== Bt || Te !== yt) && (r.stencilFunc(Je, Bt, yt), ne = Je, me = Bt, Te = yt);
      },
      setOp: function(Je, Bt, yt) {
        (Ge !== Je || it !== Bt || ht !== yt) && (r.stencilOp(Je, Bt, yt), Ge = Je, it = Bt, ht = yt);
      },
      setLocked: function(Je) {
        O = Je;
      },
      setClear: function(Je) {
        Qt !== Je && (r.clearStencil(Je), Qt = Je);
      },
      reset: function() {
        O = !1, q = null, ne = null, me = null, Te = null, Ge = null, it = null, ht = null, Qt = null;
      }
    };
  }
  const o = new i(), l = new s(), c = new a(), u = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
  let d = {}, m = {}, g = /* @__PURE__ */ new WeakMap(), p = [], f = null, v = !1, S = null, y = null, b = null, w = null, D = null, z = null, x = null, R = !1, k = null, T = null, ee = null, V = null, H = null;
  const j = r.getParameter(35661);
  let G = !1, te = 0;
  const Z = r.getParameter(7938);
  Z.indexOf("WebGL") !== -1 ? (te = parseFloat(/^WebGL (\d)/.exec(Z)[1]), G = te >= 1) : Z.indexOf("OpenGL ES") !== -1 && (te = parseFloat(/^OpenGL ES (\d)/.exec(Z)[1]), G = te >= 2);
  let re = null, $ = {};
  const K = r.getParameter(3088), W = r.getParameter(2978), le = new Ze().fromArray(K), ae = new Ze().fromArray(W);
  function ue(O, q, ne) {
    const me = new Uint8Array(4), Te = r.createTexture();
    r.bindTexture(O, Te), r.texParameteri(O, 10241, 9728), r.texParameteri(O, 10240, 9728);
    for (let Ge = 0; Ge < ne; Ge++)
      r.texImage2D(q + Ge, 0, 6408, 1, 1, 0, 6408, 5121, me);
    return Te;
  }
  const Y = {};
  Y[3553] = ue(3553, 3553, 1), Y[34067] = ue(34067, 34069, 6), o.setClear(0, 0, 0, 1), l.setClear(1), c.setClear(0), Oe(2929), l.setFunc(Or), et(!1), pt(da), Oe(2884), st(yn);
  function Oe(O) {
    d[O] !== !0 && (r.enable(O), d[O] = !0);
  }
  function be(O) {
    d[O] !== !1 && (r.disable(O), d[O] = !1);
  }
  function Ce(O, q) {
    return m[O] !== q ? (r.bindFramebuffer(O, q), m[O] = q, n && (O === 36009 && (m[36160] = q), O === 36160 && (m[36009] = q)), !0) : !1;
  }
  function ve(O, q) {
    let ne = p, me = !1;
    if (O)
      if (ne = g.get(q), ne === void 0 && (ne = [], g.set(q, ne)), O.isWebGLMultipleRenderTargets) {
        const Te = O.texture;
        if (ne.length !== Te.length || ne[0] !== 36064) {
          for (let Ge = 0, it = Te.length; Ge < it; Ge++)
            ne[Ge] = 36064 + Ge;
          ne.length = Te.length, me = !0;
        }
      } else
        ne[0] !== 36064 && (ne[0] = 36064, me = !0);
    else
      ne[0] !== 1029 && (ne[0] = 1029, me = !0);
    me && (t.isWebGL2 ? r.drawBuffers(ne) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(ne));
  }
  function Ae(O) {
    return f !== O ? (r.useProgram(O), f = O, !0) : !1;
  }
  const Ee = {
    [ci]: 32774,
    [Fc]: 32778,
    [zc]: 32779
  };
  if (n)
    Ee[ga] = 32775, Ee[_a] = 32776;
  else {
    const O = e.get("EXT_blend_minmax");
    O !== null && (Ee[ga] = O.MIN_EXT, Ee[_a] = O.MAX_EXT);
  }
  const Le = {
    [Uc]: 0,
    [kc]: 1,
    [Bc]: 768,
    [sl]: 770,
    [Xc]: 776,
    [Wc]: 774,
    [Vc]: 772,
    [Hc]: 769,
    [rl]: 771,
    [jc]: 775,
    [Gc]: 773
  };
  function st(O, q, ne, me, Te, Ge, it, ht) {
    if (O === yn) {
      v === !0 && (be(3042), v = !1);
      return;
    }
    if (v === !1 && (Oe(3042), v = !0), O !== Nc) {
      if (O !== S || ht !== R) {
        if ((y !== ci || D !== ci) && (r.blendEquation(32774), y = ci, D = ci), ht)
          switch (O) {
            case ui:
              r.blendFuncSeparate(1, 771, 1, 771);
              break;
            case fa:
              r.blendFunc(1, 1);
              break;
            case pa:
              r.blendFuncSeparate(0, 769, 0, 1);
              break;
            case ma:
              r.blendFuncSeparate(0, 768, 0, 770);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", O);
              break;
          }
        else
          switch (O) {
            case ui:
              r.blendFuncSeparate(770, 771, 1, 771);
              break;
            case fa:
              r.blendFunc(770, 1);
              break;
            case pa:
              r.blendFuncSeparate(0, 769, 0, 1);
              break;
            case ma:
              r.blendFunc(0, 768);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", O);
              break;
          }
        b = null, w = null, z = null, x = null, S = O, R = ht;
      }
      return;
    }
    Te = Te || q, Ge = Ge || ne, it = it || me, (q !== y || Te !== D) && (r.blendEquationSeparate(Ee[q], Ee[Te]), y = q, D = Te), (ne !== b || me !== w || Ge !== z || it !== x) && (r.blendFuncSeparate(Le[ne], Le[me], Le[Ge], Le[it]), b = ne, w = me, z = Ge, x = it), S = O, R = !1;
  }
  function Qe(O, q) {
    O.side === Bs ? be(2884) : Oe(2884);
    let ne = O.side === kt;
    q && (ne = !ne), et(ne), O.blending === ui && O.transparent === !1 ? st(yn) : st(O.blending, O.blendEquation, O.blendSrc, O.blendDst, O.blendEquationAlpha, O.blendSrcAlpha, O.blendDstAlpha, O.premultipliedAlpha), l.setFunc(O.depthFunc), l.setTest(O.depthTest), l.setMask(O.depthWrite), o.setMask(O.colorWrite);
    const me = O.stencilWrite;
    c.setTest(me), me && (c.setMask(O.stencilWriteMask), c.setFunc(O.stencilFunc, O.stencilRef, O.stencilFuncMask), c.setOp(O.stencilFail, O.stencilZFail, O.stencilZPass)), ke(O.polygonOffset, O.polygonOffsetFactor, O.polygonOffsetUnits), O.alphaToCoverage === !0 ? Oe(32926) : be(32926);
  }
  function et(O) {
    k !== O && (O ? r.frontFace(2304) : r.frontFace(2305), k = O);
  }
  function pt(O) {
    O !== Dc ? (Oe(2884), O !== T && (O === da ? r.cullFace(1029) : O === Ic ? r.cullFace(1028) : r.cullFace(1032))) : be(2884), T = O;
  }
  function $e(O) {
    O !== ee && (G && r.lineWidth(O), ee = O);
  }
  function ke(O, q, ne) {
    O ? (Oe(32823), (V !== q || H !== ne) && (r.polygonOffset(q, ne), V = q, H = ne)) : be(32823);
  }
  function xt(O) {
    O ? Oe(3089) : be(3089);
  }
  function at(O) {
    O === void 0 && (O = 33984 + j - 1), re !== O && (r.activeTexture(O), re = O);
  }
  function A(O, q, ne) {
    ne === void 0 && (re === null ? ne = 33984 + j - 1 : ne = re);
    let me = $[ne];
    me === void 0 && (me = { type: void 0, texture: void 0 }, $[ne] = me), (me.type !== O || me.texture !== q) && (re !== ne && (r.activeTexture(ne), re = ne), r.bindTexture(O, q || Y[O]), me.type = O, me.texture = q);
  }
  function M() {
    const O = $[re];
    O !== void 0 && O.type !== void 0 && (r.bindTexture(O.type, null), O.type = void 0, O.texture = void 0);
  }
  function X() {
    try {
      r.compressedTexImage2D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function ie() {
    try {
      r.compressedTexImage3D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function oe() {
    try {
      r.texSubImage2D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function de() {
    try {
      r.texSubImage3D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function Re() {
    try {
      r.compressedTexSubImage2D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function C() {
    try {
      r.compressedTexSubImage3D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function B() {
    try {
      r.texStorage2D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function pe() {
    try {
      r.texStorage3D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function ge() {
    try {
      r.texImage2D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function fe() {
    try {
      r.texImage3D.apply(r, arguments);
    } catch (O) {
      console.error("THREE.WebGLState:", O);
    }
  }
  function we(O) {
    le.equals(O) === !1 && (r.scissor(O.x, O.y, O.z, O.w), le.copy(O));
  }
  function Se(O) {
    ae.equals(O) === !1 && (r.viewport(O.x, O.y, O.z, O.w), ae.copy(O));
  }
  function Ne(O, q) {
    let ne = h.get(q);
    ne === void 0 && (ne = /* @__PURE__ */ new WeakMap(), h.set(q, ne));
    let me = ne.get(O);
    me === void 0 && (me = r.getUniformBlockIndex(q, O.name), ne.set(O, me));
  }
  function ze(O, q) {
    const me = h.get(q).get(O);
    u.get(q) !== me && (r.uniformBlockBinding(q, me, O.__bindingPointIndex), u.set(q, me));
  }
  function je() {
    r.disable(3042), r.disable(2884), r.disable(2929), r.disable(32823), r.disable(3089), r.disable(2960), r.disable(32926), r.blendEquation(32774), r.blendFunc(1, 0), r.blendFuncSeparate(1, 0, 1, 0), r.colorMask(!0, !0, !0, !0), r.clearColor(0, 0, 0, 0), r.depthMask(!0), r.depthFunc(513), r.clearDepth(1), r.stencilMask(4294967295), r.stencilFunc(519, 0, 4294967295), r.stencilOp(7680, 7680, 7680), r.clearStencil(0), r.cullFace(1029), r.frontFace(2305), r.polygonOffset(0, 0), r.activeTexture(33984), r.bindFramebuffer(36160, null), n === !0 && (r.bindFramebuffer(36009, null), r.bindFramebuffer(36008, null)), r.useProgram(null), r.lineWidth(1), r.scissor(0, 0, r.canvas.width, r.canvas.height), r.viewport(0, 0, r.canvas.width, r.canvas.height), d = {}, re = null, $ = {}, m = {}, g = /* @__PURE__ */ new WeakMap(), p = [], f = null, v = !1, S = null, y = null, b = null, w = null, D = null, z = null, x = null, R = !1, k = null, T = null, ee = null, V = null, H = null, le.set(0, 0, r.canvas.width, r.canvas.height), ae.set(0, 0, r.canvas.width, r.canvas.height), o.reset(), l.reset(), c.reset();
  }
  return {
    buffers: {
      color: o,
      depth: l,
      stencil: c
    },
    enable: Oe,
    disable: be,
    bindFramebuffer: Ce,
    drawBuffers: ve,
    useProgram: Ae,
    setBlending: st,
    setMaterial: Qe,
    setFlipSided: et,
    setCullFace: pt,
    setLineWidth: $e,
    setPolygonOffset: ke,
    setScissorTest: xt,
    activeTexture: at,
    bindTexture: A,
    unbindTexture: M,
    compressedTexImage2D: X,
    compressedTexImage3D: ie,
    texImage2D: ge,
    texImage3D: fe,
    updateUBOMapping: Ne,
    uniformBlockBinding: ze,
    texStorage2D: B,
    texStorage3D: pe,
    texSubImage2D: oe,
    texSubImage3D: de,
    compressedTexSubImage2D: Re,
    compressedTexSubImage3D: C,
    scissor: we,
    viewport: Se,
    reset: je
  };
}
function Dm(r, e, t, n, i, s, a) {
  const o = i.isWebGL2, l = i.maxTextures, c = i.maxCubemapSize, u = i.maxTextureSize, h = i.maxSamples, d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, m = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), g = /* @__PURE__ */ new WeakMap();
  let p;
  const f = /* @__PURE__ */ new WeakMap();
  let v = !1;
  try {
    v = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function S(A, M) {
    return v ? new OffscreenCanvas(A, M) : Ji("canvas");
  }
  function y(A, M, X, ie) {
    let oe = 1;
    if ((A.width > ie || A.height > ie) && (oe = ie / Math.max(A.width, A.height)), oe < 1 || M === !0)
      if (typeof HTMLImageElement < "u" && A instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && A instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && A instanceof ImageBitmap) {
        const de = M ? zs : Math.floor, Re = de(oe * A.width), C = de(oe * A.height);
        p === void 0 && (p = S(Re, C));
        const B = X ? S(Re, C) : p;
        return B.width = Re, B.height = C, B.getContext("2d").drawImage(A, 0, 0, Re, C), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + A.width + "x" + A.height + ") to (" + Re + "x" + C + ")."), B;
      } else
        return "data" in A && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + A.width + "x" + A.height + ")."), A;
    return A;
  }
  function b(A) {
    return Br(A.width) && Br(A.height);
  }
  function w(A) {
    return o ? !1 : A.wrapS !== Ct || A.wrapT !== Ct || A.minFilter !== ft && A.minFilter !== Et;
  }
  function D(A, M) {
    return A.generateMipmaps && M && A.minFilter !== ft && A.minFilter !== Et;
  }
  function z(A) {
    r.generateMipmap(A);
  }
  function x(A, M, X, ie, oe = !1) {
    if (o === !1)
      return M;
    if (A !== null) {
      if (r[A] !== void 0)
        return r[A];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + A + "'");
    }
    let de = M;
    return M === 6403 && (X === 5126 && (de = 33326), X === 5131 && (de = 33325), X === 5121 && (de = 33321)), M === 33319 && (X === 5126 && (de = 33328), X === 5131 && (de = 33327), X === 5121 && (de = 33323)), M === 6408 && (X === 5126 && (de = 34836), X === 5131 && (de = 34842), X === 5121 && (de = ie === Xe && oe === !1 ? 35907 : 32856), X === 32819 && (de = 32854), X === 32820 && (de = 32855)), (de === 33325 || de === 33326 || de === 33327 || de === 33328 || de === 34842 || de === 34836) && e.get("EXT_color_buffer_float"), de;
  }
  function R(A, M, X) {
    return D(A, X) === !0 || A.isFramebufferTexture && A.minFilter !== ft && A.minFilter !== Et ? Math.log2(Math.max(M.width, M.height)) + 1 : A.mipmaps !== void 0 && A.mipmaps.length > 0 ? A.mipmaps.length : A.isCompressedTexture && Array.isArray(A.image) ? M.mipmaps.length : 1;
  }
  function k(A) {
    return A === ft || A === zr || A === Ps ? 9728 : 9729;
  }
  function T(A) {
    const M = A.target;
    M.removeEventListener("dispose", T), V(M), M.isVideoTexture && g.delete(M);
  }
  function ee(A) {
    const M = A.target;
    M.removeEventListener("dispose", ee), j(M);
  }
  function V(A) {
    const M = n.get(A);
    if (M.__webglInit === void 0)
      return;
    const X = A.source, ie = f.get(X);
    if (ie) {
      const oe = ie[M.__cacheKey];
      oe.usedTimes--, oe.usedTimes === 0 && H(A), Object.keys(ie).length === 0 && f.delete(X);
    }
    n.remove(A);
  }
  function H(A) {
    const M = n.get(A);
    r.deleteTexture(M.__webglTexture);
    const X = A.source, ie = f.get(X);
    delete ie[M.__cacheKey], a.memory.textures--;
  }
  function j(A) {
    const M = A.texture, X = n.get(A), ie = n.get(M);
    if (ie.__webglTexture !== void 0 && (r.deleteTexture(ie.__webglTexture), a.memory.textures--), A.depthTexture && A.depthTexture.dispose(), A.isWebGLCubeRenderTarget)
      for (let oe = 0; oe < 6; oe++)
        r.deleteFramebuffer(X.__webglFramebuffer[oe]), X.__webglDepthbuffer && r.deleteRenderbuffer(X.__webglDepthbuffer[oe]);
    else {
      if (r.deleteFramebuffer(X.__webglFramebuffer), X.__webglDepthbuffer && r.deleteRenderbuffer(X.__webglDepthbuffer), X.__webglMultisampledFramebuffer && r.deleteFramebuffer(X.__webglMultisampledFramebuffer), X.__webglColorRenderbuffer)
        for (let oe = 0; oe < X.__webglColorRenderbuffer.length; oe++)
          X.__webglColorRenderbuffer[oe] && r.deleteRenderbuffer(X.__webglColorRenderbuffer[oe]);
      X.__webglDepthRenderbuffer && r.deleteRenderbuffer(X.__webglDepthRenderbuffer);
    }
    if (A.isWebGLMultipleRenderTargets)
      for (let oe = 0, de = M.length; oe < de; oe++) {
        const Re = n.get(M[oe]);
        Re.__webglTexture && (r.deleteTexture(Re.__webglTexture), a.memory.textures--), n.remove(M[oe]);
      }
    n.remove(M), n.remove(A);
  }
  let G = 0;
  function te() {
    G = 0;
  }
  function Z() {
    const A = G;
    return A >= l && console.warn("THREE.WebGLTextures: Trying to use " + A + " texture units while this GPU supports only " + l), G += 1, A;
  }
  function re(A) {
    const M = [];
    return M.push(A.wrapS), M.push(A.wrapT), M.push(A.wrapR || 0), M.push(A.magFilter), M.push(A.minFilter), M.push(A.anisotropy), M.push(A.internalFormat), M.push(A.format), M.push(A.type), M.push(A.generateMipmaps), M.push(A.premultiplyAlpha), M.push(A.flipY), M.push(A.unpackAlignment), M.push(A.encoding), M.join();
  }
  function $(A, M) {
    const X = n.get(A);
    if (A.isVideoTexture && xt(A), A.isRenderTargetTexture === !1 && A.version > 0 && X.__version !== A.version) {
      const ie = A.image;
      if (ie === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (ie.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        be(X, A, M);
        return;
      }
    }
    t.bindTexture(3553, X.__webglTexture, 33984 + M);
  }
  function K(A, M) {
    const X = n.get(A);
    if (A.version > 0 && X.__version !== A.version) {
      be(X, A, M);
      return;
    }
    t.bindTexture(35866, X.__webglTexture, 33984 + M);
  }
  function W(A, M) {
    const X = n.get(A);
    if (A.version > 0 && X.__version !== A.version) {
      be(X, A, M);
      return;
    }
    t.bindTexture(32879, X.__webglTexture, 33984 + M);
  }
  function le(A, M) {
    const X = n.get(A);
    if (A.version > 0 && X.__version !== A.version) {
      Ce(X, A, M);
      return;
    }
    t.bindTexture(34067, X.__webglTexture, 33984 + M);
  }
  const ae = {
    [vi]: 10497,
    [Ct]: 33071,
    [Fs]: 33648
  }, ue = {
    [ft]: 9728,
    [zr]: 9984,
    [Ps]: 9986,
    [Et]: 9729,
    [ol]: 9985,
    [Un]: 9987
  };
  function Y(A, M, X) {
    if (X ? (r.texParameteri(A, 10242, ae[M.wrapS]), r.texParameteri(A, 10243, ae[M.wrapT]), (A === 32879 || A === 35866) && r.texParameteri(A, 32882, ae[M.wrapR]), r.texParameteri(A, 10240, ue[M.magFilter]), r.texParameteri(A, 10241, ue[M.minFilter])) : (r.texParameteri(A, 10242, 33071), r.texParameteri(A, 10243, 33071), (A === 32879 || A === 35866) && r.texParameteri(A, 32882, 33071), (M.wrapS !== Ct || M.wrapT !== Ct) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), r.texParameteri(A, 10240, k(M.magFilter)), r.texParameteri(A, 10241, k(M.minFilter)), M.minFilter !== ft && M.minFilter !== Et && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), e.has("EXT_texture_filter_anisotropic") === !0) {
      const ie = e.get("EXT_texture_filter_anisotropic");
      if (M.magFilter === ft || M.minFilter !== Ps && M.minFilter !== Un || M.type === xn && e.has("OES_texture_float_linear") === !1 || o === !1 && M.type === Yi && e.has("OES_texture_half_float_linear") === !1)
        return;
      (M.anisotropy > 1 || n.get(M).__currentAnisotropy) && (r.texParameterf(A, ie.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(M.anisotropy, i.getMaxAnisotropy())), n.get(M).__currentAnisotropy = M.anisotropy);
    }
  }
  function Oe(A, M) {
    let X = !1;
    A.__webglInit === void 0 && (A.__webglInit = !0, M.addEventListener("dispose", T));
    const ie = M.source;
    let oe = f.get(ie);
    oe === void 0 && (oe = {}, f.set(ie, oe));
    const de = re(M);
    if (de !== A.__cacheKey) {
      oe[de] === void 0 && (oe[de] = {
        texture: r.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, X = !0), oe[de].usedTimes++;
      const Re = oe[A.__cacheKey];
      Re !== void 0 && (oe[A.__cacheKey].usedTimes--, Re.usedTimes === 0 && H(M)), A.__cacheKey = de, A.__webglTexture = oe[de].texture;
    }
    return X;
  }
  function be(A, M, X) {
    let ie = 3553;
    (M.isDataArrayTexture || M.isCompressedArrayTexture) && (ie = 35866), M.isData3DTexture && (ie = 32879);
    const oe = Oe(A, M), de = M.source;
    t.bindTexture(ie, A.__webglTexture, 33984 + X);
    const Re = n.get(de);
    if (de.version !== Re.__version || oe === !0) {
      t.activeTexture(33984 + X), r.pixelStorei(37440, M.flipY), r.pixelStorei(37441, M.premultiplyAlpha), r.pixelStorei(3317, M.unpackAlignment), r.pixelStorei(37443, 0);
      const C = w(M) && b(M.image) === !1;
      let B = y(M.image, C, !1, u);
      B = at(M, B);
      const pe = b(B) || o, ge = s.convert(M.format, M.encoding);
      let fe = s.convert(M.type), we = x(M.internalFormat, ge, fe, M.encoding, M.isVideoTexture);
      Y(ie, M, pe);
      let Se;
      const Ne = M.mipmaps, ze = o && M.isVideoTexture !== !0, je = Re.__version === void 0 || oe === !0, O = R(M, B, pe);
      if (M.isDepthTexture)
        we = 6402, o ? M.type === xn ? we = 36012 : M.type === Dn ? we = 33190 : M.type === di ? we = 35056 : we = 33189 : M.type === xn && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), M.format === Nn && we === 6402 && M.type !== ll && M.type !== Dn && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), M.type = Dn, fe = s.convert(M.type)), M.format === xi && we === 6402 && (we = 34041, M.type !== di && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), M.type = di, fe = s.convert(M.type))), je && (ze ? t.texStorage2D(3553, 1, we, B.width, B.height) : t.texImage2D(3553, 0, we, B.width, B.height, 0, ge, fe, null));
      else if (M.isDataTexture)
        if (Ne.length > 0 && pe) {
          ze && je && t.texStorage2D(3553, O, we, Ne[0].width, Ne[0].height);
          for (let q = 0, ne = Ne.length; q < ne; q++)
            Se = Ne[q], ze ? t.texSubImage2D(3553, q, 0, 0, Se.width, Se.height, ge, fe, Se.data) : t.texImage2D(3553, q, we, Se.width, Se.height, 0, ge, fe, Se.data);
          M.generateMipmaps = !1;
        } else
          ze ? (je && t.texStorage2D(3553, O, we, B.width, B.height), t.texSubImage2D(3553, 0, 0, 0, B.width, B.height, ge, fe, B.data)) : t.texImage2D(3553, 0, we, B.width, B.height, 0, ge, fe, B.data);
      else if (M.isCompressedTexture)
        if (M.isCompressedArrayTexture) {
          ze && je && t.texStorage3D(35866, O, we, Ne[0].width, Ne[0].height, B.depth);
          for (let q = 0, ne = Ne.length; q < ne; q++)
            Se = Ne[q], M.format !== zt ? ge !== null ? ze ? t.compressedTexSubImage3D(35866, q, 0, 0, 0, Se.width, Se.height, B.depth, ge, Se.data, 0, 0) : t.compressedTexImage3D(35866, q, we, Se.width, Se.height, B.depth, 0, Se.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : ze ? t.texSubImage3D(35866, q, 0, 0, 0, Se.width, Se.height, B.depth, ge, fe, Se.data) : t.texImage3D(35866, q, we, Se.width, Se.height, B.depth, 0, ge, fe, Se.data);
        } else {
          ze && je && t.texStorage2D(3553, O, we, Ne[0].width, Ne[0].height);
          for (let q = 0, ne = Ne.length; q < ne; q++)
            Se = Ne[q], M.format !== zt ? ge !== null ? ze ? t.compressedTexSubImage2D(3553, q, 0, 0, Se.width, Se.height, ge, Se.data) : t.compressedTexImage2D(3553, q, we, Se.width, Se.height, 0, Se.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : ze ? t.texSubImage2D(3553, q, 0, 0, Se.width, Se.height, ge, fe, Se.data) : t.texImage2D(3553, q, we, Se.width, Se.height, 0, ge, fe, Se.data);
        }
      else if (M.isDataArrayTexture)
        ze ? (je && t.texStorage3D(35866, O, we, B.width, B.height, B.depth), t.texSubImage3D(35866, 0, 0, 0, 0, B.width, B.height, B.depth, ge, fe, B.data)) : t.texImage3D(35866, 0, we, B.width, B.height, B.depth, 0, ge, fe, B.data);
      else if (M.isData3DTexture)
        ze ? (je && t.texStorage3D(32879, O, we, B.width, B.height, B.depth), t.texSubImage3D(32879, 0, 0, 0, 0, B.width, B.height, B.depth, ge, fe, B.data)) : t.texImage3D(32879, 0, we, B.width, B.height, B.depth, 0, ge, fe, B.data);
      else if (M.isFramebufferTexture) {
        if (je)
          if (ze)
            t.texStorage2D(3553, O, we, B.width, B.height);
          else {
            let q = B.width, ne = B.height;
            for (let me = 0; me < O; me++)
              t.texImage2D(3553, me, we, q, ne, 0, ge, fe, null), q >>= 1, ne >>= 1;
          }
      } else if (Ne.length > 0 && pe) {
        ze && je && t.texStorage2D(3553, O, we, Ne[0].width, Ne[0].height);
        for (let q = 0, ne = Ne.length; q < ne; q++)
          Se = Ne[q], ze ? t.texSubImage2D(3553, q, 0, 0, ge, fe, Se) : t.texImage2D(3553, q, we, ge, fe, Se);
        M.generateMipmaps = !1;
      } else
        ze ? (je && t.texStorage2D(3553, O, we, B.width, B.height), t.texSubImage2D(3553, 0, 0, 0, ge, fe, B)) : t.texImage2D(3553, 0, we, ge, fe, B);
      D(M, pe) && z(ie), Re.__version = de.version, M.onUpdate && M.onUpdate(M);
    }
    A.__version = M.version;
  }
  function Ce(A, M, X) {
    if (M.image.length !== 6)
      return;
    const ie = Oe(A, M), oe = M.source;
    t.bindTexture(34067, A.__webglTexture, 33984 + X);
    const de = n.get(oe);
    if (oe.version !== de.__version || ie === !0) {
      t.activeTexture(33984 + X), r.pixelStorei(37440, M.flipY), r.pixelStorei(37441, M.premultiplyAlpha), r.pixelStorei(3317, M.unpackAlignment), r.pixelStorei(37443, 0);
      const Re = M.isCompressedTexture || M.image[0].isCompressedTexture, C = M.image[0] && M.image[0].isDataTexture, B = [];
      for (let q = 0; q < 6; q++)
        !Re && !C ? B[q] = y(M.image[q], !1, !0, c) : B[q] = C ? M.image[q].image : M.image[q], B[q] = at(M, B[q]);
      const pe = B[0], ge = b(pe) || o, fe = s.convert(M.format, M.encoding), we = s.convert(M.type), Se = x(M.internalFormat, fe, we, M.encoding), Ne = o && M.isVideoTexture !== !0, ze = de.__version === void 0 || ie === !0;
      let je = R(M, pe, ge);
      Y(34067, M, ge);
      let O;
      if (Re) {
        Ne && ze && t.texStorage2D(34067, je, Se, pe.width, pe.height);
        for (let q = 0; q < 6; q++) {
          O = B[q].mipmaps;
          for (let ne = 0; ne < O.length; ne++) {
            const me = O[ne];
            M.format !== zt ? fe !== null ? Ne ? t.compressedTexSubImage2D(34069 + q, ne, 0, 0, me.width, me.height, fe, me.data) : t.compressedTexImage2D(34069 + q, ne, Se, me.width, me.height, 0, me.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Ne ? t.texSubImage2D(34069 + q, ne, 0, 0, me.width, me.height, fe, we, me.data) : t.texImage2D(34069 + q, ne, Se, me.width, me.height, 0, fe, we, me.data);
          }
        }
      } else {
        O = M.mipmaps, Ne && ze && (O.length > 0 && je++, t.texStorage2D(34067, je, Se, B[0].width, B[0].height));
        for (let q = 0; q < 6; q++)
          if (C) {
            Ne ? t.texSubImage2D(34069 + q, 0, 0, 0, B[q].width, B[q].height, fe, we, B[q].data) : t.texImage2D(34069 + q, 0, Se, B[q].width, B[q].height, 0, fe, we, B[q].data);
            for (let ne = 0; ne < O.length; ne++) {
              const Te = O[ne].image[q].image;
              Ne ? t.texSubImage2D(34069 + q, ne + 1, 0, 0, Te.width, Te.height, fe, we, Te.data) : t.texImage2D(34069 + q, ne + 1, Se, Te.width, Te.height, 0, fe, we, Te.data);
            }
          } else {
            Ne ? t.texSubImage2D(34069 + q, 0, 0, 0, fe, we, B[q]) : t.texImage2D(34069 + q, 0, Se, fe, we, B[q]);
            for (let ne = 0; ne < O.length; ne++) {
              const me = O[ne];
              Ne ? t.texSubImage2D(34069 + q, ne + 1, 0, 0, fe, we, me.image[q]) : t.texImage2D(34069 + q, ne + 1, Se, fe, we, me.image[q]);
            }
          }
      }
      D(M, ge) && z(34067), de.__version = oe.version, M.onUpdate && M.onUpdate(M);
    }
    A.__version = M.version;
  }
  function ve(A, M, X, ie, oe) {
    const de = s.convert(X.format, X.encoding), Re = s.convert(X.type), C = x(X.internalFormat, de, Re, X.encoding);
    n.get(M).__hasExternalTextures || (oe === 32879 || oe === 35866 ? t.texImage3D(oe, 0, C, M.width, M.height, M.depth, 0, de, Re, null) : t.texImage2D(oe, 0, C, M.width, M.height, 0, de, Re, null)), t.bindFramebuffer(36160, A), ke(M) ? d.framebufferTexture2DMultisampleEXT(36160, ie, oe, n.get(X).__webglTexture, 0, $e(M)) : (oe === 3553 || oe >= 34069 && oe <= 34074) && r.framebufferTexture2D(36160, ie, oe, n.get(X).__webglTexture, 0), t.bindFramebuffer(36160, null);
  }
  function Ae(A, M, X) {
    if (r.bindRenderbuffer(36161, A), M.depthBuffer && !M.stencilBuffer) {
      let ie = 33189;
      if (X || ke(M)) {
        const oe = M.depthTexture;
        oe && oe.isDepthTexture && (oe.type === xn ? ie = 36012 : oe.type === Dn && (ie = 33190));
        const de = $e(M);
        ke(M) ? d.renderbufferStorageMultisampleEXT(36161, de, ie, M.width, M.height) : r.renderbufferStorageMultisample(36161, de, ie, M.width, M.height);
      } else
        r.renderbufferStorage(36161, ie, M.width, M.height);
      r.framebufferRenderbuffer(36160, 36096, 36161, A);
    } else if (M.depthBuffer && M.stencilBuffer) {
      const ie = $e(M);
      X && ke(M) === !1 ? r.renderbufferStorageMultisample(36161, ie, 35056, M.width, M.height) : ke(M) ? d.renderbufferStorageMultisampleEXT(36161, ie, 35056, M.width, M.height) : r.renderbufferStorage(36161, 34041, M.width, M.height), r.framebufferRenderbuffer(36160, 33306, 36161, A);
    } else {
      const ie = M.isWebGLMultipleRenderTargets === !0 ? M.texture : [M.texture];
      for (let oe = 0; oe < ie.length; oe++) {
        const de = ie[oe], Re = s.convert(de.format, de.encoding), C = s.convert(de.type), B = x(de.internalFormat, Re, C, de.encoding), pe = $e(M);
        X && ke(M) === !1 ? r.renderbufferStorageMultisample(36161, pe, B, M.width, M.height) : ke(M) ? d.renderbufferStorageMultisampleEXT(36161, pe, B, M.width, M.height) : r.renderbufferStorage(36161, B, M.width, M.height);
      }
    }
    r.bindRenderbuffer(36161, null);
  }
  function Ee(A, M) {
    if (M && M.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported");
    if (t.bindFramebuffer(36160, A), !(M.depthTexture && M.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    (!n.get(M.depthTexture).__webglTexture || M.depthTexture.image.width !== M.width || M.depthTexture.image.height !== M.height) && (M.depthTexture.image.width = M.width, M.depthTexture.image.height = M.height, M.depthTexture.needsUpdate = !0), $(M.depthTexture, 0);
    const ie = n.get(M.depthTexture).__webglTexture, oe = $e(M);
    if (M.depthTexture.format === Nn)
      ke(M) ? d.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, ie, 0, oe) : r.framebufferTexture2D(36160, 36096, 3553, ie, 0);
    else if (M.depthTexture.format === xi)
      ke(M) ? d.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, ie, 0, oe) : r.framebufferTexture2D(36160, 33306, 3553, ie, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function Le(A) {
    const M = n.get(A), X = A.isWebGLCubeRenderTarget === !0;
    if (A.depthTexture && !M.__autoAllocateDepthBuffer) {
      if (X)
        throw new Error("target.depthTexture not supported in Cube render targets");
      Ee(M.__webglFramebuffer, A);
    } else if (X) {
      M.__webglDepthbuffer = [];
      for (let ie = 0; ie < 6; ie++)
        t.bindFramebuffer(36160, M.__webglFramebuffer[ie]), M.__webglDepthbuffer[ie] = r.createRenderbuffer(), Ae(M.__webglDepthbuffer[ie], A, !1);
    } else
      t.bindFramebuffer(36160, M.__webglFramebuffer), M.__webglDepthbuffer = r.createRenderbuffer(), Ae(M.__webglDepthbuffer, A, !1);
    t.bindFramebuffer(36160, null);
  }
  function st(A, M, X) {
    const ie = n.get(A);
    M !== void 0 && ve(ie.__webglFramebuffer, A, A.texture, 36064, 3553), X !== void 0 && Le(A);
  }
  function Qe(A) {
    const M = A.texture, X = n.get(A), ie = n.get(M);
    A.addEventListener("dispose", ee), A.isWebGLMultipleRenderTargets !== !0 && (ie.__webglTexture === void 0 && (ie.__webglTexture = r.createTexture()), ie.__version = M.version, a.memory.textures++);
    const oe = A.isWebGLCubeRenderTarget === !0, de = A.isWebGLMultipleRenderTargets === !0, Re = b(A) || o;
    if (oe) {
      X.__webglFramebuffer = [];
      for (let C = 0; C < 6; C++)
        X.__webglFramebuffer[C] = r.createFramebuffer();
    } else {
      if (X.__webglFramebuffer = r.createFramebuffer(), de)
        if (i.drawBuffers) {
          const C = A.texture;
          for (let B = 0, pe = C.length; B < pe; B++) {
            const ge = n.get(C[B]);
            ge.__webglTexture === void 0 && (ge.__webglTexture = r.createTexture(), a.memory.textures++);
          }
        } else
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      if (o && A.samples > 0 && ke(A) === !1) {
        const C = de ? M : [M];
        X.__webglMultisampledFramebuffer = r.createFramebuffer(), X.__webglColorRenderbuffer = [], t.bindFramebuffer(36160, X.__webglMultisampledFramebuffer);
        for (let B = 0; B < C.length; B++) {
          const pe = C[B];
          X.__webglColorRenderbuffer[B] = r.createRenderbuffer(), r.bindRenderbuffer(36161, X.__webglColorRenderbuffer[B]);
          const ge = s.convert(pe.format, pe.encoding), fe = s.convert(pe.type), we = x(pe.internalFormat, ge, fe, pe.encoding, A.isXRRenderTarget === !0), Se = $e(A);
          r.renderbufferStorageMultisample(36161, Se, we, A.width, A.height), r.framebufferRenderbuffer(36160, 36064 + B, 36161, X.__webglColorRenderbuffer[B]);
        }
        r.bindRenderbuffer(36161, null), A.depthBuffer && (X.__webglDepthRenderbuffer = r.createRenderbuffer(), Ae(X.__webglDepthRenderbuffer, A, !0)), t.bindFramebuffer(36160, null);
      }
    }
    if (oe) {
      t.bindTexture(34067, ie.__webglTexture), Y(34067, M, Re);
      for (let C = 0; C < 6; C++)
        ve(X.__webglFramebuffer[C], A, M, 36064, 34069 + C);
      D(M, Re) && z(34067), t.unbindTexture();
    } else if (de) {
      const C = A.texture;
      for (let B = 0, pe = C.length; B < pe; B++) {
        const ge = C[B], fe = n.get(ge);
        t.bindTexture(3553, fe.__webglTexture), Y(3553, ge, Re), ve(X.__webglFramebuffer, A, ge, 36064 + B, 3553), D(ge, Re) && z(3553);
      }
      t.unbindTexture();
    } else {
      let C = 3553;
      (A.isWebGL3DRenderTarget || A.isWebGLArrayRenderTarget) && (o ? C = A.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), t.bindTexture(C, ie.__webglTexture), Y(C, M, Re), ve(X.__webglFramebuffer, A, M, 36064, C), D(M, Re) && z(C), t.unbindTexture();
    }
    A.depthBuffer && Le(A);
  }
  function et(A) {
    const M = b(A) || o, X = A.isWebGLMultipleRenderTargets === !0 ? A.texture : [A.texture];
    for (let ie = 0, oe = X.length; ie < oe; ie++) {
      const de = X[ie];
      if (D(de, M)) {
        const Re = A.isWebGLCubeRenderTarget ? 34067 : 3553, C = n.get(de).__webglTexture;
        t.bindTexture(Re, C), z(Re), t.unbindTexture();
      }
    }
  }
  function pt(A) {
    if (o && A.samples > 0 && ke(A) === !1) {
      const M = A.isWebGLMultipleRenderTargets ? A.texture : [A.texture], X = A.width, ie = A.height;
      let oe = 16384;
      const de = [], Re = A.stencilBuffer ? 33306 : 36096, C = n.get(A), B = A.isWebGLMultipleRenderTargets === !0;
      if (B)
        for (let pe = 0; pe < M.length; pe++)
          t.bindFramebuffer(36160, C.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(36160, 36064 + pe, 36161, null), t.bindFramebuffer(36160, C.__webglFramebuffer), r.framebufferTexture2D(36009, 36064 + pe, 3553, null, 0);
      t.bindFramebuffer(36008, C.__webglMultisampledFramebuffer), t.bindFramebuffer(36009, C.__webglFramebuffer);
      for (let pe = 0; pe < M.length; pe++) {
        de.push(36064 + pe), A.depthBuffer && de.push(Re);
        const ge = C.__ignoreDepthValues !== void 0 ? C.__ignoreDepthValues : !1;
        if (ge === !1 && (A.depthBuffer && (oe |= 256), A.stencilBuffer && (oe |= 1024)), B && r.framebufferRenderbuffer(36008, 36064, 36161, C.__webglColorRenderbuffer[pe]), ge === !0 && (r.invalidateFramebuffer(36008, [Re]), r.invalidateFramebuffer(36009, [Re])), B) {
          const fe = n.get(M[pe]).__webglTexture;
          r.framebufferTexture2D(36009, 36064, 3553, fe, 0);
        }
        r.blitFramebuffer(0, 0, X, ie, 0, 0, X, ie, oe, 9728), m && r.invalidateFramebuffer(36008, de);
      }
      if (t.bindFramebuffer(36008, null), t.bindFramebuffer(36009, null), B)
        for (let pe = 0; pe < M.length; pe++) {
          t.bindFramebuffer(36160, C.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(36160, 36064 + pe, 36161, C.__webglColorRenderbuffer[pe]);
          const ge = n.get(M[pe]).__webglTexture;
          t.bindFramebuffer(36160, C.__webglFramebuffer), r.framebufferTexture2D(36009, 36064 + pe, 3553, ge, 0);
        }
      t.bindFramebuffer(36009, C.__webglMultisampledFramebuffer);
    }
  }
  function $e(A) {
    return Math.min(h, A.samples);
  }
  function ke(A) {
    const M = n.get(A);
    return o && A.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && M.__useRenderToTexture !== !1;
  }
  function xt(A) {
    const M = a.render.frame;
    g.get(A) !== M && (g.set(A, M), A.update());
  }
  function at(A, M) {
    const X = A.encoding, ie = A.format, oe = A.type;
    return A.isCompressedTexture === !0 || A.isVideoTexture === !0 || A.format === kr || X !== Bn && (X === Xe ? o === !1 ? e.has("EXT_sRGB") === !0 && ie === zt ? (A.format = kr, A.minFilter = Et, A.generateMipmaps = !1) : M = fl.sRGBToLinear(M) : (ie !== zt || oe !== kn) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", X)), M;
  }
  this.allocateTextureUnit = Z, this.resetTextureUnits = te, this.setTexture2D = $, this.setTexture2DArray = K, this.setTexture3D = W, this.setTextureCube = le, this.rebindTextures = st, this.setupRenderTarget = Qe, this.updateRenderTargetMipmap = et, this.updateMultisampleRenderTarget = pt, this.setupDepthRenderbuffer = Le, this.setupFrameBufferTexture = ve, this.useMultisampledRTT = ke;
}
function Im(r, e, t) {
  const n = t.isWebGL2;
  function i(s, a = null) {
    let o;
    if (s === kn)
      return 5121;
    if (s === hh)
      return 32819;
    if (s === uh)
      return 32820;
    if (s === oh)
      return 5120;
    if (s === lh)
      return 5122;
    if (s === ll)
      return 5123;
    if (s === ch)
      return 5124;
    if (s === Dn)
      return 5125;
    if (s === xn)
      return 5126;
    if (s === Yi)
      return n ? 5131 : (o = e.get("OES_texture_half_float"), o !== null ? o.HALF_FLOAT_OES : null);
    if (s === dh)
      return 6406;
    if (s === zt)
      return 6408;
    if (s === ph)
      return 6409;
    if (s === mh)
      return 6410;
    if (s === Nn)
      return 6402;
    if (s === xi)
      return 34041;
    if (s === fh)
      return console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228"), 6408;
    if (s === kr)
      return o = e.get("EXT_sRGB"), o !== null ? o.SRGB_ALPHA_EXT : null;
    if (s === gh)
      return 6403;
    if (s === _h)
      return 36244;
    if (s === vh)
      return 33319;
    if (s === xh)
      return 33320;
    if (s === yh)
      return 36249;
    if (s === Ys || s === Ks || s === Zs || s === $s)
      if (a === Xe)
        if (o = e.get("WEBGL_compressed_texture_s3tc_srgb"), o !== null) {
          if (s === Ys)
            return o.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (s === Ks)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (s === Zs)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (s === $s)
            return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (o = e.get("WEBGL_compressed_texture_s3tc"), o !== null) {
        if (s === Ys)
          return o.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (s === Ks)
          return o.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (s === Zs)
          return o.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (s === $s)
          return o.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (s === va || s === xa || s === ya || s === ba)
      if (o = e.get("WEBGL_compressed_texture_pvrtc"), o !== null) {
        if (s === va)
          return o.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (s === xa)
          return o.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (s === ya)
          return o.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (s === ba)
          return o.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (s === bh)
      return o = e.get("WEBGL_compressed_texture_etc1"), o !== null ? o.COMPRESSED_RGB_ETC1_WEBGL : null;
    if (s === Ma || s === wa)
      if (o = e.get("WEBGL_compressed_texture_etc"), o !== null) {
        if (s === Ma)
          return a === Xe ? o.COMPRESSED_SRGB8_ETC2 : o.COMPRESSED_RGB8_ETC2;
        if (s === wa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : o.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (s === Sa || s === Ta || s === Aa || s === Ea || s === Ca || s === La || s === Ra || s === Pa || s === Da || s === Ia || s === Oa || s === Na || s === Fa || s === za)
      if (o = e.get("WEBGL_compressed_texture_astc"), o !== null) {
        if (s === Sa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : o.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (s === Ta)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : o.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (s === Aa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : o.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (s === Ea)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : o.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (s === Ca)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : o.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (s === La)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : o.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (s === Ra)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : o.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (s === Pa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : o.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (s === Da)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : o.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (s === Ia)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : o.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (s === Oa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : o.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (s === Na)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : o.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (s === Fa)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : o.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (s === za)
          return a === Xe ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : o.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (s === Ua)
      if (o = e.get("EXT_texture_compression_bptc"), o !== null) {
        if (s === Ua)
          return a === Xe ? o.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : o.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else
        return null;
    return s === di ? n ? 34042 : (o = e.get("WEBGL_depth_texture"), o !== null ? o.UNSIGNED_INT_24_8_WEBGL : null) : r[s] !== void 0 ? r[s] : null;
  }
  return { convert: i };
}
class Om extends At {
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e;
  }
}
class On extends nt {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const Nm = { type: "move" };
class wr {
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  getHandSpace() {
    return this._hand === null && (this._hand = new On(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new On(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new F(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new F()), this._targetRay;
  }
  getGripSpace() {
    return this._grip === null && (this._grip = new On(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new F(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new F()), this._grip;
  }
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  connect(e) {
    if (e && e.hand) {
      const t = this._hand;
      if (t)
        for (const n of e.hand.values())
          this._getHandJoint(t, n);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  update(e, t, n) {
    let i = null, s = null, a = null;
    const o = this._targetRay, l = this._grip, c = this._hand;
    if (e && t.session.visibilityState !== "visible-blurred") {
      if (c && e.hand) {
        a = !0;
        for (const p of e.hand.values()) {
          const f = t.getJointPose(p, n), v = this._getHandJoint(c, p);
          f !== null && (v.matrix.fromArray(f.transform.matrix), v.matrix.decompose(v.position, v.rotation, v.scale), v.jointRadius = f.radius), v.visible = f !== null;
        }
        const u = c.joints["index-finger-tip"], h = c.joints["thumb-tip"], d = u.position.distanceTo(h.position), m = 0.02, g = 5e-3;
        c.inputState.pinching && d > m + g ? (c.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !c.inputState.pinching && d <= m - g && (c.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        l !== null && e.gripSpace && (s = t.getPose(e.gripSpace, n), s !== null && (l.matrix.fromArray(s.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), s.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s.linearVelocity)) : l.hasLinearVelocity = !1, s.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s.angularVelocity)) : l.hasAngularVelocity = !1));
      o !== null && (i = t.getPose(e.targetRaySpace, n), i === null && s !== null && (i = s), i !== null && (o.matrix.fromArray(i.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), i.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(i.linearVelocity)) : o.hasLinearVelocity = !1, i.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(i.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(Nm)));
    }
    return o !== null && (o.visible = i !== null), l !== null && (l.visible = s !== null), c !== null && (c.visible = a !== null), this;
  }
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === void 0) {
      const n = new On();
      n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
    }
    return e.joints[t.jointName];
  }
}
class Fm extends mt {
  constructor(e, t, n, i, s, a, o, l, c, u) {
    if (u = u !== void 0 ? u : Nn, u !== Nn && u !== xi)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    n === void 0 && u === Nn && (n = Dn), n === void 0 && u === xi && (n = di), super(null, i, s, a, o, l, u, n, c), this.isDepthTexture = !0, this.image = { width: e, height: t }, this.magFilter = o !== void 0 ? o : ft, this.minFilter = l !== void 0 ? l : ft, this.flipY = !1, this.generateMipmaps = !1;
  }
}
class zm extends jn {
  constructor(e, t) {
    super();
    const n = this;
    let i = null, s = 1, a = null, o = "local-floor", l = null, c = null, u = null, h = null, d = null, m = null;
    const g = t.getContextAttributes();
    let p = null, f = null;
    const v = [], S = [], y = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Map(), w = new At();
    w.layers.enable(1), w.viewport = new Ze();
    const D = new At();
    D.layers.enable(2), D.viewport = new Ze();
    const z = [w, D], x = new Om();
    x.layers.enable(1), x.layers.enable(2);
    let R = null, k = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(K) {
      let W = v[K];
      return W === void 0 && (W = new wr(), v[K] = W), W.getTargetRaySpace();
    }, this.getControllerGrip = function(K) {
      let W = v[K];
      return W === void 0 && (W = new wr(), v[K] = W), W.getGripSpace();
    }, this.getHand = function(K) {
      let W = v[K];
      return W === void 0 && (W = new wr(), v[K] = W), W.getHandSpace();
    };
    function T(K) {
      const W = S.indexOf(K.inputSource);
      if (W === -1)
        return;
      const le = v[W];
      le !== void 0 && le.dispatchEvent({ type: K.type, data: K.inputSource });
    }
    function ee() {
      i.removeEventListener("select", T), i.removeEventListener("selectstart", T), i.removeEventListener("selectend", T), i.removeEventListener("squeeze", T), i.removeEventListener("squeezestart", T), i.removeEventListener("squeezeend", T), i.removeEventListener("end", ee), i.removeEventListener("inputsourceschange", V);
      for (let K = 0; K < v.length; K++) {
        const W = S[K];
        W !== null && (S[K] = null, v[K].disconnect(W));
      }
      R = null, k = null, e.setRenderTarget(p), d = null, h = null, u = null, i = null, f = null, $.stop(), n.isPresenting = !1, n.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(K) {
      s = K, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(K) {
      o = K, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return l || a;
    }, this.setReferenceSpace = function(K) {
      l = K;
    }, this.getBaseLayer = function() {
      return h !== null ? h : d;
    }, this.getBinding = function() {
      return u;
    }, this.getFrame = function() {
      return m;
    }, this.getSession = function() {
      return i;
    }, this.setSession = async function(K) {
      if (i = K, i !== null) {
        if (p = e.getRenderTarget(), i.addEventListener("select", T), i.addEventListener("selectstart", T), i.addEventListener("selectend", T), i.addEventListener("squeeze", T), i.addEventListener("squeezestart", T), i.addEventListener("squeezeend", T), i.addEventListener("end", ee), i.addEventListener("inputsourceschange", V), g.xrCompatible !== !0 && await t.makeXRCompatible(), i.renderState.layers === void 0 || e.capabilities.isWebGL2 === !1) {
          const W = {
            antialias: i.renderState.layers === void 0 ? g.antialias : !0,
            alpha: g.alpha,
            depth: g.depth,
            stencil: g.stencil,
            framebufferScaleFactor: s
          };
          d = new XRWebGLLayer(i, t, W), i.updateRenderState({ baseLayer: d }), f = new Hn(
            d.framebufferWidth,
            d.framebufferHeight,
            {
              format: zt,
              type: kn,
              encoding: e.outputEncoding,
              stencilBuffer: g.stencil
            }
          );
        } else {
          let W = null, le = null, ae = null;
          g.depth && (ae = g.stencil ? 35056 : 33190, W = g.stencil ? xi : Nn, le = g.stencil ? di : Dn);
          const ue = {
            colorFormat: 32856,
            depthFormat: ae,
            scaleFactor: s
          };
          u = new XRWebGLBinding(i, t), h = u.createProjectionLayer(ue), i.updateRenderState({ layers: [h] }), f = new Hn(
            h.textureWidth,
            h.textureHeight,
            {
              format: zt,
              type: kn,
              depthTexture: new Fm(h.textureWidth, h.textureHeight, le, void 0, void 0, void 0, void 0, void 0, void 0, W),
              stencilBuffer: g.stencil,
              encoding: e.outputEncoding,
              samples: g.antialias ? 4 : 0
            }
          );
          const Y = e.properties.get(f);
          Y.__ignoreDepthValues = h.ignoreDepthValues;
        }
        f.isXRRenderTarget = !0, this.setFoveation(1), l = null, a = await i.requestReferenceSpace(o), $.setContext(i), $.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
      }
    };
    function V(K) {
      for (let W = 0; W < K.removed.length; W++) {
        const le = K.removed[W], ae = S.indexOf(le);
        ae >= 0 && (S[ae] = null, v[ae].disconnect(le));
      }
      for (let W = 0; W < K.added.length; W++) {
        const le = K.added[W];
        let ae = S.indexOf(le);
        if (ae === -1) {
          for (let Y = 0; Y < v.length; Y++)
            if (Y >= S.length) {
              S.push(le), ae = Y;
              break;
            } else if (S[Y] === null) {
              S[Y] = le, ae = Y;
              break;
            }
          if (ae === -1)
            break;
        }
        const ue = v[ae];
        ue && ue.connect(le);
      }
    }
    const H = new F(), j = new F();
    function G(K, W, le) {
      H.setFromMatrixPosition(W.matrixWorld), j.setFromMatrixPosition(le.matrixWorld);
      const ae = H.distanceTo(j), ue = W.projectionMatrix.elements, Y = le.projectionMatrix.elements, Oe = ue[14] / (ue[10] - 1), be = ue[14] / (ue[10] + 1), Ce = (ue[9] + 1) / ue[5], ve = (ue[9] - 1) / ue[5], Ae = (ue[8] - 1) / ue[0], Ee = (Y[8] + 1) / Y[0], Le = Oe * Ae, st = Oe * Ee, Qe = ae / (-Ae + Ee), et = Qe * -Ae;
      W.matrixWorld.decompose(K.position, K.quaternion, K.scale), K.translateX(et), K.translateZ(Qe), K.matrixWorld.compose(K.position, K.quaternion, K.scale), K.matrixWorldInverse.copy(K.matrixWorld).invert();
      const pt = Oe + Qe, $e = be + Qe, ke = Le - et, xt = st + (ae - et), at = Ce * be / $e * pt, A = ve * be / $e * pt;
      K.projectionMatrix.makePerspective(ke, xt, at, A, pt, $e);
    }
    function te(K, W) {
      W === null ? K.matrixWorld.copy(K.matrix) : K.matrixWorld.multiplyMatrices(W.matrixWorld, K.matrix), K.matrixWorldInverse.copy(K.matrixWorld).invert();
    }
    this.updateCamera = function(K) {
      if (i === null)
        return;
      x.near = D.near = w.near = K.near, x.far = D.far = w.far = K.far, (R !== x.near || k !== x.far) && (i.updateRenderState({
        depthNear: x.near,
        depthFar: x.far
      }), R = x.near, k = x.far);
      const W = K.parent, le = x.cameras;
      te(x, W);
      for (let ue = 0; ue < le.length; ue++)
        te(le[ue], W);
      x.matrixWorld.decompose(x.position, x.quaternion, x.scale), K.matrix.copy(x.matrix), K.matrix.decompose(K.position, K.quaternion, K.scale);
      const ae = K.children;
      for (let ue = 0, Y = ae.length; ue < Y; ue++)
        ae[ue].updateMatrixWorld(!0);
      le.length === 2 ? G(x, w, D) : x.projectionMatrix.copy(w.projectionMatrix);
    }, this.getCamera = function() {
      return x;
    }, this.getFoveation = function() {
      if (h !== null)
        return h.fixedFoveation;
      if (d !== null)
        return d.fixedFoveation;
    }, this.setFoveation = function(K) {
      h !== null && (h.fixedFoveation = K), d !== null && d.fixedFoveation !== void 0 && (d.fixedFoveation = K);
    }, this.getPlanes = function() {
      return y;
    };
    let Z = null;
    function re(K, W) {
      if (c = W.getViewerPose(l || a), m = W, c !== null) {
        const le = c.views;
        d !== null && (e.setRenderTargetFramebuffer(f, d.framebuffer), e.setRenderTarget(f));
        let ae = !1;
        le.length !== x.cameras.length && (x.cameras.length = 0, ae = !0);
        for (let ue = 0; ue < le.length; ue++) {
          const Y = le[ue];
          let Oe = null;
          if (d !== null)
            Oe = d.getViewport(Y);
          else {
            const Ce = u.getViewSubImage(h, Y);
            Oe = Ce.viewport, ue === 0 && (e.setRenderTargetTextures(
              f,
              Ce.colorTexture,
              h.ignoreDepthValues ? void 0 : Ce.depthStencilTexture
            ), e.setRenderTarget(f));
          }
          let be = z[ue];
          be === void 0 && (be = new At(), be.layers.enable(ue), be.viewport = new Ze(), z[ue] = be), be.matrix.fromArray(Y.transform.matrix), be.projectionMatrix.fromArray(Y.projectionMatrix), be.viewport.set(Oe.x, Oe.y, Oe.width, Oe.height), ue === 0 && x.matrix.copy(be.matrix), ae === !0 && x.cameras.push(be);
        }
      }
      for (let le = 0; le < v.length; le++) {
        const ae = S[le], ue = v[le];
        ae !== null && ue !== void 0 && ue.update(ae, W, l || a);
      }
      if (Z && Z(K, W), W.detectedPlanes) {
        n.dispatchEvent({ type: "planesdetected", data: W.detectedPlanes });
        let le = null;
        for (const ae of y)
          W.detectedPlanes.has(ae) || (le === null && (le = []), le.push(ae));
        if (le !== null)
          for (const ae of le)
            y.delete(ae), b.delete(ae), n.dispatchEvent({ type: "planeremoved", data: ae });
        for (const ae of W.detectedPlanes)
          if (!y.has(ae))
            y.add(ae), b.set(ae, W.lastChangedTime), n.dispatchEvent({ type: "planeadded", data: ae });
          else {
            const ue = b.get(ae);
            ae.lastChangedTime > ue && (b.set(ae, ae.lastChangedTime), n.dispatchEvent({ type: "planechanged", data: ae }));
          }
      }
      m = null;
    }
    const $ = new Ml();
    $.setAnimationLoop(re), this.setAnimationLoop = function(K) {
      Z = K;
    }, this.dispose = function() {
    };
  }
}
function Um(r, e) {
  function t(p, f) {
    f.color.getRGB(p.fogColor.value, xl(r)), f.isFog ? (p.fogNear.value = f.near, p.fogFar.value = f.far) : f.isFogExp2 && (p.fogDensity.value = f.density);
  }
  function n(p, f, v, S, y) {
    f.isMeshBasicMaterial || f.isMeshLambertMaterial ? i(p, f) : f.isMeshToonMaterial ? (i(p, f), u(p, f)) : f.isMeshPhongMaterial ? (i(p, f), c(p, f)) : f.isMeshStandardMaterial ? (i(p, f), h(p, f), f.isMeshPhysicalMaterial && d(p, f, y)) : f.isMeshMatcapMaterial ? (i(p, f), m(p, f)) : f.isMeshDepthMaterial ? i(p, f) : f.isMeshDistanceMaterial ? (i(p, f), g(p, f)) : f.isMeshNormalMaterial ? i(p, f) : f.isLineBasicMaterial ? (s(p, f), f.isLineDashedMaterial && a(p, f)) : f.isPointsMaterial ? o(p, f, v, S) : f.isSpriteMaterial ? l(p, f) : f.isShadowMaterial ? (p.color.value.copy(f.color), p.opacity.value = f.opacity) : f.isShaderMaterial && (f.uniformsNeedUpdate = !1);
  }
  function i(p, f) {
    p.opacity.value = f.opacity, f.color && p.diffuse.value.copy(f.color), f.emissive && p.emissive.value.copy(f.emissive).multiplyScalar(f.emissiveIntensity), f.map && (p.map.value = f.map), f.alphaMap && (p.alphaMap.value = f.alphaMap), f.bumpMap && (p.bumpMap.value = f.bumpMap, p.bumpScale.value = f.bumpScale, f.side === kt && (p.bumpScale.value *= -1)), f.displacementMap && (p.displacementMap.value = f.displacementMap, p.displacementScale.value = f.displacementScale, p.displacementBias.value = f.displacementBias), f.emissiveMap && (p.emissiveMap.value = f.emissiveMap), f.normalMap && (p.normalMap.value = f.normalMap, p.normalScale.value.copy(f.normalScale), f.side === kt && p.normalScale.value.negate()), f.specularMap && (p.specularMap.value = f.specularMap), f.alphaTest > 0 && (p.alphaTest.value = f.alphaTest);
    const v = e.get(f).envMap;
    if (v && (p.envMap.value = v, p.flipEnvMap.value = v.isCubeTexture && v.isRenderTargetTexture === !1 ? -1 : 1, p.reflectivity.value = f.reflectivity, p.ior.value = f.ior, p.refractionRatio.value = f.refractionRatio), f.lightMap) {
      p.lightMap.value = f.lightMap;
      const b = r.physicallyCorrectLights !== !0 ? Math.PI : 1;
      p.lightMapIntensity.value = f.lightMapIntensity * b;
    }
    f.aoMap && (p.aoMap.value = f.aoMap, p.aoMapIntensity.value = f.aoMapIntensity);
    let S;
    f.map ? S = f.map : f.specularMap ? S = f.specularMap : f.displacementMap ? S = f.displacementMap : f.normalMap ? S = f.normalMap : f.bumpMap ? S = f.bumpMap : f.roughnessMap ? S = f.roughnessMap : f.metalnessMap ? S = f.metalnessMap : f.alphaMap ? S = f.alphaMap : f.emissiveMap ? S = f.emissiveMap : f.clearcoatMap ? S = f.clearcoatMap : f.clearcoatNormalMap ? S = f.clearcoatNormalMap : f.clearcoatRoughnessMap ? S = f.clearcoatRoughnessMap : f.iridescenceMap ? S = f.iridescenceMap : f.iridescenceThicknessMap ? S = f.iridescenceThicknessMap : f.specularIntensityMap ? S = f.specularIntensityMap : f.specularColorMap ? S = f.specularColorMap : f.transmissionMap ? S = f.transmissionMap : f.thicknessMap ? S = f.thicknessMap : f.sheenColorMap ? S = f.sheenColorMap : f.sheenRoughnessMap && (S = f.sheenRoughnessMap), S !== void 0 && (S.isWebGLRenderTarget && (S = S.texture), S.matrixAutoUpdate === !0 && S.updateMatrix(), p.uvTransform.value.copy(S.matrix));
    let y;
    f.aoMap ? y = f.aoMap : f.lightMap && (y = f.lightMap), y !== void 0 && (y.isWebGLRenderTarget && (y = y.texture), y.matrixAutoUpdate === !0 && y.updateMatrix(), p.uv2Transform.value.copy(y.matrix));
  }
  function s(p, f) {
    p.diffuse.value.copy(f.color), p.opacity.value = f.opacity;
  }
  function a(p, f) {
    p.dashSize.value = f.dashSize, p.totalSize.value = f.dashSize + f.gapSize, p.scale.value = f.scale;
  }
  function o(p, f, v, S) {
    p.diffuse.value.copy(f.color), p.opacity.value = f.opacity, p.size.value = f.size * v, p.scale.value = S * 0.5, f.map && (p.map.value = f.map), f.alphaMap && (p.alphaMap.value = f.alphaMap), f.alphaTest > 0 && (p.alphaTest.value = f.alphaTest);
    let y;
    f.map ? y = f.map : f.alphaMap && (y = f.alphaMap), y !== void 0 && (y.matrixAutoUpdate === !0 && y.updateMatrix(), p.uvTransform.value.copy(y.matrix));
  }
  function l(p, f) {
    p.diffuse.value.copy(f.color), p.opacity.value = f.opacity, p.rotation.value = f.rotation, f.map && (p.map.value = f.map), f.alphaMap && (p.alphaMap.value = f.alphaMap), f.alphaTest > 0 && (p.alphaTest.value = f.alphaTest);
    let v;
    f.map ? v = f.map : f.alphaMap && (v = f.alphaMap), v !== void 0 && (v.matrixAutoUpdate === !0 && v.updateMatrix(), p.uvTransform.value.copy(v.matrix));
  }
  function c(p, f) {
    p.specular.value.copy(f.specular), p.shininess.value = Math.max(f.shininess, 1e-4);
  }
  function u(p, f) {
    f.gradientMap && (p.gradientMap.value = f.gradientMap);
  }
  function h(p, f) {
    p.roughness.value = f.roughness, p.metalness.value = f.metalness, f.roughnessMap && (p.roughnessMap.value = f.roughnessMap), f.metalnessMap && (p.metalnessMap.value = f.metalnessMap), e.get(f).envMap && (p.envMapIntensity.value = f.envMapIntensity);
  }
  function d(p, f, v) {
    p.ior.value = f.ior, f.sheen > 0 && (p.sheenColor.value.copy(f.sheenColor).multiplyScalar(f.sheen), p.sheenRoughness.value = f.sheenRoughness, f.sheenColorMap && (p.sheenColorMap.value = f.sheenColorMap), f.sheenRoughnessMap && (p.sheenRoughnessMap.value = f.sheenRoughnessMap)), f.clearcoat > 0 && (p.clearcoat.value = f.clearcoat, p.clearcoatRoughness.value = f.clearcoatRoughness, f.clearcoatMap && (p.clearcoatMap.value = f.clearcoatMap), f.clearcoatRoughnessMap && (p.clearcoatRoughnessMap.value = f.clearcoatRoughnessMap), f.clearcoatNormalMap && (p.clearcoatNormalScale.value.copy(f.clearcoatNormalScale), p.clearcoatNormalMap.value = f.clearcoatNormalMap, f.side === kt && p.clearcoatNormalScale.value.negate())), f.iridescence > 0 && (p.iridescence.value = f.iridescence, p.iridescenceIOR.value = f.iridescenceIOR, p.iridescenceThicknessMinimum.value = f.iridescenceThicknessRange[0], p.iridescenceThicknessMaximum.value = f.iridescenceThicknessRange[1], f.iridescenceMap && (p.iridescenceMap.value = f.iridescenceMap), f.iridescenceThicknessMap && (p.iridescenceThicknessMap.value = f.iridescenceThicknessMap)), f.transmission > 0 && (p.transmission.value = f.transmission, p.transmissionSamplerMap.value = v.texture, p.transmissionSamplerSize.value.set(v.width, v.height), f.transmissionMap && (p.transmissionMap.value = f.transmissionMap), p.thickness.value = f.thickness, f.thicknessMap && (p.thicknessMap.value = f.thicknessMap), p.attenuationDistance.value = f.attenuationDistance, p.attenuationColor.value.copy(f.attenuationColor)), p.specularIntensity.value = f.specularIntensity, p.specularColor.value.copy(f.specularColor), f.specularIntensityMap && (p.specularIntensityMap.value = f.specularIntensityMap), f.specularColorMap && (p.specularColorMap.value = f.specularColorMap);
  }
  function m(p, f) {
    f.matcap && (p.matcap.value = f.matcap);
  }
  function g(p, f) {
    p.referencePosition.value.copy(f.referencePosition), p.nearDistance.value = f.nearDistance, p.farDistance.value = f.farDistance;
  }
  return {
    refreshFogUniforms: t,
    refreshMaterialUniforms: n
  };
}
function km(r, e, t, n) {
  let i = {}, s = {}, a = [];
  const o = t.isWebGL2 ? r.getParameter(35375) : 0;
  function l(S, y) {
    const b = y.program;
    n.uniformBlockBinding(S, b);
  }
  function c(S, y) {
    let b = i[S.id];
    b === void 0 && (g(S), b = u(S), i[S.id] = b, S.addEventListener("dispose", f));
    const w = y.program;
    n.updateUBOMapping(S, w);
    const D = e.render.frame;
    s[S.id] !== D && (d(S), s[S.id] = D);
  }
  function u(S) {
    const y = h();
    S.__bindingPointIndex = y;
    const b = r.createBuffer(), w = S.__size, D = S.usage;
    return r.bindBuffer(35345, b), r.bufferData(35345, w, D), r.bindBuffer(35345, null), r.bindBufferBase(35345, y, b), b;
  }
  function h() {
    for (let S = 0; S < o; S++)
      if (a.indexOf(S) === -1)
        return a.push(S), S;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function d(S) {
    const y = i[S.id], b = S.uniforms, w = S.__cache;
    r.bindBuffer(35345, y);
    for (let D = 0, z = b.length; D < z; D++) {
      const x = b[D];
      if (m(x, D, w) === !0) {
        const R = x.__offset, k = Array.isArray(x.value) ? x.value : [x.value];
        let T = 0;
        for (let ee = 0; ee < k.length; ee++) {
          const V = k[ee], H = p(V);
          typeof V == "number" ? (x.__data[0] = V, r.bufferSubData(35345, R + T, x.__data)) : V.isMatrix3 ? (x.__data[0] = V.elements[0], x.__data[1] = V.elements[1], x.__data[2] = V.elements[2], x.__data[3] = V.elements[0], x.__data[4] = V.elements[3], x.__data[5] = V.elements[4], x.__data[6] = V.elements[5], x.__data[7] = V.elements[0], x.__data[8] = V.elements[6], x.__data[9] = V.elements[7], x.__data[10] = V.elements[8], x.__data[11] = V.elements[0]) : (V.toArray(x.__data, T), T += H.storage / Float32Array.BYTES_PER_ELEMENT);
        }
        r.bufferSubData(35345, R, x.__data);
      }
    }
    r.bindBuffer(35345, null);
  }
  function m(S, y, b) {
    const w = S.value;
    if (b[y] === void 0) {
      if (typeof w == "number")
        b[y] = w;
      else {
        const D = Array.isArray(w) ? w : [w], z = [];
        for (let x = 0; x < D.length; x++)
          z.push(D[x].clone());
        b[y] = z;
      }
      return !0;
    } else if (typeof w == "number") {
      if (b[y] !== w)
        return b[y] = w, !0;
    } else {
      const D = Array.isArray(b[y]) ? b[y] : [b[y]], z = Array.isArray(w) ? w : [w];
      for (let x = 0; x < D.length; x++) {
        const R = D[x];
        if (R.equals(z[x]) === !1)
          return R.copy(z[x]), !0;
      }
    }
    return !1;
  }
  function g(S) {
    const y = S.uniforms;
    let b = 0;
    const w = 16;
    let D = 0;
    for (let z = 0, x = y.length; z < x; z++) {
      const R = y[z], k = {
        boundary: 0,
        storage: 0
      }, T = Array.isArray(R.value) ? R.value : [R.value];
      for (let ee = 0, V = T.length; ee < V; ee++) {
        const H = T[ee], j = p(H);
        k.boundary += j.boundary, k.storage += j.storage;
      }
      if (R.__data = new Float32Array(k.storage / Float32Array.BYTES_PER_ELEMENT), R.__offset = b, z > 0) {
        D = b % w;
        const ee = w - D;
        D !== 0 && ee - k.boundary < 0 && (b += w - D, R.__offset = b);
      }
      b += k.storage;
    }
    return D = b % w, D > 0 && (b += w - D), S.__size = b, S.__cache = {}, this;
  }
  function p(S) {
    const y = {
      boundary: 0,
      storage: 0
    };
    return typeof S == "number" ? (y.boundary = 4, y.storage = 4) : S.isVector2 ? (y.boundary = 8, y.storage = 8) : S.isVector3 || S.isColor ? (y.boundary = 16, y.storage = 12) : S.isVector4 ? (y.boundary = 16, y.storage = 16) : S.isMatrix3 ? (y.boundary = 48, y.storage = 48) : S.isMatrix4 ? (y.boundary = 64, y.storage = 64) : S.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", S), y;
  }
  function f(S) {
    const y = S.target;
    y.removeEventListener("dispose", f);
    const b = a.indexOf(y.__bindingPointIndex);
    a.splice(b, 1), r.deleteBuffer(i[y.id]), delete i[y.id], delete s[y.id];
  }
  function v() {
    for (const S in i)
      r.deleteBuffer(i[S]);
    a = [], i = {}, s = {};
  }
  return {
    bind: l,
    update: c,
    dispose: v
  };
}
function Bm() {
  const r = Ji("canvas");
  return r.style.display = "block", r;
}
function El(r = {}) {
  this.isWebGLRenderer = !0;
  const e = r.canvas !== void 0 ? r.canvas : Bm(), t = r.context !== void 0 ? r.context : null, n = r.depth !== void 0 ? r.depth : !0, i = r.stencil !== void 0 ? r.stencil : !0, s = r.antialias !== void 0 ? r.antialias : !1, a = r.premultipliedAlpha !== void 0 ? r.premultipliedAlpha : !0, o = r.preserveDrawingBuffer !== void 0 ? r.preserveDrawingBuffer : !1, l = r.powerPreference !== void 0 ? r.powerPreference : "default", c = r.failIfMajorPerformanceCaveat !== void 0 ? r.failIfMajorPerformanceCaveat : !1;
  let u;
  t !== null ? u = t.getContextAttributes().alpha : u = r.alpha !== void 0 ? r.alpha : !1;
  let h = null, d = null;
  const m = [], g = [];
  this.domElement = e, this.debug = {
    checkShaderErrors: !0
  }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = Bn, this.physicallyCorrectLights = !1, this.toneMapping = cn, this.toneMappingExposure = 1;
  const p = this;
  let f = !1, v = 0, S = 0, y = null, b = -1, w = null;
  const D = new Ze(), z = new Ze();
  let x = null, R = e.width, k = e.height, T = 1, ee = null, V = null;
  const H = new Ze(0, 0, R, k), j = new Ze(0, 0, R, k);
  let G = !1;
  const te = new Jr();
  let Z = !1, re = !1, $ = null;
  const K = new Fe(), W = new Pe(), le = new F(), ae = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
  function ue() {
    return y === null ? T : 1;
  }
  let Y = t;
  function Oe(_, E) {
    for (let U = 0; U < _.length; U++) {
      const I = _[U], N = e.getContext(I, E);
      if (N !== null)
        return N;
    }
    return null;
  }
  try {
    const _ = {
      alpha: !0,
      depth: n,
      stencil: i,
      antialias: s,
      premultipliedAlpha: a,
      preserveDrawingBuffer: o,
      powerPreference: l,
      failIfMajorPerformanceCaveat: c
    };
    if ("setAttribute" in e && e.setAttribute("data-engine", `three.js r${qr}`), e.addEventListener("webglcontextlost", we, !1), e.addEventListener("webglcontextrestored", Se, !1), e.addEventListener("webglcontextcreationerror", Ne, !1), Y === null) {
      const E = ["webgl2", "webgl", "experimental-webgl"];
      if (p.isWebGL1Renderer === !0 && E.shift(), Y = Oe(E, _), Y === null)
        throw Oe(E) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
    }
    Y.getShaderPrecisionFormat === void 0 && (Y.getShaderPrecisionFormat = function() {
      return { rangeMin: 1, rangeMax: 1, precision: 1 };
    });
  } catch (_) {
    throw console.error("THREE.WebGLRenderer: " + _.message), _;
  }
  let be, Ce, ve, Ae, Ee, Le, st, Qe, et, pt, $e, ke, xt, at, A, M, X, ie, oe, de, Re, C, B, pe;
  function ge() {
    be = new $f(Y), Ce = new jf(Y, be, r), be.init(Ce), C = new Im(Y, be, Ce), ve = new Pm(Y, be, Ce), Ae = new ep(), Ee = new _m(), Le = new Dm(Y, be, ve, Ee, Ce, C, Ae), st = new qf(p), Qe = new Zf(p), et = new lu(Y, Ce), B = new Gf(Y, be, et, Ce), pt = new Jf(Y, et, Ae, B), $e = new sp(Y, pt, et, Ae), oe = new ip(Y, Ce, Le), M = new Xf(Ee), ke = new gm(p, st, Qe, be, Ce, B, M), xt = new Um(p, Ee), at = new xm(), A = new Tm(be, Ce), ie = new Vf(p, st, Qe, ve, $e, u, a), X = new Rm(p, $e, Ce), pe = new km(Y, Ae, Ce, ve), de = new Wf(Y, be, Ae, Ce), Re = new Qf(Y, be, Ae, Ce), Ae.programs = ke.programs, p.capabilities = Ce, p.extensions = be, p.properties = Ee, p.renderLists = at, p.shadowMap = X, p.state = ve, p.info = Ae;
  }
  ge();
  const fe = new zm(p, Y);
  this.xr = fe, this.getContext = function() {
    return Y;
  }, this.getContextAttributes = function() {
    return Y.getContextAttributes();
  }, this.forceContextLoss = function() {
    const _ = be.get("WEBGL_lose_context");
    _ && _.loseContext();
  }, this.forceContextRestore = function() {
    const _ = be.get("WEBGL_lose_context");
    _ && _.restoreContext();
  }, this.getPixelRatio = function() {
    return T;
  }, this.setPixelRatio = function(_) {
    _ !== void 0 && (T = _, this.setSize(R, k, !1));
  }, this.getSize = function(_) {
    return _.set(R, k);
  }, this.setSize = function(_, E, U) {
    if (fe.isPresenting) {
      console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
      return;
    }
    R = _, k = E, e.width = Math.floor(_ * T), e.height = Math.floor(E * T), U !== !1 && (e.style.width = _ + "px", e.style.height = E + "px"), this.setViewport(0, 0, _, E);
  }, this.getDrawingBufferSize = function(_) {
    return _.set(R * T, k * T).floor();
  }, this.setDrawingBufferSize = function(_, E, U) {
    R = _, k = E, T = U, e.width = Math.floor(_ * U), e.height = Math.floor(E * U), this.setViewport(0, 0, _, E);
  }, this.getCurrentViewport = function(_) {
    return _.copy(D);
  }, this.getViewport = function(_) {
    return _.copy(H);
  }, this.setViewport = function(_, E, U, I) {
    _.isVector4 ? H.set(_.x, _.y, _.z, _.w) : H.set(_, E, U, I), ve.viewport(D.copy(H).multiplyScalar(T).floor());
  }, this.getScissor = function(_) {
    return _.copy(j);
  }, this.setScissor = function(_, E, U, I) {
    _.isVector4 ? j.set(_.x, _.y, _.z, _.w) : j.set(_, E, U, I), ve.scissor(z.copy(j).multiplyScalar(T).floor());
  }, this.getScissorTest = function() {
    return G;
  }, this.setScissorTest = function(_) {
    ve.setScissorTest(G = _);
  }, this.setOpaqueSort = function(_) {
    ee = _;
  }, this.setTransparentSort = function(_) {
    V = _;
  }, this.getClearColor = function(_) {
    return _.copy(ie.getClearColor());
  }, this.setClearColor = function() {
    ie.setClearColor.apply(ie, arguments);
  }, this.getClearAlpha = function() {
    return ie.getClearAlpha();
  }, this.setClearAlpha = function() {
    ie.setClearAlpha.apply(ie, arguments);
  }, this.clear = function(_ = !0, E = !0, U = !0) {
    let I = 0;
    _ && (I |= 16384), E && (I |= 256), U && (I |= 1024), Y.clear(I);
  }, this.clearColor = function() {
    this.clear(!0, !1, !1);
  }, this.clearDepth = function() {
    this.clear(!1, !0, !1);
  }, this.clearStencil = function() {
    this.clear(!1, !1, !0);
  }, this.dispose = function() {
    e.removeEventListener("webglcontextlost", we, !1), e.removeEventListener("webglcontextrestored", Se, !1), e.removeEventListener("webglcontextcreationerror", Ne, !1), at.dispose(), A.dispose(), Ee.dispose(), st.dispose(), Qe.dispose(), $e.dispose(), B.dispose(), pe.dispose(), ke.dispose(), fe.dispose(), fe.removeEventListener("sessionstart", me), fe.removeEventListener("sessionend", Te), $ && ($.dispose(), $ = null), Ge.stop();
  };
  function we(_) {
    _.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), f = !0;
  }
  function Se() {
    console.log("THREE.WebGLRenderer: Context Restored."), f = !1;
    const _ = Ae.autoReset, E = X.enabled, U = X.autoUpdate, I = X.needsUpdate, N = X.type;
    ge(), Ae.autoReset = _, X.enabled = E, X.autoUpdate = U, X.needsUpdate = I, X.type = N;
  }
  function Ne(_) {
    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", _.statusMessage);
  }
  function ze(_) {
    const E = _.target;
    E.removeEventListener("dispose", ze), je(E);
  }
  function je(_) {
    O(_), Ee.remove(_);
  }
  function O(_) {
    const E = Ee.get(_).programs;
    E !== void 0 && (E.forEach(function(U) {
      ke.releaseProgram(U);
    }), _.isShaderMaterial && ke.releaseShaderCache(_));
  }
  this.renderBufferDirect = function(_, E, U, I, N, J) {
    E === null && (E = ae);
    const Q = N.isMesh && N.matrixWorld.determinant() < 0, se = rs(_, E, U, I, N);
    ve.setMaterial(I, Q);
    let xe = U.index, ce = 1;
    I.wireframe === !0 && (xe = pt.getWireframeAttribute(U), ce = 2);
    const Me = U.drawRange, ye = U.attributes.position;
    let He = Me.start * ce, Be = (Me.start + Me.count) * ce;
    J !== null && (He = Math.max(He, J.start * ce), Be = Math.min(Be, (J.start + J.count) * ce)), xe !== null ? (He = Math.max(He, 0), Be = Math.min(Be, xe.count)) : ye != null && (He = Math.max(He, 0), Be = Math.min(Be, ye.count));
    const Lt = Be - He;
    if (Lt < 0 || Lt === 1 / 0)
      return;
    B.setup(N, I, se, U, xe);
    let bt, tt = de;
    if (xe !== null && (bt = et.get(xe), tt = Re, tt.setIndex(bt)), N.isMesh)
      I.wireframe === !0 ? (ve.setLineWidth(I.wireframeLinewidth * ue()), tt.setMode(1)) : tt.setMode(4);
    else if (N.isLine) {
      let Ue = I.linewidth;
      Ue === void 0 && (Ue = 1), ve.setLineWidth(Ue * ue()), N.isLineSegments ? tt.setMode(1) : N.isLineLoop ? tt.setMode(2) : tt.setMode(3);
    } else
      N.isPoints ? tt.setMode(0) : N.isSprite && tt.setMode(4);
    if (N.isInstancedMesh)
      tt.renderInstances(He, Lt, N.count);
    else if (U.isInstancedBufferGeometry) {
      const Ue = U._maxInstanceCount !== void 0 ? U._maxInstanceCount : 1 / 0, Ws = Math.min(U.instanceCount, Ue);
      tt.renderInstances(He, Lt, Ws);
    } else
      tt.render(He, Lt);
  }, this.compile = function(_, E) {
    function U(I, N, J) {
      I.transparent === !0 && I.side === as ? (I.side = kt, I.needsUpdate = !0, yt(I, N, J), I.side = Mn, I.needsUpdate = !0, yt(I, N, J), I.side = as) : yt(I, N, J);
    }
    d = A.get(_), d.init(), g.push(d), _.traverseVisible(function(I) {
      I.isLight && I.layers.test(E.layers) && (d.pushLight(I), I.castShadow && d.pushShadow(I));
    }), d.setupLights(p.physicallyCorrectLights), _.traverse(function(I) {
      const N = I.material;
      if (N)
        if (Array.isArray(N))
          for (let J = 0; J < N.length; J++) {
            const Q = N[J];
            U(Q, _, I);
          }
        else
          U(N, _, I);
    }), g.pop(), d = null;
  };
  let q = null;
  function ne(_) {
    q && q(_);
  }
  function me() {
    Ge.stop();
  }
  function Te() {
    Ge.start();
  }
  const Ge = new Ml();
  Ge.setAnimationLoop(ne), typeof self < "u" && Ge.setContext(self), this.setAnimationLoop = function(_) {
    q = _, fe.setAnimationLoop(_), _ === null ? Ge.stop() : Ge.start();
  }, fe.addEventListener("sessionstart", me), fe.addEventListener("sessionend", Te), this.render = function(_, E) {
    if (E !== void 0 && E.isCamera !== !0) {
      console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      return;
    }
    if (f === !0)
      return;
    _.matrixWorldAutoUpdate === !0 && _.updateMatrixWorld(), E.parent === null && E.matrixWorldAutoUpdate === !0 && E.updateMatrixWorld(), fe.enabled === !0 && fe.isPresenting === !0 && (fe.cameraAutoUpdate === !0 && fe.updateCamera(E), E = fe.getCamera()), _.isScene === !0 && _.onBeforeRender(p, _, E, y), d = A.get(_, g.length), d.init(), g.push(d), K.multiplyMatrices(E.projectionMatrix, E.matrixWorldInverse), te.setFromProjectionMatrix(K), re = this.localClippingEnabled, Z = M.init(this.clippingPlanes, re, E), h = at.get(_, m.length), h.init(), m.push(h), it(_, E, 0, p.sortObjects), h.finish(), p.sortObjects === !0 && h.sort(ee, V), Z === !0 && M.beginShadows();
    const U = d.state.shadowsArray;
    if (X.render(U, _, E), Z === !0 && M.endShadows(), this.info.autoReset === !0 && this.info.reset(), ie.render(h, _), d.setupLights(p.physicallyCorrectLights), E.isArrayCamera) {
      const I = E.cameras;
      for (let N = 0, J = I.length; N < J; N++) {
        const Q = I[N];
        ht(h, _, Q, Q.viewport);
      }
    } else
      ht(h, _, E);
    y !== null && (Le.updateMultisampleRenderTarget(y), Le.updateRenderTargetMipmap(y)), _.isScene === !0 && _.onAfterRender(p, _, E), B.resetDefaultState(), b = -1, w = null, g.pop(), g.length > 0 ? d = g[g.length - 1] : d = null, m.pop(), m.length > 0 ? h = m[m.length - 1] : h = null;
  };
  function it(_, E, U, I) {
    if (_.visible === !1)
      return;
    if (_.layers.test(E.layers)) {
      if (_.isGroup)
        U = _.renderOrder;
      else if (_.isLOD)
        _.autoUpdate === !0 && _.update(E);
      else if (_.isLight)
        d.pushLight(_), _.castShadow && d.pushShadow(_);
      else if (_.isSprite) {
        if (!_.frustumCulled || te.intersectsSprite(_)) {
          I && le.setFromMatrixPosition(_.matrixWorld).applyMatrix4(K);
          const Q = $e.update(_), se = _.material;
          se.visible && h.push(_, Q, se, U, le.z, null);
        }
      } else if ((_.isMesh || _.isLine || _.isPoints) && (_.isSkinnedMesh && _.skeleton.frame !== Ae.render.frame && (_.skeleton.update(), _.skeleton.frame = Ae.render.frame), !_.frustumCulled || te.intersectsObject(_))) {
        I && le.setFromMatrixPosition(_.matrixWorld).applyMatrix4(K);
        const Q = $e.update(_), se = _.material;
        if (Array.isArray(se)) {
          const xe = Q.groups;
          for (let ce = 0, Me = xe.length; ce < Me; ce++) {
            const ye = xe[ce], He = se[ye.materialIndex];
            He && He.visible && h.push(_, Q, He, U, le.z, ye);
          }
        } else
          se.visible && h.push(_, Q, se, U, le.z, null);
      }
    }
    const J = _.children;
    for (let Q = 0, se = J.length; Q < se; Q++)
      it(J[Q], E, U, I);
  }
  function ht(_, E, U, I) {
    const N = _.opaque, J = _.transmissive, Q = _.transparent;
    d.setupLightsView(U), J.length > 0 && Qt(N, E, U), I && ve.viewport(D.copy(I)), N.length > 0 && Je(N, E, U), J.length > 0 && Je(J, E, U), Q.length > 0 && Je(Q, E, U), ve.buffers.depth.setTest(!0), ve.buffers.depth.setMask(!0), ve.buffers.color.setMask(!0), ve.setPolygonOffset(!1);
  }
  function Qt(_, E, U) {
    const I = Ce.isWebGL2;
    $ === null && ($ = new Hn(1, 1, {
      generateMipmaps: !0,
      type: be.has("EXT_color_buffer_half_float") ? Yi : kn,
      minFilter: Un,
      samples: I && s === !0 ? 4 : 0
    })), p.getDrawingBufferSize(W), I ? $.setSize(W.x, W.y) : $.setSize(zs(W.x), zs(W.y));
    const N = p.getRenderTarget();
    p.setRenderTarget($), p.clear();
    const J = p.toneMapping;
    p.toneMapping = cn, Je(_, E, U), p.toneMapping = J, Le.updateMultisampleRenderTarget($), Le.updateRenderTargetMipmap($), p.setRenderTarget(N);
  }
  function Je(_, E, U) {
    const I = E.isScene === !0 ? E.overrideMaterial : null;
    for (let N = 0, J = _.length; N < J; N++) {
      const Q = _[N], se = Q.object, xe = Q.geometry, ce = I === null ? Q.material : I, Me = Q.group;
      se.layers.test(U.layers) && Bt(se, E, U, xe, ce, Me);
    }
  }
  function Bt(_, E, U, I, N, J) {
    _.onBeforeRender(p, E, U, I, N, J), _.modelViewMatrix.multiplyMatrices(U.matrixWorldInverse, _.matrixWorld), _.normalMatrix.getNormalMatrix(_.modelViewMatrix), N.onBeforeRender(p, E, U, I, _, J), N.transparent === !0 && N.side === as ? (N.side = kt, N.needsUpdate = !0, p.renderBufferDirect(U, E, I, N, _, J), N.side = Mn, N.needsUpdate = !0, p.renderBufferDirect(U, E, I, N, _, J), N.side = as) : p.renderBufferDirect(U, E, I, N, _, J), _.onAfterRender(p, E, U, I, N, J);
  }
  function yt(_, E, U) {
    E.isScene !== !0 && (E = ae);
    const I = Ee.get(_), N = d.state.lights, J = d.state.shadowsArray, Q = N.state.version, se = ke.getParameters(_, N.state, J, E, U), xe = ke.getProgramCacheKey(se);
    let ce = I.programs;
    I.environment = _.isMeshStandardMaterial ? E.environment : null, I.fog = E.fog, I.envMap = (_.isMeshStandardMaterial ? Qe : st).get(_.envMap || I.environment), ce === void 0 && (_.addEventListener("dispose", ze), ce = /* @__PURE__ */ new Map(), I.programs = ce);
    let Me = ce.get(xe);
    if (Me !== void 0) {
      if (I.currentProgram === Me && I.lightsStateVersion === Q)
        return ss(_, se), Me;
    } else
      se.uniforms = ke.getUniforms(_), _.onBuild(U, se, p), _.onBeforeCompile(se, p), Me = ke.acquireProgram(se, xe), ce.set(xe, Me), I.uniforms = se.uniforms;
    const ye = I.uniforms;
    (!_.isShaderMaterial && !_.isRawShaderMaterial || _.clipping === !0) && (ye.clippingPlanes = M.uniform), ss(_, se), I.needsLights = L(_), I.lightsStateVersion = Q, I.needsLights && (ye.ambientLightColor.value = N.state.ambient, ye.lightProbe.value = N.state.probe, ye.directionalLights.value = N.state.directional, ye.directionalLightShadows.value = N.state.directionalShadow, ye.spotLights.value = N.state.spot, ye.spotLightShadows.value = N.state.spotShadow, ye.rectAreaLights.value = N.state.rectArea, ye.ltc_1.value = N.state.rectAreaLTC1, ye.ltc_2.value = N.state.rectAreaLTC2, ye.pointLights.value = N.state.point, ye.pointLightShadows.value = N.state.pointShadow, ye.hemisphereLights.value = N.state.hemi, ye.directionalShadowMap.value = N.state.directionalShadowMap, ye.directionalShadowMatrix.value = N.state.directionalShadowMatrix, ye.spotShadowMap.value = N.state.spotShadowMap, ye.spotLightMatrix.value = N.state.spotLightMatrix, ye.spotLightMap.value = N.state.spotLightMap, ye.pointShadowMap.value = N.state.pointShadowMap, ye.pointShadowMatrix.value = N.state.pointShadowMatrix);
    const He = Me.getUniforms(), Be = Is.seqWithValue(He.seq, ye);
    return I.currentProgram = Me, I.uniformsList = Be, Me;
  }
  function ss(_, E) {
    const U = Ee.get(_);
    U.outputEncoding = E.outputEncoding, U.instancing = E.instancing, U.skinning = E.skinning, U.morphTargets = E.morphTargets, U.morphNormals = E.morphNormals, U.morphColors = E.morphColors, U.morphTargetsCount = E.morphTargetsCount, U.numClippingPlanes = E.numClippingPlanes, U.numIntersection = E.numClipIntersection, U.vertexAlphas = E.vertexAlphas, U.vertexTangents = E.vertexTangents, U.toneMapping = E.toneMapping;
  }
  function rs(_, E, U, I, N) {
    E.isScene !== !0 && (E = ae), Le.resetTextureUnits();
    const J = E.fog, Q = I.isMeshStandardMaterial ? E.environment : null, se = y === null ? p.outputEncoding : y.isXRRenderTarget === !0 ? y.texture.encoding : Bn, xe = (I.isMeshStandardMaterial ? Qe : st).get(I.envMap || Q), ce = I.vertexColors === !0 && !!U.attributes.color && U.attributes.color.itemSize === 4, Me = !!I.normalMap && !!U.attributes.tangent, ye = !!U.morphAttributes.position, He = !!U.morphAttributes.normal, Be = !!U.morphAttributes.color, Lt = I.toneMapped ? p.toneMapping : cn, bt = U.morphAttributes.position || U.morphAttributes.normal || U.morphAttributes.color, tt = bt !== void 0 ? bt.length : 0, Ue = Ee.get(I), Ws = d.state.lights;
    if (Z === !0 && (re === !0 || _ !== w)) {
      const Rt = _ === w && I.id === b;
      M.setState(I, _, Rt);
    }
    let ut = !1;
    I.version === Ue.__version ? (Ue.needsLights && Ue.lightsStateVersion !== Ws.state.version || Ue.outputEncoding !== se || N.isInstancedMesh && Ue.instancing === !1 || !N.isInstancedMesh && Ue.instancing === !0 || N.isSkinnedMesh && Ue.skinning === !1 || !N.isSkinnedMesh && Ue.skinning === !0 || Ue.envMap !== xe || I.fog === !0 && Ue.fog !== J || Ue.numClippingPlanes !== void 0 && (Ue.numClippingPlanes !== M.numPlanes || Ue.numIntersection !== M.numIntersection) || Ue.vertexAlphas !== ce || Ue.vertexTangents !== Me || Ue.morphTargets !== ye || Ue.morphNormals !== He || Ue.morphColors !== Be || Ue.toneMapping !== Lt || Ce.isWebGL2 === !0 && Ue.morphTargetsCount !== tt) && (ut = !0) : (ut = !0, Ue.__version = I.version);
    let wn = Ue.currentProgram;
    ut === !0 && (wn = yt(I, E, N));
    let ha = !1, Li = !1, js = !1;
    const Mt = wn.getUniforms(), Sn = Ue.uniforms;
    if (ve.useProgram(wn.program) && (ha = !0, Li = !0, js = !0), I.id !== b && (b = I.id, Li = !0), ha || w !== _) {
      if (Mt.setValue(Y, "projectionMatrix", _.projectionMatrix), Ce.logarithmicDepthBuffer && Mt.setValue(
        Y,
        "logDepthBufFC",
        2 / (Math.log(_.far + 1) / Math.LN2)
      ), w !== _ && (w = _, Li = !0, js = !0), I.isShaderMaterial || I.isMeshPhongMaterial || I.isMeshToonMaterial || I.isMeshStandardMaterial || I.envMap) {
        const Rt = Mt.map.cameraPosition;
        Rt !== void 0 && Rt.setValue(
          Y,
          le.setFromMatrixPosition(_.matrixWorld)
        );
      }
      (I.isMeshPhongMaterial || I.isMeshToonMaterial || I.isMeshLambertMaterial || I.isMeshBasicMaterial || I.isMeshStandardMaterial || I.isShaderMaterial) && Mt.setValue(Y, "isOrthographic", _.isOrthographicCamera === !0), (I.isMeshPhongMaterial || I.isMeshToonMaterial || I.isMeshLambertMaterial || I.isMeshBasicMaterial || I.isMeshStandardMaterial || I.isShaderMaterial || I.isShadowMaterial || N.isSkinnedMesh) && Mt.setValue(Y, "viewMatrix", _.matrixWorldInverse);
    }
    if (N.isSkinnedMesh) {
      Mt.setOptional(Y, N, "bindMatrix"), Mt.setOptional(Y, N, "bindMatrixInverse");
      const Rt = N.skeleton;
      Rt && (Ce.floatVertexTextures ? (Rt.boneTexture === null && Rt.computeBoneTexture(), Mt.setValue(Y, "boneTexture", Rt.boneTexture, Le), Mt.setValue(Y, "boneTextureSize", Rt.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
    }
    const Xs = U.morphAttributes;
    if ((Xs.position !== void 0 || Xs.normal !== void 0 || Xs.color !== void 0 && Ce.isWebGL2 === !0) && oe.update(N, U, I, wn), (Li || Ue.receiveShadow !== N.receiveShadow) && (Ue.receiveShadow = N.receiveShadow, Mt.setValue(Y, "receiveShadow", N.receiveShadow)), I.isMeshGouraudMaterial && I.envMap !== null && (Sn.envMap.value = xe, Sn.flipEnvMap.value = xe.isCubeTexture && xe.isRenderTargetTexture === !1 ? -1 : 1), Li && (Mt.setValue(Y, "toneMappingExposure", p.toneMappingExposure), Ue.needsLights && P(Sn, js), J && I.fog === !0 && xt.refreshFogUniforms(Sn, J), xt.refreshMaterialUniforms(Sn, I, T, k, $), Is.upload(Y, Ue.uniformsList, Sn, Le)), I.isShaderMaterial && I.uniformsNeedUpdate === !0 && (Is.upload(Y, Ue.uniformsList, Sn, Le), I.uniformsNeedUpdate = !1), I.isSpriteMaterial && Mt.setValue(Y, "center", N.center), Mt.setValue(Y, "modelViewMatrix", N.modelViewMatrix), Mt.setValue(Y, "normalMatrix", N.normalMatrix), Mt.setValue(Y, "modelMatrix", N.matrixWorld), I.isShaderMaterial || I.isRawShaderMaterial) {
      const Rt = I.uniformsGroups;
      for (let qs = 0, Ul = Rt.length; qs < Ul; qs++)
        if (Ce.isWebGL2) {
          const ua = Rt[qs];
          pe.update(ua, wn), pe.bind(ua, wn);
        } else
          console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
    }
    return wn;
  }
  function P(_, E) {
    _.ambientLightColor.needsUpdate = E, _.lightProbe.needsUpdate = E, _.directionalLights.needsUpdate = E, _.directionalLightShadows.needsUpdate = E, _.pointLights.needsUpdate = E, _.pointLightShadows.needsUpdate = E, _.spotLights.needsUpdate = E, _.spotLightShadows.needsUpdate = E, _.rectAreaLights.needsUpdate = E, _.hemisphereLights.needsUpdate = E;
  }
  function L(_) {
    return _.isMeshLambertMaterial || _.isMeshToonMaterial || _.isMeshPhongMaterial || _.isMeshStandardMaterial || _.isShadowMaterial || _.isShaderMaterial && _.lights === !0;
  }
  this.getActiveCubeFace = function() {
    return v;
  }, this.getActiveMipmapLevel = function() {
    return S;
  }, this.getRenderTarget = function() {
    return y;
  }, this.setRenderTargetTextures = function(_, E, U) {
    Ee.get(_.texture).__webglTexture = E, Ee.get(_.depthTexture).__webglTexture = U;
    const I = Ee.get(_);
    I.__hasExternalTextures = !0, I.__hasExternalTextures && (I.__autoAllocateDepthBuffer = U === void 0, I.__autoAllocateDepthBuffer || be.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), I.__useRenderToTexture = !1));
  }, this.setRenderTargetFramebuffer = function(_, E) {
    const U = Ee.get(_);
    U.__webglFramebuffer = E, U.__useDefaultFramebuffer = E === void 0;
  }, this.setRenderTarget = function(_, E = 0, U = 0) {
    y = _, v = E, S = U;
    let I = !0, N = null, J = !1, Q = !1;
    if (_) {
      const xe = Ee.get(_);
      xe.__useDefaultFramebuffer !== void 0 ? (ve.bindFramebuffer(36160, null), I = !1) : xe.__webglFramebuffer === void 0 ? Le.setupRenderTarget(_) : xe.__hasExternalTextures && Le.rebindTextures(_, Ee.get(_.texture).__webglTexture, Ee.get(_.depthTexture).__webglTexture);
      const ce = _.texture;
      (ce.isData3DTexture || ce.isDataArrayTexture || ce.isCompressedArrayTexture) && (Q = !0);
      const Me = Ee.get(_).__webglFramebuffer;
      _.isWebGLCubeRenderTarget ? (N = Me[E], J = !0) : Ce.isWebGL2 && _.samples > 0 && Le.useMultisampledRTT(_) === !1 ? N = Ee.get(_).__webglMultisampledFramebuffer : N = Me, D.copy(_.viewport), z.copy(_.scissor), x = _.scissorTest;
    } else
      D.copy(H).multiplyScalar(T).floor(), z.copy(j).multiplyScalar(T).floor(), x = G;
    if (ve.bindFramebuffer(36160, N) && Ce.drawBuffers && I && ve.drawBuffers(_, N), ve.viewport(D), ve.scissor(z), ve.setScissorTest(x), J) {
      const xe = Ee.get(_.texture);
      Y.framebufferTexture2D(36160, 36064, 34069 + E, xe.__webglTexture, U);
    } else if (Q) {
      const xe = Ee.get(_.texture), ce = E || 0;
      Y.framebufferTextureLayer(36160, 36064, xe.__webglTexture, U || 0, ce);
    }
    b = -1;
  }, this.readRenderTargetPixels = function(_, E, U, I, N, J, Q) {
    if (!(_ && _.isWebGLRenderTarget)) {
      console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      return;
    }
    let se = Ee.get(_).__webglFramebuffer;
    if (_.isWebGLCubeRenderTarget && Q !== void 0 && (se = se[Q]), se) {
      ve.bindFramebuffer(36160, se);
      try {
        const xe = _.texture, ce = xe.format, Me = xe.type;
        if (ce !== zt && C.convert(ce) !== Y.getParameter(35739)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          return;
        }
        const ye = Me === Yi && (be.has("EXT_color_buffer_half_float") || Ce.isWebGL2 && be.has("EXT_color_buffer_float"));
        if (Me !== kn && C.convert(Me) !== Y.getParameter(35738) && !(Me === xn && (Ce.isWebGL2 || be.has("OES_texture_float") || be.has("WEBGL_color_buffer_float"))) && !ye) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          return;
        }
        E >= 0 && E <= _.width - I && U >= 0 && U <= _.height - N && Y.readPixels(E, U, I, N, C.convert(ce), C.convert(Me), J);
      } finally {
        const xe = y !== null ? Ee.get(y).__webglFramebuffer : null;
        ve.bindFramebuffer(36160, xe);
      }
    }
  }, this.copyFramebufferToTexture = function(_, E, U = 0) {
    const I = Math.pow(2, -U), N = Math.floor(E.image.width * I), J = Math.floor(E.image.height * I);
    Le.setTexture2D(E, 0), Y.copyTexSubImage2D(3553, U, 0, 0, _.x, _.y, N, J), ve.unbindTexture();
  }, this.copyTextureToTexture = function(_, E, U, I = 0) {
    const N = E.image.width, J = E.image.height, Q = C.convert(U.format), se = C.convert(U.type);
    Le.setTexture2D(U, 0), Y.pixelStorei(37440, U.flipY), Y.pixelStorei(37441, U.premultiplyAlpha), Y.pixelStorei(3317, U.unpackAlignment), E.isDataTexture ? Y.texSubImage2D(3553, I, _.x, _.y, N, J, Q, se, E.image.data) : E.isCompressedTexture ? Y.compressedTexSubImage2D(3553, I, _.x, _.y, E.mipmaps[0].width, E.mipmaps[0].height, Q, E.mipmaps[0].data) : Y.texSubImage2D(3553, I, _.x, _.y, Q, se, E.image), I === 0 && U.generateMipmaps && Y.generateMipmap(3553), ve.unbindTexture();
  }, this.copyTextureToTexture3D = function(_, E, U, I, N = 0) {
    if (p.isWebGL1Renderer) {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      return;
    }
    const J = _.max.x - _.min.x + 1, Q = _.max.y - _.min.y + 1, se = _.max.z - _.min.z + 1, xe = C.convert(I.format), ce = C.convert(I.type);
    let Me;
    if (I.isData3DTexture)
      Le.setTexture3D(I, 0), Me = 32879;
    else if (I.isDataArrayTexture)
      Le.setTexture2DArray(I, 0), Me = 35866;
    else {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      return;
    }
    Y.pixelStorei(37440, I.flipY), Y.pixelStorei(37441, I.premultiplyAlpha), Y.pixelStorei(3317, I.unpackAlignment);
    const ye = Y.getParameter(3314), He = Y.getParameter(32878), Be = Y.getParameter(3316), Lt = Y.getParameter(3315), bt = Y.getParameter(32877), tt = U.isCompressedTexture ? U.mipmaps[0] : U.image;
    Y.pixelStorei(3314, tt.width), Y.pixelStorei(32878, tt.height), Y.pixelStorei(3316, _.min.x), Y.pixelStorei(3315, _.min.y), Y.pixelStorei(32877, _.min.z), U.isDataTexture || U.isData3DTexture ? Y.texSubImage3D(Me, N, E.x, E.y, E.z, J, Q, se, xe, ce, tt.data) : U.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), Y.compressedTexSubImage3D(Me, N, E.x, E.y, E.z, J, Q, se, xe, tt.data)) : Y.texSubImage3D(Me, N, E.x, E.y, E.z, J, Q, se, xe, ce, tt), Y.pixelStorei(3314, ye), Y.pixelStorei(32878, He), Y.pixelStorei(3316, Be), Y.pixelStorei(3315, Lt), Y.pixelStorei(32877, bt), N === 0 && I.generateMipmaps && Y.generateMipmap(Me), ve.unbindTexture();
  }, this.initTexture = function(_) {
    _.isCubeTexture ? Le.setTextureCube(_, 0) : _.isData3DTexture ? Le.setTexture3D(_, 0) : _.isDataArrayTexture || _.isCompressedArrayTexture ? Le.setTexture2DArray(_, 0) : Le.setTexture2D(_, 0), ve.unbindTexture();
  }, this.resetState = function() {
    v = 0, S = 0, y = null, ve.reset(), B.reset();
  }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
}
class Hm extends El {
}
Hm.prototype.isWebGL1Renderer = !0;
class na {
  constructor(e, t = 25e-5) {
    this.isFogExp2 = !0, this.name = "", this.color = new De(e), this.density = t;
  }
  clone() {
    return new na(this.color, this.density);
  }
  toJSON() {
    return {
      type: "FogExp2",
      color: this.color.getHex(),
      density: this.density
    };
  }
}
class Vm extends nt {
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, t) {
    return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.backgroundIntensity = this.backgroundIntensity), t;
  }
  get autoUpdate() {
    return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
  }
  set autoUpdate(e) {
    console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = e;
  }
}
class Gm {
  constructor(e, t) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = Ur, this.updateRange = { offset: 0, count: -1 }, this.version = 0, this.uuid = jt();
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  copyAt(e, t, n) {
    e *= this.stride, n *= t.stride;
    for (let i = 0, s = this.stride; i < s; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = jt()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
    return n.setUsage(this.usage), n;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = jt()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const St = /* @__PURE__ */ new F();
class ia {
  constructor(e, t, n, i = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = n, this.normalized = i;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  applyMatrix4(e) {
    for (let t = 0, n = this.data.count; t < n; t++)
      St.fromBufferAttribute(this, t), St.applyMatrix4(e), this.setXYZ(t, St.x, St.y, St.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      St.fromBufferAttribute(this, t), St.applyNormalMatrix(e), this.setXYZ(t, St.x, St.y, St.z);
    return this;
  }
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      St.fromBufferAttribute(this, t), St.transformDirection(e), this.setXYZ(t, St.x, St.y, St.z);
    return this;
  }
  setX(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
  }
  setY(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
  }
  setZ(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
  }
  setW(e, t) {
    return this.normalized && (t = Ke(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
  }
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (t = ln(t, this.array)), t;
  }
  setXY(e, t, n) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
  }
  setXYZ(e, t, n, i) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array), i = Ke(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this;
  }
  setXYZW(e, t, n, i, s) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = Ke(t, this.array), n = Ke(n, this.array), i = Ke(i, this.array), s = Ke(s, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this.data.array[e + 3] = s, this;
  }
  clone(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let s = 0; s < this.itemSize; s++)
          t.push(this.data.array[i + s]);
      }
      return new gt(new this.array.constructor(t), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new ia(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  toJSON(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let s = 0; s < this.itemSize; s++)
          t.push(this.data.array[i + s]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
const wo = /* @__PURE__ */ new F(), So = /* @__PURE__ */ new Ze(), To = /* @__PURE__ */ new Ze(), Wm = /* @__PURE__ */ new F(), Ao = /* @__PURE__ */ new Fe();
class jm extends Ut {
  constructor(e, t) {
    super(e, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = "attached", this.bindMatrix = new Fe(), this.bindMatrixInverse = new Fe();
  }
  copy(e, t) {
    return super.copy(e, t), this.bindMode = e.bindMode, this.bindMatrix.copy(e.bindMatrix), this.bindMatrixInverse.copy(e.bindMatrixInverse), this.skeleton = e.skeleton, this;
  }
  bind(e, t) {
    this.skeleton = e, t === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const e = new Ze(), t = this.geometry.attributes.skinWeight;
    for (let n = 0, i = t.count; n < i; n++) {
      e.fromBufferAttribute(t, n);
      const s = 1 / e.manhattanLength();
      s !== 1 / 0 ? e.multiplyScalar(s) : e.set(1, 0, 0, 0), t.setXYZW(n, e.x, e.y, e.z, e.w);
    }
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.bindMode === "attached" ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === "detached" ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
  }
  boneTransform(e, t) {
    const n = this.skeleton, i = this.geometry;
    So.fromBufferAttribute(i.attributes.skinIndex, e), To.fromBufferAttribute(i.attributes.skinWeight, e), wo.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
    for (let s = 0; s < 4; s++) {
      const a = To.getComponent(s);
      if (a !== 0) {
        const o = So.getComponent(s);
        Ao.multiplyMatrices(n.bones[o].matrixWorld, n.boneInverses[o]), t.addScaledVector(Wm.copy(wo).applyMatrix4(Ao), a);
      }
    }
    return t.applyMatrix4(this.bindMatrixInverse);
  }
}
class Cl extends nt {
  constructor() {
    super(), this.isBone = !0, this.type = "Bone";
  }
}
class Ll extends mt {
  constructor(e = null, t = 1, n = 1, i, s, a, o, l, c = ft, u = ft, h, d) {
    super(null, a, o, l, c, u, i, s, h, d), this.isDataTexture = !0, this.image = { data: e, width: t, height: n }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
const Eo = /* @__PURE__ */ new Fe(), Xm = /* @__PURE__ */ new Fe();
class sa {
  constructor(e = [], t = []) {
    this.uuid = jt(), this.bones = e.slice(0), this.boneInverses = t, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
  }
  init() {
    const e = this.bones, t = this.boneInverses;
    if (this.boneMatrices = new Float32Array(e.length * 16), t.length === 0)
      this.calculateInverses();
    else if (e.length !== t.length) {
      console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
      for (let n = 0, i = this.bones.length; n < i; n++)
        this.boneInverses.push(new Fe());
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = new Fe();
      this.bones[e] && n.copy(this.bones[e].matrixWorld).invert(), this.boneInverses.push(n);
    }
  }
  pose() {
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = this.bones[e];
      n && n.matrixWorld.copy(this.boneInverses[e]).invert();
    }
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const n = this.bones[e];
      n && (n.parent && n.parent.isBone ? (n.matrix.copy(n.parent.matrixWorld).invert(), n.matrix.multiply(n.matrixWorld)) : n.matrix.copy(n.matrixWorld), n.matrix.decompose(n.position, n.quaternion, n.scale));
    }
  }
  update() {
    const e = this.bones, t = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
    for (let s = 0, a = e.length; s < a; s++) {
      const o = e[s] ? e[s].matrixWorld : Xm;
      Eo.multiplyMatrices(o, t[s]), Eo.toArray(n, s * 16);
    }
    i !== null && (i.needsUpdate = !0);
  }
  clone() {
    return new sa(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let e = Math.sqrt(this.bones.length * 4);
    e = hl(e), e = Math.max(e, 4);
    const t = new Float32Array(e * e * 4);
    t.set(this.boneMatrices);
    const n = new Ll(t, e, e, zt, xn);
    return n.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = n, this.boneTextureSize = e, this;
  }
  getBoneByName(e) {
    for (let t = 0, n = this.bones.length; t < n; t++) {
      const i = this.bones[t];
      if (i.name === e)
        return i;
    }
  }
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
  }
  fromJSON(e, t) {
    this.uuid = e.uuid;
    for (let n = 0, i = e.bones.length; n < i; n++) {
      const s = e.bones[n];
      let a = t[s];
      a === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", s), a = new Cl()), this.bones.push(a), this.boneInverses.push(new Fe().fromArray(e.boneInverses[n]));
    }
    return this.init(), this;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.5,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    e.uuid = this.uuid;
    const t = this.bones, n = this.boneInverses;
    for (let i = 0, s = t.length; i < s; i++) {
      const a = t[i];
      e.bones.push(a.uuid);
      const o = n[i];
      e.boneInverses.push(o.toArray());
    }
    return e;
  }
}
class Co extends gt {
  constructor(e, t, n, i = 1) {
    super(e, t, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
  }
}
const Lo = /* @__PURE__ */ new Fe(), Ro = /* @__PURE__ */ new Fe(), Ts = [], qm = /* @__PURE__ */ new Fe(), zi = /* @__PURE__ */ new Ut();
class Ym extends Ut {
  constructor(e, t, n) {
    super(e, t), this.isInstancedMesh = !0, this.instanceMatrix = new Co(new Float32Array(n * 16), 16), this.instanceColor = null, this.count = n, this.frustumCulled = !1;
    for (let i = 0; i < n; i++)
      this.setMatrixAt(i, qm);
  }
  copy(e, t) {
    return super.copy(e, t), this.instanceMatrix.copy(e.instanceMatrix), e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()), this.count = e.count, this;
  }
  getColorAt(e, t) {
    t.fromArray(this.instanceColor.array, e * 3);
  }
  getMatrixAt(e, t) {
    t.fromArray(this.instanceMatrix.array, e * 16);
  }
  raycast(e, t) {
    const n = this.matrixWorld, i = this.count;
    if (zi.geometry = this.geometry, zi.material = this.material, zi.material !== void 0)
      for (let s = 0; s < i; s++) {
        this.getMatrixAt(s, Lo), Ro.multiplyMatrices(n, Lo), zi.matrixWorld = Ro, zi.raycast(e, Ts);
        for (let a = 0, o = Ts.length; a < o; a++) {
          const l = Ts[a];
          l.instanceId = s, l.object = this, t.push(l);
        }
        Ts.length = 0;
      }
  }
  setColorAt(e, t) {
    this.instanceColor === null && (this.instanceColor = new Co(new Float32Array(this.instanceMatrix.count * 3), 3)), t.toArray(this.instanceColor.array, e * 3);
  }
  setMatrixAt(e, t) {
    t.toArray(this.instanceMatrix.array, e * 16);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class Rl extends Xt {
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new De(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const Po = /* @__PURE__ */ new F(), Do = /* @__PURE__ */ new F(), Io = /* @__PURE__ */ new Fe(), Sr = /* @__PURE__ */ new $r(), As = /* @__PURE__ */ new Si();
class ra extends nt {
  constructor(e = new Yt(), t = new Rl()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = e.material, this.geometry = e.geometry, this;
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, n = [0];
      for (let i = 1, s = t.count; i < s; i++)
        Po.fromBufferAttribute(t, i - 1), Do.fromBufferAttribute(t, i), n[i] = n[i - 1], n[i] += Po.distanceTo(Do);
      e.setAttribute("lineDistance", new hn(n, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, s = e.params.Line.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), As.copy(n.boundingSphere), As.applyMatrix4(i), As.radius += s, e.ray.intersectsSphere(As) === !1)
      return;
    Io.copy(i).invert(), Sr.copy(e.ray).applyMatrix4(Io);
    const o = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = new F(), u = new F(), h = new F(), d = new F(), m = this.isLineSegments ? 2 : 1, g = n.index, f = n.attributes.position;
    if (g !== null) {
      const v = Math.max(0, a.start), S = Math.min(g.count, a.start + a.count);
      for (let y = v, b = S - 1; y < b; y += m) {
        const w = g.getX(y), D = g.getX(y + 1);
        if (c.fromBufferAttribute(f, w), u.fromBufferAttribute(f, D), Sr.distanceSqToSegment(c, u, d, h) > l)
          continue;
        d.applyMatrix4(this.matrixWorld);
        const x = e.ray.origin.distanceTo(d);
        x < e.near || x > e.far || t.push({
          distance: x,
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: y,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    } else {
      const v = Math.max(0, a.start), S = Math.min(f.count, a.start + a.count);
      for (let y = v, b = S - 1; y < b; y += m) {
        if (c.fromBufferAttribute(f, y), u.fromBufferAttribute(f, y + 1), Sr.distanceSqToSegment(c, u, d, h) > l)
          continue;
        d.applyMatrix4(this.matrixWorld);
        const D = e.ray.origin.distanceTo(d);
        D < e.near || D > e.far || t.push({
          distance: D,
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: y,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    }
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
}
const Oo = /* @__PURE__ */ new F(), No = /* @__PURE__ */ new F();
class Km extends ra {
  constructor(e, t) {
    super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, n = [];
      for (let i = 0, s = t.count; i < s; i += 2)
        Oo.fromBufferAttribute(t, i), No.fromBufferAttribute(t, i + 1), n[i] = i === 0 ? 0 : n[i - 1], n[i + 1] = n[i] + Oo.distanceTo(No);
      e.setAttribute("lineDistance", new hn(n, 1));
    } else
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class Zm extends ra {
  constructor(e, t) {
    super(e, t), this.isLineLoop = !0, this.type = "LineLoop";
  }
}
class Pl extends Xt {
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new De(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
const Fo = /* @__PURE__ */ new Fe(), Vr = /* @__PURE__ */ new $r(), Es = /* @__PURE__ */ new Si(), Cs = /* @__PURE__ */ new F();
class $m extends nt {
  constructor(e = new Yt(), t = new Pl()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = t, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = e.material, this.geometry = e.geometry, this;
  }
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, s = e.params.Points.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), Es.copy(n.boundingSphere), Es.applyMatrix4(i), Es.radius += s, e.ray.intersectsSphere(Es) === !1)
      return;
    Fo.copy(i).invert(), Vr.copy(e.ray).applyMatrix4(Fo);
    const o = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = o * o, c = n.index, h = n.attributes.position;
    if (c !== null) {
      const d = Math.max(0, a.start), m = Math.min(c.count, a.start + a.count);
      for (let g = d, p = m; g < p; g++) {
        const f = c.getX(g);
        Cs.fromBufferAttribute(h, f), zo(Cs, f, l, i, e, t, this);
      }
    } else {
      const d = Math.max(0, a.start), m = Math.min(h.count, a.start + a.count);
      for (let g = d, p = m; g < p; g++)
        Cs.fromBufferAttribute(h, g), zo(Cs, g, l, i, e, t, this);
    }
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
}
function zo(r, e, t, n, i, s, a) {
  const o = Vr.distanceSqToPoint(r);
  if (o < t) {
    const l = new F();
    Vr.closestPointToPoint(r, l), l.applyMatrix4(n);
    const c = i.ray.origin.distanceTo(l);
    if (c < i.near || c > i.far)
      return;
    s.push({
      distance: c,
      distanceToRay: Math.sqrt(o),
      point: l,
      index: e,
      face: null,
      object: a
    });
  }
}
class aa extends Xt {
  constructor(e) {
    super(), this.isMeshStandardMaterial = !0, this.defines = { STANDARD: "" }, this.type = "MeshStandardMaterial", this.color = new De(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new De(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Kr, this.normalScale = new Pe(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class Xn extends aa {
  constructor(e) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Pe(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return vt(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(t) {
        this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new De(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new De(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new De(1, 1, 1), this.specularColorMap = null, this._sheen = 0, this._clearcoat = 0, this._iridescence = 0, this._transmission = 0, this.setValues(e);
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
  }
  copy(e) {
    return super.copy(e), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [...e.iridescenceThicknessRange], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
  }
}
class Tr extends Xt {
  constructor(e) {
    super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new De(16777215), this.specular = new De(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new De(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Kr, this.normalScale = new Pe(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Yr, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
function gn(r, e, t) {
  return Dl(r) ? new r.constructor(r.subarray(e, t !== void 0 ? t : r.length)) : r.slice(e, t);
}
function Ls(r, e, t) {
  return !r || !t && r.constructor === e ? r : typeof e.BYTES_PER_ELEMENT == "number" ? new e(r) : Array.prototype.slice.call(r);
}
function Dl(r) {
  return ArrayBuffer.isView(r) && !(r instanceof DataView);
}
function Jm(r) {
  function e(i, s) {
    return r[i] - r[s];
  }
  const t = r.length, n = new Array(t);
  for (let i = 0; i !== t; ++i)
    n[i] = i;
  return n.sort(e), n;
}
function Uo(r, e, t) {
  const n = r.length, i = new r.constructor(n);
  for (let s = 0, a = 0; a !== n; ++s) {
    const o = t[s] * e;
    for (let l = 0; l !== e; ++l)
      i[a++] = r[o + l];
  }
  return i;
}
function Il(r, e, t, n) {
  let i = 1, s = r[0];
  for (; s !== void 0 && s[n] === void 0; )
    s = r[i++];
  if (s === void 0)
    return;
  let a = s[n];
  if (a !== void 0)
    if (Array.isArray(a))
      do
        a = s[n], a !== void 0 && (e.push(s.time), t.push.apply(t, a)), s = r[i++];
      while (s !== void 0);
    else if (a.toArray !== void 0)
      do
        a = s[n], a !== void 0 && (e.push(s.time), a.toArray(t, t.length)), s = r[i++];
      while (s !== void 0);
    else
      do
        a = s[n], a !== void 0 && (e.push(s.time), t.push(a)), s = r[i++];
      while (s !== void 0);
}
class is {
  constructor(e, t, n, i) {
    this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new t.constructor(n), this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
  }
  evaluate(e) {
    const t = this.parameterPositions;
    let n = this._cachedIndex, i = t[n], s = t[n - 1];
    n: {
      e: {
        let a;
        t: {
          i:
            if (!(e < i)) {
              for (let o = n + 2; ; ) {
                if (i === void 0) {
                  if (e < s)
                    break i;
                  return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                }
                if (n === o)
                  break;
                if (s = i, i = t[++n], e < i)
                  break e;
              }
              a = t.length;
              break t;
            }
          if (!(e >= s)) {
            const o = t[1];
            e < o && (n = 2, s = o);
            for (let l = n - 2; ; ) {
              if (s === void 0)
                return this._cachedIndex = 0, this.copySampleValue_(0);
              if (n === l)
                break;
              if (i = s, s = t[--n - 1], e >= s)
                break e;
            }
            a = n, n = 0;
            break t;
          }
          break n;
        }
        for (; n < a; ) {
          const o = n + a >>> 1;
          e < t[o] ? a = o : n = o + 1;
        }
        if (i = t[n], s = t[n - 1], s === void 0)
          return this._cachedIndex = 0, this.copySampleValue_(0);
        if (i === void 0)
          return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
      }
      this._cachedIndex = n, this.intervalChanged_(n, s, i);
    }
    return this.interpolate_(n, s, e, i);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(e) {
    const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, s = e * i;
    for (let a = 0; a !== i; ++a)
      t[a] = n[s + a];
    return t;
  }
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
class Qm extends is {
  constructor(e, t, n, i) {
    super(e, t, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
      endingStart: ka,
      endingEnd: ka
    };
  }
  intervalChanged_(e, t, n) {
    const i = this.parameterPositions;
    let s = e - 2, a = e + 1, o = i[s], l = i[a];
    if (o === void 0)
      switch (this.getSettings_().endingStart) {
        case Ba:
          s = e, o = 2 * t - n;
          break;
        case Ha:
          s = i.length - 2, o = t + i[s] - i[s + 1];
          break;
        default:
          s = e, o = n;
      }
    if (l === void 0)
      switch (this.getSettings_().endingEnd) {
        case Ba:
          a = e, l = 2 * n - t;
          break;
        case Ha:
          a = 1, l = n + i[1] - i[0];
          break;
        default:
          a = e - 1, l = t;
      }
    const c = (n - t) * 0.5, u = this.valueSize;
    this._weightPrev = c / (t - o), this._weightNext = c / (l - n), this._offsetPrev = s * u, this._offsetNext = a * u;
  }
  interpolate_(e, t, n, i) {
    const s = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, u = this._offsetPrev, h = this._offsetNext, d = this._weightPrev, m = this._weightNext, g = (n - t) / (i - t), p = g * g, f = p * g, v = -d * f + 2 * d * p - d * g, S = (1 + d) * f + (-1.5 - 2 * d) * p + (-0.5 + d) * g + 1, y = (-1 - m) * f + (1.5 + m) * p + 0.5 * g, b = m * f - m * p;
    for (let w = 0; w !== o; ++w)
      s[w] = v * a[u + w] + S * a[c + w] + y * a[l + w] + b * a[h + w];
    return s;
  }
}
class eg extends is {
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e, t, n, i) {
    const s = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = e * o, c = l - o, u = (n - t) / (i - t), h = 1 - u;
    for (let d = 0; d !== o; ++d)
      s[d] = a[c + d] * h + a[l + d] * u;
    return s;
  }
}
class tg extends is {
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1);
  }
}
class Jt {
  constructor(e, t, n, i) {
    if (e === void 0)
      throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (t === void 0 || t.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
    this.name = e, this.times = Ls(t, this.TimeBufferType), this.values = Ls(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
  }
  static toJSON(e) {
    const t = e.constructor;
    let n;
    if (t.toJSON !== this.toJSON)
      n = t.toJSON(e);
    else {
      n = {
        name: e.name,
        times: Ls(e.times, Array),
        values: Ls(e.values, Array)
      };
      const i = e.getInterpolation();
      i !== e.DefaultInterpolation && (n.interpolation = i);
    }
    return n.type = e.ValueTypeName, n;
  }
  InterpolantFactoryMethodDiscrete(e) {
    return new tg(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodLinear(e) {
    return new eg(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodSmooth(e) {
    return new Qm(this.times, this.values, this.getValueSize(), e);
  }
  setInterpolation(e) {
    let t;
    switch (e) {
      case Ki:
        t = this.InterpolantFactoryMethodDiscrete;
        break;
      case yi:
        t = this.InterpolantFactoryMethodLinear;
        break;
      case Js:
        t = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (t === void 0) {
      const n = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0)
        if (e !== this.DefaultInterpolation)
          this.setInterpolation(this.DefaultInterpolation);
        else
          throw new Error(n);
      return console.warn("THREE.KeyframeTrack:", n), this;
    }
    return this.createInterpolant = t, this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return Ki;
      case this.InterpolantFactoryMethodLinear:
        return yi;
      case this.InterpolantFactoryMethodSmooth:
        return Js;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  shift(e) {
    if (e !== 0) {
      const t = this.times;
      for (let n = 0, i = t.length; n !== i; ++n)
        t[n] += e;
    }
    return this;
  }
  scale(e) {
    if (e !== 1) {
      const t = this.times;
      for (let n = 0, i = t.length; n !== i; ++n)
        t[n] *= e;
    }
    return this;
  }
  trim(e, t) {
    const n = this.times, i = n.length;
    let s = 0, a = i - 1;
    for (; s !== i && n[s] < e; )
      ++s;
    for (; a !== -1 && n[a] > t; )
      --a;
    if (++a, s !== 0 || a !== i) {
      s >= a && (a = Math.max(a, 1), s = a - 1);
      const o = this.getValueSize();
      this.times = gn(n, s, a), this.values = gn(this.values, s * o, a * o);
    }
    return this;
  }
  validate() {
    let e = !0;
    const t = this.getValueSize();
    t - Math.floor(t) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e = !1);
    const n = this.times, i = this.values, s = n.length;
    s === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), e = !1);
    let a = null;
    for (let o = 0; o !== s; o++) {
      const l = n[o];
      if (typeof l == "number" && isNaN(l)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, o, l), e = !1;
        break;
      }
      if (a !== null && a > l) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, o, l, a), e = !1;
        break;
      }
      a = l;
    }
    if (i !== void 0 && Dl(i))
      for (let o = 0, l = i.length; o !== l; ++o) {
        const c = i[o];
        if (isNaN(c)) {
          console.error("THREE.KeyframeTrack: Value is not a valid number.", this, o, c), e = !1;
          break;
        }
      }
    return e;
  }
  optimize() {
    const e = gn(this.times), t = gn(this.values), n = this.getValueSize(), i = this.getInterpolation() === Js, s = e.length - 1;
    let a = 1;
    for (let o = 1; o < s; ++o) {
      let l = !1;
      const c = e[o], u = e[o + 1];
      if (c !== u && (o !== 1 || c !== e[0]))
        if (i)
          l = !0;
        else {
          const h = o * n, d = h - n, m = h + n;
          for (let g = 0; g !== n; ++g) {
            const p = t[h + g];
            if (p !== t[d + g] || p !== t[m + g]) {
              l = !0;
              break;
            }
          }
        }
      if (l) {
        if (o !== a) {
          e[a] = e[o];
          const h = o * n, d = a * n;
          for (let m = 0; m !== n; ++m)
            t[d + m] = t[h + m];
        }
        ++a;
      }
    }
    if (s > 0) {
      e[a] = e[s];
      for (let o = s * n, l = a * n, c = 0; c !== n; ++c)
        t[l + c] = t[o + c];
      ++a;
    }
    return a !== e.length ? (this.times = gn(e, 0, a), this.values = gn(t, 0, a * n)) : (this.times = e, this.values = t), this;
  }
  clone() {
    const e = gn(this.times, 0), t = gn(this.values, 0), n = this.constructor, i = new n(this.name, e, t);
    return i.createInterpolant = this.createInterpolant, i;
  }
}
Jt.prototype.TimeBufferType = Float32Array;
Jt.prototype.ValueBufferType = Float32Array;
Jt.prototype.DefaultInterpolation = yi;
class Ai extends Jt {
}
Ai.prototype.ValueTypeName = "bool";
Ai.prototype.ValueBufferType = Array;
Ai.prototype.DefaultInterpolation = Ki;
Ai.prototype.InterpolantFactoryMethodLinear = void 0;
Ai.prototype.InterpolantFactoryMethodSmooth = void 0;
class Ol extends Jt {
}
Ol.prototype.ValueTypeName = "color";
class Qi extends Jt {
}
Qi.prototype.ValueTypeName = "number";
class ng extends is {
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  interpolate_(e, t, n, i) {
    const s = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = (n - t) / (i - t);
    let c = e * o;
    for (let u = c + o; c !== u; c += 4)
      $t.slerpFlat(s, 0, a, c - o, a, c, l);
    return s;
  }
}
class Gn extends Jt {
  InterpolantFactoryMethodLinear(e) {
    return new ng(this.times, this.values, this.getValueSize(), e);
  }
}
Gn.prototype.ValueTypeName = "quaternion";
Gn.prototype.DefaultInterpolation = yi;
Gn.prototype.InterpolantFactoryMethodSmooth = void 0;
class Ei extends Jt {
}
Ei.prototype.ValueTypeName = "string";
Ei.prototype.ValueBufferType = Array;
Ei.prototype.DefaultInterpolation = Ki;
Ei.prototype.InterpolantFactoryMethodLinear = void 0;
Ei.prototype.InterpolantFactoryMethodSmooth = void 0;
class es extends Jt {
}
es.prototype.ValueTypeName = "vector";
class ig {
  constructor(e, t = -1, n, i = Mh) {
    this.name = e, this.tracks = n, this.duration = t, this.blendMode = i, this.uuid = jt(), this.duration < 0 && this.resetDuration();
  }
  static parse(e) {
    const t = [], n = e.tracks, i = 1 / (e.fps || 1);
    for (let a = 0, o = n.length; a !== o; ++a)
      t.push(rg(n[a]).scale(i));
    const s = new this(e.name, e.duration, t, e.blendMode);
    return s.uuid = e.uuid, s;
  }
  static toJSON(e) {
    const t = [], n = e.tracks, i = {
      name: e.name,
      duration: e.duration,
      tracks: t,
      uuid: e.uuid,
      blendMode: e.blendMode
    };
    for (let s = 0, a = n.length; s !== a; ++s)
      t.push(Jt.toJSON(n[s]));
    return i;
  }
  static CreateFromMorphTargetSequence(e, t, n, i) {
    const s = t.length, a = [];
    for (let o = 0; o < s; o++) {
      let l = [], c = [];
      l.push(
        (o + s - 1) % s,
        o,
        (o + 1) % s
      ), c.push(0, 1, 0);
      const u = Jm(l);
      l = Uo(l, 1, u), c = Uo(c, 1, u), !i && l[0] === 0 && (l.push(s), c.push(c[0])), a.push(
        new Qi(
          ".morphTargetInfluences[" + t[o].name + "]",
          l,
          c
        ).scale(1 / n)
      );
    }
    return new this(e, -1, a);
  }
  static findByName(e, t) {
    let n = e;
    if (!Array.isArray(e)) {
      const i = e;
      n = i.geometry && i.geometry.animations || i.animations;
    }
    for (let i = 0; i < n.length; i++)
      if (n[i].name === t)
        return n[i];
    return null;
  }
  static CreateClipsFromMorphTargetSequences(e, t, n) {
    const i = {}, s = /^([\w-]*?)([\d]+)$/;
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], u = c.name.match(s);
      if (u && u.length > 1) {
        const h = u[1];
        let d = i[h];
        d || (i[h] = d = []), d.push(c);
      }
    }
    const a = [];
    for (const o in i)
      a.push(this.CreateFromMorphTargetSequence(o, i[o], t, n));
    return a;
  }
  static parseAnimation(e, t) {
    if (!e)
      return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
    const n = function(h, d, m, g, p) {
      if (m.length !== 0) {
        const f = [], v = [];
        Il(m, f, v, g), f.length !== 0 && p.push(new h(d, f, v));
      }
    }, i = [], s = e.name || "default", a = e.fps || 30, o = e.blendMode;
    let l = e.length || -1;
    const c = e.hierarchy || [];
    for (let h = 0; h < c.length; h++) {
      const d = c[h].keys;
      if (!(!d || d.length === 0))
        if (d[0].morphTargets) {
          const m = {};
          let g;
          for (g = 0; g < d.length; g++)
            if (d[g].morphTargets)
              for (let p = 0; p < d[g].morphTargets.length; p++)
                m[d[g].morphTargets[p]] = -1;
          for (const p in m) {
            const f = [], v = [];
            for (let S = 0; S !== d[g].morphTargets.length; ++S) {
              const y = d[g];
              f.push(y.time), v.push(y.morphTarget === p ? 1 : 0);
            }
            i.push(new Qi(".morphTargetInfluence[" + p + "]", f, v));
          }
          l = m.length * a;
        } else {
          const m = ".bones[" + t[h].name + "]";
          n(
            es,
            m + ".position",
            d,
            "pos",
            i
          ), n(
            Gn,
            m + ".quaternion",
            d,
            "rot",
            i
          ), n(
            es,
            m + ".scale",
            d,
            "scl",
            i
          );
        }
    }
    return i.length === 0 ? null : new this(s, l, i, o);
  }
  resetDuration() {
    const e = this.tracks;
    let t = 0;
    for (let n = 0, i = e.length; n !== i; ++n) {
      const s = this.tracks[n];
      t = Math.max(t, s.times[s.times.length - 1]);
    }
    return this.duration = t, this;
  }
  trim() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].trim(0, this.duration);
    return this;
  }
  validate() {
    let e = !0;
    for (let t = 0; t < this.tracks.length; t++)
      e = e && this.tracks[t].validate();
    return e;
  }
  optimize() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].optimize();
    return this;
  }
  clone() {
    const e = [];
    for (let t = 0; t < this.tracks.length; t++)
      e.push(this.tracks[t].clone());
    return new this.constructor(this.name, this.duration, e, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function sg(r) {
  switch (r.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return Qi;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return es;
    case "color":
      return Ol;
    case "quaternion":
      return Gn;
    case "bool":
    case "boolean":
      return Ai;
    case "string":
      return Ei;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + r);
}
function rg(r) {
  if (r.type === void 0)
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  const e = sg(r.type);
  if (r.times === void 0) {
    const t = [], n = [];
    Il(r.keys, t, n, "value"), r.times = t, r.values = n;
  }
  return e.parse !== void 0 ? e.parse(r) : new e(r.name, r.times, r.values, r.interpolation);
}
const Mi = {
  enabled: !1,
  files: {},
  add: function(r, e) {
    this.enabled !== !1 && (this.files[r] = e);
  },
  get: function(r) {
    if (this.enabled !== !1)
      return this.files[r];
  },
  remove: function(r) {
    delete this.files[r];
  },
  clear: function() {
    this.files = {};
  }
};
class ag {
  constructor(e, t, n) {
    const i = this;
    let s = !1, a = 0, o = 0, l;
    const c = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this.itemStart = function(u) {
      o++, s === !1 && i.onStart !== void 0 && i.onStart(u, a, o), s = !0;
    }, this.itemEnd = function(u) {
      a++, i.onProgress !== void 0 && i.onProgress(u, a, o), a === o && (s = !1, i.onLoad !== void 0 && i.onLoad());
    }, this.itemError = function(u) {
      i.onError !== void 0 && i.onError(u);
    }, this.resolveURL = function(u) {
      return l ? l(u) : u;
    }, this.setURLModifier = function(u) {
      return l = u, this;
    }, this.addHandler = function(u, h) {
      return c.push(u, h), this;
    }, this.removeHandler = function(u) {
      const h = c.indexOf(u);
      return h !== -1 && c.splice(h, 2), this;
    }, this.getHandler = function(u) {
      for (let h = 0, d = c.length; h < d; h += 2) {
        const m = c[h], g = c[h + 1];
        if (m.global && (m.lastIndex = 0), m.test(u))
          return g;
      }
      return null;
    };
  }
}
const og = /* @__PURE__ */ new ag();
class Ci {
  constructor(e) {
    this.manager = e !== void 0 ? e : og, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  load() {
  }
  loadAsync(e, t) {
    const n = this;
    return new Promise(function(i, s) {
      n.load(e, i, t, s);
    });
  }
  parse() {
  }
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  setPath(e) {
    return this.path = e, this;
  }
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
}
const an = {};
class lg extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
class Us extends Ci {
  constructor(e) {
    super(e);
  }
  load(e, t, n, i) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const s = Mi.get(e);
    if (s !== void 0)
      return this.manager.itemStart(e), setTimeout(() => {
        t && t(s), this.manager.itemEnd(e);
      }, 0), s;
    if (an[e] !== void 0) {
      an[e].push({
        onLoad: t,
        onProgress: n,
        onError: i
      });
      return;
    }
    an[e] = [], an[e].push({
      onLoad: t,
      onProgress: n,
      onError: i
    });
    const a = new Request(e, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
    }), o = this.mimeType, l = this.responseType;
    fetch(a).then((c) => {
      if (c.status === 200 || c.status === 0) {
        if (c.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0)
          return c;
        const u = an[e], h = c.body.getReader(), d = c.headers.get("Content-Length") || c.headers.get("X-File-Size"), m = d ? parseInt(d) : 0, g = m !== 0;
        let p = 0;
        const f = new ReadableStream({
          start(v) {
            S();
            function S() {
              h.read().then(({ done: y, value: b }) => {
                if (y)
                  v.close();
                else {
                  p += b.byteLength;
                  const w = new ProgressEvent("progress", { lengthComputable: g, loaded: p, total: m });
                  for (let D = 0, z = u.length; D < z; D++) {
                    const x = u[D];
                    x.onProgress && x.onProgress(w);
                  }
                  v.enqueue(b), S();
                }
              });
            }
          }
        });
        return new Response(f);
      } else
        throw new lg(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
    }).then((c) => {
      switch (l) {
        case "arraybuffer":
          return c.arrayBuffer();
        case "blob":
          return c.blob();
        case "document":
          return c.text().then((u) => new DOMParser().parseFromString(u, o));
        case "json":
          return c.json();
        default:
          if (o === void 0)
            return c.text();
          {
            const h = /charset="?([^;"\s]*)"?/i.exec(o), d = h && h[1] ? h[1].toLowerCase() : void 0, m = new TextDecoder(d);
            return c.arrayBuffer().then((g) => m.decode(g));
          }
      }
    }).then((c) => {
      Mi.add(e, c);
      const u = an[e];
      delete an[e];
      for (let h = 0, d = u.length; h < d; h++) {
        const m = u[h];
        m.onLoad && m.onLoad(c);
      }
    }).catch((c) => {
      const u = an[e];
      if (u === void 0)
        throw this.manager.itemError(e), c;
      delete an[e];
      for (let h = 0, d = u.length; h < d; h++) {
        const m = u[h];
        m.onError && m.onError(c);
      }
      this.manager.itemError(e);
    }).finally(() => {
      this.manager.itemEnd(e);
    }), this.manager.itemStart(e);
  }
  setResponseType(e) {
    return this.responseType = e, this;
  }
  setMimeType(e) {
    return this.mimeType = e, this;
  }
}
class cg extends Ci {
  constructor(e) {
    super(e);
  }
  load(e, t, n, i) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const s = this, a = Mi.get(e);
    if (a !== void 0)
      return s.manager.itemStart(e), setTimeout(function() {
        t && t(a), s.manager.itemEnd(e);
      }, 0), a;
    const o = Ji("img");
    function l() {
      u(), Mi.add(e, this), t && t(this), s.manager.itemEnd(e);
    }
    function c(h) {
      u(), i && i(h), s.manager.itemError(e), s.manager.itemEnd(e);
    }
    function u() {
      o.removeEventListener("load", l, !1), o.removeEventListener("error", c, !1);
    }
    return o.addEventListener("load", l, !1), o.addEventListener("error", c, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), s.manager.itemStart(e), o.src = e, o;
  }
}
class Nl extends Ci {
  constructor(e) {
    super(e);
  }
  load(e, t, n, i) {
    const s = new mt(), a = new cg(this.manager);
    return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(o) {
      s.image = o, s.needsUpdate = !0, t !== void 0 && t(s);
    }, n, i), s;
  }
}
class Gs extends nt {
  constructor(e, t = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new De(e), this.intensity = t;
  }
  dispose() {
  }
  copy(e, t) {
    return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, this.groundColor !== void 0 && (t.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (t.object.distance = this.distance), this.angle !== void 0 && (t.object.angle = this.angle), this.decay !== void 0 && (t.object.decay = this.decay), this.penumbra !== void 0 && (t.object.penumbra = this.penumbra), this.shadow !== void 0 && (t.object.shadow = this.shadow.toJSON()), t;
  }
}
const Ar = /* @__PURE__ */ new Fe(), ko = /* @__PURE__ */ new F(), Bo = /* @__PURE__ */ new F();
class oa {
  constructor(e) {
    this.camera = e, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Pe(512, 512), this.map = null, this.mapPass = null, this.matrix = new Fe(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Jr(), this._frameExtents = new Pe(1, 1), this._viewportCount = 1, this._viewports = [
      new Ze(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(e) {
    const t = this.camera, n = this.matrix;
    ko.setFromMatrixPosition(e.matrixWorld), t.position.copy(ko), Bo.setFromMatrixPosition(e.target.matrixWorld), t.lookAt(Bo), t.updateMatrixWorld(), Ar.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Ar), n.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), n.multiply(Ar);
  }
  getViewport(e) {
    return this._viewports[e];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  copy(e) {
    return this.camera = e.camera.clone(), this.bias = e.bias, this.radius = e.radius, this.mapSize.copy(e.mapSize), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const e = {};
    return this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
  }
}
class hg extends oa {
  constructor() {
    super(new At(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
  }
  updateMatrices(e) {
    const t = this.camera, n = $i * 2 * e.angle * this.focus, i = this.mapSize.width / this.mapSize.height, s = e.distance || t.far;
    (n !== t.fov || i !== t.aspect || s !== t.far) && (t.fov = n, t.aspect = i, t.far = s, t.updateProjectionMatrix()), super.updateMatrices(e);
  }
  copy(e) {
    return super.copy(e), this.focus = e.focus, this;
  }
}
class ug extends Gs {
  constructor(e, t, n = 0, i = Math.PI / 3, s = 0, a = 2) {
    super(e, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(nt.DefaultUp), this.updateMatrix(), this.target = new nt(), this.distance = n, this.angle = i, this.penumbra = s, this.decay = a, this.map = null, this.shadow = new hg();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(e) {
    this.intensity = e / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
const Ho = /* @__PURE__ */ new Fe(), Ui = /* @__PURE__ */ new F(), Er = /* @__PURE__ */ new F();
class dg extends oa {
  constructor() {
    super(new At(90, 1, 0.5, 500)), this.isPointLightShadow = !0, this._frameExtents = new Pe(4, 2), this._viewportCount = 6, this._viewports = [
      new Ze(2, 1, 1, 1),
      new Ze(0, 1, 1, 1),
      new Ze(3, 1, 1, 1),
      new Ze(1, 1, 1, 1),
      new Ze(3, 0, 1, 1),
      new Ze(1, 0, 1, 1)
    ], this._cubeDirections = [
      new F(1, 0, 0),
      new F(-1, 0, 0),
      new F(0, 0, 1),
      new F(0, 0, -1),
      new F(0, 1, 0),
      new F(0, -1, 0)
    ], this._cubeUps = [
      new F(0, 1, 0),
      new F(0, 1, 0),
      new F(0, 1, 0),
      new F(0, 1, 0),
      new F(0, 0, 1),
      new F(0, 0, -1)
    ];
  }
  updateMatrices(e, t = 0) {
    const n = this.camera, i = this.matrix, s = e.distance || n.far;
    s !== n.far && (n.far = s, n.updateProjectionMatrix()), Ui.setFromMatrixPosition(e.matrixWorld), n.position.copy(Ui), Er.copy(n.position), Er.add(this._cubeDirections[t]), n.up.copy(this._cubeUps[t]), n.lookAt(Er), n.updateMatrixWorld(), i.makeTranslation(-Ui.x, -Ui.y, -Ui.z), Ho.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Ho);
  }
}
class fg extends Gs {
  constructor(e, t, n = 0, i = 2) {
    super(e, t), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new dg();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(e) {
    this.intensity = e / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, t) {
    return super.copy(e, t), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
  }
}
class pg extends oa {
  constructor() {
    super(new ea(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class Gr extends Gs {
  constructor(e, t) {
    super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(nt.DefaultUp), this.updateMatrix(), this.target = new nt(), this.shadow = new pg();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e) {
    return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
class mg extends Gs {
  constructor(e, t) {
    super(e, t), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
}
class zn {
  static decodeText(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let n = 0, i = e.length; n < i; n++)
      t += String.fromCharCode(e[n]);
    try {
      return decodeURIComponent(escape(t));
    } catch {
      return t;
    }
  }
  static extractUrlBase(e) {
    const t = e.lastIndexOf("/");
    return t === -1 ? "./" : e.slice(0, t + 1);
  }
  static resolveURL(e, t) {
    return typeof e != "string" || e === "" ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e) ? e : t + e);
  }
}
class gg extends Ci {
  constructor(e) {
    super(e), this.isImageBitmapLoader = !0, typeof createImageBitmap > "u" && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), typeof fetch > "u" && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = { premultiplyAlpha: "none" };
  }
  setOptions(e) {
    return this.options = e, this;
  }
  load(e, t, n, i) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const s = this, a = Mi.get(e);
    if (a !== void 0)
      return s.manager.itemStart(e), setTimeout(function() {
        t && t(a), s.manager.itemEnd(e);
      }, 0), a;
    const o = {};
    o.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include", o.headers = this.requestHeader, fetch(e, o).then(function(l) {
      return l.blob();
    }).then(function(l) {
      return createImageBitmap(l, Object.assign(s.options, { colorSpaceConversion: "none" }));
    }).then(function(l) {
      Mi.add(e, l), t && t(l), s.manager.itemEnd(e);
    }).catch(function(l) {
      i && i(l), s.manager.itemError(e), s.manager.itemEnd(e);
    }), s.manager.itemStart(e);
  }
}
const la = "\\[\\]\\.:\\/", _g = new RegExp("[" + la + "]", "g"), ca = "[^" + la + "]", vg = "[^" + la.replace("\\.", "") + "]", xg = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", ca), yg = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", vg), bg = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", ca), Mg = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", ca), wg = new RegExp(
  "^" + xg + yg + bg + Mg + "$"
), Sg = ["material", "materials", "bones", "map"];
class Tg {
  constructor(e, t, n) {
    const i = n || qe.parseTrackName(t);
    this._targetGroup = e, this._bindings = e.subscribe_(t, i);
  }
  getValue(e, t) {
    this.bind();
    const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
    i !== void 0 && i.getValue(e, t);
  }
  setValue(e, t) {
    const n = this._bindings;
    for (let i = this._targetGroup.nCachedObjects_, s = n.length; i !== s; ++i)
      n[i].setValue(e, t);
  }
  bind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)
      e[t].bind();
  }
  unbind() {
    const e = this._bindings;
    for (let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)
      e[t].unbind();
  }
}
class qe {
  constructor(e, t, n) {
    this.path = t, this.parsedPath = n || qe.parseTrackName(t), this.node = qe.findNode(e, this.parsedPath.nodeName) || e, this.rootNode = e, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
  static create(e, t, n) {
    return e && e.isAnimationObjectGroup ? new qe.Composite(e, t, n) : new qe(e, t, n);
  }
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, "_").replace(_g, "");
  }
  static parseTrackName(e) {
    const t = wg.exec(e);
    if (t === null)
      throw new Error("PropertyBinding: Cannot parse trackName: " + e);
    const n = {
      nodeName: t[2],
      objectName: t[3],
      objectIndex: t[4],
      propertyName: t[5],
      propertyIndex: t[6]
    }, i = n.nodeName && n.nodeName.lastIndexOf(".");
    if (i !== void 0 && i !== -1) {
      const s = n.nodeName.substring(i + 1);
      Sg.indexOf(s) !== -1 && (n.nodeName = n.nodeName.substring(0, i), n.objectName = s);
    }
    if (n.propertyName === null || n.propertyName.length === 0)
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
    return n;
  }
  static findNode(e, t) {
    if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid)
      return e;
    if (e.skeleton) {
      const n = e.skeleton.getBoneByName(t);
      if (n !== void 0)
        return n;
    }
    if (e.children) {
      const n = function(s) {
        for (let a = 0; a < s.length; a++) {
          const o = s[a];
          if (o.name === t || o.uuid === t)
            return o;
          const l = n(o.children);
          if (l)
            return l;
        }
        return null;
      }, i = n(e.children);
      if (i)
        return i;
    }
    return null;
  }
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  _getValue_direct(e, t) {
    e[t] = this.targetObject[this.propertyName];
  }
  _getValue_array(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, s = n.length; i !== s; ++i)
      e[t++] = n[i];
  }
  _getValue_arrayElement(e, t) {
    e[t] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(e, t) {
    this.resolvedProperty.toArray(e, t);
  }
  _setValue_direct(e, t) {
    this.targetObject[this.propertyName] = e[t];
  }
  _setValue_direct_setNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
    this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_array(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, s = n.length; i !== s; ++i)
      n[i] = e[t++];
  }
  _setValue_array_setNeedsUpdate(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, s = n.length; i !== s; ++i)
      n[i] = e[t++];
    this.targetObject.needsUpdate = !0;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
    const n = this.resolvedProperty;
    for (let i = 0, s = n.length; i !== s; ++i)
      n[i] = e[t++];
    this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_arrayElement(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t];
  }
  _setValue_arrayElement_setNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _setValue_fromArray(e, t) {
    this.resolvedProperty.fromArray(e, t);
  }
  _setValue_fromArray_setNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _getValue_unbound(e, t) {
    this.bind(), this.getValue(e, t);
  }
  _setValue_unbound(e, t) {
    this.bind(), this.setValue(e, t);
  }
  bind() {
    let e = this.node;
    const t = this.parsedPath, n = t.objectName, i = t.propertyName;
    let s = t.propertyIndex;
    if (e || (e = qe.findNode(this.rootNode, t.nodeName) || this.rootNode, this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) {
      console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
      return;
    }
    if (n) {
      let c = t.objectIndex;
      switch (n) {
        case "materials":
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          e = e.material.materials;
          break;
        case "bones":
          if (!e.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          e = e.skeleton.bones;
          for (let u = 0; u < e.length; u++)
            if (e[u].name === c) {
              c = u;
              break;
            }
          break;
        case "map":
          if ("map" in e) {
            e = e.map;
            break;
          }
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          e = e.material.map;
          break;
        default:
          if (e[n] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          e = e[n];
      }
      if (c !== void 0) {
        if (e[c] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
          return;
        }
        e = e[c];
      }
    }
    const a = e[i];
    if (a === void 0) {
      const c = t.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + c + "." + i + " but it wasn't found.", e);
      return;
    }
    let o = this.Versioning.None;
    this.targetObject = e, e.needsUpdate !== void 0 ? o = this.Versioning.NeedsUpdate : e.matrixWorldNeedsUpdate !== void 0 && (o = this.Versioning.MatrixWorldNeedsUpdate);
    let l = this.BindingType.Direct;
    if (s !== void 0) {
      if (i === "morphTargetInfluences") {
        if (!e.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!e.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        e.morphTargetDictionary[s] !== void 0 && (s = e.morphTargetDictionary[s]);
      }
      l = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = s;
    } else
      a.fromArray !== void 0 && a.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (l = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = i;
    this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][o];
  }
  unbind() {
    this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
}
qe.Composite = Tg;
qe.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
qe.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
qe.prototype.GetterByBindingType = [
  qe.prototype._getValue_direct,
  qe.prototype._getValue_array,
  qe.prototype._getValue_arrayElement,
  qe.prototype._getValue_toArray
];
qe.prototype.SetterByBindingTypeAndVersioning = [
  [
    qe.prototype._setValue_direct,
    qe.prototype._setValue_direct_setNeedsUpdate,
    qe.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    qe.prototype._setValue_array,
    qe.prototype._setValue_array_setNeedsUpdate,
    qe.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    qe.prototype._setValue_arrayElement,
    qe.prototype._setValue_arrayElement_setNeedsUpdate,
    qe.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    qe.prototype._setValue_fromArray,
    qe.prototype._setValue_fromArray_setNeedsUpdate,
    qe.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class Vo {
  constructor(e = 1, t = 0, n = 0) {
    return this.radius = e, this.phi = t, this.theta = n, this;
  }
  set(e, t, n) {
    return this.radius = e, this.phi = t, this.theta = n, this;
  }
  copy(e) {
    return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
  }
  makeSafe() {
    return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
  }
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z);
  }
  setFromCartesianCoords(e, t, n) {
    return this.radius = Math.sqrt(e * e + t * t + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e, n), this.phi = Math.acos(vt(t / this.radius, -1, 1))), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: qr
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = qr);
const Go = { type: "change" }, Cr = { type: "start" }, Wo = { type: "end" };
class Ag extends jn {
  constructor(e, t) {
    super(), this.object = e, this.domElement = t, this.domElement.style.touchAction = "none", this.enabled = !0, this.target = new F(), this.minDistance = 0, this.maxDistance = 1 / 0, this.minZoom = 0, this.maxZoom = 1 / 0, this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.enableDamping = !1, this.dampingFactor = 0.05, this.enableZoom = !0, this.zoomSpeed = 1, this.enableRotate = !0, this.rotateSpeed = 1, this.enablePan = !0, this.panSpeed = 1, this.screenSpacePanning = !0, this.keyPanSpeed = 7, this.autoRotate = !1, this.autoRotateSpeed = 2, this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" }, this.mouseButtons = { LEFT: qn.ROTATE, MIDDLE: qn.DOLLY, RIGHT: qn.PAN }, this.touches = { ONE: Yn.ROTATE, TWO: Yn.DOLLY_PAN }, this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this._domElementKeyEvents = null, this.getPolarAngle = function() {
      return o.phi;
    }, this.getAzimuthalAngle = function() {
      return o.theta;
    }, this.getDistance = function() {
      return this.object.position.distanceTo(this.target);
    }, this.listenToKeyEvents = function(C) {
      C.addEventListener("keydown", at), this._domElementKeyEvents = C;
    }, this.saveState = function() {
      n.target0.copy(n.target), n.position0.copy(n.object.position), n.zoom0 = n.object.zoom;
    }, this.reset = function() {
      n.target.copy(n.target0), n.object.position.copy(n.position0), n.object.zoom = n.zoom0, n.object.updateProjectionMatrix(), n.dispatchEvent(Go), n.update(), s = i.NONE;
    }, this.update = function() {
      const C = new F(), B = new $t().setFromUnitVectors(e.up, new F(0, 1, 0)), pe = B.clone().invert(), ge = new F(), fe = new $t(), we = 2 * Math.PI;
      return function() {
        const Ne = n.object.position;
        C.copy(Ne).sub(n.target), C.applyQuaternion(B), o.setFromVector3(C), n.autoRotate && s === i.NONE && R(z()), n.enableDamping ? (o.theta += l.theta * n.dampingFactor, o.phi += l.phi * n.dampingFactor) : (o.theta += l.theta, o.phi += l.phi);
        let ze = n.minAzimuthAngle, je = n.maxAzimuthAngle;
        return isFinite(ze) && isFinite(je) && (ze < -Math.PI ? ze += we : ze > Math.PI && (ze -= we), je < -Math.PI ? je += we : je > Math.PI && (je -= we), ze <= je ? o.theta = Math.max(ze, Math.min(je, o.theta)) : o.theta = o.theta > (ze + je) / 2 ? Math.max(ze, o.theta) : Math.min(je, o.theta)), o.phi = Math.max(n.minPolarAngle, Math.min(n.maxPolarAngle, o.phi)), o.makeSafe(), o.radius *= c, o.radius = Math.max(n.minDistance, Math.min(n.maxDistance, o.radius)), n.enableDamping === !0 ? n.target.addScaledVector(u, n.dampingFactor) : n.target.add(u), C.setFromSpherical(o), C.applyQuaternion(pe), Ne.copy(n.target).add(C), n.object.lookAt(n.target), n.enableDamping === !0 ? (l.theta *= 1 - n.dampingFactor, l.phi *= 1 - n.dampingFactor, u.multiplyScalar(1 - n.dampingFactor)) : (l.set(0, 0, 0), u.set(0, 0, 0)), c = 1, h || ge.distanceToSquared(n.object.position) > a || 8 * (1 - fe.dot(n.object.quaternion)) > a ? (n.dispatchEvent(Go), ge.copy(n.object.position), fe.copy(n.object.quaternion), h = !1, !0) : !1;
      };
    }(), this.dispose = function() {
      n.domElement.removeEventListener("contextmenu", X), n.domElement.removeEventListener("pointerdown", st), n.domElement.removeEventListener("pointercancel", pt), n.domElement.removeEventListener("wheel", xt), n.domElement.removeEventListener("pointermove", Qe), n.domElement.removeEventListener("pointerup", et), n._domElementKeyEvents !== null && n._domElementKeyEvents.removeEventListener("keydown", at);
    };
    const n = this, i = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6
    };
    let s = i.NONE;
    const a = 1e-6, o = new Vo(), l = new Vo();
    let c = 1;
    const u = new F();
    let h = !1;
    const d = new Pe(), m = new Pe(), g = new Pe(), p = new Pe(), f = new Pe(), v = new Pe(), S = new Pe(), y = new Pe(), b = new Pe(), w = [], D = {};
    function z() {
      return 2 * Math.PI / 60 / 60 * n.autoRotateSpeed;
    }
    function x() {
      return Math.pow(0.95, n.zoomSpeed);
    }
    function R(C) {
      l.theta -= C;
    }
    function k(C) {
      l.phi -= C;
    }
    const T = function() {
      const C = new F();
      return function(pe, ge) {
        C.setFromMatrixColumn(ge, 0), C.multiplyScalar(-pe), u.add(C);
      };
    }(), ee = function() {
      const C = new F();
      return function(pe, ge) {
        n.screenSpacePanning === !0 ? C.setFromMatrixColumn(ge, 1) : (C.setFromMatrixColumn(ge, 0), C.crossVectors(n.object.up, C)), C.multiplyScalar(pe), u.add(C);
      };
    }(), V = function() {
      const C = new F();
      return function(pe, ge) {
        const fe = n.domElement;
        if (n.object.isPerspectiveCamera) {
          const we = n.object.position;
          C.copy(we).sub(n.target);
          let Se = C.length();
          Se *= Math.tan(n.object.fov / 2 * Math.PI / 180), T(2 * pe * Se / fe.clientHeight, n.object.matrix), ee(2 * ge * Se / fe.clientHeight, n.object.matrix);
        } else
          n.object.isOrthographicCamera ? (T(pe * (n.object.right - n.object.left) / n.object.zoom / fe.clientWidth, n.object.matrix), ee(ge * (n.object.top - n.object.bottom) / n.object.zoom / fe.clientHeight, n.object.matrix)) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."), n.enablePan = !1);
      };
    }();
    function H(C) {
      n.object.isPerspectiveCamera ? c /= C : n.object.isOrthographicCamera ? (n.object.zoom = Math.max(n.minZoom, Math.min(n.maxZoom, n.object.zoom * C)), n.object.updateProjectionMatrix(), h = !0) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), n.enableZoom = !1);
    }
    function j(C) {
      n.object.isPerspectiveCamera ? c *= C : n.object.isOrthographicCamera ? (n.object.zoom = Math.max(n.minZoom, Math.min(n.maxZoom, n.object.zoom / C)), n.object.updateProjectionMatrix(), h = !0) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), n.enableZoom = !1);
    }
    function G(C) {
      d.set(C.clientX, C.clientY);
    }
    function te(C) {
      S.set(C.clientX, C.clientY);
    }
    function Z(C) {
      p.set(C.clientX, C.clientY);
    }
    function re(C) {
      m.set(C.clientX, C.clientY), g.subVectors(m, d).multiplyScalar(n.rotateSpeed);
      const B = n.domElement;
      R(2 * Math.PI * g.x / B.clientHeight), k(2 * Math.PI * g.y / B.clientHeight), d.copy(m), n.update();
    }
    function $(C) {
      y.set(C.clientX, C.clientY), b.subVectors(y, S), b.y > 0 ? H(x()) : b.y < 0 && j(x()), S.copy(y), n.update();
    }
    function K(C) {
      f.set(C.clientX, C.clientY), v.subVectors(f, p).multiplyScalar(n.panSpeed), V(v.x, v.y), p.copy(f), n.update();
    }
    function W(C) {
      C.deltaY < 0 ? j(x()) : C.deltaY > 0 && H(x()), n.update();
    }
    function le(C) {
      let B = !1;
      switch (C.code) {
        case n.keys.UP:
          C.ctrlKey || C.metaKey || C.shiftKey ? k(2 * Math.PI * n.rotateSpeed / n.domElement.clientHeight) : V(0, n.keyPanSpeed), B = !0;
          break;
        case n.keys.BOTTOM:
          C.ctrlKey || C.metaKey || C.shiftKey ? k(-2 * Math.PI * n.rotateSpeed / n.domElement.clientHeight) : V(0, -n.keyPanSpeed), B = !0;
          break;
        case n.keys.LEFT:
          C.ctrlKey || C.metaKey || C.shiftKey ? R(2 * Math.PI * n.rotateSpeed / n.domElement.clientHeight) : V(n.keyPanSpeed, 0), B = !0;
          break;
        case n.keys.RIGHT:
          C.ctrlKey || C.metaKey || C.shiftKey ? R(-2 * Math.PI * n.rotateSpeed / n.domElement.clientHeight) : V(-n.keyPanSpeed, 0), B = !0;
          break;
      }
      B && (C.preventDefault(), n.update());
    }
    function ae() {
      if (w.length === 1)
        d.set(w[0].pageX, w[0].pageY);
      else {
        const C = 0.5 * (w[0].pageX + w[1].pageX), B = 0.5 * (w[0].pageY + w[1].pageY);
        d.set(C, B);
      }
    }
    function ue() {
      if (w.length === 1)
        p.set(w[0].pageX, w[0].pageY);
      else {
        const C = 0.5 * (w[0].pageX + w[1].pageX), B = 0.5 * (w[0].pageY + w[1].pageY);
        p.set(C, B);
      }
    }
    function Y() {
      const C = w[0].pageX - w[1].pageX, B = w[0].pageY - w[1].pageY, pe = Math.sqrt(C * C + B * B);
      S.set(0, pe);
    }
    function Oe() {
      n.enableZoom && Y(), n.enablePan && ue();
    }
    function be() {
      n.enableZoom && Y(), n.enableRotate && ae();
    }
    function Ce(C) {
      if (w.length == 1)
        m.set(C.pageX, C.pageY);
      else {
        const pe = Re(C), ge = 0.5 * (C.pageX + pe.x), fe = 0.5 * (C.pageY + pe.y);
        m.set(ge, fe);
      }
      g.subVectors(m, d).multiplyScalar(n.rotateSpeed);
      const B = n.domElement;
      R(2 * Math.PI * g.x / B.clientHeight), k(2 * Math.PI * g.y / B.clientHeight), d.copy(m);
    }
    function ve(C) {
      if (w.length === 1)
        f.set(C.pageX, C.pageY);
      else {
        const B = Re(C), pe = 0.5 * (C.pageX + B.x), ge = 0.5 * (C.pageY + B.y);
        f.set(pe, ge);
      }
      v.subVectors(f, p).multiplyScalar(n.panSpeed), V(v.x, v.y), p.copy(f);
    }
    function Ae(C) {
      const B = Re(C), pe = C.pageX - B.x, ge = C.pageY - B.y, fe = Math.sqrt(pe * pe + ge * ge);
      y.set(0, fe), b.set(0, Math.pow(y.y / S.y, n.zoomSpeed)), H(b.y), S.copy(y);
    }
    function Ee(C) {
      n.enableZoom && Ae(C), n.enablePan && ve(C);
    }
    function Le(C) {
      n.enableZoom && Ae(C), n.enableRotate && Ce(C);
    }
    function st(C) {
      n.enabled !== !1 && (w.length === 0 && (n.domElement.setPointerCapture(C.pointerId), n.domElement.addEventListener("pointermove", Qe), n.domElement.addEventListener("pointerup", et)), ie(C), C.pointerType === "touch" ? A(C) : $e(C));
    }
    function Qe(C) {
      n.enabled !== !1 && (C.pointerType === "touch" ? M(C) : ke(C));
    }
    function et(C) {
      oe(C), w.length === 0 && (n.domElement.releasePointerCapture(C.pointerId), n.domElement.removeEventListener("pointermove", Qe), n.domElement.removeEventListener("pointerup", et)), n.dispatchEvent(Wo), s = i.NONE;
    }
    function pt(C) {
      oe(C);
    }
    function $e(C) {
      let B;
      switch (C.button) {
        case 0:
          B = n.mouseButtons.LEFT;
          break;
        case 1:
          B = n.mouseButtons.MIDDLE;
          break;
        case 2:
          B = n.mouseButtons.RIGHT;
          break;
        default:
          B = -1;
      }
      switch (B) {
        case qn.DOLLY:
          if (n.enableZoom === !1)
            return;
          te(C), s = i.DOLLY;
          break;
        case qn.ROTATE:
          if (C.ctrlKey || C.metaKey || C.shiftKey) {
            if (n.enablePan === !1)
              return;
            Z(C), s = i.PAN;
          } else {
            if (n.enableRotate === !1)
              return;
            G(C), s = i.ROTATE;
          }
          break;
        case qn.PAN:
          if (C.ctrlKey || C.metaKey || C.shiftKey) {
            if (n.enableRotate === !1)
              return;
            G(C), s = i.ROTATE;
          } else {
            if (n.enablePan === !1)
              return;
            Z(C), s = i.PAN;
          }
          break;
        default:
          s = i.NONE;
      }
      s !== i.NONE && n.dispatchEvent(Cr);
    }
    function ke(C) {
      switch (s) {
        case i.ROTATE:
          if (n.enableRotate === !1)
            return;
          re(C);
          break;
        case i.DOLLY:
          if (n.enableZoom === !1)
            return;
          $(C);
          break;
        case i.PAN:
          if (n.enablePan === !1)
            return;
          K(C);
          break;
      }
    }
    function xt(C) {
      n.enabled === !1 || n.enableZoom === !1 || s !== i.NONE || (C.preventDefault(), n.dispatchEvent(Cr), W(C), n.dispatchEvent(Wo));
    }
    function at(C) {
      n.enabled === !1 || n.enablePan === !1 || le(C);
    }
    function A(C) {
      switch (de(C), w.length) {
        case 1:
          switch (n.touches.ONE) {
            case Yn.ROTATE:
              if (n.enableRotate === !1)
                return;
              ae(), s = i.TOUCH_ROTATE;
              break;
            case Yn.PAN:
              if (n.enablePan === !1)
                return;
              ue(), s = i.TOUCH_PAN;
              break;
            default:
              s = i.NONE;
          }
          break;
        case 2:
          switch (n.touches.TWO) {
            case Yn.DOLLY_PAN:
              if (n.enableZoom === !1 && n.enablePan === !1)
                return;
              Oe(), s = i.TOUCH_DOLLY_PAN;
              break;
            case Yn.DOLLY_ROTATE:
              if (n.enableZoom === !1 && n.enableRotate === !1)
                return;
              be(), s = i.TOUCH_DOLLY_ROTATE;
              break;
            default:
              s = i.NONE;
          }
          break;
        default:
          s = i.NONE;
      }
      s !== i.NONE && n.dispatchEvent(Cr);
    }
    function M(C) {
      switch (de(C), s) {
        case i.TOUCH_ROTATE:
          if (n.enableRotate === !1)
            return;
          Ce(C), n.update();
          break;
        case i.TOUCH_PAN:
          if (n.enablePan === !1)
            return;
          ve(C), n.update();
          break;
        case i.TOUCH_DOLLY_PAN:
          if (n.enableZoom === !1 && n.enablePan === !1)
            return;
          Ee(C), n.update();
          break;
        case i.TOUCH_DOLLY_ROTATE:
          if (n.enableZoom === !1 && n.enableRotate === !1)
            return;
          Le(C), n.update();
          break;
        default:
          s = i.NONE;
      }
    }
    function X(C) {
      n.enabled !== !1 && C.preventDefault();
    }
    function ie(C) {
      w.push(C);
    }
    function oe(C) {
      delete D[C.pointerId];
      for (let B = 0; B < w.length; B++)
        if (w[B].pointerId == C.pointerId) {
          w.splice(B, 1);
          return;
        }
    }
    function de(C) {
      let B = D[C.pointerId];
      B === void 0 && (B = new Pe(), D[C.pointerId] = B), B.set(C.pageX, C.pageY);
    }
    function Re(C) {
      const B = C.pointerId === w[0].pointerId ? w[1] : w[0];
      return D[B.pointerId];
    }
    n.domElement.addEventListener("contextmenu", X), n.domElement.addEventListener("pointerdown", st), n.domElement.addEventListener("pointercancel", pt), n.domElement.addEventListener("wheel", xt, { passive: !1 }), this.update();
  }
}
class Eg extends Ci {
  constructor(e) {
    super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t) {
      return new Dg(t);
    }), this.register(function(t) {
      return new kg(t);
    }), this.register(function(t) {
      return new Bg(t);
    }), this.register(function(t) {
      return new Og(t);
    }), this.register(function(t) {
      return new Ng(t);
    }), this.register(function(t) {
      return new Fg(t);
    }), this.register(function(t) {
      return new zg(t);
    }), this.register(function(t) {
      return new Pg(t);
    }), this.register(function(t) {
      return new Ug(t);
    }), this.register(function(t) {
      return new Ig(t);
    }), this.register(function(t) {
      return new Lg(t);
    }), this.register(function(t) {
      return new Hg(t);
    }), this.register(function(t) {
      return new Vg(t);
    });
  }
  load(e, t, n, i) {
    const s = this;
    let a;
    this.resourcePath !== "" ? a = this.resourcePath : this.path !== "" ? a = this.path : a = zn.extractUrlBase(e), this.manager.itemStart(e);
    const o = function(c) {
      i ? i(c) : console.error(c), s.manager.itemError(e), s.manager.itemEnd(e);
    }, l = new Us(this.manager);
    l.setPath(this.path), l.setResponseType("arraybuffer"), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, function(c) {
      try {
        s.parse(c, a, function(u) {
          t(u), s.manager.itemEnd(e);
        }, o);
      } catch (u) {
        o(u);
      }
    }, n, o);
  }
  setDRACOLoader(e) {
    return this.dracoLoader = e, this;
  }
  setDDSLoader() {
    throw new Error(
      'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'
    );
  }
  setKTX2Loader(e) {
    return this.ktx2Loader = e, this;
  }
  setMeshoptDecoder(e) {
    return this.meshoptDecoder = e, this;
  }
  register(e) {
    return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
  }
  unregister(e) {
    return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
  }
  parse(e, t, n, i) {
    let s;
    const a = {}, o = {};
    if (typeof e == "string")
      s = JSON.parse(e);
    else if (e instanceof ArrayBuffer)
      if (zn.decodeText(new Uint8Array(e, 0, 4)) === Fl) {
        try {
          a[Ve.KHR_BINARY_GLTF] = new Gg(e);
        } catch (u) {
          i && i(u);
          return;
        }
        s = JSON.parse(a[Ve.KHR_BINARY_GLTF].content);
      } else
        s = JSON.parse(zn.decodeText(new Uint8Array(e)));
    else
      s = e;
    if (s.asset === void 0 || s.asset.version[0] < 2) {
      i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const l = new n_(s, {
      path: t || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    l.fileLoader.setRequestHeader(this.requestHeader);
    for (let c = 0; c < this.pluginCallbacks.length; c++) {
      const u = this.pluginCallbacks[c](l);
      o[u.name] = u, a[u.name] = !0;
    }
    if (s.extensionsUsed)
      for (let c = 0; c < s.extensionsUsed.length; ++c) {
        const u = s.extensionsUsed[c], h = s.extensionsRequired || [];
        switch (u) {
          case Ve.KHR_MATERIALS_UNLIT:
            a[u] = new Rg();
            break;
          case Ve.KHR_DRACO_MESH_COMPRESSION:
            a[u] = new Wg(s, this.dracoLoader);
            break;
          case Ve.KHR_TEXTURE_TRANSFORM:
            a[u] = new jg();
            break;
          case Ve.KHR_MESH_QUANTIZATION:
            a[u] = new Xg();
            break;
          default:
            h.indexOf(u) >= 0 && o[u] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + u + '".');
        }
      }
    l.setExtensions(a), l.setPlugins(o), l.parse(n, i);
  }
  parseAsync(e, t) {
    const n = this;
    return new Promise(function(i, s) {
      n.parse(e, t, i, s);
    });
  }
}
function Cg() {
  let r = {};
  return {
    get: function(e) {
      return r[e];
    },
    add: function(e, t) {
      r[e] = t;
    },
    remove: function(e) {
      delete r[e];
    },
    removeAll: function() {
      r = {};
    }
  };
}
const Ve = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class Lg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_LIGHTS_PUNCTUAL, this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const e = this.parser, t = this.parser.json.nodes || [];
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      s.extensions && s.extensions[this.name] && s.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, s.extensions[this.name].light);
    }
  }
  _loadLight(e) {
    const t = this.parser, n = "light:" + e;
    let i = t.cache.get(n);
    if (i)
      return i;
    const s = t.json, l = ((s.extensions && s.extensions[this.name] || {}).lights || [])[e];
    let c;
    const u = new De(16777215);
    l.color !== void 0 && u.fromArray(l.color);
    const h = l.range !== void 0 ? l.range : 0;
    switch (l.type) {
      case "directional":
        c = new Gr(u), c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      case "point":
        c = new fg(u), c.distance = h;
        break;
      case "spot":
        c = new ug(u), c.distance = h, l.spot = l.spot || {}, l.spot.innerConeAngle = l.spot.innerConeAngle !== void 0 ? l.spot.innerConeAngle : 0, l.spot.outerConeAngle = l.spot.outerConeAngle !== void 0 ? l.spot.outerConeAngle : Math.PI / 4, c.angle = l.spot.outerConeAngle, c.penumbra = 1 - l.spot.innerConeAngle / l.spot.outerConeAngle, c.target.position.set(0, 0, -1), c.add(c.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + l.type);
    }
    return c.position.set(0, 0, 0), c.decay = 2, vn(c, l), l.intensity !== void 0 && (c.intensity = l.intensity), c.name = t.createUniqueName(l.name || "light_" + e), i = Promise.resolve(c), t.cache.add(n, i), i;
  }
  getDependency(e, t) {
    if (e === "light")
      return this._loadLight(t);
  }
  createNodeAttachment(e) {
    const t = this, n = this.parser, s = n.json.nodes[e], o = (s.extensions && s.extensions[this.name] || {}).light;
    return o === void 0 ? null : this._loadLight(o).then(function(l) {
      return n._getNodeRef(t.cache, o, l);
    });
  }
}
class Rg {
  constructor() {
    this.name = Ve.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return In;
  }
  extendParams(e, t, n) {
    const i = [];
    e.color = new De(1, 1, 1), e.opacity = 1;
    const s = t.pbrMetallicRoughness;
    if (s) {
      if (Array.isArray(s.baseColorFactor)) {
        const a = s.baseColorFactor;
        e.color.fromArray(a), e.opacity = a[3];
      }
      s.baseColorTexture !== void 0 && i.push(n.assignTexture(e, "map", s.baseColorTexture, Xe));
    }
    return Promise.all(i);
  }
}
class Pg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(e, t) {
    const i = this.parser.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = i.extensions[this.name].emissiveStrength;
    return s !== void 0 && (t.emissiveIntensity = s), Promise.resolve();
  }
}
class Dg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [], a = i.extensions[this.name];
    if (a.clearcoatFactor !== void 0 && (t.clearcoat = a.clearcoatFactor), a.clearcoatTexture !== void 0 && s.push(n.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), a.clearcoatRoughnessFactor !== void 0 && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), a.clearcoatRoughnessTexture !== void 0 && s.push(n.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), a.clearcoatNormalTexture !== void 0 && (s.push(n.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), a.clearcoatNormalTexture.scale !== void 0)) {
      const o = a.clearcoatNormalTexture.scale;
      t.clearcoatNormalScale = new Pe(o, o);
    }
    return Promise.all(s);
  }
}
class Ig {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [], a = i.extensions[this.name];
    return a.iridescenceFactor !== void 0 && (t.iridescence = a.iridescenceFactor), a.iridescenceTexture !== void 0 && s.push(n.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), a.iridescenceIor !== void 0 && (t.iridescenceIOR = a.iridescenceIor), t.iridescenceThicknessRange === void 0 && (t.iridescenceThicknessRange = [100, 400]), a.iridescenceThicknessMinimum !== void 0 && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), a.iridescenceThicknessMaximum !== void 0 && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), a.iridescenceThicknessTexture !== void 0 && s.push(n.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(s);
  }
}
class Og {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [];
    t.sheenColor = new De(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
    const a = i.extensions[this.name];
    return a.sheenColorFactor !== void 0 && t.sheenColor.fromArray(a.sheenColorFactor), a.sheenRoughnessFactor !== void 0 && (t.sheenRoughness = a.sheenRoughnessFactor), a.sheenColorTexture !== void 0 && s.push(n.assignTexture(t, "sheenColorMap", a.sheenColorTexture, Xe)), a.sheenRoughnessTexture !== void 0 && s.push(n.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(s);
  }
}
class Ng {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [], a = i.extensions[this.name];
    return a.transmissionFactor !== void 0 && (t.transmission = a.transmissionFactor), a.transmissionTexture !== void 0 && s.push(n.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(s);
  }
}
class Fg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [], a = i.extensions[this.name];
    t.thickness = a.thicknessFactor !== void 0 ? a.thicknessFactor : 0, a.thicknessTexture !== void 0 && s.push(n.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
    const o = a.attenuationColor || [1, 1, 1];
    return t.attenuationColor = new De(o[0], o[1], o[2]), Promise.all(s);
  }
}
class zg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_IOR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const i = this.parser.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = i.extensions[this.name];
    return t.ior = s.ior !== void 0 ? s.ior : 1.5, Promise.resolve();
  }
}
class Ug {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : Xn;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, i = n.json.materials[e];
    if (!i.extensions || !i.extensions[this.name])
      return Promise.resolve();
    const s = [], a = i.extensions[this.name];
    t.specularIntensity = a.specularFactor !== void 0 ? a.specularFactor : 1, a.specularTexture !== void 0 && s.push(n.assignTexture(t, "specularIntensityMap", a.specularTexture));
    const o = a.specularColorFactor || [1, 1, 1];
    return t.specularColor = new De(o[0], o[1], o[2]), a.specularColorTexture !== void 0 && s.push(n.assignTexture(t, "specularColorMap", a.specularColorTexture, Xe)), Promise.all(s);
  }
}
class kg {
  constructor(e) {
    this.parser = e, this.name = Ve.KHR_TEXTURE_BASISU;
  }
  loadTexture(e) {
    const t = this.parser, n = t.json, i = n.textures[e];
    if (!i.extensions || !i.extensions[this.name])
      return null;
    const s = i.extensions[this.name], a = t.options.ktx2Loader;
    if (!a) {
      if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      return null;
    }
    return t.loadTextureImage(e, s.source, a);
  }
}
class Bg {
  constructor(e) {
    this.parser = e, this.name = Ve.EXT_TEXTURE_WEBP, this.isSupported = null;
  }
  loadTexture(e) {
    const t = this.name, n = this.parser, i = n.json, s = i.textures[e];
    if (!s.extensions || !s.extensions[t])
      return null;
    const a = s.extensions[t], o = i.images[a.source];
    let l = n.textureLoader;
    if (o.uri) {
      const c = n.options.manager.getHandler(o.uri);
      c !== null && (l = c);
    }
    return this.detectSupport().then(function(c) {
      if (c)
        return n.loadTextureImage(e, a.source, l);
      if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0)
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      return n.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const t = new Image();
      t.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", t.onload = t.onerror = function() {
        e(t.height === 1);
      };
    })), this.isSupported;
  }
}
class Hg {
  constructor(e) {
    this.name = Ve.EXT_MESHOPT_COMPRESSION, this.parser = e;
  }
  loadBufferView(e) {
    const t = this.parser.json, n = t.bufferViews[e];
    if (n.extensions && n.extensions[this.name]) {
      const i = n.extensions[this.name], s = this.parser.getDependency("buffer", i.buffer), a = this.parser.options.meshoptDecoder;
      if (!a || !a.supported) {
        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        return null;
      }
      return s.then(function(o) {
        const l = i.byteOffset || 0, c = i.byteLength || 0, u = i.count, h = i.byteStride, d = new Uint8Array(o, l, c);
        return a.decodeGltfBufferAsync ? a.decodeGltfBufferAsync(u, h, d, i.mode, i.filter).then(function(m) {
          return m.buffer;
        }) : a.ready.then(function() {
          const m = new ArrayBuffer(u * h);
          return a.decodeGltfBuffer(new Uint8Array(m), u, h, d, i.mode, i.filter), m;
        });
      });
    } else
      return null;
  }
}
class Vg {
  constructor(e) {
    this.name = Ve.EXT_MESH_GPU_INSTANCING, this.parser = e;
  }
  createNodeMesh(e) {
    const t = this.parser.json, n = t.nodes[e];
    if (!n.extensions || !n.extensions[this.name] || n.mesh === void 0)
      return null;
    const i = t.meshes[n.mesh];
    for (const c of i.primitives)
      if (c.mode !== Nt.TRIANGLES && c.mode !== Nt.TRIANGLE_STRIP && c.mode !== Nt.TRIANGLE_FAN && c.mode !== void 0)
        return null;
    const a = n.extensions[this.name].attributes, o = [], l = {};
    for (const c in a)
      o.push(this.parser.getDependency("accessor", a[c]).then((u) => (l[c] = u, l[c])));
    return o.length < 1 ? null : (o.push(this.parser.createNodeMesh(e)), Promise.all(o).then((c) => {
      const u = c.pop(), h = u.isGroup ? u.children : [u], d = c[0].count, m = [];
      for (const g of h) {
        const p = new Fe(), f = new F(), v = new $t(), S = new F(1, 1, 1), y = new Ym(g.geometry, g.material, d);
        for (let b = 0; b < d; b++)
          l.TRANSLATION && f.fromBufferAttribute(l.TRANSLATION, b), l.ROTATION && v.fromBufferAttribute(l.ROTATION, b), l.SCALE && S.fromBufferAttribute(l.SCALE, b), y.setMatrixAt(b, p.compose(f, v, S));
        for (const b in l)
          b !== "TRANSLATION" && b !== "ROTATION" && b !== "SCALE" && g.geometry.setAttribute(b, l[b]);
        nt.prototype.copy.call(y, g), y.frustumCulled = !1, this.parser.assignFinalMaterial(y), m.push(y);
      }
      return u.isGroup ? (u.clear(), u.add(...m), u) : m[0];
    }));
  }
}
const Fl = "glTF", ki = 12, jo = { JSON: 1313821514, BIN: 5130562 };
class Gg {
  constructor(e) {
    this.name = Ve.KHR_BINARY_GLTF, this.content = null, this.body = null;
    const t = new DataView(e, 0, ki);
    if (this.header = {
      magic: zn.decodeText(new Uint8Array(e.slice(0, 4))),
      version: t.getUint32(4, !0),
      length: t.getUint32(8, !0)
    }, this.header.magic !== Fl)
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    if (this.header.version < 2)
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    const n = this.header.length - ki, i = new DataView(e, ki);
    let s = 0;
    for (; s < n; ) {
      const a = i.getUint32(s, !0);
      s += 4;
      const o = i.getUint32(s, !0);
      if (s += 4, o === jo.JSON) {
        const l = new Uint8Array(e, ki + s, a);
        this.content = zn.decodeText(l);
      } else if (o === jo.BIN) {
        const l = ki + s;
        this.body = e.slice(l, l + a);
      }
      s += a;
    }
    if (this.content === null)
      throw new Error("THREE.GLTFLoader: JSON content not found.");
  }
}
class Wg {
  constructor(e, t) {
    if (!t)
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = Ve.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
  }
  decodePrimitive(e, t) {
    const n = this.json, i = this.dracoLoader, s = e.extensions[this.name].bufferView, a = e.extensions[this.name].attributes, o = {}, l = {}, c = {};
    for (const u in a) {
      const h = Wr[u] || u.toLowerCase();
      o[h] = a[u];
    }
    for (const u in e.attributes) {
      const h = Wr[u] || u.toLowerCase();
      if (a[u] !== void 0) {
        const d = n.accessors[e.attributes[u]], m = fi[d.componentType];
        c[h] = m.name, l[h] = d.normalized === !0;
      }
    }
    return t.getDependency("bufferView", s).then(function(u) {
      return new Promise(function(h) {
        i.decodeDracoFile(u, function(d) {
          for (const m in d.attributes) {
            const g = d.attributes[m], p = l[m];
            p !== void 0 && (g.normalized = p);
          }
          h(d);
        }, o, c);
      });
    });
  }
}
class jg {
  constructor() {
    this.name = Ve.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(e, t) {
    return t.texCoord !== void 0 && console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.'), t.offset === void 0 && t.rotation === void 0 && t.scale === void 0 || (e = e.clone(), t.offset !== void 0 && e.offset.fromArray(t.offset), t.rotation !== void 0 && (e.rotation = t.rotation), t.scale !== void 0 && e.repeat.fromArray(t.scale), e.needsUpdate = !0), e;
  }
}
class Xg {
  constructor() {
    this.name = Ve.KHR_MESH_QUANTIZATION;
  }
}
class zl extends is {
  constructor(e, t, n, i) {
    super(e, t, n, i);
  }
  copySampleValue_(e) {
    const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, s = e * i * 3 + i;
    for (let a = 0; a !== i; a++)
      t[a] = n[s + a];
    return t;
  }
  interpolate_(e, t, n, i) {
    const s = this.resultBuffer, a = this.sampleValues, o = this.valueSize, l = o * 2, c = o * 3, u = i - t, h = (n - t) / u, d = h * h, m = d * h, g = e * c, p = g - c, f = -2 * m + 3 * d, v = m - d, S = 1 - f, y = v - d + h;
    for (let b = 0; b !== o; b++) {
      const w = a[p + b + o], D = a[p + b + l] * u, z = a[g + b + o], x = a[g + b] * u;
      s[b] = S * w + y * D + f * z + v * x;
    }
    return s;
  }
}
const qg = new $t();
class Yg extends zl {
  interpolate_(e, t, n, i) {
    const s = super.interpolate_(e, t, n, i);
    return qg.fromArray(s).normalize().toArray(s), s;
  }
}
const Nt = {
  FLOAT: 5126,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
}, fi = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, Xo = {
  9728: ft,
  9729: Et,
  9984: zr,
  9985: ol,
  9986: Ps,
  9987: Un
}, qo = {
  33071: Ct,
  33648: Fs,
  10497: vi
}, Lr = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Wr = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
}, _n = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
}, Kg = {
  CUBICSPLINE: void 0,
  LINEAR: yi,
  STEP: Ki
}, Rr = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function Zg(r) {
  return r.DefaultMaterial === void 0 && (r.DefaultMaterial = new aa({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: Mn
  })), r.DefaultMaterial;
}
function Bi(r, e, t) {
  for (const n in t.extensions)
    r[n] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[n] = t.extensions[n]);
}
function vn(r, e) {
  e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(r.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function $g(r, e, t) {
  let n = !1, i = !1, s = !1;
  for (let c = 0, u = e.length; c < u; c++) {
    const h = e[c];
    if (h.POSITION !== void 0 && (n = !0), h.NORMAL !== void 0 && (i = !0), h.COLOR_0 !== void 0 && (s = !0), n && i && s)
      break;
  }
  if (!n && !i && !s)
    return Promise.resolve(r);
  const a = [], o = [], l = [];
  for (let c = 0, u = e.length; c < u; c++) {
    const h = e[c];
    if (n) {
      const d = h.POSITION !== void 0 ? t.getDependency("accessor", h.POSITION) : r.attributes.position;
      a.push(d);
    }
    if (i) {
      const d = h.NORMAL !== void 0 ? t.getDependency("accessor", h.NORMAL) : r.attributes.normal;
      o.push(d);
    }
    if (s) {
      const d = h.COLOR_0 !== void 0 ? t.getDependency("accessor", h.COLOR_0) : r.attributes.color;
      l.push(d);
    }
  }
  return Promise.all([
    Promise.all(a),
    Promise.all(o),
    Promise.all(l)
  ]).then(function(c) {
    const u = c[0], h = c[1], d = c[2];
    return n && (r.morphAttributes.position = u), i && (r.morphAttributes.normal = h), s && (r.morphAttributes.color = d), r.morphTargetsRelative = !0, r;
  });
}
function Jg(r, e) {
  if (r.updateMorphTargets(), e.weights !== void 0)
    for (let t = 0, n = e.weights.length; t < n; t++)
      r.morphTargetInfluences[t] = e.weights[t];
  if (e.extras && Array.isArray(e.extras.targetNames)) {
    const t = e.extras.targetNames;
    if (r.morphTargetInfluences.length === t.length) {
      r.morphTargetDictionary = {};
      for (let n = 0, i = t.length; n < i; n++)
        r.morphTargetDictionary[t[n]] = n;
    } else
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}
function Qg(r) {
  const e = r.extensions && r.extensions[Ve.KHR_DRACO_MESH_COMPRESSION];
  let t;
  return e ? t = "draco:" + e.bufferView + ":" + e.indices + ":" + Yo(e.attributes) : t = r.indices + ":" + Yo(r.attributes) + ":" + r.mode, t;
}
function Yo(r) {
  let e = "";
  const t = Object.keys(r).sort();
  for (let n = 0, i = t.length; n < i; n++)
    e += t[n] + ":" + r[t[n]] + ";";
  return e;
}
function jr(r) {
  switch (r) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function e_(r) {
  return r.search(/\.jpe?g($|\?)/i) > 0 || r.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : r.search(/\.webp($|\?)/i) > 0 || r.search(/^data\:image\/webp/) === 0 ? "image/webp" : "image/png";
}
const t_ = new Fe();
class n_ {
  constructor(e = {}, t = {}) {
    this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new Cg(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.meshCache = { refs: {}, uses: {} }, this.cameraCache = { refs: {}, uses: {} }, this.lightCache = { refs: {}, uses: {} }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
    let n = !1, i = !1, s = -1;
    typeof navigator < "u" && (n = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === !0, i = navigator.userAgent.indexOf("Firefox") > -1, s = i ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), typeof createImageBitmap > "u" || n || i && s < 98 ? this.textureLoader = new Nl(this.options.manager) : this.textureLoader = new gg(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new Us(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
  }
  setExtensions(e) {
    this.extensions = e;
  }
  setPlugins(e) {
    this.plugins = e;
  }
  parse(e, t) {
    const n = this, i = this.json, s = this.extensions;
    this.cache.removeAll(), this._invokeAll(function(a) {
      return a._markDefs && a._markDefs();
    }), Promise.all(this._invokeAll(function(a) {
      return a.beforeRoot && a.beforeRoot();
    })).then(function() {
      return Promise.all([
        n.getDependencies("scene"),
        n.getDependencies("animation"),
        n.getDependencies("camera")
      ]);
    }).then(function(a) {
      const o = {
        scene: a[0][i.scene || 0],
        scenes: a[0],
        animations: a[1],
        cameras: a[2],
        asset: i.asset,
        parser: n,
        userData: {}
      };
      Bi(s, o, i), vn(o, i), Promise.all(n._invokeAll(function(l) {
        return l.afterRoot && l.afterRoot(o);
      })).then(function() {
        e(o);
      });
    }).catch(t);
  }
  _markDefs() {
    const e = this.json.nodes || [], t = this.json.skins || [], n = this.json.meshes || [];
    for (let i = 0, s = t.length; i < s; i++) {
      const a = t[i].joints;
      for (let o = 0, l = a.length; o < l; o++)
        e[a[o]].isBone = !0;
    }
    for (let i = 0, s = e.length; i < s; i++) {
      const a = e[i];
      a.mesh !== void 0 && (this._addNodeRef(this.meshCache, a.mesh), a.skin !== void 0 && (n[a.mesh].isSkinnedMesh = !0)), a.camera !== void 0 && this._addNodeRef(this.cameraCache, a.camera);
    }
  }
  _addNodeRef(e, t) {
    t !== void 0 && (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
  }
  _getNodeRef(e, t, n) {
    if (e.refs[t] <= 1)
      return n;
    const i = n.clone(), s = (a, o) => {
      const l = this.associations.get(a);
      l != null && this.associations.set(o, l);
      for (const [c, u] of a.children.entries())
        s(u, o.children[c]);
    };
    return s(n, i), i.name += "_instance_" + e.uses[t]++, i;
  }
  _invokeOne(e) {
    const t = Object.values(this.plugins);
    t.push(this);
    for (let n = 0; n < t.length; n++) {
      const i = e(t[n]);
      if (i)
        return i;
    }
    return null;
  }
  _invokeAll(e) {
    const t = Object.values(this.plugins);
    t.unshift(this);
    const n = [];
    for (let i = 0; i < t.length; i++) {
      const s = e(t[i]);
      s && n.push(s);
    }
    return n;
  }
  getDependency(e, t) {
    const n = e + ":" + t;
    let i = this.cache.get(n);
    if (!i) {
      switch (e) {
        case "scene":
          i = this.loadScene(t);
          break;
        case "node":
          i = this._invokeOne(function(s) {
            return s.loadNode && s.loadNode(t);
          });
          break;
        case "mesh":
          i = this._invokeOne(function(s) {
            return s.loadMesh && s.loadMesh(t);
          });
          break;
        case "accessor":
          i = this.loadAccessor(t);
          break;
        case "bufferView":
          i = this._invokeOne(function(s) {
            return s.loadBufferView && s.loadBufferView(t);
          });
          break;
        case "buffer":
          i = this.loadBuffer(t);
          break;
        case "material":
          i = this._invokeOne(function(s) {
            return s.loadMaterial && s.loadMaterial(t);
          });
          break;
        case "texture":
          i = this._invokeOne(function(s) {
            return s.loadTexture && s.loadTexture(t);
          });
          break;
        case "skin":
          i = this.loadSkin(t);
          break;
        case "animation":
          i = this._invokeOne(function(s) {
            return s.loadAnimation && s.loadAnimation(t);
          });
          break;
        case "camera":
          i = this.loadCamera(t);
          break;
        default:
          if (i = this._invokeOne(function(s) {
            return s != this && s.getDependency && s.getDependency(e, t);
          }), !i)
            throw new Error("Unknown type: " + e);
          break;
      }
      this.cache.add(n, i);
    }
    return i;
  }
  getDependencies(e) {
    let t = this.cache.get(e);
    if (!t) {
      const n = this, i = this.json[e + (e === "mesh" ? "es" : "s")] || [];
      t = Promise.all(i.map(function(s, a) {
        return n.getDependency(e, a);
      })), this.cache.add(e, t);
    }
    return t;
  }
  loadBuffer(e) {
    const t = this.json.buffers[e], n = this.fileLoader;
    if (t.type && t.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
    if (t.uri === void 0 && e === 0)
      return Promise.resolve(this.extensions[Ve.KHR_BINARY_GLTF].body);
    const i = this.options;
    return new Promise(function(s, a) {
      n.load(zn.resolveURL(t.uri, i.path), s, void 0, function() {
        a(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
      });
    });
  }
  loadBufferView(e) {
    const t = this.json.bufferViews[e];
    return this.getDependency("buffer", t.buffer).then(function(n) {
      const i = t.byteLength || 0, s = t.byteOffset || 0;
      return n.slice(s, s + i);
    });
  }
  loadAccessor(e) {
    const t = this, n = this.json, i = this.json.accessors[e];
    if (i.bufferView === void 0 && i.sparse === void 0) {
      const a = Lr[i.type], o = fi[i.componentType], l = i.normalized === !0, c = new o(i.count * a);
      return Promise.resolve(new gt(c, a, l));
    }
    const s = [];
    return i.bufferView !== void 0 ? s.push(this.getDependency("bufferView", i.bufferView)) : s.push(null), i.sparse !== void 0 && (s.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), s.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(s).then(function(a) {
      const o = a[0], l = Lr[i.type], c = fi[i.componentType], u = c.BYTES_PER_ELEMENT, h = u * l, d = i.byteOffset || 0, m = i.bufferView !== void 0 ? n.bufferViews[i.bufferView].byteStride : void 0, g = i.normalized === !0;
      let p, f;
      if (m && m !== h) {
        const v = Math.floor(d / m), S = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + v + ":" + i.count;
        let y = t.cache.get(S);
        y || (p = new c(o, v * m, i.count * m / u), y = new Gm(p, m / u), t.cache.add(S, y)), f = new ia(y, l, d % m / u, g);
      } else
        o === null ? p = new c(i.count * l) : p = new c(o, d, i.count * l), f = new gt(p, l, g);
      if (i.sparse !== void 0) {
        const v = Lr.SCALAR, S = fi[i.sparse.indices.componentType], y = i.sparse.indices.byteOffset || 0, b = i.sparse.values.byteOffset || 0, w = new S(a[1], y, i.sparse.count * v), D = new c(a[2], b, i.sparse.count * l);
        o !== null && (f = new gt(f.array.slice(), f.itemSize, f.normalized));
        for (let z = 0, x = w.length; z < x; z++) {
          const R = w[z];
          if (f.setX(R, D[z * l]), l >= 2 && f.setY(R, D[z * l + 1]), l >= 3 && f.setZ(R, D[z * l + 2]), l >= 4 && f.setW(R, D[z * l + 3]), l >= 5)
            throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
      }
      return f;
    });
  }
  loadTexture(e) {
    const t = this.json, n = this.options, s = t.textures[e].source, a = t.images[s];
    let o = this.textureLoader;
    if (a.uri) {
      const l = n.manager.getHandler(a.uri);
      l !== null && (o = l);
    }
    return this.loadTextureImage(e, s, o);
  }
  loadTextureImage(e, t, n) {
    const i = this, s = this.json, a = s.textures[e], o = s.images[t], l = (o.uri || o.bufferView) + ":" + a.sampler;
    if (this.textureCache[l])
      return this.textureCache[l];
    const c = this.loadImageSource(t, n).then(function(u) {
      u.flipY = !1, u.name = a.name || o.name || "";
      const d = (s.samplers || {})[a.sampler] || {};
      return u.magFilter = Xo[d.magFilter] || Et, u.minFilter = Xo[d.minFilter] || Un, u.wrapS = qo[d.wrapS] || vi, u.wrapT = qo[d.wrapT] || vi, i.associations.set(u, { textures: e }), u;
    }).catch(function() {
      return null;
    });
    return this.textureCache[l] = c, c;
  }
  loadImageSource(e, t) {
    const n = this, i = this.json, s = this.options;
    if (this.sourceCache[e] !== void 0)
      return this.sourceCache[e].then((h) => h.clone());
    const a = i.images[e], o = self.URL || self.webkitURL;
    let l = a.uri || "", c = !1;
    if (a.bufferView !== void 0)
      l = n.getDependency("bufferView", a.bufferView).then(function(h) {
        c = !0;
        const d = new Blob([h], { type: a.mimeType });
        return l = o.createObjectURL(d), l;
      });
    else if (a.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
    const u = Promise.resolve(l).then(function(h) {
      return new Promise(function(d, m) {
        let g = d;
        t.isImageBitmapLoader === !0 && (g = function(p) {
          const f = new mt(p);
          f.needsUpdate = !0, d(f);
        }), t.load(zn.resolveURL(h, s.path), g, void 0, m);
      });
    }).then(function(h) {
      return c === !0 && o.revokeObjectURL(l), h.userData.mimeType = a.mimeType || e_(a.uri), h;
    }).catch(function(h) {
      throw console.error("THREE.GLTFLoader: Couldn't load texture", l), h;
    });
    return this.sourceCache[e] = u, u;
  }
  assignTexture(e, t, n, i) {
    const s = this;
    return this.getDependency("texture", n.index).then(function(a) {
      if (!a)
        return null;
      if (n.texCoord !== void 0 && n.texCoord != 0 && !(t === "aoMap" && n.texCoord == 1) && console.warn("THREE.GLTFLoader: Custom UV set " + n.texCoord + " for texture " + t + " not yet supported."), s.extensions[Ve.KHR_TEXTURE_TRANSFORM]) {
        const o = n.extensions !== void 0 ? n.extensions[Ve.KHR_TEXTURE_TRANSFORM] : void 0;
        if (o) {
          const l = s.associations.get(a);
          a = s.extensions[Ve.KHR_TEXTURE_TRANSFORM].extendTexture(a, o), s.associations.set(a, l);
        }
      }
      return i !== void 0 && (a.encoding = i), e[t] = a, a;
    });
  }
  assignFinalMaterial(e) {
    const t = e.geometry;
    let n = e.material;
    const i = t.attributes.tangent === void 0, s = t.attributes.color !== void 0, a = t.attributes.normal === void 0;
    if (e.isPoints) {
      const o = "PointsMaterial:" + n.uuid;
      let l = this.cache.get(o);
      l || (l = new Pl(), Xt.prototype.copy.call(l, n), l.color.copy(n.color), l.map = n.map, l.sizeAttenuation = !1, this.cache.add(o, l)), n = l;
    } else if (e.isLine) {
      const o = "LineBasicMaterial:" + n.uuid;
      let l = this.cache.get(o);
      l || (l = new Rl(), Xt.prototype.copy.call(l, n), l.color.copy(n.color), this.cache.add(o, l)), n = l;
    }
    if (i || s || a) {
      let o = "ClonedMaterial:" + n.uuid + ":";
      i && (o += "derivative-tangents:"), s && (o += "vertex-colors:"), a && (o += "flat-shading:");
      let l = this.cache.get(o);
      l || (l = n.clone(), s && (l.vertexColors = !0), a && (l.flatShading = !0), i && (l.normalScale && (l.normalScale.y *= -1), l.clearcoatNormalScale && (l.clearcoatNormalScale.y *= -1)), this.cache.add(o, l), this.associations.set(l, this.associations.get(n))), n = l;
    }
    n.aoMap && t.attributes.uv2 === void 0 && t.attributes.uv !== void 0 && t.setAttribute("uv2", t.attributes.uv), e.material = n;
  }
  getMaterialType() {
    return aa;
  }
  loadMaterial(e) {
    const t = this, n = this.json, i = this.extensions, s = n.materials[e];
    let a;
    const o = {}, l = s.extensions || {}, c = [];
    if (l[Ve.KHR_MATERIALS_UNLIT]) {
      const h = i[Ve.KHR_MATERIALS_UNLIT];
      a = h.getMaterialType(), c.push(h.extendParams(o, s, t));
    } else {
      const h = s.pbrMetallicRoughness || {};
      if (o.color = new De(1, 1, 1), o.opacity = 1, Array.isArray(h.baseColorFactor)) {
        const d = h.baseColorFactor;
        o.color.fromArray(d), o.opacity = d[3];
      }
      h.baseColorTexture !== void 0 && c.push(t.assignTexture(o, "map", h.baseColorTexture, Xe)), o.metalness = h.metallicFactor !== void 0 ? h.metallicFactor : 1, o.roughness = h.roughnessFactor !== void 0 ? h.roughnessFactor : 1, h.metallicRoughnessTexture !== void 0 && (c.push(t.assignTexture(o, "metalnessMap", h.metallicRoughnessTexture)), c.push(t.assignTexture(o, "roughnessMap", h.metallicRoughnessTexture))), a = this._invokeOne(function(d) {
        return d.getMaterialType && d.getMaterialType(e);
      }), c.push(Promise.all(this._invokeAll(function(d) {
        return d.extendMaterialParams && d.extendMaterialParams(e, o);
      })));
    }
    s.doubleSided === !0 && (o.side = Bs);
    const u = s.alphaMode || Rr.OPAQUE;
    if (u === Rr.BLEND ? (o.transparent = !0, o.depthWrite = !1) : (o.transparent = !1, u === Rr.MASK && (o.alphaTest = s.alphaCutoff !== void 0 ? s.alphaCutoff : 0.5)), s.normalTexture !== void 0 && a !== In && (c.push(t.assignTexture(o, "normalMap", s.normalTexture)), o.normalScale = new Pe(1, 1), s.normalTexture.scale !== void 0)) {
      const h = s.normalTexture.scale;
      o.normalScale.set(h, h);
    }
    return s.occlusionTexture !== void 0 && a !== In && (c.push(t.assignTexture(o, "aoMap", s.occlusionTexture)), s.occlusionTexture.strength !== void 0 && (o.aoMapIntensity = s.occlusionTexture.strength)), s.emissiveFactor !== void 0 && a !== In && (o.emissive = new De().fromArray(s.emissiveFactor)), s.emissiveTexture !== void 0 && a !== In && c.push(t.assignTexture(o, "emissiveMap", s.emissiveTexture, Xe)), Promise.all(c).then(function() {
      const h = new a(o);
      return s.name && (h.name = s.name), vn(h, s), t.associations.set(h, { materials: e }), s.extensions && Bi(i, h, s), h;
    });
  }
  createUniqueName(e) {
    const t = qe.sanitizeNodeName(e || "");
    let n = t;
    for (let i = 1; this.nodeNamesUsed[n]; ++i)
      n = t + "_" + i;
    return this.nodeNamesUsed[n] = !0, n;
  }
  loadGeometries(e) {
    const t = this, n = this.extensions, i = this.primitiveCache;
    function s(o) {
      return n[Ve.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(o, t).then(function(l) {
        return Ko(l, o, t);
      });
    }
    const a = [];
    for (let o = 0, l = e.length; o < l; o++) {
      const c = e[o], u = Qg(c), h = i[u];
      if (h)
        a.push(h.promise);
      else {
        let d;
        c.extensions && c.extensions[Ve.KHR_DRACO_MESH_COMPRESSION] ? d = s(c) : d = Ko(new Yt(), c, t), i[u] = { primitive: c, promise: d }, a.push(d);
      }
    }
    return Promise.all(a);
  }
  loadMesh(e) {
    const t = this, n = this.json, i = this.extensions, s = n.meshes[e], a = s.primitives, o = [];
    for (let l = 0, c = a.length; l < c; l++) {
      const u = a[l].material === void 0 ? Zg(this.cache) : this.getDependency("material", a[l].material);
      o.push(u);
    }
    return o.push(t.loadGeometries(a)), Promise.all(o).then(function(l) {
      const c = l.slice(0, l.length - 1), u = l[l.length - 1], h = [];
      for (let m = 0, g = u.length; m < g; m++) {
        const p = u[m], f = a[m];
        let v;
        const S = c[m];
        if (f.mode === Nt.TRIANGLES || f.mode === Nt.TRIANGLE_STRIP || f.mode === Nt.TRIANGLE_FAN || f.mode === void 0)
          v = s.isSkinnedMesh === !0 ? new jm(p, S) : new Ut(p, S), v.isSkinnedMesh === !0 && !v.geometry.attributes.skinWeight.normalized && v.normalizeSkinWeights(), f.mode === Nt.TRIANGLE_STRIP ? v.geometry = Zo(v.geometry, wh) : f.mode === Nt.TRIANGLE_FAN && (v.geometry = Zo(v.geometry, cl));
        else if (f.mode === Nt.LINES)
          v = new Km(p, S);
        else if (f.mode === Nt.LINE_STRIP)
          v = new ra(p, S);
        else if (f.mode === Nt.LINE_LOOP)
          v = new Zm(p, S);
        else if (f.mode === Nt.POINTS)
          v = new $m(p, S);
        else
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + f.mode);
        Object.keys(v.geometry.morphAttributes).length > 0 && Jg(v, s), v.name = t.createUniqueName(s.name || "mesh_" + e), vn(v, s), f.extensions && Bi(i, v, f), t.assignFinalMaterial(v), h.push(v);
      }
      for (let m = 0, g = h.length; m < g; m++)
        t.associations.set(h[m], {
          meshes: e,
          primitives: m
        });
      if (h.length === 1)
        return h[0];
      const d = new On();
      t.associations.set(d, { meshes: e });
      for (let m = 0, g = h.length; m < g; m++)
        d.add(h[m]);
      return d;
    });
  }
  loadCamera(e) {
    let t;
    const n = this.json.cameras[e], i = n[n.type];
    if (!i) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    return n.type === "perspective" ? t = new At(Hh.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : n.type === "orthographic" && (t = new ea(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (t.name = this.createUniqueName(n.name)), vn(t, n), Promise.resolve(t);
  }
  loadSkin(e) {
    const t = this.json.skins[e], n = [];
    for (let i = 0, s = t.joints.length; i < s; i++)
      n.push(this.getDependency("node", t.joints[i]));
    return t.inverseBindMatrices !== void 0 ? n.push(this.getDependency("accessor", t.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(i) {
      const s = i.pop(), a = i, o = [], l = [];
      for (let c = 0, u = a.length; c < u; c++) {
        const h = a[c];
        if (h) {
          o.push(h);
          const d = new Fe();
          s !== null && d.fromArray(s.array, c * 16), l.push(d);
        } else
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[c]);
      }
      return new sa(o, l);
    });
  }
  loadAnimation(e) {
    const n = this.json.animations[e], i = [], s = [], a = [], o = [], l = [];
    for (let c = 0, u = n.channels.length; c < u; c++) {
      const h = n.channels[c], d = n.samplers[h.sampler], m = h.target, g = m.node, p = n.parameters !== void 0 ? n.parameters[d.input] : d.input, f = n.parameters !== void 0 ? n.parameters[d.output] : d.output;
      i.push(this.getDependency("node", g)), s.push(this.getDependency("accessor", p)), a.push(this.getDependency("accessor", f)), o.push(d), l.push(m);
    }
    return Promise.all([
      Promise.all(i),
      Promise.all(s),
      Promise.all(a),
      Promise.all(o),
      Promise.all(l)
    ]).then(function(c) {
      const u = c[0], h = c[1], d = c[2], m = c[3], g = c[4], p = [];
      for (let v = 0, S = u.length; v < S; v++) {
        const y = u[v], b = h[v], w = d[v], D = m[v], z = g[v];
        if (y === void 0)
          continue;
        y.updateMatrix();
        let x;
        switch (_n[z.path]) {
          case _n.weights:
            x = Qi;
            break;
          case _n.rotation:
            x = Gn;
            break;
          case _n.position:
          case _n.scale:
          default:
            x = es;
            break;
        }
        const R = y.name ? y.name : y.uuid, k = D.interpolation !== void 0 ? Kg[D.interpolation] : yi, T = [];
        _n[z.path] === _n.weights ? y.traverse(function(V) {
          V.morphTargetInfluences && T.push(V.name ? V.name : V.uuid);
        }) : T.push(R);
        let ee = w.array;
        if (w.normalized) {
          const V = jr(ee.constructor), H = new Float32Array(ee.length);
          for (let j = 0, G = ee.length; j < G; j++)
            H[j] = ee[j] * V;
          ee = H;
        }
        for (let V = 0, H = T.length; V < H; V++) {
          const j = new x(
            T[V] + "." + _n[z.path],
            b.array,
            ee,
            k
          );
          D.interpolation === "CUBICSPLINE" && (j.createInterpolant = function(te) {
            const Z = this instanceof Gn ? Yg : zl;
            return new Z(this.times, this.values, this.getValueSize() / 3, te);
          }, j.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0), p.push(j);
        }
      }
      const f = n.name ? n.name : "animation_" + e;
      return new ig(f, void 0, p);
    });
  }
  createNodeMesh(e) {
    const t = this.json, n = this, i = t.nodes[e];
    return i.mesh === void 0 ? null : n.getDependency("mesh", i.mesh).then(function(s) {
      const a = n._getNodeRef(n.meshCache, i.mesh, s);
      return i.weights !== void 0 && a.traverse(function(o) {
        if (!!o.isMesh)
          for (let l = 0, c = i.weights.length; l < c; l++)
            o.morphTargetInfluences[l] = i.weights[l];
      }), a;
    });
  }
  loadNode(e) {
    const t = this.json, n = this.extensions, i = this, s = t.nodes[e], a = s.name ? i.createUniqueName(s.name) : "";
    return function() {
      const o = [], l = i._invokeOne(function(d) {
        return d.createNodeMesh && d.createNodeMesh(e);
      });
      l && o.push(l), s.camera !== void 0 && o.push(i.getDependency("camera", s.camera).then(function(d) {
        return i._getNodeRef(i.cameraCache, s.camera, d);
      })), i._invokeAll(function(d) {
        return d.createNodeAttachment && d.createNodeAttachment(e);
      }).forEach(function(d) {
        o.push(d);
      });
      const c = [], u = s.children || [];
      for (let d = 0, m = u.length; d < m; d++)
        c.push(i.getDependency("node", u[d]));
      const h = s.skin === void 0 ? Promise.resolve(null) : i.getDependency("skin", s.skin);
      return Promise.all([
        Promise.all(o),
        Promise.all(c),
        h
      ]);
    }().then(function(o) {
      const l = o[0], c = o[1], u = o[2];
      let h;
      if (s.isBone === !0 ? h = new Cl() : l.length > 1 ? h = new On() : l.length === 1 ? h = l[0] : h = new nt(), h !== l[0])
        for (let d = 0, m = l.length; d < m; d++)
          h.add(l[d]);
      if (s.name && (h.userData.name = s.name, h.name = a), vn(h, s), s.extensions && Bi(n, h, s), s.matrix !== void 0) {
        const d = new Fe();
        d.fromArray(s.matrix), h.applyMatrix4(d);
      } else
        s.translation !== void 0 && h.position.fromArray(s.translation), s.rotation !== void 0 && h.quaternion.fromArray(s.rotation), s.scale !== void 0 && h.scale.fromArray(s.scale);
      i.associations.has(h) || i.associations.set(h, {}), i.associations.get(h).nodes = e, u !== null && h.traverse(function(d) {
        !d.isSkinnedMesh || d.bind(u, t_);
      });
      for (let d = 0, m = c.length; d < m; d++)
        h.add(c[d]);
      return h;
    });
  }
  loadScene(e) {
    const t = this.extensions, n = this.json.scenes[e], i = this, s = new On();
    n.name && (s.name = i.createUniqueName(n.name)), vn(s, n), n.extensions && Bi(t, s, n);
    const a = n.nodes || [], o = [];
    for (let l = 0, c = a.length; l < c; l++)
      o.push(i.getDependency("node", a[l]));
    return Promise.all(o).then(function(l) {
      for (let u = 0, h = l.length; u < h; u++)
        s.add(l[u]);
      const c = (u) => {
        const h = /* @__PURE__ */ new Map();
        for (const [d, m] of i.associations)
          (d instanceof Xt || d instanceof mt) && h.set(d, m);
        return u.traverse((d) => {
          const m = i.associations.get(d);
          m != null && h.set(d, m);
        }), h;
      };
      return i.associations = c(s), s;
    });
  }
}
function i_(r, e, t) {
  const n = e.attributes, i = new wi();
  if (n.POSITION !== void 0) {
    const o = t.json.accessors[n.POSITION], l = o.min, c = o.max;
    if (l !== void 0 && c !== void 0) {
      if (i.set(
        new F(l[0], l[1], l[2]),
        new F(c[0], c[1], c[2])
      ), o.normalized) {
        const u = jr(fi[o.componentType]);
        i.min.multiplyScalar(u), i.max.multiplyScalar(u);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else
    return;
  const s = e.targets;
  if (s !== void 0) {
    const o = new F(), l = new F();
    for (let c = 0, u = s.length; c < u; c++) {
      const h = s[c];
      if (h.POSITION !== void 0) {
        const d = t.json.accessors[h.POSITION], m = d.min, g = d.max;
        if (m !== void 0 && g !== void 0) {
          if (l.setX(Math.max(Math.abs(m[0]), Math.abs(g[0]))), l.setY(Math.max(Math.abs(m[1]), Math.abs(g[1]))), l.setZ(Math.max(Math.abs(m[2]), Math.abs(g[2]))), d.normalized) {
            const p = jr(fi[d.componentType]);
            l.multiplyScalar(p);
          }
          o.max(l);
        } else
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      }
    }
    i.expandByVector(o);
  }
  r.boundingBox = i;
  const a = new Si();
  i.getCenter(a.center), a.radius = i.min.distanceTo(i.max) / 2, r.boundingSphere = a;
}
function Ko(r, e, t) {
  const n = e.attributes, i = [];
  function s(a, o) {
    return t.getDependency("accessor", a).then(function(l) {
      r.setAttribute(o, l);
    });
  }
  for (const a in n) {
    const o = Wr[a] || a.toLowerCase();
    o in r.attributes || i.push(s(n[a], o));
  }
  if (e.indices !== void 0 && !r.index) {
    const a = t.getDependency("accessor", e.indices).then(function(o) {
      r.setIndex(o);
    });
    i.push(a);
  }
  return vn(r, e), i_(r, e, t), Promise.all(i).then(function() {
    return e.targets !== void 0 ? $g(r, e.targets, t) : r;
  });
}
function Zo(r, e) {
  let t = r.getIndex();
  if (t === null) {
    const a = [], o = r.getAttribute("position");
    if (o !== void 0) {
      for (let l = 0; l < o.count; l++)
        a.push(l);
      r.setIndex(a), t = r.getIndex();
    } else
      return console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), r;
  }
  const n = t.count - 2, i = [];
  if (e === cl)
    for (let a = 1; a <= n; a++)
      i.push(t.getX(0)), i.push(t.getX(a)), i.push(t.getX(a + 1));
  else
    for (let a = 0; a < n; a++)
      a % 2 === 0 ? (i.push(t.getX(a)), i.push(t.getX(a + 1)), i.push(t.getX(a + 2))) : (i.push(t.getX(a + 2)), i.push(t.getX(a + 1)), i.push(t.getX(a)));
  i.length / 3 !== n && console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
  const s = r.clone();
  return s.setIndex(i), s;
}
const Pr = /* @__PURE__ */ new WeakMap();
class s_ extends Ci {
  constructor(e) {
    super(e), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    }, this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(e) {
    return this.decoderPath = e, this;
  }
  setDecoderConfig(e) {
    return this.decoderConfig = e, this;
  }
  setWorkerLimit(e) {
    return this.workerLimit = e, this;
  }
  load(e, t, n, i) {
    const s = new Us(this.manager);
    s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(e, (a) => {
      this.decodeDracoFile(a, t).catch(i);
    }, n, i);
  }
  decodeDracoFile(e, t, n, i) {
    const s = {
      attributeIDs: n || this.defaultAttributeIDs,
      attributeTypes: i || this.defaultAttributeTypes,
      useUniqueIDs: !!n
    };
    return this.decodeGeometry(e, s).then(t);
  }
  decodeGeometry(e, t) {
    const n = JSON.stringify(t);
    if (Pr.has(e)) {
      const l = Pr.get(e);
      if (l.key === n)
        return l.promise;
      if (e.byteLength === 0)
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
    }
    let i;
    const s = this.workerNextTaskID++, a = e.byteLength, o = this._getWorker(s, a).then((l) => (i = l, new Promise((c, u) => {
      i._callbacks[s] = { resolve: c, reject: u }, i.postMessage({ type: "decode", id: s, taskConfig: t, buffer: e }, [e]);
    }))).then((l) => this._createGeometry(l.geometry));
    return o.catch(() => !0).then(() => {
      i && s && this._releaseTask(i, s);
    }), Pr.set(e, {
      key: n,
      promise: o
    }), o;
  }
  _createGeometry(e) {
    const t = new Yt();
    e.index && t.setIndex(new gt(e.index.array, 1));
    for (let n = 0; n < e.attributes.length; n++) {
      const i = e.attributes[n], s = i.name, a = i.array, o = i.itemSize;
      t.setAttribute(s, new gt(a, o));
    }
    return t;
  }
  _loadLibrary(e, t) {
    const n = new Us(this.manager);
    return n.setPath(this.decoderPath), n.setResponseType(t), n.setWithCredentials(this.withCredentials), new Promise((i, s) => {
      n.load(e, i, void 0, s);
    });
  }
  preload() {
    return this._initDecoder(), this;
  }
  _initDecoder() {
    if (this.decoderPending)
      return this.decoderPending;
    const e = typeof WebAssembly != "object" || this.decoderConfig.type === "js", t = [];
    return e ? t.push(this._loadLibrary("draco_decoder.js", "text")) : (t.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), t.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(t).then((n) => {
      const i = n[0];
      e || (this.decoderConfig.wasmBinary = n[1]);
      const s = r_.toString(), a = [
        "/* draco decoder */",
        i,
        "",
        "/* worker */",
        s.substring(s.indexOf("{") + 1, s.lastIndexOf("}"))
      ].join(`
`);
      this.workerSourceURL = URL.createObjectURL(new Blob([a]));
    }), this.decoderPending;
  }
  _getWorker(e, t) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const i = new Worker(this.workerSourceURL);
        i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({ type: "init", decoderConfig: this.decoderConfig }), i.onmessage = function(s) {
          const a = s.data;
          switch (a.type) {
            case "decode":
              i._callbacks[a.id].resolve(a);
              break;
            case "error":
              i._callbacks[a.id].reject(a);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + a.type + '"');
          }
        }, this.workerPool.push(i);
      } else
        this.workerPool.sort(function(i, s) {
          return i._taskLoad > s._taskLoad ? -1 : 1;
        });
      const n = this.workerPool[this.workerPool.length - 1];
      return n._taskCosts[e] = t, n._taskLoad += t, n;
    });
  }
  _releaseTask(e, t) {
    e._taskLoad -= e._taskCosts[t], delete e._callbacks[t], delete e._taskCosts[t];
  }
  debug() {
    console.log("Task load: ", this.workerPool.map((e) => e._taskLoad));
  }
  dispose() {
    for (let e = 0; e < this.workerPool.length; ++e)
      this.workerPool[e].terminate();
    return this.workerPool.length = 0, this;
  }
}
function r_() {
  let r, e;
  onmessage = function(a) {
    const o = a.data;
    switch (o.type) {
      case "init":
        r = o.decoderConfig, e = new Promise(function(u) {
          r.onModuleLoaded = function(h) {
            u({ draco: h });
          }, DracoDecoderModule(r);
        });
        break;
      case "decode":
        const l = o.buffer, c = o.taskConfig;
        e.then((u) => {
          const h = u.draco, d = new h.Decoder(), m = new h.DecoderBuffer();
          m.Init(new Int8Array(l), l.byteLength);
          try {
            const g = t(h, d, m, c), p = g.attributes.map((f) => f.array.buffer);
            g.index && p.push(g.index.array.buffer), self.postMessage({ type: "decode", id: o.id, geometry: g }, p);
          } catch (g) {
            console.error(g), self.postMessage({ type: "error", id: o.id, error: g.message });
          } finally {
            h.destroy(m), h.destroy(d);
          }
        });
        break;
    }
  };
  function t(a, o, l, c) {
    const u = c.attributeIDs, h = c.attributeTypes;
    let d, m;
    const g = o.GetEncodedGeometryType(l);
    if (g === a.TRIANGULAR_MESH)
      d = new a.Mesh(), m = o.DecodeBufferToMesh(l, d);
    else if (g === a.POINT_CLOUD)
      d = new a.PointCloud(), m = o.DecodeBufferToPointCloud(l, d);
    else
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    if (!m.ok() || d.ptr === 0)
      throw new Error("THREE.DRACOLoader: Decoding failed: " + m.error_msg());
    const p = { index: null, attributes: [] };
    for (const f in u) {
      const v = self[h[f]];
      let S, y;
      if (c.useUniqueIDs)
        y = u[f], S = o.GetAttributeByUniqueId(d, y);
      else {
        if (y = o.GetAttributeId(d, a[u[f]]), y === -1)
          continue;
        S = o.GetAttribute(d, y);
      }
      p.attributes.push(i(a, o, d, f, v, S));
    }
    return g === a.TRIANGULAR_MESH && (p.index = n(a, o, d)), a.destroy(d), p;
  }
  function n(a, o, l) {
    const u = l.num_faces() * 3, h = u * 4, d = a._malloc(h);
    o.GetTrianglesUInt32Array(l, h, d);
    const m = new Uint32Array(a.HEAPF32.buffer, d, u).slice();
    return a._free(d), { array: m, itemSize: 1 };
  }
  function i(a, o, l, c, u, h) {
    const d = h.num_components(), g = l.num_points() * d, p = g * u.BYTES_PER_ELEMENT, f = s(a, u), v = a._malloc(p);
    o.GetAttributeDataArrayForAllPoints(l, h, f, p, v);
    const S = new u(a.HEAPF32.buffer, v, g).slice();
    return a._free(v), {
      name: c,
      array: S,
      itemSize: d
    };
  }
  function s(a, o) {
    switch (o) {
      case Float32Array:
        return a.DT_FLOAT32;
      case Int8Array:
        return a.DT_INT8;
      case Int16Array:
        return a.DT_INT16;
      case Int32Array:
        return a.DT_INT32;
      case Uint8Array:
        return a.DT_UINT8;
      case Uint16Array:
        return a.DT_UINT16;
      case Uint32Array:
        return a.DT_UINT32;
    }
  }
}
const a_ = ["id"], o_ = /* @__PURE__ */ Wn({
  __name: "ThreeDimensional",
  props: {
    refresh: { type: Boolean },
    backgroundColor: null,
    labelById: null,
    threeDimensionalModelInfo: null,
    dracoUrl: null
  },
  setup(r, { expose: e }) {
    const t = r;
    Wt(() => {
      var a;
      return (a = t.threeDimensionalModelInfo) == null ? void 0 : a.url;
    }, (a) => {
      a && i();
    }), ks(() => {
      var a;
      (a = t.threeDimensionalModelInfo) != null && a.url && i();
    });
    const n = Ye(), i = () => {
      Wt(() => t.refresh, () => {
        Ir(() => {
          v();
        });
      }), Wt(() => t.backgroundColor, () => {
        f(d.value);
      }), Wt(() => t.threeDimensionalModelInfo, (b) => {
        var w;
        (w = b.relevanceSwatch) == null || w.forEach((D) => {
          p(D);
        }), b.relevanceSwatch.length || f(d.value);
      }, {
        deep: !0
      });
      const a = new Vm(), o = document.getElementById(t.labelById).clientWidth, l = document.getElementById(t.labelById).clientHeight, c = new At(45, o / l, 1, 1e3), u = new El({ antialias: !0 });
      u.setSize(o, l);
      const h = new Ag(c, u.domElement), d = Ye({}), m = () => {
        var z;
        a.background = new De(16119285), a.fog = new na(16119285, 2e-3), u.setPixelRatio(window.devicePixelRatio), u.setSize(o, l), (z = document.getElementById(t.labelById)) == null || z.appendChild(u.domElement), c.position.set(200, 200, 200), h.enableDamping = !0, h.dampingFactor = 0.05, h.screenSpacePanning = !1, h.minDistance = 100, h.maxDistance = 500, h.maxPolarAngle = Math.PI, g();
        const b = new Gr(16777215);
        b.position.set(1, 1, 1), a.add(b);
        const w = new Gr(8840);
        w.position.set(-1, -1, -1), a.add(w);
        const D = new mg(2236962);
        a.add(D), h.saveState(), n.value = h, window.addEventListener("resize", v);
      }, g = () => {
        try {
          const b = new Eg().setPath(t.threeDimensionalModelInfo.url);
          if (t.dracoUrl) {
            const w = new s_().setDecoderPath(t.dracoUrl);
            b.setDRACOLoader(w);
          }
          b.load("", (w) => {
            var z;
            let D = w.scene;
            D.traverse((x) => {
              x.isMesh && (x.castShadow = !0, x.receiveShadow = !0);
            }), D.rotation.y = Math.PI, D.position.y = -1, D.scale.set(100, 100, 100), d.value = D, a.add(D), (z = t.threeDimensionalModelInfo.relevanceSwatch) == null || z.forEach((x) => {
              x.currentLocation && p(x);
            });
          });
        } catch (b) {
          console.log(b), Hi.error("\u6A21\u578B\u52A0\u8F7D\u5931\u8D25");
        }
      }, p = async (b) => {
        let w;
        if (b.texture) {
          let D;
          b.texture instanceof String ? D = new Nl().load(b.texture) : b.texture instanceof ImageData && (D = new Ll(b.texture.data, b.texture.width, b.texture.height), D.needsUpdate = !0), D.repeat.set(1, 1), D.wrapS = Ct, D.wrapT = Ct, w = new Tr({
            map: D,
            shininess: 60
          });
        } else
          b.color && (w = new Tr({
            color: parseInt("0x" + b.color),
            shininess: 60
          }));
        f(d.value, b.currentLocation, w);
      }, f = (b, w = void 0, D = void 0) => {
        let z = new Tr({
          color: parseInt("0x" + t.backgroundColor.replace("#", "")),
          shininess: 60
        });
        b.traverse((x) => {
          t.threeDimensionalModelInfo.relevanceSwatch.find((R) => x.nameID == R.currentLocation) || (x.nameID = null, x.material = z), x.isMesh && D && x.name.includes(w) && (x.nameID = w, x.material = D);
        });
      }, v = () => {
        let b = document.getElementById(t.labelById).clientWidth, w = document.getElementById(t.labelById).clientHeight;
        c.aspect = b / w, c.updateProjectionMatrix(), u.setSize(b, w);
      }, S = () => {
        requestAnimationFrame(S), h.update(), y();
      }, y = () => {
        u.render(a, c);
      };
      m(), S();
    };
    return e({
      defaultLocation: () => {
        n.value.reset();
      }
    }), (a, o) => (qt(), bn("div", {
      id: r.labelById,
      style: { width: "100%", height: "100%" }
    }, null, 8, a_));
  }
}), l_ = { class: "container" }, c_ = ["src"], h_ = /* @__PURE__ */ Wn({
  __name: "CustomizedImagePreview",
  props: {
    customizedData: null
  },
  setup(r) {
    const e = r;
    ks(() => {
      s();
    }), Wt([
      () => e.customizedData.customArea,
      () => e.customizedData.cssWidth,
      () => e.customizedData.width,
      () => e.customizedData.image
    ], () => {
      s();
    });
    const t = Ye({
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }), n = pi(() => ({
      width: `${e.customizedData.cssWidth}px`,
      height: `${e.customizedData.cssHeight}px`,
      backgroundImage: e.customizedData.image ? `url(${e.customizedData.image})` : "none",
      backgroundSize: "cover",
      backgroundPosition: "center"
    })), i = pi(() => ({
      position: "absolute",
      top: `${t.value.top}px`,
      left: `${t.value.left}px`,
      width: `${t.value.width}px`,
      height: `${t.value.height}px`
    })), s = () => {
      var a, o, l, c;
      try {
        if (e.customizedData.image && e.customizedData.customArea && e.customizedData.width) {
          const u = e.customizedData.width / e.customizedData.customArea.bgWidth || 1, h = e.customizedData.cssWidth / e.customizedData.width || 0;
          t.value = {
            width: (((a = e.customizedData.customArea.boundingRect) == null ? void 0 : a.width) || 0) * h * u,
            height: (((o = e.customizedData.customArea.boundingRect) == null ? void 0 : o.height) || 0) * h * u,
            left: (((l = e.customizedData.customArea.boundingRect) == null ? void 0 : l.left) || 0) * h * u,
            top: (((c = e.customizedData.customArea.boundingRect) == null ? void 0 : c.top) || 0) * h * u
          };
        }
      } catch (u) {
        console.error(u);
      }
    };
    return (a, o) => (qt(), bn("div", l_, [
      Ft("div", {
        style: Wi(qi(n)),
        class: "background"
      }, [
        r.customizedData.image && r.customizedData.customizedImage ? (qt(), bn("img", {
          key: 0,
          src: r.customizedData.customizedImage,
          style: Wi(qi(i)),
          class: "foreground-image"
        }, null, 12, c_)) : Ns("", !0)
      ], 4)
    ]));
  }
});
const u_ = /* @__PURE__ */ un(h_, [["__scopeId", "data-v-2e9d3de1"]]), $o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AutoIcon: ec,
  Avatar: gc,
  AvatarEditor: tl,
  AvatarViewer: nl,
  RawAvatar: xc,
  CountDownButton: Mc,
  AScrollTable: Sc,
  APagination: Ac,
  PaginationSelect: Cc,
  ThreeDimensional: o_,
  ImageCustomizeEditor: Pc,
  CustomizedImagePreview: u_
}, Symbol.toStringTag, { value: "Module" }));
function d_(r) {
  for (const e in $o)
    r.component(e, $o[e]);
}
const g_ = { install: d_ };
export {
  Ac as APagination,
  Sc as AScrollTable,
  ec as AutoIcon,
  gc as Avatar,
  tl as AvatarEditor,
  nl as AvatarViewer,
  Mc as CountDownButton,
  u_ as CustomizedImagePreview,
  Pc as ImageCustomizeEditor,
  Cc as PaginationSelect,
  xc as RawAvatar,
  o_ as ThreeDimensional,
  g_ as default
};
